var Pc = Object.defineProperty, jc = Object.defineProperties;
var Ec = Object.getOwnPropertyDescriptors;
var ir = Object.getOwnPropertySymbols;
var ni = Object.prototype.hasOwnProperty, ri = Object.prototype.propertyIsEnumerable;
var Cr = (n, e, t) => e in n ? Pc(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Y = (n, e) => {
  for (var t in e || (e = {}))
    ni.call(e, t) && Cr(n, t, e[t]);
  if (ir)
    for (var t of ir(e))
      ri.call(e, t) && Cr(n, t, e[t]);
  return n;
}, ie = (n, e) => jc(n, Ec(e));
var Rn = (n, e) => {
  var t = {};
  for (var r in n)
    ni.call(n, r) && e.indexOf(r) < 0 && (t[r] = n[r]);
  if (n != null && ir)
    for (var r of ir(n))
      e.indexOf(r) < 0 && ri.call(n, r) && (t[r] = n[r]);
  return t;
};
var _ = (n, e, t) => (Cr(n, typeof e != "symbol" ? e + "" : e, t), t);
var ai = (n, e, t) => new Promise((r, a) => {
  var i = (m) => {
    try {
      u(t.next(m));
    } catch (f) {
      a(f);
    }
  }, s = (m) => {
    try {
      u(t.throw(m));
    } catch (f) {
      a(f);
    }
  }, u = (m) => m.done ? r(m.value) : Promise.resolve(m.value).then(i, s);
  u((t = t.apply(n, e)).next());
});
import "./style.css";
import ao, { createContext as Sc, useContext as je, useRef as pt, useState as C, useMemo as B, useCallback as oe, useEffect as U, Fragment as ha, forwardRef as io } from "react";
import { useUnionText as J, Breadcrumbs as fa, useViewport as pa, Flex as ce, Element as ne, useHttpApi as qe, Form as Ac, Captcha as Nc, captchaValue as Ic, ErrorBoundary as ft, useHwCompareDockbarSeoIds as Mc, Button as ii, GalleryCarousel as _c, Container as Dc, Row as ot, Col as Je, ExternalContent as jr, SkuAvailability as Cc, usePrevious as sn, HwCompareDockbar as oo, useSessionHandler as Lc, UnionPortlet as Wc, RouterWrapper as $c } from "@o2-shared/react-components";
import { Button as ve, Icon as Ge, Modal as bn, Box as Bt, Picture as wn, Input as oi, Select as Kr, Checkbox as so, Tooltip as Bc, Badge as dn, Accordion as Fc, Content as mr, Status as Er, Search as co, Alert as Zt, Chip as uo, Slider as Rc, Swiper as lo, SwiperSlide as mo } from "@o2-shared/react-components/wc";
import { useSearchParams as Ue, useNavigate as ga, useLocation as ho, Link as Jn, useParams as fo, Routes as Hc, Route as si, BrowserRouter as zc } from "react-router-dom";
import { Formik as Uc, Field as ci } from "formik";
import qc, { createPortal as ba } from "react-dom";
var Yc = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Vc(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var po = { exports: {} }, Sr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gc = ao, Qc = Symbol.for("react.element"), Xc = Symbol.for("react.fragment"), Kc = Object.prototype.hasOwnProperty, Zc = Gc.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, Jc = { key: !0, ref: !0, __self: !0, __source: !0 };
function go(n, e, t) {
  var r, a = {}, i = null, s = null;
  t !== void 0 && (i = "" + t), e.key !== void 0 && (i = "" + e.key), e.ref !== void 0 && (s = e.ref);
  for (r in e)
    Kc.call(e, r) && !Jc.hasOwnProperty(r) && (a[r] = e[r]);
  if (n && n.defaultProps)
    for (r in e = n.defaultProps, e)
      a[r] === void 0 && (a[r] = e[r]);
  return { $$typeof: Qc, type: n, key: i, ref: s, props: a, _owner: Zc.current };
}
Sr.Fragment = Xc;
Sr.jsx = go;
Sr.jsxs = go;
po.exports = Sr;
var o = po.exports;
const ye = Sc({
  namespace: "",
  config: {
    cpcPagesUrl: "",
    searchHwUrl: "",
    skuSearchUrl: "",
    skusSearchUrl: "",
    hwDeviceDetailUrl: "",
    customerContactsUrl: "",
    selectedOrganizationType: "",
    articleSearchUrl: "",
    selectedOrganization: "",
    selectedOrganizationStockId: "",
    tariffDetailUrl: "",
    skuConfigs: {},
    pricingInfoUrl: "",
    stockAvailabilityDetailUrl: "",
    hasNegativeStockOrders: !1,
    subscriberServiceProvider: null
  }
});
var D = {}, Zr = { exports: {} };
(function(n, e) {
  (function(t, r) {
    var a = "1.0.36", i = "", s = "?", u = "function", m = "undefined", f = "object", p = "string", d = "major", c = "model", l = "name", h = "type", g = "vendor", b = "version", w = "architecture", y = "console", v = "mobile", x = "tablet", T = "smarttv", j = "wearable", A = "embedded", N = 350, S = "Amazon", E = "Apple", k = "ASUS", M = "BlackBerry", O = "Browser", I = "Chrome", re = "Edge", V = "Firefox", R = "Google", P = "Huawei", Q = "LG", H = "Microsoft", xe = "Motorola", Fe = "Opera", $e = "Samsung", F = "Sharp", ee = "Sony", Xe = "Xiaomi", dt = "Zebra", Ot = "Facebook", Ee = "Chromium OS", rn = "Mac OS", an = function(G, z) {
      var X = {};
      for (var pe in G)
        z[pe] && z[pe].length % 2 === 0 ? X[pe] = z[pe].concat(G[pe]) : X[pe] = G[pe];
      return X;
    }, bt = function(G) {
      for (var z = {}, X = 0; X < G.length; X++)
        z[G[X].toUpperCase()] = G[X];
      return z;
    }, Pt = function(G, z) {
      return typeof G === p ? rt(z).indexOf(rt(G)) !== -1 : !1;
    }, rt = function(G) {
      return G.toLowerCase();
    }, Ke = function(G) {
      return typeof G === p ? G.replace(/[^\d\.]/g, i).split(".")[0] : r;
    }, Ut = function(G, z) {
      if (typeof G === p)
        return G = G.replace(/^\s\s*/, i), typeof z === m ? G : G.substring(0, N);
    }, wt = function(G, z) {
      for (var X = 0, pe, at, mt, se, $, ht; X < z.length && !$; ) {
        var Wn = z[X], $n = z[X + 1];
        for (pe = at = 0; pe < Wn.length && !$ && Wn[pe]; )
          if ($ = Wn[pe++].exec(G), $)
            for (mt = 0; mt < $n.length; mt++)
              ht = $[++at], se = $n[mt], typeof se === f && se.length > 0 ? se.length === 2 ? typeof se[1] == u ? this[se[0]] = se[1].call(this, ht) : this[se[0]] = se[1] : se.length === 3 ? typeof se[1] === u && !(se[1].exec && se[1].test) ? this[se[0]] = ht ? se[1].call(this, ht, se[2]) : r : this[se[0]] = ht ? ht.replace(se[1], se[2]) : r : se.length === 4 && (this[se[0]] = ht ? se[3].call(this, ht.replace(se[1], se[2])) : r) : this[se] = ht || r;
        X += 2;
      }
    }, zt = function(G, z) {
      for (var X in z)
        if (typeof z[X] === f && z[X].length > 0) {
          for (var pe = 0; pe < z[X].length; pe++)
            if (Pt(z[X][pe], G))
              return X === s ? r : X;
        } else if (Pt(z[X], G))
          return X === s ? r : X;
      return G;
    }, qt = { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" }, vt = { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" }, q = { browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [b, [l, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [b, [l, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [l, b], [/opios[\/ ]+([\w\.]+)/i], [b, [l, Fe + " Mini"]], [/\bopr\/([\w\.]+)/i], [b, [l, Fe]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i, /(ba?idubrowser)[\/ ]?([\w\.]+)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i, /(heytap|ovi)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [l, b], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [b, [l, "UC" + O]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i], [b, [l, "WeChat(Win) Desktop"]], [/micromessenger\/([\w\.]+)/i], [b, [l, "WeChat"]], [/konqueror\/([\w\.]+)/i], [b, [l, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [b, [l, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [b, [l, "Yandex"]], [/(avast|avg)\/([\w\.]+)/i], [[l, /(.+)/, "$1 Secure " + O], b], [/\bfocus\/([\w\.]+)/i], [b, [l, V + " Focus"]], [/\bopt\/([\w\.]+)/i], [b, [l, Fe + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [b, [l, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [b, [l, "Dolphin"]], [/coast\/([\w\.]+)/i], [b, [l, Fe + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [b, [l, "MIUI " + O]], [/fxios\/([-\w\.]+)/i], [b, [l, V]], [/\bqihu|(qi?ho?o?|360)browser/i], [[l, "360 " + O]], [/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i], [[l, /(.+)/, "$1 " + O], b], [/(comodo_dragon)\/([\w\.]+)/i], [[l, /_/g, " "], b], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i], [l, b], [/(metasr)[\/ ]?([\w\.]+)/i, /(lbbrowser)/i, /\[(linkedin)app\]/i], [l], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[l, Ot], b], [/(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i], [l, b], [/\bgsa\/([\w\.]+) .*safari\//i], [b, [l, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [b, [l, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [b, [l, I + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[l, I + " WebView"], b], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [b, [l, "Android " + O]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [l, b], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [b, [l, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [b, l], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [l, [b, zt, qt]], [/(webkit|khtml)\/([\w\.]+)/i], [l, b], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[l, "Netscape"], b], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [b, [l, V + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i, /panasonic;(viera)/i], [l, b], [/(cobalt)\/([\w\.]+)/i], [l, [b, /master.|lts./, ""]]], cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[w, "amd64"]], [/(ia32(?=;))/i], [[w, rt]], [/((?:i[346]|x)86)[;\)]/i], [[w, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[w, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[w, "armhf"]], [/windows (ce|mobile); ppc;/i], [[w, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[w, /ower/, i, rt]], [/(sun4\w)[;\)]/i], [[w, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[w, rt]]], device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [c, [g, $e], [h, x]], [/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [c, [g, $e], [h, v]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [c, [g, E], [h, v]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [c, [g, E], [h, x]], [/(macintosh);/i], [c, [g, E]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [c, [g, F], [h, v]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [c, [g, P], [h, x]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [c, [g, P], [h, v]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[c, /_/g, " "], [g, Xe], [h, v]], [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[c, /_/g, " "], [g, Xe], [h, x]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [c, [g, "OPPO"], [h, v]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [c, [g, "Vivo"], [h, v]], [/\b(rmx[12]\d{3})(?: bui|;|\))/i], [c, [g, "Realme"], [h, v]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [c, [g, xe], [h, v]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [c, [g, xe], [h, x]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [c, [g, Q], [h, x]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [c, [g, Q], [h, v]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [c, [g, "Lenovo"], [h, x]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[c, /_/g, " "], [g, "Nokia"], [h, v]], [/(pixel c)\b/i], [c, [g, R], [h, x]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [c, [g, R], [h, v]], [/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [c, [g, ee], [h, v]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[c, "Xperia Tablet"], [g, ee], [h, x]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [c, [g, "OnePlus"], [h, v]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [c, [g, S], [h, x]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[c, /(.+)/g, "Fire Phone $1"], [g, S], [h, v]], [/(playbook);[-\w\),; ]+(rim)/i], [c, g, [h, x]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [c, [g, M], [h, v]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [c, [g, k], [h, x]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [c, [g, k], [h, v]], [/(nexus 9)/i], [c, [g, "HTC"], [h, x]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [g, [c, /_/g, " "], [h, v]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [c, [g, "Acer"], [h, x]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [c, [g, "Meizu"], [h, v]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [g, c, [h, v]], [/(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [g, c, [h, x]], [/(surface duo)/i], [c, [g, H], [h, x]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [c, [g, "Fairphone"], [h, v]], [/(u304aa)/i], [c, [g, "AT&T"], [h, v]], [/\bsie-(\w*)/i], [c, [g, "Siemens"], [h, v]], [/\b(rct\w+) b/i], [c, [g, "RCA"], [h, x]], [/\b(venue[\d ]{2,7}) b/i], [c, [g, "Dell"], [h, x]], [/\b(q(?:mv|ta)\w+) b/i], [c, [g, "Verizon"], [h, x]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [c, [g, "Barnes & Noble"], [h, x]], [/\b(tm\d{3}\w+) b/i], [c, [g, "NuVision"], [h, x]], [/\b(k88) b/i], [c, [g, "ZTE"], [h, x]], [/\b(nx\d{3}j) b/i], [c, [g, "ZTE"], [h, v]], [/\b(gen\d{3}) b.+49h/i], [c, [g, "Swiss"], [h, v]], [/\b(zur\d{3}) b/i], [c, [g, "Swiss"], [h, x]], [/\b((zeki)?tb.*\b) b/i], [c, [g, "Zeki"], [h, x]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[g, "Dragon Touch"], c, [h, x]], [/\b(ns-?\w{0,9}) b/i], [c, [g, "Insignia"], [h, x]], [/\b((nxa|next)-?\w{0,9}) b/i], [c, [g, "NextBook"], [h, x]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[g, "Voice"], c, [h, v]], [/\b(lvtel\-)?(v1[12]) b/i], [[g, "LvTel"], c, [h, v]], [/\b(ph-1) /i], [c, [g, "Essential"], [h, v]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [c, [g, "Envizen"], [h, x]], [/\b(trio[-\w\. ]+) b/i], [c, [g, "MachSpeed"], [h, x]], [/\btu_(1491) b/i], [c, [g, "Rotor"], [h, x]], [/(shield[\w ]+) b/i], [c, [g, "Nvidia"], [h, x]], [/(sprint) (\w+)/i], [g, c, [h, v]], [/(kin\.[onetw]{3})/i], [[c, /\./g, " "], [g, H], [h, v]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [c, [g, dt], [h, x]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [c, [g, dt], [h, v]], [/smart-tv.+(samsung)/i], [g, [h, T]], [/hbbtv.+maple;(\d+)/i], [[c, /^/, "SmartTV"], [g, $e], [h, T]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[g, Q], [h, T]], [/(apple) ?tv/i], [g, [c, E + " TV"], [h, T]], [/crkey/i], [[c, I + "cast"], [g, R], [h, T]], [/droid.+aft(\w+)( bui|\))/i], [c, [g, S], [h, T]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [c, [g, F], [h, T]], [/(bravia[\w ]+)( bui|\))/i], [c, [g, ee], [h, T]], [/(mitv-\w{5}) bui/i], [c, [g, Xe], [h, T]], [/Hbbtv.*(technisat) (.*);/i], [g, c, [h, T]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[g, Ut], [c, Ut], [h, T]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[h, T]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [g, c, [h, y]], [/droid.+; (shield) bui/i], [c, [g, "Nvidia"], [h, y]], [/(playstation [345portablevi]+)/i], [c, [g, ee], [h, y]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [c, [g, H], [h, y]], [/((pebble))app/i], [g, c, [h, j]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [c, [g, E], [h, j]], [/droid.+; (glass) \d/i], [c, [g, R], [h, j]], [/droid.+; (wt63?0{2,3})\)/i], [c, [g, dt], [h, j]], [/(quest( 2| pro)?)/i], [c, [g, Ot], [h, j]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [g, [h, A]], [/(aeobc)\b/i], [c, [g, S], [h, A]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i], [c, [h, v]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [c, [h, x]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[h, x]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[h, v]], [/(android[-\w\. ]{0,9});.+buil/i], [c, [g, "Generic"]]], engine: [[/windows.+ edge\/([\w\.]+)/i], [b, [l, re + "HTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [b, [l, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [l, b], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [b, l]], os: [[/microsoft (windows) (vista|xp)/i], [l, b], [/(windows) nt 6\.2; (arm)/i, /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i, /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [l, [b, zt, vt]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[l, "Windows"], [b, zt, vt]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[b, /_/g, "."], [l, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[l, rn], [b, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [b, l], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [l, b], [/\(bb(10);/i], [b, [l, M]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [b, [l, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [b, [l, V + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [b, [l, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [b, [l, "watchOS"]], [/crkey\/([\d\.]+)/i], [b, [l, I + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[l, Ee], b], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [l, b], [/(sunos) ?([\w\.\d]*)/i], [[l, "Solaris"], b], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [l, b]] }, te = function(G, z) {
      if (typeof G === f && (z = G, G = r), !(this instanceof te))
        return new te(G, z).getResult();
      var X = typeof t !== m && t.navigator ? t.navigator : r, pe = G || (X && X.userAgent ? X.userAgent : i), at = X && X.userAgentData ? X.userAgentData : r, mt = z ? an(q, z) : q, se = X && X.userAgent == pe;
      return this.getBrowser = function() {
        var $ = {};
        return $[l] = r, $[b] = r, wt.call($, pe, mt.browser), $[d] = Ke($[b]), se && X && X.brave && typeof X.brave.isBrave == u && ($[l] = "Brave"), $;
      }, this.getCPU = function() {
        var $ = {};
        return $[w] = r, wt.call($, pe, mt.cpu), $;
      }, this.getDevice = function() {
        var $ = {};
        return $[g] = r, $[c] = r, $[h] = r, wt.call($, pe, mt.device), se && !$[h] && at && at.mobile && ($[h] = v), se && $[c] == "Macintosh" && X && typeof X.standalone !== m && X.maxTouchPoints && X.maxTouchPoints > 2 && ($[c] = "iPad", $[h] = x), $;
      }, this.getEngine = function() {
        var $ = {};
        return $[l] = r, $[b] = r, wt.call($, pe, mt.engine), $;
      }, this.getOS = function() {
        var $ = {};
        return $[l] = r, $[b] = r, wt.call($, pe, mt.os), se && !$[l] && at && at.platform != "Unknown" && ($[l] = at.platform.replace(/chrome os/i, Ee).replace(/macos/i, rn)), $;
      }, this.getResult = function() {
        return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
      }, this.getUA = function() {
        return pe;
      }, this.setUA = function($) {
        return pe = typeof $ === p && $.length > N ? Ut($, N) : $, this;
      }, this.setUA(pe), this;
    };
    te.VERSION = a, te.BROWSER = bt([l, b, d]), te.CPU = bt([w]), te.DEVICE = bt([c, g, h, y, v, T, x, j, A]), te.ENGINE = te.OS = bt([l, b]), n.exports && (e = n.exports = te), e.UAParser = te;
    var ae = typeof t !== m && (t.jQuery || t.Zepto);
    if (ae && !ae.ua) {
      var ke = new te();
      ae.ua = ke.getResult(), ae.ua.get = function() {
        return ke.getUA();
      }, ae.ua.set = function(G) {
        ke.setUA(G);
        var z = ke.getResult();
        for (var X in z)
          ae.ua[X] = z[X];
      };
    }
  })(typeof window == "object" ? window : Yc);
})(Zr, Zr.exports);
var eu = Zr.exports;
Object.defineProperty(D, "__esModule", { value: !0 });
function tu(n) {
  return n && typeof n == "object" && "default" in n ? n.default : n;
}
var Ve = ao, ge = tu(Ve), bo = eu, en = new bo(), Qe = en.getBrowser(), nu = en.getCPU(), lt = en.getDevice(), wa = en.getEngine(), tn = en.getOS(), er = en.getUA(), wo = function(e) {
  return en.setUA(e);
}, tr = function(e) {
  if (!e) {
    console.error("No userAgent string was provided");
    return;
  }
  var t = new bo(e);
  return {
    UA: t,
    browser: t.getBrowser(),
    cpu: t.getCPU(),
    device: t.getDevice(),
    engine: t.getEngine(),
    os: t.getOS(),
    ua: t.getUA(),
    setUserAgent: function(a) {
      return t.setUA(a);
    }
  };
}, vo = /* @__PURE__ */ Object.freeze({
  ClientUAInstance: en,
  browser: Qe,
  cpu: nu,
  device: lt,
  engine: wa,
  os: tn,
  ua: er,
  setUa: wo,
  parseUserAgent: tr
});
function ui(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function ru(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ui(Object(t), !0).forEach(function(r) {
      ou(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : ui(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function Yn(n) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Yn = function(e) {
    return typeof e;
  } : Yn = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Yn(n);
}
function au(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function li(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
  }
}
function iu(n, e, t) {
  return e && li(n.prototype, e), t && li(n, t), n;
}
function ou(n, e, t) {
  return e in n ? Object.defineProperty(n, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = t, n;
}
function Jr() {
  return Jr = Object.assign || function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, Jr.apply(this, arguments);
}
function su(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: n,
      writable: !0,
      configurable: !0
    }
  }), e && ta(n, e);
}
function ea(n) {
  return ea = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, ea(n);
}
function ta(n, e) {
  return ta = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, ta(n, e);
}
function cu(n, e) {
  if (n == null)
    return {};
  var t = {}, r = Object.keys(n), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(e.indexOf(a) >= 0) && (t[a] = n[a]);
  return t;
}
function gt(n, e) {
  if (n == null)
    return {};
  var t = cu(n, e), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(n);
    for (a = 0; a < i.length; a++)
      r = i[a], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function lr(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function uu(n, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return lr(n);
}
function lu(n, e) {
  return du(n) || mu(n, e) || hu(n, e) || fu();
}
function du(n) {
  if (Array.isArray(n))
    return n;
}
function mu(n, e) {
  var t = n == null ? null : typeof Symbol != "undefined" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r = [], a = !0, i = !1, s, u;
    try {
      for (t = t.call(n); !(a = (s = t.next()).done) && (r.push(s.value), !(e && r.length === e)); a = !0)
        ;
    } catch (m) {
      i = !0, u = m;
    } finally {
      try {
        !a && t.return != null && t.return();
      } finally {
        if (i)
          throw u;
      }
    }
    return r;
  }
}
function hu(n, e) {
  if (n) {
    if (typeof n == "string")
      return di(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return di(n, e);
  }
}
function di(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
function fu() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Ye = {
  Mobile: "mobile",
  Tablet: "tablet",
  SmartTv: "smarttv",
  Console: "console",
  Wearable: "wearable",
  Embedded: "embedded",
  Browser: void 0
}, tt = {
  Chrome: "Chrome",
  Firefox: "Firefox",
  Opera: "Opera",
  Yandex: "Yandex",
  Safari: "Safari",
  InternetExplorer: "Internet Explorer",
  Edge: "Edge",
  Chromium: "Chromium",
  Ie: "IE",
  MobileSafari: "Mobile Safari",
  EdgeChromium: "Edge Chromium",
  MIUI: "MIUI Browser",
  SamsungBrowser: "Samsung Browser"
}, Dn = {
  IOS: "iOS",
  Android: "Android",
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MAC_OS: "Mac OS"
}, pu = {
  isMobile: !1,
  isTablet: !1,
  isBrowser: !1,
  isSmartTV: !1,
  isConsole: !1,
  isWearable: !1
}, gu = function(e) {
  switch (e) {
    case Ye.Mobile:
      return {
        isMobile: !0
      };
    case Ye.Tablet:
      return {
        isTablet: !0
      };
    case Ye.SmartTv:
      return {
        isSmartTV: !0
      };
    case Ye.Console:
      return {
        isConsole: !0
      };
    case Ye.Wearable:
      return {
        isWearable: !0
      };
    case Ye.Browser:
      return {
        isBrowser: !0
      };
    case Ye.Embedded:
      return {
        isEmbedded: !0
      };
    default:
      return pu;
  }
}, bu = function(e) {
  return wo(e);
}, K = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
  return e || t;
}, va = function() {
  return typeof window != "undefined" && (window.navigator || navigator) ? window.navigator || navigator : !1;
}, ya = function(e) {
  var t = va();
  return t && t.platform && (t.platform.indexOf(e) !== -1 || t.platform === "MacIntel" && t.maxTouchPoints > 1 && !window.MSStream);
}, wu = function(e, t, r, a, i) {
  return {
    isBrowser: e,
    browserMajorVersion: K(t.major),
    browserFullVersion: K(t.version),
    browserName: K(t.name),
    engineName: K(r.name),
    engineVersion: K(r.version),
    osName: K(a.name),
    osVersion: K(a.version),
    userAgent: K(i)
  };
}, mi = function(e, t, r, a) {
  return ru({}, e, {
    vendor: K(t.vendor),
    model: K(t.model),
    os: K(r.name),
    osVersion: K(r.version),
    ua: K(a)
  });
}, vu = function(e, t, r, a) {
  return {
    isSmartTV: e,
    engineName: K(t.name),
    engineVersion: K(t.version),
    osName: K(r.name),
    osVersion: K(r.version),
    userAgent: K(a)
  };
}, yu = function(e, t, r, a) {
  return {
    isConsole: e,
    engineName: K(t.name),
    engineVersion: K(t.version),
    osName: K(r.name),
    osVersion: K(r.version),
    userAgent: K(a)
  };
}, xu = function(e, t, r, a) {
  return {
    isWearable: e,
    engineName: K(t.name),
    engineVersion: K(t.version),
    osName: K(r.name),
    osVersion: K(r.version),
    userAgent: K(a)
  };
}, ku = function(e, t, r, a, i) {
  return {
    isEmbedded: e,
    vendor: K(t.vendor),
    model: K(t.model),
    engineName: K(r.name),
    engineVersion: K(r.version),
    osName: K(a.name),
    osVersion: K(a.version),
    userAgent: K(i)
  };
};
function Tu(n) {
  var e = n ? tr(n) : vo, t = e.device, r = e.browser, a = e.engine, i = e.os, s = e.ua, u = gu(t.type), m = u.isBrowser, f = u.isMobile, p = u.isTablet, d = u.isSmartTV, c = u.isConsole, l = u.isWearable, h = u.isEmbedded;
  if (m)
    return wu(m, r, a, i, s);
  if (d)
    return vu(d, a, i, s);
  if (c)
    return yu(c, a, i, s);
  if (f || p)
    return mi(u, t, i, s);
  if (l)
    return xu(l, a, i, s);
  if (h)
    return ku(h, t, a, i, s);
}
var yo = function(e) {
  var t = e.type;
  return t === Ye.Mobile;
}, xo = function(e) {
  var t = e.type;
  return t === Ye.Tablet;
}, ko = function(e) {
  var t = e.type;
  return t === Ye.Mobile || t === Ye.Tablet;
}, To = function(e) {
  var t = e.type;
  return t === Ye.SmartTv;
}, hr = function(e) {
  var t = e.type;
  return t === Ye.Browser;
}, Oo = function(e) {
  var t = e.type;
  return t === Ye.Wearable;
}, Po = function(e) {
  var t = e.type;
  return t === Ye.Console;
}, jo = function(e) {
  var t = e.type;
  return t === Ye.Embedded;
}, Eo = function(e) {
  var t = e.vendor;
  return K(t);
}, So = function(e) {
  var t = e.model;
  return K(t);
}, Ao = function(e) {
  var t = e.type;
  return K(t, "browser");
}, No = function(e) {
  var t = e.name;
  return t === Dn.Android;
}, Io = function(e) {
  var t = e.name;
  return t === Dn.Windows;
}, Mo = function(e) {
  var t = e.name;
  return t === Dn.MAC_OS;
}, _o = function(e) {
  var t = e.name;
  return t === Dn.WindowsPhone;
}, Do = function(e) {
  var t = e.name;
  return t === Dn.IOS;
}, Co = function(e) {
  var t = e.version;
  return K(t);
}, Lo = function(e) {
  var t = e.name;
  return K(t);
}, Wo = function(e) {
  var t = e.name;
  return t === tt.Chrome;
}, $o = function(e) {
  var t = e.name;
  return t === tt.Firefox;
}, Bo = function(e) {
  var t = e.name;
  return t === tt.Chromium;
}, fr = function(e) {
  var t = e.name;
  return t === tt.Edge;
}, Fo = function(e) {
  var t = e.name;
  return t === tt.Yandex;
}, Ro = function(e) {
  var t = e.name;
  return t === tt.Safari || t === tt.MobileSafari;
}, Ho = function(e) {
  var t = e.name;
  return t === tt.MobileSafari;
}, zo = function(e) {
  var t = e.name;
  return t === tt.Opera;
}, Uo = function(e) {
  var t = e.name;
  return t === tt.InternetExplorer || t === tt.Ie;
}, qo = function(e) {
  var t = e.name;
  return t === tt.MIUI;
}, Yo = function(e) {
  var t = e.name;
  return t === tt.SamsungBrowser;
}, Vo = function(e) {
  var t = e.version;
  return K(t);
}, Go = function(e) {
  var t = e.major;
  return K(t);
}, Qo = function(e) {
  var t = e.name;
  return K(t);
}, Xo = function(e) {
  var t = e.name;
  return K(t);
}, Ko = function(e) {
  var t = e.version;
  return K(t);
}, Zo = function() {
  var e = va(), t = e && e.userAgent && e.userAgent.toLowerCase();
  return typeof t == "string" ? /electron/.test(t) : !1;
}, kn = function(e) {
  return typeof e == "string" && e.indexOf("Edg/") !== -1;
}, Jo = function() {
  var e = va();
  return e && (/iPad|iPhone|iPod/.test(e.platform) || e.platform === "MacIntel" && e.maxTouchPoints > 1) && !window.MSStream;
}, Et = function() {
  return ya("iPad");
}, es = function() {
  return ya("iPhone");
}, ts = function() {
  return ya("iPod");
}, ns = function(e) {
  return K(e);
};
function rs(n) {
  var e = n || vo, t = e.device, r = e.browser, a = e.os, i = e.engine, s = e.ua;
  return {
    isSmartTV: To(t),
    isConsole: Po(t),
    isWearable: Oo(t),
    isEmbedded: jo(t),
    isMobileSafari: Ho(r) || Et(),
    isChromium: Bo(r),
    isMobile: ko(t) || Et(),
    isMobileOnly: yo(t),
    isTablet: xo(t) || Et(),
    isBrowser: hr(t),
    isDesktop: hr(t),
    isAndroid: No(a),
    isWinPhone: _o(a),
    isIOS: Do(a) || Et(),
    isChrome: Wo(r),
    isFirefox: $o(r),
    isSafari: Ro(r),
    isOpera: zo(r),
    isIE: Uo(r),
    osVersion: Co(a),
    osName: Lo(a),
    fullBrowserVersion: Vo(r),
    browserVersion: Go(r),
    browserName: Qo(r),
    mobileVendor: Eo(t),
    mobileModel: So(t),
    engineName: Xo(i),
    engineVersion: Ko(i),
    getUA: ns(s),
    isEdge: fr(r) || kn(s),
    isYandex: Fo(r),
    deviceType: Ao(t),
    isIOS13: Jo(),
    isIPad13: Et(),
    isIPhone13: es(),
    isIPod13: ts(),
    isElectron: Zo(),
    isEdgeChromium: kn(s),
    isLegacyEdge: fr(r) && !kn(s),
    isWindows: Io(a),
    isMacOs: Mo(a),
    isMIUI: qo(r),
    isSamsungBrowser: Yo(r)
  };
}
var as = To(lt), is = Po(lt), os = Oo(lt), Ou = jo(lt), Pu = Ho(Qe) || Et(), ju = Bo(Qe), Ar = ko(lt) || Et(), ss = yo(lt), cs = xo(lt) || Et(), us = hr(lt), Eu = hr(lt), ls = No(tn), ds = _o(tn), ms = Do(tn) || Et(), Su = Wo(Qe), Au = $o(Qe), Nu = Ro(Qe), Iu = zo(Qe), hs = Uo(Qe), Mu = Co(tn), _u = Lo(tn), Du = Vo(Qe), Cu = Go(Qe), Lu = Qo(Qe), Wu = Eo(lt), $u = So(lt), Bu = Xo(wa), Fu = Ko(wa), Ru = ns(er), Hu = fr(Qe) || kn(er), zu = Fo(Qe), Uu = Ao(lt), qu = Jo(), Yu = Et(), Vu = es(), Gu = ts(), Qu = Zo(), Xu = kn(er), Ku = fr(Qe) && !kn(er), Zu = Io(tn), Ju = Mo(tn), el = qo(Qe), tl = Yo(Qe), nl = function(e) {
  if (!e || typeof e != "string") {
    console.error("No valid user agent string was provided");
    return;
  }
  var t = tr(e), r = t.device, a = t.browser, i = t.os, s = t.engine, u = t.ua;
  return rs({
    device: r,
    browser: a,
    os: i,
    engine: s,
    ua: u
  });
}, rl = function(e) {
  var t = e.renderWithFragment, r = e.children, a = gt(e, ["renderWithFragment", "children"]);
  return ls ? t ? ge.createElement(Ve.Fragment, null, r) : ge.createElement("div", a, r) : null;
}, al = function(e) {
  var t = e.renderWithFragment, r = e.children, a = gt(e, ["renderWithFragment", "children"]);
  return us ? t ? ge.createElement(Ve.Fragment, null, r) : ge.createElement("div", a, r) : null;
}, il = function(e) {
  var t = e.renderWithFragment, r = e.children, a = gt(e, ["renderWithFragment", "children"]);
  return hs ? t ? ge.createElement(Ve.Fragment, null, r) : ge.createElement("div", a, r) : null;
}, ol = function(e) {
  var t = e.renderWithFragment, r = e.children, a = gt(e, ["renderWithFragment", "children"]);
  return ms ? t ? ge.createElement(Ve.Fragment, null, r) : ge.createElement("div", a, r) : null;
}, sl = function(e) {
  var t = e.renderWithFragment, r = e.children, a = gt(e, ["renderWithFragment", "children"]);
  return Ar ? t ? ge.createElement(Ve.Fragment, null, r) : ge.createElement("div", a, r) : null;
}, cl = function(e) {
  var t = e.renderWithFragment, r = e.children, a = gt(e, ["renderWithFragment", "children"]);
  return cs ? t ? ge.createElement(Ve.Fragment, null, r) : ge.createElement("div", a, r) : null;
}, ul = function(e) {
  var t = e.renderWithFragment, r = e.children, a = gt(e, ["renderWithFragment", "children"]);
  return ds ? t ? ge.createElement(Ve.Fragment, null, r) : ge.createElement("div", a, r) : null;
}, ll = function(e) {
  var t = e.renderWithFragment, r = e.children;
  e.viewClassName, e.style;
  var a = gt(e, ["renderWithFragment", "children", "viewClassName", "style"]);
  return ss ? t ? ge.createElement(Ve.Fragment, null, r) : ge.createElement("div", a, r) : null;
}, dl = function(e) {
  var t = e.renderWithFragment, r = e.children, a = gt(e, ["renderWithFragment", "children"]);
  return as ? t ? ge.createElement(Ve.Fragment, null, r) : ge.createElement("div", a, r) : null;
}, ml = function(e) {
  var t = e.renderWithFragment, r = e.children, a = gt(e, ["renderWithFragment", "children"]);
  return is ? t ? ge.createElement(Ve.Fragment, null, r) : ge.createElement("div", a, r) : null;
}, hl = function(e) {
  var t = e.renderWithFragment, r = e.children, a = gt(e, ["renderWithFragment", "children"]);
  return os ? t ? ge.createElement(Ve.Fragment, null, r) : ge.createElement("div", a, r) : null;
}, fl = function(e) {
  var t = e.renderWithFragment, r = e.children;
  e.viewClassName, e.style;
  var a = e.condition, i = gt(e, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);
  return a ? t ? ge.createElement(Ve.Fragment, null, r) : ge.createElement("div", i, r) : null;
};
function pl(n) {
  return /* @__PURE__ */ function(e) {
    su(t, e);
    function t(r) {
      var a;
      return au(this, t), a = uu(this, ea(t).call(this, r)), a.isEventListenerAdded = !1, a.handleOrientationChange = a.handleOrientationChange.bind(lr(a)), a.onOrientationChange = a.onOrientationChange.bind(lr(a)), a.onPageLoad = a.onPageLoad.bind(lr(a)), a.state = {
        isLandscape: !1,
        isPortrait: !1
      }, a;
    }
    return iu(t, [{
      key: "handleOrientationChange",
      value: function() {
        this.isEventListenerAdded || (this.isEventListenerAdded = !0);
        var a = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: a === 0,
          isLandscape: a === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function() {
        (typeof window == "undefined" ? "undefined" : Yn(window)) !== void 0 && Ar && (this.isEventListenerAdded ? window.removeEventListener("load", this.onPageLoad, !1) : (this.handleOrientationChange(), window.addEventListener("load", this.onPageLoad, !1)), window.addEventListener("resize", this.onOrientationChange, !1));
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        window.removeEventListener("resize", this.onOrientationChange, !1);
      }
    }, {
      key: "render",
      value: function() {
        return ge.createElement(n, Jr({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]), t;
  }(ge.Component);
}
function gl() {
  var n = Ve.useState(function() {
    var i = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: i === 0,
      isLandscape: i === 90,
      orientation: i === 0 ? "portrait" : "landscape"
    };
  }), e = lu(n, 2), t = e[0], r = e[1], a = Ve.useCallback(function() {
    var i = window.innerWidth > window.innerHeight ? 90 : 0, s = {
      isPortrait: i === 0,
      isLandscape: i === 90,
      orientation: i === 0 ? "portrait" : "landscape"
    };
    t.orientation !== s.orientation && r(s);
  }, [t.orientation]);
  return Ve.useEffect(function() {
    return (typeof window == "undefined" ? "undefined" : Yn(window)) !== void 0 && Ar && (a(), window.addEventListener("load", a, !1), window.addEventListener("resize", a, !1)), function() {
      window.removeEventListener("resize", a, !1), window.removeEventListener("load", a, !1);
    };
  }, [a]), t;
}
function fs(n) {
  var e = n || window.navigator.userAgent;
  return tr(e);
}
function bl(n) {
  var e = n || window.navigator.userAgent, t = fs(e), r = rs(t);
  return [r, t];
}
D.AndroidView = rl;
D.BrowserTypes = tt;
D.BrowserView = al;
D.ConsoleView = ml;
D.CustomView = fl;
D.IEView = il;
D.IOSView = ol;
D.MobileOnlyView = ll;
D.MobileView = sl;
D.OsTypes = Dn;
D.SmartTVView = dl;
D.TabletView = cl;
D.WearableView = hl;
D.WinPhoneView = ul;
D.browserName = Lu;
D.browserVersion = Cu;
D.deviceDetect = Tu;
D.deviceType = Uu;
D.engineName = Bu;
D.engineVersion = Fu;
D.fullBrowserVersion = Du;
D.getSelectorsByUserAgent = nl;
D.getUA = Ru;
D.isAndroid = ls;
D.isBrowser = us;
D.isChrome = Su;
D.isChromium = ju;
D.isConsole = is;
D.isDesktop = Eu;
D.isEdge = Hu;
D.isEdgeChromium = Xu;
D.isElectron = Qu;
D.isEmbedded = Ou;
D.isFirefox = Au;
D.isIE = hs;
D.isIOS = ms;
D.isIOS13 = qu;
D.isIPad13 = Yu;
D.isIPhone13 = Vu;
D.isIPod13 = Gu;
D.isLegacyEdge = Ku;
D.isMIUI = el;
D.isMacOs = Ju;
var Tn = D.isMobile = Ar;
D.isMobileOnly = ss;
D.isMobileSafari = Pu;
D.isOpera = Iu;
D.isSafari = Nu;
D.isSamsungBrowser = tl;
D.isSmartTV = as;
D.isTablet = cs;
D.isWearable = os;
D.isWinPhone = ds;
D.isWindows = Zu;
D.isYandex = zu;
D.mobileModel = $u;
D.mobileVendor = Wu;
D.osName = _u;
D.osVersion = Mu;
D.parseUserAgent = tr;
D.setUserAgent = bu;
D.useDeviceData = fs;
D.useDeviceSelectors = bl;
D.useMobileOrientation = gl;
D.withOrientationChange = pl;
const Nr = ({ buyHw: n, disableBuyWithTariff: e }) => {
  const { unionText: t } = J();
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    !e && /* @__PURE__ */ o.jsx("div", { className: "mb-2", children: /* @__PURE__ */ o.jsx(
      ve,
      {
        "data-o2-id": "hw-detail-pricing-buy-with-tariff",
        "data-testid": "hw-detail-pricing-buy-with-tariff",
        name: "hw-detail-pricing-buy-with-tariff",
        fullwidth: !0,
        onClick: () => n(!0),
        children: t.detail.buyWithTariffBtn
      }
    ) }),
    /* @__PURE__ */ o.jsx(
      ve,
      {
        "data-o2-id": "hw-detail-pricing-buy-without-tariff",
        "data-testid": "hw-detail-pricing-buy-without-tariff",
        name: "hw-detail-pricing-buy-without-tariff",
        usage: "outlined",
        onClick: () => n(!1),
        fullwidth: !0,
        children: t.detail.buyWithoutTariffBtn
      }
    )
  ] });
}, ps = 13, hi = 5, xa = ["O2_EXTRA", "SMARTWATCH", "MOBILE_PHONES", "TABLETS", "ACCESSORIES"], wl = "2022-04-08T13:00:00+02:00", vl = [
  "DISPLAYNAME_ASC",
  "ONETIMEPRICE_ASC",
  "ONETIMEPRICE_DESC",
  "SKUPOPULARITY_DESC",
  "ACTIVESTARTDATE_DESC"
], gs = "DEVICE_COLOR", Xt = "SKESH.00003.00001", yl = "P007:SK02", fi = 2, xl = {
  telefony: "MOBILE_PHONES",
  "mobile-phones": "MOBILE_PHONES",
  phones: "MOBILE_PHONES",
  tablets: "TABLETS",
  "smart-watches": "SMARTWATCH",
  accessories: "ACCESSORIES",
  extra: "O2_EXTRA"
}, nr = [
  "LTE",
  "GPS",
  "IRDA",
  "NFC",
  "BLUETOOTH",
  "WIFI",
  "Volte",
  "WIRELESS_CHARGING",
  "VoWiFi",
  "DUAL_SIM",
  "FINGERPRINT",
  "BLUETOOTH_BOOL",
  "WIFI_BOOL",
  "5G",
  "ESIM"
], ka = {
  newest: "ACTIVESTARTDATE_DESC",
  mostExpensive: "ONETIMEPRICE_DESC",
  cheapest: "ONETIMEPRICE_ASC"
}, kl = "product.defaultCategory", Lr = "HW_GROUPING", or = "DEVICE_COLOR", sr = "INTERNAL_STORAGE", pi = "DISPLAY_WATCH_SIZE", Tl = "/ponuka/telefony-a-zariadenia", na = "isHwInsuranceSelected", Ol = "/e-shop/nakup/#/", gi = "paymentMethod", bi = {
  MOBILE: "o2mobil",
  CASH: "cash"
}, Pl = "contextTariff", vn = {
  HW_CONTEXT: "contextHw",
  HW_INSURANCE: "hwInsurance",
  PROMO_CODE: "promoCode",
  TRANSACTION: "transaction",
  PAYMENT_METHOD: "paymentMethod",
  CONTEXT_TARIFF: "contextTariff"
};
var jl = Object.defineProperty, El = Object.defineProperties, Sl = Object.getOwnPropertyDescriptors, wi = Object.getOwnPropertySymbols, Al = Object.prototype.hasOwnProperty, Nl = Object.prototype.propertyIsEnumerable, ra = (n, e, t) => e in n ? jl(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, bs = (n, e) => {
  for (var t in e || (e = {}))
    Al.call(e, t) && ra(n, t, e[t]);
  if (wi)
    for (var t of wi(e))
      Nl.call(e, t) && ra(n, t, e[t]);
  return n;
}, Il = (n, e) => El(n, Sl(e)), L = (n, e, t) => (ra(n, typeof e != "symbol" ? e + "" : e, t), t), Ze = /* @__PURE__ */ ((n) => (n.ESHOP_AVAILABLEINESHOP = "ESHOP_AVAILABLEINESHOP", n.ESHOP_AVAILABLEOUTSIDEESHOP = "ESHOP_AVAILABLEOUTSIDEESHOP", n.ESHOP_UNAVAILABLE = "ESHOP_UNAVAILABLE", n.SHOP_AVAILABLE = "SHOP_AVAILABLE", n.SHOP_AVAILABLEINESHOP = "SHOP_AVAILABLEINESHOP", n.SHOP_AVAILABLEOUTSIDEESHOP = "SHOP_AVAILABLEOUTSIDEESHOP", n.SHOP_UNAVAILABLE = "SHOP_UNAVAILABLE", n))(Ze || {});
const Ta = ({
  selectedOrganization: n = "",
  selectedOrganizationStockId: e = "",
  stockAvailability: t = [],
  stockAvailabilitySummary: r = "unavailable"
}) => {
  if (!n || !e)
    switch (r) {
      case "availableInEshop":
        return Ze.ESHOP_AVAILABLEINESHOP;
      case "availableOutsideEshop":
        return Ze.ESHOP_AVAILABLEOUTSIDEESHOP;
      default:
        return Ze.ESHOP_UNAVAILABLE;
    }
  if (t && t.find(
    ({ availableAmount: a, stockIdentifier: i }) => i === e && a > 0
  ))
    return Ze.SHOP_AVAILABLE;
  switch (r) {
    case "availableInEshop":
      return Ze.SHOP_AVAILABLEINESHOP;
    case "availableOutsideEshop":
      return Ze.SHOP_AVAILABLEOUTSIDEESHOP;
    default:
      return Ze.SHOP_UNAVAILABLE;
  }
}, ws = 6048e5, Ml = 864e5, _l = 6e4, Dl = 36e5, Cl = 1e3, vi = Symbol.for("constructDateFrom");
function nt(n, e) {
  return typeof n == "function" ? n(e) : n && typeof n == "object" && vi in n ? n[vi](e) : n instanceof Date ? new n.constructor(e) : new Date(e);
}
function He(n, e) {
  return nt(e || n, n);
}
function vs(n, e, t) {
  const r = He(n, t == null ? void 0 : t.in);
  return isNaN(e) ? nt((t == null ? void 0 : t.in) || n, NaN) : (e && r.setDate(r.getDate() + e), r);
}
let Ll = {};
function rr() {
  return Ll;
}
function Ft(n, e) {
  var t, r, a, i, s, u, m, f;
  const p = rr(), d = (f = (m = (i = (a = e == null ? void 0 : e.weekStartsOn) != null ? a : (r = (t = e == null ? void 0 : e.locale) == null ? void 0 : t.options) == null ? void 0 : r.weekStartsOn) != null ? i : p.weekStartsOn) != null ? m : (u = (s = p.locale) == null ? void 0 : s.options) == null ? void 0 : u.weekStartsOn) != null ? f : 0, c = He(n, e == null ? void 0 : e.in), l = c.getDay(), h = (l < d ? 7 : 0) + l - d;
  return c.setDate(c.getDate() - h), c.setHours(0, 0, 0, 0), c;
}
function Nn(n, e) {
  return Ft(n, Il(bs({}, e), { weekStartsOn: 1 }));
}
function ys(n, e) {
  const t = He(n, e == null ? void 0 : e.in), r = t.getFullYear(), a = nt(t, 0);
  a.setFullYear(r + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const i = Nn(a), s = nt(t, 0);
  s.setFullYear(r, 0, 4), s.setHours(0, 0, 0, 0);
  const u = Nn(s);
  return t.getTime() >= i.getTime() ? r + 1 : t.getTime() >= u.getTime() ? r : r - 1;
}
function pr(n) {
  const e = He(n), t = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return t.setUTCFullYear(e.getFullYear()), +n - +t;
}
function xs(n, ...e) {
  const t = nt.bind(
    null,
    n || e.find((r) => typeof r == "object")
  );
  return e.map(t);
}
function yi(n, e) {
  const t = He(n, e == null ? void 0 : e.in);
  return t.setHours(0, 0, 0, 0), t;
}
function Wl(n, e, t) {
  const [r, a] = xs(
    t == null ? void 0 : t.in,
    n,
    e
  ), i = yi(r), s = yi(a), u = +i - pr(i), m = +s - pr(s);
  return Math.round((u - m) / Ml);
}
function $l(n, e) {
  const t = ys(n, e), r = nt((e == null ? void 0 : e.in) || n, 0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), Nn(r);
}
function Bl(n) {
  return n instanceof Date || typeof n == "object" && Object.prototype.toString.call(n) === "[object Date]";
}
function Fl(n) {
  return !(!Bl(n) && typeof n != "number" || isNaN(+He(n)));
}
function Rl(n, e) {
  const t = He(n, e == null ? void 0 : e.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
const Hl = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, zl = (n, e, t) => {
  let r;
  const a = Hl[n];
  return typeof a == "string" ? r = a : e === 1 ? r = a.one : r = a.other.replace("{{count}}", e.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + r : r + " ago" : r;
};
function On(n) {
  return (e = {}) => {
    const t = e.width ? String(e.width) : n.defaultWidth;
    return n.formats[t] || n.formats[n.defaultWidth];
  };
}
const Ul = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, ql = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Yl = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Vl = {
  date: On({
    formats: Ul,
    defaultWidth: "full"
  }),
  time: On({
    formats: ql,
    defaultWidth: "full"
  }),
  dateTime: On({
    formats: Yl,
    defaultWidth: "full"
  })
}, Gl = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Ql = (n, e, t, r) => Gl[n];
function St(n) {
  return (e, t) => {
    const r = t != null && t.context ? String(t.context) : "standalone";
    let a;
    if (r === "formatting" && n.formattingValues) {
      const s = n.defaultFormattingWidth || n.defaultWidth, u = t != null && t.width ? String(t.width) : s;
      a = n.formattingValues[u] || n.formattingValues[s];
    } else {
      const s = n.defaultWidth, u = t != null && t.width ? String(t.width) : n.defaultWidth;
      a = n.values[u] || n.values[s];
    }
    const i = n.argumentCallback ? n.argumentCallback(e) : e;
    return a[i];
  };
}
const Xl = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Kl = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Zl = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Jl = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, ed = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, td = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, nd = (n, e) => {
  const t = Number(n), r = t % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, rd = {
  ordinalNumber: nd,
  era: St({
    values: Xl,
    defaultWidth: "wide"
  }),
  quarter: St({
    values: Kl,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: St({
    values: Zl,
    defaultWidth: "wide"
  }),
  day: St({
    values: Jl,
    defaultWidth: "wide"
  }),
  dayPeriod: St({
    values: ed,
    defaultWidth: "wide",
    formattingValues: td,
    defaultFormattingWidth: "wide"
  })
};
function At(n) {
  return (e, t = {}) => {
    const r = t.width, a = r && n.matchPatterns[r] || n.matchPatterns[n.defaultMatchWidth], i = e.match(a);
    if (!i)
      return null;
    const s = i[0], u = r && n.parsePatterns[r] || n.parsePatterns[n.defaultParseWidth], m = Array.isArray(u) ? id(u, (d) => d.test(s)) : (
      // [TODO] -- I challenge you to fix the type
      ad(u, (d) => d.test(s))
    );
    let f;
    f = n.valueCallback ? n.valueCallback(m) : m, f = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(f)
    ) : f;
    const p = e.slice(s.length);
    return { value: f, rest: p };
  };
}
function ad(n, e) {
  for (const t in n)
    if (Object.prototype.hasOwnProperty.call(n, t) && e(n[t]))
      return t;
}
function id(n, e) {
  for (let t = 0; t < n.length; t++)
    if (e(n[t]))
      return t;
}
function ks(n) {
  return (e, t = {}) => {
    const r = e.match(n.matchPattern);
    if (!r)
      return null;
    const a = r[0], i = e.match(n.parsePattern);
    if (!i)
      return null;
    let s = n.valueCallback ? n.valueCallback(i[0]) : i[0];
    s = t.valueCallback ? t.valueCallback(s) : s;
    const u = e.slice(a.length);
    return { value: s, rest: u };
  };
}
const od = /^(\d+)(th|st|nd|rd)?/i, sd = /\d+/i, cd = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, ud = {
  any: [/^b/i, /^(a|c)/i]
}, ld = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, dd = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, md = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, hd = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, fd = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, pd = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, gd = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, bd = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, wd = {
  ordinalNumber: ks({
    matchPattern: od,
    parsePattern: sd,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: At({
    matchPatterns: cd,
    defaultMatchWidth: "wide",
    parsePatterns: ud,
    defaultParseWidth: "any"
  }),
  quarter: At({
    matchPatterns: ld,
    defaultMatchWidth: "wide",
    parsePatterns: dd,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: At({
    matchPatterns: md,
    defaultMatchWidth: "wide",
    parsePatterns: hd,
    defaultParseWidth: "any"
  }),
  day: At({
    matchPatterns: fd,
    defaultMatchWidth: "wide",
    parsePatterns: pd,
    defaultParseWidth: "any"
  }),
  dayPeriod: At({
    matchPatterns: gd,
    defaultMatchWidth: "any",
    parsePatterns: bd,
    defaultParseWidth: "any"
  })
}, vd = {
  code: "en-US",
  formatDistance: zl,
  formatLong: Vl,
  formatRelative: Ql,
  localize: rd,
  match: wd,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function yd(n, e) {
  const t = He(n, e == null ? void 0 : e.in);
  return Wl(t, Rl(t)) + 1;
}
function Ts(n, e) {
  const t = He(n, e == null ? void 0 : e.in), r = +Nn(t) - +$l(t);
  return Math.round(r / ws) + 1;
}
function Oa(n, e) {
  var t, r, a, i, s, u, m, f;
  const p = He(n, e == null ? void 0 : e.in), d = p.getFullYear(), c = rr(), l = (f = (m = (i = (a = e == null ? void 0 : e.firstWeekContainsDate) != null ? a : (r = (t = e == null ? void 0 : e.locale) == null ? void 0 : t.options) == null ? void 0 : r.firstWeekContainsDate) != null ? i : c.firstWeekContainsDate) != null ? m : (u = (s = c.locale) == null ? void 0 : s.options) == null ? void 0 : u.firstWeekContainsDate) != null ? f : 1, h = nt((e == null ? void 0 : e.in) || n, 0);
  h.setFullYear(d + 1, 0, l), h.setHours(0, 0, 0, 0);
  const g = Ft(h, e), b = nt((e == null ? void 0 : e.in) || n, 0);
  b.setFullYear(d, 0, l), b.setHours(0, 0, 0, 0);
  const w = Ft(b, e);
  return +p >= +g ? d + 1 : +p >= +w ? d : d - 1;
}
function xd(n, e) {
  var t, r, a, i, s, u, m, f;
  const p = rr(), d = (f = (m = (i = (a = e == null ? void 0 : e.firstWeekContainsDate) != null ? a : (r = (t = e == null ? void 0 : e.locale) == null ? void 0 : t.options) == null ? void 0 : r.firstWeekContainsDate) != null ? i : p.firstWeekContainsDate) != null ? m : (u = (s = p.locale) == null ? void 0 : s.options) == null ? void 0 : u.firstWeekContainsDate) != null ? f : 1, c = Oa(n, e), l = nt((e == null ? void 0 : e.in) || n, 0);
  return l.setFullYear(c, 0, d), l.setHours(0, 0, 0, 0), Ft(l, e);
}
function Os(n, e) {
  const t = He(n, e == null ? void 0 : e.in), r = +Ft(t, e) - +xd(t, e);
  return Math.round(r / ws) + 1;
}
function me(n, e) {
  const t = n < 0 ? "-" : "", r = Math.abs(n).toString().padStart(e, "0");
  return t + r;
}
const Yt = {
  // Year
  y(n, e) {
    const t = n.getFullYear(), r = t > 0 ? t : 1 - t;
    return me(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(n, e) {
    const t = n.getMonth();
    return e === "M" ? String(t + 1) : me(t + 1, 2);
  },
  // Day of the month
  d(n, e) {
    return me(n.getDate(), e.length);
  },
  // AM or PM
  a(n, e) {
    const t = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(n, e) {
    return me(n.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(n, e) {
    return me(n.getHours(), e.length);
  },
  // Minute
  m(n, e) {
    return me(n.getMinutes(), e.length);
  },
  // Second
  s(n, e) {
    return me(n.getSeconds(), e.length);
  },
  // Fraction of second
  S(n, e) {
    const t = e.length, r = n.getMilliseconds(), a = Math.trunc(
      r * Math.pow(10, t - 3)
    );
    return me(a, e.length);
  }
}, yn = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, xi = {
  // Era
  G: function(n, e, t) {
    const r = n.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(r, { width: "abbreviated" });
      case "GGGGG":
        return t.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(n, e, t) {
    if (e === "yo") {
      const r = n.getFullYear(), a = r > 0 ? r : 1 - r;
      return t.ordinalNumber(a, { unit: "year" });
    }
    return Yt.y(n, e);
  },
  // Local week-numbering year
  Y: function(n, e, t, r) {
    const a = Oa(n, r), i = a > 0 ? a : 1 - a;
    if (e === "YY") {
      const s = i % 100;
      return me(s, 2);
    }
    return e === "Yo" ? t.ordinalNumber(i, { unit: "year" }) : me(i, e.length);
  },
  // ISO week-numbering year
  R: function(n, e) {
    const t = ys(n);
    return me(t, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, e) {
    const t = n.getFullYear();
    return me(t, e.length);
  },
  // Quarter
  Q: function(n, e, t) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(r);
      case "QQ":
        return me(r, 2);
      case "Qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return t.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, e, t) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(r);
      case "qq":
        return me(r, 2);
      case "qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return t.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, e, t) {
    const r = n.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Yt.M(n, e);
      case "Mo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return t.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(n, e, t) {
    const r = n.getMonth();
    switch (e) {
      case "L":
        return String(r + 1);
      case "LL":
        return me(r + 1, 2);
      case "Lo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return t.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(n, e, t, r) {
    const a = Os(n, r);
    return e === "wo" ? t.ordinalNumber(a, { unit: "week" }) : me(a, e.length);
  },
  // ISO week of year
  I: function(n, e, t) {
    const r = Ts(n);
    return e === "Io" ? t.ordinalNumber(r, { unit: "week" }) : me(r, e.length);
  },
  // Day of the month
  d: function(n, e, t) {
    return e === "do" ? t.ordinalNumber(n.getDate(), { unit: "date" }) : Yt.d(n, e);
  },
  // Day of year
  D: function(n, e, t) {
    const r = yd(n);
    return e === "Do" ? t.ordinalNumber(r, { unit: "dayOfYear" }) : me(r, e.length);
  },
  // Day of week
  E: function(n, e, t) {
    const r = n.getDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, e, t, r) {
    const a = n.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(i);
      case "ee":
        return me(i, 2);
      case "eo":
        return t.ordinalNumber(i, { unit: "day" });
      case "eee":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, e, t, r) {
    const a = n.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(i);
      case "cc":
        return me(i, e.length);
      case "co":
        return t.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return t.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, e, t) {
    const r = n.getDay(), a = r === 0 ? 7 : r;
    switch (e) {
      case "i":
        return String(a);
      case "ii":
        return me(a, e.length);
      case "io":
        return t.ordinalNumber(a, { unit: "day" });
      case "iii":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, e, t) {
    const r = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, e, t) {
    const r = n.getHours();
    let a;
    switch (r === 12 ? a = yn.noon : r === 0 ? a = yn.midnight : a = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, e, t) {
    const r = n.getHours();
    let a;
    switch (r >= 17 ? a = yn.evening : r >= 12 ? a = yn.afternoon : r >= 4 ? a = yn.morning : a = yn.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, e, t) {
    if (e === "ho") {
      let r = n.getHours() % 12;
      return r === 0 && (r = 12), t.ordinalNumber(r, { unit: "hour" });
    }
    return Yt.h(n, e);
  },
  // Hour [0-23]
  H: function(n, e, t) {
    return e === "Ho" ? t.ordinalNumber(n.getHours(), { unit: "hour" }) : Yt.H(n, e);
  },
  // Hour [0-11]
  K: function(n, e, t) {
    const r = n.getHours() % 12;
    return e === "Ko" ? t.ordinalNumber(r, { unit: "hour" }) : me(r, e.length);
  },
  // Hour [1-24]
  k: function(n, e, t) {
    let r = n.getHours();
    return r === 0 && (r = 24), e === "ko" ? t.ordinalNumber(r, { unit: "hour" }) : me(r, e.length);
  },
  // Minute
  m: function(n, e, t) {
    return e === "mo" ? t.ordinalNumber(n.getMinutes(), { unit: "minute" }) : Yt.m(n, e);
  },
  // Second
  s: function(n, e, t) {
    return e === "so" ? t.ordinalNumber(n.getSeconds(), { unit: "second" }) : Yt.s(n, e);
  },
  // Fraction of second
  S: function(n, e) {
    return Yt.S(n, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, e, t) {
    const r = n.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      case "X":
        return Ti(r);
      case "XXXX":
      case "XX":
        return cn(r);
      case "XXXXX":
      case "XXX":
      default:
        return cn(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      case "x":
        return Ti(r);
      case "xxxx":
      case "xx":
        return cn(r);
      case "xxxxx":
      case "xxx":
      default:
        return cn(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ki(r, ":");
      case "OOOO":
      default:
        return "GMT" + cn(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + ki(r, ":");
      case "zzzz":
      default:
        return "GMT" + cn(r, ":");
    }
  },
  // Seconds timestamp
  t: function(n, e, t) {
    const r = Math.trunc(+n / 1e3);
    return me(r, e.length);
  },
  // Milliseconds timestamp
  T: function(n, e, t) {
    return me(+n, e.length);
  }
};
function ki(n, e = "") {
  const t = n > 0 ? "-" : "+", r = Math.abs(n), a = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? t + String(a) : t + String(a) + e + me(i, 2);
}
function Ti(n, e) {
  return n % 60 === 0 ? (n > 0 ? "-" : "+") + me(Math.abs(n) / 60, 2) : cn(n, e);
}
function cn(n, e = "") {
  const t = n > 0 ? "-" : "+", r = Math.abs(n), a = me(Math.trunc(r / 60), 2), i = me(r % 60, 2);
  return t + a + e + i;
}
const Oi = (n, e) => {
  switch (n) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, Ps = (n, e) => {
  switch (n) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, kd = (n, e) => {
  const t = n.match(/(P+)(p+)?/) || [], r = t[1], a = t[2];
  if (!a)
    return Oi(n, e);
  let i;
  switch (r) {
    case "P":
      i = e.dateTime({ width: "short" });
      break;
    case "PP":
      i = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = e.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Oi(r, e)).replace("{{time}}", Ps(a, e));
}, Td = {
  p: Ps,
  P: kd
}, Od = /^D+$/, Pd = /^Y+$/, jd = ["D", "DD", "YY", "YYYY"];
function Ed(n) {
  return Od.test(n);
}
function Sd(n) {
  return Pd.test(n);
}
function Ad(n, e, t) {
  const r = Nd(n, e, t);
  if (console.warn(r), jd.includes(n))
    throw new RangeError(r);
}
function Nd(n, e, t) {
  const r = n[0] === "Y" ? "years" : "days of the month";
  return `Use \`${n.toLowerCase()}\` instead of \`${n}\` (in \`${e}\`) for formatting ${r} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Id = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Md = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, _d = /^'([^]*?)'?$/, Dd = /''/g, Cd = /[a-zA-Z]/;
function Ld(n, e, t) {
  var r, a, i, s, u, m, f, p, d, c, l, h, g, b, w, y, v, x;
  const T = rr(), j = (a = (r = t == null ? void 0 : t.locale) != null ? r : T.locale) != null ? a : vd, A = (c = (d = (m = (u = t == null ? void 0 : t.firstWeekContainsDate) != null ? u : (s = (i = t == null ? void 0 : t.locale) == null ? void 0 : i.options) == null ? void 0 : s.firstWeekContainsDate) != null ? m : T.firstWeekContainsDate) != null ? d : (p = (f = T.locale) == null ? void 0 : f.options) == null ? void 0 : p.firstWeekContainsDate) != null ? c : 1, N = (x = (v = (b = (g = t == null ? void 0 : t.weekStartsOn) != null ? g : (h = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : h.weekStartsOn) != null ? b : T.weekStartsOn) != null ? v : (y = (w = T.locale) == null ? void 0 : w.options) == null ? void 0 : y.weekStartsOn) != null ? x : 0, S = He(n, t == null ? void 0 : t.in);
  if (!Fl(S))
    throw new RangeError("Invalid time value");
  let E = e.match(Md).map((M) => {
    const O = M[0];
    if (O === "p" || O === "P") {
      const I = Td[O];
      return I(M, j.formatLong);
    }
    return M;
  }).join("").match(Id).map((M) => {
    if (M === "''")
      return { isToken: !1, value: "'" };
    const O = M[0];
    if (O === "'")
      return { isToken: !1, value: Wd(M) };
    if (xi[O])
      return { isToken: !0, value: M };
    if (O.match(Cd))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + O + "`"
      );
    return { isToken: !1, value: M };
  });
  j.localize.preprocessor && (E = j.localize.preprocessor(S, E));
  const k = {
    firstWeekContainsDate: A,
    weekStartsOn: N,
    locale: j
  };
  return E.map((M) => {
    if (!M.isToken)
      return M.value;
    const O = M.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && Sd(O) || !(t != null && t.useAdditionalDayOfYearTokens) && Ed(O)) && Ad(O, e, String(n));
    const I = xi[O[0]];
    return I(S, O, j.localize, k);
  }).join("");
}
function Wd(n) {
  const e = n.match(_d);
  return e ? e[1].replace(Dd, "'") : n;
}
function $d(n, e) {
  const t = He(n, e == null ? void 0 : e.in).getDay();
  return t === 0 ? 7 : t;
}
let Bd = class {
  constructor() {
    L(this, "subPriority", 0);
  }
  validate(e, t) {
    return !0;
  }
};
class Fd extends Bd {
  constructor(e, t, r, a, i) {
    super(), this.value = e, this.validateValue = t, this.setValue = r, this.priority = a, i && (this.subPriority = i);
  }
  validate(e, t) {
    return this.validateValue(e, this.value, t);
  }
  set(e, t, r) {
    return this.setValue(e, t, this.value, r);
  }
}
class ue {
  run(e, t, r, a) {
    const i = this.parse(e, t, r, a);
    return i ? {
      setter: new Fd(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(e, t, r) {
    return !0;
  }
}
class Rd extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 140), L(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(e, { width: "abbreviated" }) || r.era(e, { width: "narrow" });
      case "GGGGG":
        return r.era(e, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(e, { width: "wide" }) || r.era(e, { width: "abbreviated" }) || r.era(e, { width: "narrow" });
    }
  }
  set(e, t, r) {
    return t.era = r, e.setFullYear(r, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
const Me = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Nt = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function _e(n, e) {
  return n && {
    value: e(n.value),
    rest: n.rest
  };
}
function Te(n, e) {
  const t = e.match(n);
  return t ? {
    value: parseInt(t[0], 10),
    rest: e.slice(t[0].length)
  } : null;
}
function It(n, e) {
  const t = e.match(n);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  const r = t[1] === "+" ? 1 : -1, a = t[2] ? parseInt(t[2], 10) : 0, i = t[3] ? parseInt(t[3], 10) : 0, s = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: r * (a * Dl + i * _l + s * Cl),
    rest: e.slice(t[0].length)
  };
}
function js(n) {
  return Te(Me.anyDigitsSigned, n);
}
function Se(n, e) {
  switch (n) {
    case 1:
      return Te(Me.singleDigit, e);
    case 2:
      return Te(Me.twoDigits, e);
    case 3:
      return Te(Me.threeDigits, e);
    case 4:
      return Te(Me.fourDigits, e);
    default:
      return Te(new RegExp("^\\d{1," + n + "}"), e);
  }
}
function Es(n, e) {
  switch (n) {
    case 1:
      return Te(Me.singleDigitSigned, e);
    case 2:
      return Te(Me.twoDigitsSigned, e);
    case 3:
      return Te(Me.threeDigitsSigned, e);
    case 4:
      return Te(Me.fourDigitsSigned, e);
    default:
      return Te(new RegExp("^-?\\d{1," + n + "}"), e);
  }
}
function Pa(n) {
  switch (n) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Ss(n, e) {
  const t = e > 0, r = t ? e : 1 - e;
  let a;
  if (r <= 50)
    a = n || 100;
  else {
    const i = r + 50, s = Math.trunc(i / 100) * 100, u = n >= i % 100;
    a = n + s - (u ? 100 : 0);
  }
  return t ? a : 1 - a;
}
function As(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
class Hd extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 130), L(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, t, r) {
    const a = (i) => ({
      year: i,
      isTwoDigitYear: t === "yy"
    });
    switch (t) {
      case "y":
        return _e(Se(4, e), a);
      case "yo":
        return _e(
          r.ordinalNumber(e, {
            unit: "year"
          }),
          a
        );
      default:
        return _e(Se(t.length, e), a);
    }
  }
  validate(e, t) {
    return t.isTwoDigitYear || t.year > 0;
  }
  set(e, t, r) {
    const a = e.getFullYear();
    if (r.isTwoDigitYear) {
      const s = Ss(
        r.year,
        a
      );
      return e.setFullYear(s, 0, 1), e.setHours(0, 0, 0, 0), e;
    }
    const i = !("era" in t) || t.era === 1 ? r.year : 1 - r.year;
    return e.setFullYear(i, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class zd extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 130), L(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    const a = (i) => ({
      year: i,
      isTwoDigitYear: t === "YY"
    });
    switch (t) {
      case "Y":
        return _e(Se(4, e), a);
      case "Yo":
        return _e(
          r.ordinalNumber(e, {
            unit: "year"
          }),
          a
        );
      default:
        return _e(Se(t.length, e), a);
    }
  }
  validate(e, t) {
    return t.isTwoDigitYear || t.year > 0;
  }
  set(e, t, r, a) {
    const i = Oa(e, a);
    if (r.isTwoDigitYear) {
      const u = Ss(
        r.year,
        i
      );
      return e.setFullYear(
        u,
        0,
        a.firstWeekContainsDate
      ), e.setHours(0, 0, 0, 0), Ft(e, a);
    }
    const s = !("era" in t) || t.era === 1 ? r.year : 1 - r.year;
    return e.setFullYear(s, 0, a.firstWeekContainsDate), e.setHours(0, 0, 0, 0), Ft(e, a);
  }
}
class Ud extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 130), L(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t) {
    return Es(t === "R" ? 4 : t.length, e);
  }
  set(e, t, r) {
    const a = nt(e, 0);
    return a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0), Nn(a);
  }
}
class qd extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 130), L(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, t) {
    return Es(t === "u" ? 4 : t.length, e);
  }
  set(e, t, r) {
    return e.setFullYear(r, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Yd extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 120), L(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    switch (t) {
      case "Q":
      case "QQ":
        return Se(t.length, e);
      case "Qo":
        return r.ordinalNumber(e, { unit: "quarter" });
      case "QQQ":
        return r.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(e, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 4;
  }
  set(e, t, r) {
    return e.setMonth((r - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Vd extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 120), L(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    switch (t) {
      case "q":
      case "qq":
        return Se(t.length, e);
      case "qo":
        return r.ordinalNumber(e, { unit: "quarter" });
      case "qqq":
        return r.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(e, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 4;
  }
  set(e, t, r) {
    return e.setMonth((r - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Gd extends ue {
  constructor() {
    super(...arguments), L(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]), L(this, "priority", 110);
  }
  parse(e, t, r) {
    const a = (i) => i - 1;
    switch (t) {
      case "M":
        return _e(
          Te(Me.month, e),
          a
        );
      case "MM":
        return _e(Se(2, e), a);
      case "Mo":
        return _e(
          r.ordinalNumber(e, {
            unit: "month"
          }),
          a
        );
      case "MMM":
        return r.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(e, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return r.month(e, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(e, { width: "wide", context: "formatting" }) || r.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 11;
  }
  set(e, t, r) {
    return e.setMonth(r, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Qd extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 110), L(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    const a = (i) => i - 1;
    switch (t) {
      case "L":
        return _e(
          Te(Me.month, e),
          a
        );
      case "LL":
        return _e(Se(2, e), a);
      case "Lo":
        return _e(
          r.ordinalNumber(e, {
            unit: "month"
          }),
          a
        );
      case "LLL":
        return r.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(e, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return r.month(e, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(e, { width: "wide", context: "standalone" }) || r.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 11;
  }
  set(e, t, r) {
    return e.setMonth(r, 1), e.setHours(0, 0, 0, 0), e;
  }
}
function Xd(n, e, t) {
  const r = He(n, t == null ? void 0 : t.in), a = Os(r, t) - e;
  return r.setDate(r.getDate() - a * 7), He(r, t == null ? void 0 : t.in);
}
class Kd extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 100), L(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    switch (t) {
      case "w":
        return Te(Me.week, e);
      case "wo":
        return r.ordinalNumber(e, { unit: "week" });
      default:
        return Se(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 53;
  }
  set(e, t, r, a) {
    return Ft(Xd(e, r, a), a);
  }
}
function Zd(n, e, t) {
  const r = He(n, t == null ? void 0 : t.in), a = Ts(r, t) - e;
  return r.setDate(r.getDate() - a * 7), r;
}
class Jd extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 100), L(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    switch (t) {
      case "I":
        return Te(Me.week, e);
      case "Io":
        return r.ordinalNumber(e, { unit: "week" });
      default:
        return Se(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 53;
  }
  set(e, t, r) {
    return Nn(Zd(e, r));
  }
}
const em = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], tm = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class nm extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 90), L(this, "subPriority", 1), L(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    switch (t) {
      case "d":
        return Te(Me.date, e);
      case "do":
        return r.ordinalNumber(e, { unit: "date" });
      default:
        return Se(t.length, e);
    }
  }
  validate(e, t) {
    const r = e.getFullYear(), a = As(r), i = e.getMonth();
    return a ? t >= 1 && t <= tm[i] : t >= 1 && t <= em[i];
  }
  set(e, t, r) {
    return e.setDate(r), e.setHours(0, 0, 0, 0), e;
  }
}
class rm extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 90), L(this, "subpriority", 1), L(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    switch (t) {
      case "D":
      case "DD":
        return Te(Me.dayOfYear, e);
      case "Do":
        return r.ordinalNumber(e, { unit: "date" });
      default:
        return Se(t.length, e);
    }
  }
  validate(e, t) {
    const r = e.getFullYear();
    return As(r) ? t >= 1 && t <= 366 : t >= 1 && t <= 365;
  }
  set(e, t, r) {
    return e.setMonth(0, r), e.setHours(0, 0, 0, 0), e;
  }
}
function ja(n, e, t) {
  var r, a, i, s, u, m, f, p;
  const d = rr(), c = (p = (f = (s = (i = t == null ? void 0 : t.weekStartsOn) != null ? i : (a = (r = t == null ? void 0 : t.locale) == null ? void 0 : r.options) == null ? void 0 : a.weekStartsOn) != null ? s : d.weekStartsOn) != null ? f : (m = (u = d.locale) == null ? void 0 : u.options) == null ? void 0 : m.weekStartsOn) != null ? p : 0, l = He(n, t == null ? void 0 : t.in), h = l.getDay(), g = (e % 7 + 7) % 7, b = 7 - c, w = e < 0 || e > 6 ? e - (h + b) % 7 : (g + b) % 7 - (h + b) % 7;
  return vs(l, w, t);
}
class am extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 90), L(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return r.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return r.day(e, { width: "wide", context: "formatting" }) || r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 6;
  }
  set(e, t, r, a) {
    return e = ja(e, r, a), e.setHours(0, 0, 0, 0), e;
  }
}
class im extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 90), L(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, r, a) {
    const i = (s) => {
      const u = Math.floor((s - 1) / 7) * 7;
      return (s + a.weekStartsOn + 6) % 7 + u;
    };
    switch (t) {
      case "e":
      case "ee":
        return _e(Se(t.length, e), i);
      case "eo":
        return _e(
          r.ordinalNumber(e, {
            unit: "day"
          }),
          i
        );
      case "eee":
        return r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      case "eeeee":
        return r.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return r.day(e, { width: "wide", context: "formatting" }) || r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 6;
  }
  set(e, t, r, a) {
    return e = ja(e, r, a), e.setHours(0, 0, 0, 0), e;
  }
}
class om extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 90), L(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(e, t, r, a) {
    const i = (s) => {
      const u = Math.floor((s - 1) / 7) * 7;
      return (s + a.weekStartsOn + 6) % 7 + u;
    };
    switch (t) {
      case "c":
      case "cc":
        return _e(Se(t.length, e), i);
      case "co":
        return _e(
          r.ordinalNumber(e, {
            unit: "day"
          }),
          i
        );
      case "ccc":
        return r.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(e, { width: "short", context: "standalone" }) || r.day(e, { width: "narrow", context: "standalone" });
      case "ccccc":
        return r.day(e, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(e, { width: "short", context: "standalone" }) || r.day(e, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return r.day(e, { width: "wide", context: "standalone" }) || r.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(e, { width: "short", context: "standalone" }) || r.day(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 6;
  }
  set(e, t, r, a) {
    return e = ja(e, r, a), e.setHours(0, 0, 0, 0), e;
  }
}
function sm(n, e, t) {
  const r = He(n, t == null ? void 0 : t.in), a = $d(r, t), i = e - a;
  return vs(r, i, t);
}
class cm extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 90), L(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    const a = (i) => i === 0 ? 7 : i;
    switch (t) {
      case "i":
      case "ii":
        return Se(t.length, e);
      case "io":
        return r.ordinalNumber(e, { unit: "day" });
      case "iii":
        return _e(
          r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      case "iiiii":
        return _e(
          r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      case "iiiiii":
        return _e(
          r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      case "iiii":
      default:
        return _e(
          r.day(e, {
            width: "wide",
            context: "formatting"
          }) || r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 7;
  }
  set(e, t, r) {
    return e = sm(e, r), e.setHours(0, 0, 0, 0), e;
  }
}
class um extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 80), L(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, t, r) {
    return e.setHours(Pa(r), 0, 0, 0), e;
  }
}
class lm extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 80), L(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, t, r) {
    return e.setHours(Pa(r), 0, 0, 0), e;
  }
}
class dm extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 80), L(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, t, r) {
    return e.setHours(Pa(r), 0, 0, 0), e;
  }
}
class mm extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 70), L(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "h":
        return Te(Me.hour12h, e);
      case "ho":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return Se(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 12;
  }
  set(e, t, r) {
    const a = e.getHours() >= 12;
    return a && r < 12 ? e.setHours(r + 12, 0, 0, 0) : !a && r === 12 ? e.setHours(0, 0, 0, 0) : e.setHours(r, 0, 0, 0), e;
  }
}
class hm extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 70), L(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "H":
        return Te(Me.hour23h, e);
      case "Ho":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return Se(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 23;
  }
  set(e, t, r) {
    return e.setHours(r, 0, 0, 0), e;
  }
}
class fm extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 70), L(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "K":
        return Te(Me.hour11h, e);
      case "Ko":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return Se(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 11;
  }
  set(e, t, r) {
    return e.getHours() >= 12 && r < 12 ? e.setHours(r + 12, 0, 0, 0) : e.setHours(r, 0, 0, 0), e;
  }
}
class pm extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 70), L(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "k":
        return Te(Me.hour24h, e);
      case "ko":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return Se(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 24;
  }
  set(e, t, r) {
    const a = r <= 24 ? r % 24 : r;
    return e.setHours(a, 0, 0, 0), e;
  }
}
class gm extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 60), L(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "m":
        return Te(Me.minute, e);
      case "mo":
        return r.ordinalNumber(e, { unit: "minute" });
      default:
        return Se(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 59;
  }
  set(e, t, r) {
    return e.setMinutes(r, 0, 0), e;
  }
}
class bm extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 50), L(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "s":
        return Te(Me.second, e);
      case "so":
        return r.ordinalNumber(e, { unit: "second" });
      default:
        return Se(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 59;
  }
  set(e, t, r) {
    return e.setSeconds(r, 0), e;
  }
}
class wm extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 30), L(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, t) {
    const r = (a) => Math.trunc(a * Math.pow(10, -t.length + 3));
    return _e(Se(t.length, e), r);
  }
  set(e, t, r) {
    return e.setMilliseconds(r), e;
  }
}
class vm extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 10), L(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(e, t) {
    switch (t) {
      case "X":
        return It(
          Nt.basicOptionalMinutes,
          e
        );
      case "XX":
        return It(Nt.basic, e);
      case "XXXX":
        return It(
          Nt.basicOptionalSeconds,
          e
        );
      case "XXXXX":
        return It(
          Nt.extendedOptionalSeconds,
          e
        );
      case "XXX":
      default:
        return It(Nt.extended, e);
    }
  }
  set(e, t, r) {
    return t.timestampIsSet ? e : nt(
      e,
      e.getTime() - pr(e) - r
    );
  }
}
class ym extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 10), L(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(e, t) {
    switch (t) {
      case "x":
        return It(
          Nt.basicOptionalMinutes,
          e
        );
      case "xx":
        return It(Nt.basic, e);
      case "xxxx":
        return It(
          Nt.basicOptionalSeconds,
          e
        );
      case "xxxxx":
        return It(
          Nt.extendedOptionalSeconds,
          e
        );
      case "xxx":
      default:
        return It(Nt.extended, e);
    }
  }
  set(e, t, r) {
    return t.timestampIsSet ? e : nt(
      e,
      e.getTime() - pr(e) - r
    );
  }
}
class xm extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 40), L(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return js(e);
  }
  set(e, t, r) {
    return [nt(e, r * 1e3), { timestampIsSet: !0 }];
  }
}
class km extends ue {
  constructor() {
    super(...arguments), L(this, "priority", 20), L(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return js(e);
  }
  set(e, t, r) {
    return [nt(e, r), { timestampIsSet: !0 }];
  }
}
new Rd(), new Hd(), new zd(), new Ud(), new qd(), new Yd(), new Vd(), new Gd(), new Qd(), new Kd(), new Jd(), new nm(), new rm(), new am(), new im(), new om(), new cm(), new um(), new lm(), new dm(), new mm(), new hm(), new fm(), new pm(), new gm(), new bm(), new wm(), new vm(), new ym(), new xm(), new km();
function Pi(n, e, t) {
  const [r, a] = xs(
    t == null ? void 0 : t.in,
    n,
    e
  );
  return +Ft(r, t) == +Ft(a, t);
}
function Tm(n) {
  return n.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}
function Pn(n) {
  return n % 1 !== 0 ? n.toFixed(2).replace(".", ",") : n.toString().replace(".", ",");
}
const Ea = (n, e) => {
  let t = !0;
  return n.length !== e.length ? t = !1 : n.forEach((r, a) => {
    const i = In(r), s = In(e[a]);
    i !== s ? t = !1 : i === "object" ? Sa(r, e[a]) || (t = !1) : i === "array" ? Ea(r, e[a]) || (t = !1) : r !== e[a] && (t = !1);
  }), t;
}, Sa = (n, e) => {
  let t = !0;
  return Object.keys(n).length !== Object.keys(e).length ? t = !1 : Object.keys(n).forEach((r) => {
    const a = In(n[r]), i = In(e[r]);
    a !== i ? t = !1 : a === "object" ? Sa(n[r], e[r]) || (t = !1) : a === "array" ? Ea(n[r], e[r]) || (t = !1) : e[r] !== n[r] && (t = !1);
  }), t;
}, In = (n) => {
  const e = typeof n;
  if (e === "number")
    return isNaN(n) ? "NaN" : e;
  if (e === "object") {
    if (n instanceof Array)
      return "array";
    if (n instanceof Element)
      return "node";
    if (String(n == null ? void 0 : n.$$typeof) === "Symbol(react.element)")
      return "ReactNode";
    if (n === null)
      return "null";
  }
  return e;
}, Un = (n, e) => {
  const t = In(n), r = In(e);
  return t !== r ? !1 : t === "array" ? Ea(n, e) : t === "object" || t === "ReactNode" ? Sa(n, e) : t === "node" ? n.isEqualNode(e) : n === e;
};
function Om(n, e) {
  return e === 1 && n.one ? n.one : e >= 2 && e <= 4 && n.twoFour ? n.twoFour : n.other;
}
function Wr(n, e, t) {
  return Om(n, e)[t].replace("{{count}}", String(e));
}
function Pm(n) {
  return ["lessThan", "about", "over", "almost"].filter(
    function(e) {
      return !!n.match(new RegExp("^" + e));
    }
  )[0];
}
function $r(n) {
  let e = "";
  return n === "almost" && (e = "takmer"), n === "about" && (e = "približne"), e.length > 0 ? e + " " : "";
}
function Br(n) {
  let e = "";
  return n === "lessThan" && (e = "menej než"), n === "over" && (e = "viac než"), e.length > 0 ? e + " " : "";
}
function jm(n) {
  return n.charAt(0).toLowerCase() + n.slice(1);
}
const Em = {
  xSeconds: {
    one: {
      present: "sekunda",
      past: "sekundou",
      future: "sekundu"
    },
    twoFour: {
      present: "{{count}} sekundy",
      past: "{{count}} sekundami",
      future: "{{count}} sekundy"
    },
    other: {
      present: "{{count}} sekúnd",
      past: "{{count}} sekundami",
      future: "{{count}} sekúnd"
    }
  },
  halfAMinute: {
    other: {
      present: "pol minúty",
      past: "pol minútou",
      future: "pol minúty"
    }
  },
  xMinutes: {
    one: {
      present: "minúta",
      past: "minútou",
      future: "minútu"
    },
    twoFour: {
      present: "{{count}} minúty",
      past: "{{count}} minútami",
      future: "{{count}} minúty"
    },
    other: {
      present: "{{count}} minút",
      past: "{{count}} minútami",
      future: "{{count}} minút"
    }
  },
  xHours: {
    one: {
      present: "hodina",
      past: "hodinou",
      future: "hodinu"
    },
    twoFour: {
      present: "{{count}} hodiny",
      past: "{{count}} hodinami",
      future: "{{count}} hodiny"
    },
    other: {
      present: "{{count}} hodín",
      past: "{{count}} hodinami",
      future: "{{count}} hodín"
    }
  },
  xDays: {
    one: {
      present: "deň",
      past: "dňom",
      future: "deň"
    },
    twoFour: {
      present: "{{count}} dni",
      past: "{{count}} dňami",
      future: "{{count}} dni"
    },
    other: {
      present: "{{count}} dní",
      past: "{{count}} dňami",
      future: "{{count}} dní"
    }
  },
  xWeeks: {
    one: {
      present: "týždeň",
      past: "týždňom",
      future: "týždeň"
    },
    twoFour: {
      present: "{{count}} týždne",
      past: "{{count}} týždňami",
      future: "{{count}} týždne"
    },
    other: {
      present: "{{count}} týždňov",
      past: "{{count}} týždňami",
      future: "{{count}} týždňov"
    }
  },
  xMonths: {
    one: {
      present: "mesiac",
      past: "mesiacom",
      future: "mesiac"
    },
    twoFour: {
      present: "{{count}} mesiace",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiace"
    },
    other: {
      present: "{{count}} mesiacov",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiacov"
    }
  },
  xYears: {
    one: {
      present: "rok",
      past: "rokom",
      future: "rok"
    },
    twoFour: {
      present: "{{count}} roky",
      past: "{{count}} rokmi",
      future: "{{count}} roky"
    },
    other: {
      present: "{{count}} rokov",
      past: "{{count}} rokmi",
      future: "{{count}} rokov"
    }
  }
}, Sm = (n, e, t) => {
  const r = Pm(n) || "", a = jm(n.substring(r.length)), i = Em[a];
  return t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? $r(r) + "o " + Br(r) + Wr(i, e, "future") : $r(r) + "pred " + Br(r) + Wr(i, e, "past") : $r(r) + Br(r) + Wr(i, e, "present");
}, Am = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. M. y",
  short: "d. M. y"
}, Nm = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, Im = {
  full: "{{date}}, {{time}}",
  long: "{{date}}, {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}} {{time}}"
}, Mm = {
  date: On({
    formats: Am,
    defaultWidth: "full"
  }),
  time: On({
    formats: Nm,
    defaultWidth: "full"
  }),
  dateTime: On({
    formats: Im,
    defaultWidth: "full"
  })
}, Aa = [
  "nedeľu",
  "pondelok",
  "utorok",
  "stredu",
  "štvrtok",
  "piatok",
  "sobotu"
];
function _m(n) {
  const e = Aa[n];
  switch (n) {
    case 0:
    case 3:
    case 6:
      return "'minulú " + e + " o' p";
    default:
      return "'minulý' eeee 'o' p";
  }
}
function ji(n) {
  const e = Aa[n];
  return n === 4 ? "'vo' eeee 'o' p" : "'v " + e + " o' p";
}
function Dm(n) {
  const e = Aa[n];
  switch (n) {
    case 0:
    case 4:
    case 6:
      return "'budúcu " + e + " o' p";
    default:
      return "'budúci' eeee 'o' p";
  }
}
const Cm = {
  lastWeek: (n, e, t) => {
    const r = n.getDay();
    return Pi(n, e, t) ? ji(r) : _m(r);
  },
  yesterday: "'včera o' p",
  today: "'dnes o' p",
  tomorrow: "'zajtra o' p",
  nextWeek: (n, e, t) => {
    const r = n.getDay();
    return Pi(n, e, t) ? ji(r) : Dm(r);
  },
  other: "P"
}, Lm = (n, e, t, r) => {
  const a = Cm[n];
  return typeof a == "function" ? a(e, t, r) : a;
}, Wm = {
  narrow: ["pred Kr.", "po Kr."],
  abbreviated: ["pred Kr.", "po Kr."],
  wide: ["pred Kristom", "po Kristovi"]
}, $m = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. štvrťrok", "2. štvrťrok", "3. štvrťrok", "4. štvrťrok"]
}, Bm = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "január",
    "február",
    "marec",
    "apríl",
    "máj",
    "jún",
    "júl",
    "august",
    "september",
    "október",
    "november",
    "december"
  ]
}, Fm = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januára",
    "februára",
    "marca",
    "apríla",
    "mája",
    "júna",
    "júla",
    "augusta",
    "septembra",
    "októbra",
    "novembra",
    "decembra"
  ]
}, Rm = {
  narrow: ["n", "p", "u", "s", "š", "p", "s"],
  short: ["ne", "po", "ut", "st", "št", "pi", "so"],
  abbreviated: ["ne", "po", "ut", "st", "št", "pi", "so"],
  wide: [
    "nedeľa",
    "pondelok",
    "utorok",
    "streda",
    "štvrtok",
    "piatok",
    "sobota"
  ]
}, Hm = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "noc"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "polnoc",
    noon: "poludnie",
    morning: "ráno",
    afternoon: "popoludnie",
    evening: "večer",
    night: "noc"
  }
}, zm = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "nap.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "v n."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "napol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "v noci"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o polnoci",
    noon: "napoludnie",
    morning: "ráno",
    afternoon: "popoludní",
    evening: "večer",
    night: "v noci"
  }
}, Um = (n, e) => Number(n) + ".", qm = {
  ordinalNumber: Um,
  era: St({
    values: Wm,
    defaultWidth: "wide"
  }),
  quarter: St({
    values: $m,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: St({
    values: Bm,
    defaultWidth: "wide",
    formattingValues: Fm,
    defaultFormattingWidth: "wide"
  }),
  day: St({
    values: Rm,
    defaultWidth: "wide"
  }),
  dayPeriod: St({
    values: Hm,
    defaultWidth: "wide",
    formattingValues: zm,
    defaultFormattingWidth: "wide"
  })
}, Ym = /^(\d+)\.?/i, Vm = /\d+/i, Gm = {
  narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
}, Qm = {
  any: [/^pr/i, /^(po|n)/i]
}, Xm = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\. [šs]tvr[ťt]rok/i
}, Km = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Zm = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
  wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
}, Jm = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^m[áa]j/i,
    /^j[úu]n/i,
    /^j[úu]l/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, eh = {
  narrow: /^[npusšp]/i,
  short: /^(ne|po|ut|st|št|pi|so)/i,
  abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
  wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
}, th = {
  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
}, nh = {
  narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
  abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
  any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
}, rh = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /poln/i,
    noon: /^(nap|(na)?pol(\.|u))/i,
    morning: /^r[áa]no/i,
    afternoon: /^pop/i,
    evening: /^ve[čc]/i,
    night: /^(noc|v n\.)/i
  }
}, ah = {
  ordinalNumber: ks({
    matchPattern: Ym,
    parsePattern: Vm,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: At({
    matchPatterns: Gm,
    defaultMatchWidth: "wide",
    parsePatterns: Qm,
    defaultParseWidth: "any"
  }),
  quarter: At({
    matchPatterns: Xm,
    defaultMatchWidth: "wide",
    parsePatterns: Km,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: At({
    matchPatterns: Zm,
    defaultMatchWidth: "wide",
    parsePatterns: Jm,
    defaultParseWidth: "any"
  }),
  day: At({
    matchPatterns: eh,
    defaultMatchWidth: "wide",
    parsePatterns: th,
    defaultParseWidth: "any"
  }),
  dayPeriod: At({
    matchPatterns: nh,
    defaultMatchWidth: "any",
    parsePatterns: rh,
    defaultParseWidth: "any"
  })
}, ih = {
  code: "sk",
  formatDistance: Sm,
  formatLong: Mm,
  formatRelative: Lm,
  localize: qm,
  match: ah,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
function Ns() {
  return process.env.LOGGER_ENV !== "PROD";
}
function oh() {
  return process.env.LOGGER_ENV !== "PROD" && process.env.LOGGER_ENV !== "PPT";
}
class jt {
  static get currentDate() {
    const e = (f) => f < 10 ? `0${f}` : `${f}`, t = new Date(Date.now()), r = e(t.getFullYear()), a = e(t.getMonth()), i = e(t.getDate()), s = e(t.getHours()), u = e(t.getMinutes()), m = e(t.getSeconds());
    return `${r}-${a}-${i} ${s}:${u}:${m}`;
  }
  /**
   * Log a message at the level specified in first argument.
   *
   * @param level the log level
   * @param name the name of the logger to distinguish individual loggers
   * @param message the log message
   * @param data an additional arguments to include in the log
   */
  static log(e, t, r, ...a) {
    if (Ns() && !(e === "DEBUG" && !oh()))
      switch (e) {
        case "DEBUG":
          console.debug(`${jt.currentDate} - ${t}: ${r}`, ...a);
          break;
        case "INFO":
          console.info(`${jt.currentDate} - ${t}: ${r}`, ...a);
          break;
        case "WARN":
          console.warn(`${jt.currentDate} - ${t}: ${r}`, ...a);
          break;
        case "ERROR":
          console.error(`${jt.currentDate} - ${t}: ${r}`, ...a);
          break;
      }
  }
  /**
   * Log a message at the DEBUG level.
   *
   * @param name the name of the logger to distinguish individual loggers
   * @param message the log message
   * @param data an additional arguments to include in the log
   */
  static debug(e, t, ...r) {
    jt.log("DEBUG", e, t, ...r);
  }
  /**
   * Log a message at the INFO level.
   *
   * @param name the name of the logger to distinguish individual loggers
   * @param message the log message
   * @param data an additional arguments to include in the log
   */
  static info(e, t, ...r) {
    jt.log("INFO", e, t, ...r);
  }
  /**
   * Log a message at the WARN level.
   *
   * @param name the name of the logger to distinguish individual loggers
   * @param message the log message
   * @param data an additional arguments to include in the log
   */
  static warn(e, t, ...r) {
    jt.log("WARN", e, t, ...r);
  }
  /**
   * Log a message at the ERROR level.
   *
   * @param name the name of the logger to distinguish individual loggers
   * @param message the log message
   * @param data an additional arguments to include in the log
   */
  static error(e, t, ...r) {
    jt.log("ERROR", e, t, ...r);
  }
}
function aa(n, e = "d. M. yyyy H:mm", t) {
  if (!n)
    return "";
  try {
    return Ld(n, e, bs({ locale: ih }, t));
  } catch (r) {
    return Ns() && jt.error("utilities", "Invalid date string received", n), n instanceof Date ? n.toString() : `${n}`;
  }
}
function Na(n, e) {
  var t, r;
  (r = (t = window.dtrum) == null ? void 0 : t.reportCustomError) == null || r.call(t, "REACT", n, e);
}
var sh = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
(function(n) {
  n();
})(function() {
  function n(w, y) {
    if (!(w instanceof y))
      throw new TypeError("Cannot call a class as a function");
  }
  function e(w, y) {
    for (var v = 0; v < y.length; v++) {
      var x = y[v];
      x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(w, x.key, x);
    }
  }
  function t(w, y, v) {
    return y && e(w.prototype, y), v && e(w, v), Object.defineProperty(w, "prototype", {
      writable: !1
    }), w;
  }
  function r(w, y) {
    if (typeof y != "function" && y !== null)
      throw new TypeError("Super expression must either be null or a function");
    w.prototype = Object.create(y && y.prototype, {
      constructor: {
        value: w,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(w, "prototype", {
      writable: !1
    }), y && i(w, y);
  }
  function a(w) {
    return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(y) {
      return y.__proto__ || Object.getPrototypeOf(y);
    }, a(w);
  }
  function i(w, y) {
    return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(v, x) {
      return v.__proto__ = x, v;
    }, i(w, y);
  }
  function s() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (w) {
      return !1;
    }
  }
  function u(w) {
    if (w === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return w;
  }
  function m(w, y) {
    if (y && (typeof y == "object" || typeof y == "function"))
      return y;
    if (y !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return u(w);
  }
  function f(w) {
    var y = s();
    return function() {
      var v = a(w), x;
      if (y) {
        var T = a(this).constructor;
        x = Reflect.construct(v, arguments, T);
      } else
        x = v.apply(this, arguments);
      return m(this, x);
    };
  }
  function p(w, y) {
    for (; !Object.prototype.hasOwnProperty.call(w, y) && (w = a(w), w !== null); )
      ;
    return w;
  }
  function d() {
    return typeof Reflect != "undefined" && Reflect.get ? d = Reflect.get.bind() : d = function(w, y, v) {
      var x = p(w, y);
      if (x) {
        var T = Object.getOwnPropertyDescriptor(x, y);
        return T.get ? T.get.call(arguments.length < 3 ? w : v) : T.value;
      }
    }, d.apply(this, arguments);
  }
  var c = /* @__PURE__ */ function() {
    function w() {
      n(this, w), Object.defineProperty(this, "listeners", {
        value: {},
        writable: !0,
        configurable: !0
      });
    }
    return t(w, [{
      key: "addEventListener",
      value: function(y, v, x) {
        y in this.listeners || (this.listeners[y] = []), this.listeners[y].push({
          callback: v,
          options: x
        });
      }
    }, {
      key: "removeEventListener",
      value: function(y, v) {
        if (y in this.listeners) {
          for (var x = this.listeners[y], T = 0, j = x.length; T < j; T++)
            if (x[T].callback === v) {
              x.splice(T, 1);
              return;
            }
        }
      }
    }, {
      key: "dispatchEvent",
      value: function(y) {
        if (y.type in this.listeners) {
          for (var v = this.listeners[y.type], x = v.slice(), T = 0, j = x.length; T < j; T++) {
            var A = x[T];
            try {
              A.callback.call(this, y);
            } catch (N) {
              Promise.resolve().then(function() {
                throw N;
              });
            }
            A.options && A.options.once && this.removeEventListener(y.type, A.callback);
          }
          return !y.defaultPrevented;
        }
      }
    }]), w;
  }(), l = /* @__PURE__ */ function(w) {
    r(v, w);
    var y = f(v);
    function v() {
      var x;
      return n(this, v), x = y.call(this), x.listeners || c.call(u(x)), Object.defineProperty(u(x), "aborted", {
        value: !1,
        writable: !0,
        configurable: !0
      }), Object.defineProperty(u(x), "onabort", {
        value: null,
        writable: !0,
        configurable: !0
      }), Object.defineProperty(u(x), "reason", {
        value: void 0,
        writable: !0,
        configurable: !0
      }), x;
    }
    return t(v, [{
      key: "toString",
      value: function() {
        return "[object AbortSignal]";
      }
    }, {
      key: "dispatchEvent",
      value: function(x) {
        x.type === "abort" && (this.aborted = !0, typeof this.onabort == "function" && this.onabort.call(this, x)), d(a(v.prototype), "dispatchEvent", this).call(this, x);
      }
    }]), v;
  }(c), h = /* @__PURE__ */ function() {
    function w() {
      n(this, w), Object.defineProperty(this, "signal", {
        value: new l(),
        writable: !0,
        configurable: !0
      });
    }
    return t(w, [{
      key: "abort",
      value: function(y) {
        var v;
        try {
          v = new Event("abort");
        } catch (T) {
          typeof document != "undefined" ? document.createEvent ? (v = document.createEvent("Event"), v.initEvent("abort", !1, !1)) : (v = document.createEventObject(), v.type = "abort") : v = {
            type: "abort",
            bubbles: !1,
            cancelable: !1
          };
        }
        var x = y;
        if (x === void 0)
          if (typeof document == "undefined")
            x = new Error("This operation was aborted"), x.name = "AbortError";
          else
            try {
              x = new DOMException("signal is aborted without reason");
            } catch (T) {
              x = new Error("This operation was aborted"), x.name = "AbortError";
            }
        this.signal.reason = x, this.signal.dispatchEvent(v);
      }
    }, {
      key: "toString",
      value: function() {
        return "[object AbortController]";
      }
    }]), w;
  }();
  typeof Symbol != "undefined" && Symbol.toStringTag && (h.prototype[Symbol.toStringTag] = "AbortController", l.prototype[Symbol.toStringTag] = "AbortSignal");
  function g(w) {
    return w.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL ? (console.log("__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill"), !0) : typeof w.Request == "function" && !w.Request.prototype.hasOwnProperty("signal") || !w.AbortController;
  }
  function b(w) {
    typeof w == "function" && (w = {
      fetch: w
    });
    var y = w, v = y.fetch, x = y.Request, T = x === void 0 ? v.Request : x, j = y.AbortController, A = y.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL, N = A === void 0 ? !1 : A;
    if (!g({
      fetch: v,
      Request: T,
      AbortController: j,
      __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL: N
    }))
      return {
        fetch: v,
        Request: S
      };
    var S = T;
    (S && !S.prototype.hasOwnProperty("signal") || N) && (S = function(M, O) {
      var I;
      O && O.signal && (I = O.signal, delete O.signal);
      var re = new T(M, O);
      return I && Object.defineProperty(re, "signal", {
        writable: !1,
        enumerable: !1,
        configurable: !0,
        value: I
      }), re;
    }, S.prototype = T.prototype);
    var E = v, k = function(M, O) {
      var I = S && S.prototype.isPrototypeOf(M) ? M.signal : O ? O.signal : void 0;
      if (I) {
        var re;
        try {
          re = new DOMException("Aborted", "AbortError");
        } catch (R) {
          re = new Error("Aborted"), re.name = "AbortError";
        }
        if (I.aborted)
          return Promise.reject(re);
        var V = new Promise(function(R, P) {
          I.addEventListener("abort", function() {
            return P(re);
          }, {
            once: !0
          });
        });
        return O && O.signal && delete O.signal, Promise.race([V, E(M, O)]);
      }
      return E(M, O);
    };
    return {
      fetch: k,
      Request: S
    };
  }
  (function(w) {
    if (g(w)) {
      if (!w.fetch) {
        console.warn("fetch() is not available, cannot install abortcontroller-polyfill");
        return;
      }
      var y = b(w), v = y.fetch, x = y.Request;
      w.fetch = v, w.Request = x, Object.defineProperty(w, "AbortController", {
        writable: !0,
        enumerable: !1,
        configurable: !0,
        value: h
      }), Object.defineProperty(w, "AbortSignal", {
        writable: !0,
        enumerable: !1,
        configurable: !0,
        value: l
      });
    }
  })(typeof self != "undefined" ? self : sh);
});
function Tt(n) {
  for (var e = arguments.length, t = Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    t[r - 1] = arguments[r];
  throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(a) {
    return "'" + a + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function mn(n) {
  return !!n && !!n[we];
}
function hn(n) {
  var e;
  return !!n && (function(t) {
    if (!t || typeof t != "object")
      return !1;
    var r = Object.getPrototypeOf(t);
    if (r === null)
      return !0;
    var a = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
    return a === Object || typeof a == "function" && Function.toString.call(a) === gh;
  }(n) || Array.isArray(n) || !!n[_i] || !!(!((e = n.constructor) === null || e === void 0) && e[_i]) || Ia(n) || Ma(n));
}
function fn(n, e, t) {
  t === void 0 && (t = !1), Cn(n) === 0 ? (t ? Object.keys : En)(n).forEach(function(r) {
    t && typeof r == "symbol" || e(r, n[r], n);
  }) : n.forEach(function(r, a) {
    return e(a, r, n);
  });
}
function Cn(n) {
  var e = n[we];
  return e ? e.i > 3 ? e.i - 4 : e.i : Array.isArray(n) ? 1 : Ia(n) ? 2 : Ma(n) ? 3 : 0;
}
function jn(n, e) {
  return Cn(n) === 2 ? n.has(e) : Object.prototype.hasOwnProperty.call(n, e);
}
function ch(n, e) {
  return Cn(n) === 2 ? n.get(e) : n[e];
}
function Is(n, e, t) {
  var r = Cn(n);
  r === 2 ? n.set(e, t) : r === 3 ? n.add(t) : n[e] = t;
}
function Ms(n, e) {
  return n === e ? n !== 0 || 1 / n == 1 / e : n != n && e != e;
}
function Ia(n) {
  return fh && n instanceof Map;
}
function Ma(n) {
  return ph && n instanceof Set;
}
function un(n) {
  return n.o || n.t;
}
function _a(n) {
  if (Array.isArray(n))
    return Array.prototype.slice.call(n);
  var e = Ds(n);
  delete e[we];
  for (var t = En(e), r = 0; r < t.length; r++) {
    var a = t[r], i = e[a];
    i.writable === !1 && (i.writable = !0, i.configurable = !0), (i.get || i.set) && (e[a] = { configurable: !0, writable: !0, enumerable: i.enumerable, value: n[a] });
  }
  return Object.create(Object.getPrototypeOf(n), e);
}
function Da(n, e) {
  return e === void 0 && (e = !1), Ca(n) || mn(n) || !hn(n) || (Cn(n) > 1 && (n.set = n.add = n.clear = n.delete = uh), Object.freeze(n), e && fn(n, function(t, r) {
    return Da(r, !0);
  }, !0)), n;
}
function uh() {
  Tt(2);
}
function Ca(n) {
  return n == null || typeof n != "object" || Object.isFrozen(n);
}
function $t(n) {
  var e = ca[n];
  return e || Tt(18, n), e;
}
function lh(n, e) {
  ca[n] || (ca[n] = e);
}
function ia() {
  return Gn;
}
function Fr(n, e) {
  e && ($t("Patches"), n.u = [], n.s = [], n.v = e);
}
function gr(n) {
  oa(n), n.p.forEach(dh), n.p = null;
}
function oa(n) {
  n === Gn && (Gn = n.l);
}
function Ei(n) {
  return Gn = { p: [], l: Gn, h: n, m: !0, _: 0 };
}
function dh(n) {
  var e = n[we];
  e.i === 0 || e.i === 1 ? e.j() : e.g = !0;
}
function Rr(n, e) {
  e._ = e.p.length;
  var t = e.p[0], r = n !== void 0 && n !== t;
  return e.h.O || $t("ES5").S(e, n, r), r ? (t[we].P && (gr(e), Tt(4)), hn(n) && (n = br(e, n), e.l || wr(e, n)), e.u && $t("Patches").M(t[we].t, n, e.u, e.s)) : n = br(e, t, []), gr(e), e.u && e.v(e.u, e.s), n !== _s ? n : void 0;
}
function br(n, e, t) {
  if (Ca(e))
    return e;
  var r = e[we];
  if (!r)
    return fn(e, function(u, m) {
      return Si(n, r, e, u, m, t);
    }, !0), e;
  if (r.A !== n)
    return e;
  if (!r.P)
    return wr(n, r.t, !0), r.t;
  if (!r.I) {
    r.I = !0, r.A._--;
    var a = r.i === 4 || r.i === 5 ? r.o = _a(r.k) : r.o, i = a, s = !1;
    r.i === 3 && (i = new Set(a), a.clear(), s = !0), fn(i, function(u, m) {
      return Si(n, r, a, u, m, t, s);
    }), wr(n, a, !1), t && n.u && $t("Patches").N(r, t, n.u, n.s);
  }
  return r.o;
}
function Si(n, e, t, r, a, i, s) {
  if (mn(a)) {
    var u = br(n, a, i && e && e.i !== 3 && !jn(e.R, r) ? i.concat(r) : void 0);
    if (Is(t, r, u), !mn(u))
      return;
    n.m = !1;
  } else
    s && t.add(a);
  if (hn(a) && !Ca(a)) {
    if (!n.h.D && n._ < 1)
      return;
    br(n, a), e && e.A.l || wr(n, a);
  }
}
function wr(n, e, t) {
  t === void 0 && (t = !1), !n.l && n.h.D && n.m && Da(e, t);
}
function Hr(n, e) {
  var t = n[we];
  return (t ? un(t) : n)[e];
}
function Ai(n, e) {
  if (e in n)
    for (var t = Object.getPrototypeOf(n); t; ) {
      var r = Object.getOwnPropertyDescriptor(t, e);
      if (r)
        return r;
      t = Object.getPrototypeOf(t);
    }
}
function Gt(n) {
  n.P || (n.P = !0, n.l && Gt(n.l));
}
function zr(n) {
  n.o || (n.o = _a(n.t));
}
function sa(n, e, t) {
  var r = Ia(e) ? $t("MapSet").F(e, t) : Ma(e) ? $t("MapSet").T(e, t) : n.O ? function(a, i) {
    var s = Array.isArray(a), u = { i: s ? 1 : 0, A: i ? i.A : ia(), P: !1, I: !1, R: {}, l: i, t: a, k: null, o: null, j: null, C: !1 }, m = u, f = Qn;
    s && (m = [u], f = qn);
    var p = Proxy.revocable(m, f), d = p.revoke, c = p.proxy;
    return u.k = c, u.j = d, c;
  }(e, t) : $t("ES5").J(e, t);
  return (t ? t.A : ia()).p.push(r), r;
}
function mh(n) {
  return mn(n) || Tt(22, n), function e(t) {
    if (!hn(t))
      return t;
    var r, a = t[we], i = Cn(t);
    if (a) {
      if (!a.P && (a.i < 4 || !$t("ES5").K(a)))
        return a.t;
      a.I = !0, r = Ni(t, i), a.I = !1;
    } else
      r = Ni(t, i);
    return fn(r, function(s, u) {
      a && ch(a.t, s) === u || Is(r, s, e(u));
    }), i === 3 ? new Set(r) : r;
  }(n);
}
function Ni(n, e) {
  switch (e) {
    case 2:
      return new Map(n);
    case 3:
      return Array.from(n);
  }
  return _a(n);
}
function hh() {
  function n(i, s) {
    var u = a[i];
    return u ? u.enumerable = s : a[i] = u = { configurable: !0, enumerable: s, get: function() {
      var m = this[we];
      return Qn.get(m, i);
    }, set: function(m) {
      var f = this[we];
      Qn.set(f, i, m);
    } }, u;
  }
  function e(i) {
    for (var s = i.length - 1; s >= 0; s--) {
      var u = i[s][we];
      if (!u.P)
        switch (u.i) {
          case 5:
            r(u) && Gt(u);
            break;
          case 4:
            t(u) && Gt(u);
        }
    }
  }
  function t(i) {
    for (var s = i.t, u = i.k, m = En(u), f = m.length - 1; f >= 0; f--) {
      var p = m[f];
      if (p !== we) {
        var d = s[p];
        if (d === void 0 && !jn(s, p))
          return !0;
        var c = u[p], l = c && c[we];
        if (l ? l.t !== d : !Ms(c, d))
          return !0;
      }
    }
    var h = !!s[we];
    return m.length !== En(s).length + (h ? 0 : 1);
  }
  function r(i) {
    var s = i.k;
    if (s.length !== i.t.length)
      return !0;
    var u = Object.getOwnPropertyDescriptor(s, s.length - 1);
    if (u && !u.get)
      return !0;
    for (var m = 0; m < s.length; m++)
      if (!s.hasOwnProperty(m))
        return !0;
    return !1;
  }
  var a = {};
  lh("ES5", { J: function(i, s) {
    var u = Array.isArray(i), m = function(p, d) {
      if (p) {
        for (var c = Array(d.length), l = 0; l < d.length; l++)
          Object.defineProperty(c, "" + l, n(l, !0));
        return c;
      }
      var h = Ds(d);
      delete h[we];
      for (var g = En(h), b = 0; b < g.length; b++) {
        var w = g[b];
        h[w] = n(w, p || !!h[w].enumerable);
      }
      return Object.create(Object.getPrototypeOf(d), h);
    }(u, i), f = { i: u ? 5 : 4, A: s ? s.A : ia(), P: !1, I: !1, R: {}, l: s, t: i, k: m, o: null, g: !1, C: !1 };
    return Object.defineProperty(m, we, { value: f, writable: !0 }), m;
  }, S: function(i, s, u) {
    u ? mn(s) && s[we].A === i && e(i.p) : (i.u && function m(f) {
      if (f && typeof f == "object") {
        var p = f[we];
        if (p) {
          var d = p.t, c = p.k, l = p.R, h = p.i;
          if (h === 4)
            fn(c, function(v) {
              v !== we && (d[v] !== void 0 || jn(d, v) ? l[v] || m(c[v]) : (l[v] = !0, Gt(p)));
            }), fn(d, function(v) {
              c[v] !== void 0 || jn(c, v) || (l[v] = !1, Gt(p));
            });
          else if (h === 5) {
            if (r(p) && (Gt(p), l.length = !0), c.length < d.length)
              for (var g = c.length; g < d.length; g++)
                l[g] = !1;
            else
              for (var b = d.length; b < c.length; b++)
                l[b] = !0;
            for (var w = Math.min(c.length, d.length), y = 0; y < w; y++)
              c.hasOwnProperty(y) || (l[y] = !0), l[y] === void 0 && m(c[y]);
          }
        }
      }
    }(i.p[0]), e(i.p));
  }, K: function(i) {
    return i.i === 4 ? t(i) : r(i);
  } });
}
var Ii, Gn, La = typeof Symbol != "undefined" && typeof Symbol("x") == "symbol", fh = typeof Map != "undefined", ph = typeof Set != "undefined", Mi = typeof Proxy != "undefined" && Proxy.revocable !== void 0 && typeof Reflect != "undefined", _s = La ? Symbol.for("immer-nothing") : ((Ii = {})["immer-nothing"] = !0, Ii), _i = La ? Symbol.for("immer-draftable") : "__$immer_draftable", we = La ? Symbol.for("immer-state") : "__$immer_state", gh = "" + Object.prototype.constructor, En = typeof Reflect != "undefined" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(n) {
  return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, Ds = Object.getOwnPropertyDescriptors || function(n) {
  var e = {};
  return En(n).forEach(function(t) {
    e[t] = Object.getOwnPropertyDescriptor(n, t);
  }), e;
}, ca = {}, Qn = { get: function(n, e) {
  if (e === we)
    return n;
  var t = un(n);
  if (!jn(t, e))
    return function(a, i, s) {
      var u, m = Ai(i, s);
      return m ? "value" in m ? m.value : (u = m.get) === null || u === void 0 ? void 0 : u.call(a.k) : void 0;
    }(n, t, e);
  var r = t[e];
  return n.I || !hn(r) ? r : r === Hr(n.t, e) ? (zr(n), n.o[e] = sa(n.A.h, r, n)) : r;
}, has: function(n, e) {
  return e in un(n);
}, ownKeys: function(n) {
  return Reflect.ownKeys(un(n));
}, set: function(n, e, t) {
  var r = Ai(un(n), e);
  if (r != null && r.set)
    return r.set.call(n.k, t), !0;
  if (!n.P) {
    var a = Hr(un(n), e), i = a == null ? void 0 : a[we];
    if (i && i.t === t)
      return n.o[e] = t, n.R[e] = !1, !0;
    if (Ms(t, a) && (t !== void 0 || jn(n.t, e)))
      return !0;
    zr(n), Gt(n);
  }
  return n.o[e] === t && (t !== void 0 || e in n.o) || Number.isNaN(t) && Number.isNaN(n.o[e]) || (n.o[e] = t, n.R[e] = !0), !0;
}, deleteProperty: function(n, e) {
  return Hr(n.t, e) !== void 0 || e in n.t ? (n.R[e] = !1, zr(n), Gt(n)) : delete n.R[e], n.o && delete n.o[e], !0;
}, getOwnPropertyDescriptor: function(n, e) {
  var t = un(n), r = Reflect.getOwnPropertyDescriptor(t, e);
  return r && { writable: !0, configurable: n.i !== 1 || e !== "length", enumerable: r.enumerable, value: t[e] };
}, defineProperty: function() {
  Tt(11);
}, getPrototypeOf: function(n) {
  return Object.getPrototypeOf(n.t);
}, setPrototypeOf: function() {
  Tt(12);
} }, qn = {};
fn(Qn, function(n, e) {
  qn[n] = function() {
    return arguments[0] = arguments[0][0], e.apply(this, arguments);
  };
}), qn.deleteProperty = function(n, e) {
  return qn.set.call(this, n, e, void 0);
}, qn.set = function(n, e, t) {
  return Qn.set.call(this, n[0], e, t, n[0]);
};
var bh = function() {
  function n(t) {
    var r = this;
    this.O = Mi, this.D = !0, this.produce = function(a, i, s) {
      if (typeof a == "function" && typeof i != "function") {
        var u = i;
        i = a;
        var m = r;
        return function(g) {
          var b = this;
          g === void 0 && (g = u);
          for (var w = arguments.length, y = Array(w > 1 ? w - 1 : 0), v = 1; v < w; v++)
            y[v - 1] = arguments[v];
          return m.produce(g, function(x) {
            var T;
            return (T = i).call.apply(T, [b, x].concat(y));
          });
        };
      }
      var f;
      if (typeof i != "function" && Tt(6), s !== void 0 && typeof s != "function" && Tt(7), hn(a)) {
        var p = Ei(r), d = sa(r, a, void 0), c = !0;
        try {
          f = i(d), c = !1;
        } finally {
          c ? gr(p) : oa(p);
        }
        return typeof Promise != "undefined" && f instanceof Promise ? f.then(function(g) {
          return Fr(p, s), Rr(g, p);
        }, function(g) {
          throw gr(p), g;
        }) : (Fr(p, s), Rr(f, p));
      }
      if (!a || typeof a != "object") {
        if ((f = i(a)) === void 0 && (f = a), f === _s && (f = void 0), r.D && Da(f, !0), s) {
          var l = [], h = [];
          $t("Patches").M(a, f, l, h), s(l, h);
        }
        return f;
      }
      Tt(21, a);
    }, this.produceWithPatches = function(a, i) {
      if (typeof a == "function")
        return function(f) {
          for (var p = arguments.length, d = Array(p > 1 ? p - 1 : 0), c = 1; c < p; c++)
            d[c - 1] = arguments[c];
          return r.produceWithPatches(f, function(l) {
            return a.apply(void 0, [l].concat(d));
          });
        };
      var s, u, m = r.produce(a, i, function(f, p) {
        s = f, u = p;
      });
      return typeof Promise != "undefined" && m instanceof Promise ? m.then(function(f) {
        return [f, s, u];
      }) : [m, s, u];
    }, typeof (t == null ? void 0 : t.useProxies) == "boolean" && this.setUseProxies(t.useProxies), typeof (t == null ? void 0 : t.autoFreeze) == "boolean" && this.setAutoFreeze(t.autoFreeze);
  }
  var e = n.prototype;
  return e.createDraft = function(t) {
    hn(t) || Tt(8), mn(t) && (t = mh(t));
    var r = Ei(this), a = sa(this, t, void 0);
    return a[we].C = !0, oa(r), a;
  }, e.finishDraft = function(t, r) {
    var a = t && t[we], i = a.A;
    return Fr(i, r), Rr(void 0, i);
  }, e.setAutoFreeze = function(t) {
    this.D = t;
  }, e.setUseProxies = function(t) {
    t && !Mi && Tt(20), this.O = t;
  }, e.applyPatches = function(t, r) {
    var a;
    for (a = r.length - 1; a >= 0; a--) {
      var i = r[a];
      if (i.path.length === 0 && i.op === "replace") {
        t = i.value;
        break;
      }
    }
    a > -1 && (r = r.slice(a + 1));
    var s = $t("Patches").$;
    return mn(t) ? s(t, r) : this.produce(t, function(u) {
      return s(u, r);
    });
  }, n;
}(), st = new bh();
st.produce;
st.produceWithPatches.bind(st);
st.setAutoFreeze.bind(st);
st.setUseProxies.bind(st);
st.applyPatches.bind(st);
st.createDraft.bind(st);
st.finishDraft.bind(st);
var Cs = globalThis && globalThis.__extends || function() {
  var n = function(e, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, a) {
      r.__proto__ = a;
    } || function(r, a) {
      for (var i in a)
        Object.prototype.hasOwnProperty.call(a, i) && (r[i] = a[i]);
    }, n(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    n(e, t);
    function r() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
  };
}(), wh = globalThis && globalThis.__generator || function(n, e) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, a, i, s;
  return s = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function u(f) {
    return function(p) {
      return m([f, p]);
    };
  }
  function m(f) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; t; )
      try {
        if (r = 1, a && (i = f[0] & 2 ? a.return : f[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, f[1])).done)
          return i;
        switch (a = 0, i && (f = [f[0] & 2, i.value]), f[0]) {
          case 0:
          case 1:
            i = f;
            break;
          case 4:
            return t.label++, { value: f[1], done: !1 };
          case 5:
            t.label++, a = f[1], f = [0];
            continue;
          case 7:
            f = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (f[0] === 6 || f[0] === 2)) {
              t = 0;
              continue;
            }
            if (f[0] === 3 && (!i || f[1] > i[0] && f[1] < i[3])) {
              t.label = f[1];
              break;
            }
            if (f[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = f;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(f);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        f = e.call(n, t);
      } catch (p) {
        f = [6, p], a = 0;
      } finally {
        r = i = 0;
      }
    if (f[0] & 5)
      throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}, vr = globalThis && globalThis.__spreadArray || function(n, e) {
  for (var t = 0, r = e.length, a = n.length; t < r; t++, a++)
    n[a] = e[t];
  return n;
}, vh = Object.defineProperty, yh = Object.defineProperties, xh = Object.getOwnPropertyDescriptors, Di = Object.getOwnPropertySymbols, kh = Object.prototype.hasOwnProperty, Th = Object.prototype.propertyIsEnumerable, Ci = function(n, e, t) {
  return e in n ? vh(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
}, Vn = function(n, e) {
  for (var t in e || (e = {}))
    kh.call(e, t) && Ci(n, t, e[t]);
  if (Di)
    for (var r = 0, a = Di(e); r < a.length; r++) {
      var t = a[r];
      Th.call(e, t) && Ci(n, t, e[t]);
    }
  return n;
}, Ur = function(n, e) {
  return yh(n, xh(e));
}, Oh = function(n, e, t) {
  return new Promise(function(r, a) {
    var i = function(m) {
      try {
        u(t.next(m));
      } catch (f) {
        a(f);
      }
    }, s = function(m) {
      try {
        u(t.throw(m));
      } catch (f) {
        a(f);
      }
    }, u = function(m) {
      return m.done ? r(m.value) : Promise.resolve(m.value).then(i, s);
    };
    u((t = t.apply(n, e)).next());
  });
};
function Sn(n, e) {
  function t() {
    for (var r = [], a = 0; a < arguments.length; a++)
      r[a] = arguments[a];
    if (e) {
      var i = e.apply(void 0, r);
      if (!i)
        throw new Error("prepareAction did not return an object");
      return Vn(Vn({
        type: n,
        payload: i.payload
      }, "meta" in i && { meta: i.meta }), "error" in i && { error: i.error });
    }
    return { type: n, payload: r[0] };
  }
  return t.toString = function() {
    return "" + n;
  }, t.type = n, t.match = function(r) {
    return r.type === n;
  }, t;
}
(function(n) {
  Cs(e, n);
  function e() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    var a = n.apply(this, t) || this;
    return Object.setPrototypeOf(a, e.prototype), a;
  }
  return Object.defineProperty(e, Symbol.species, {
    get: function() {
      return e;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.concat = function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    return n.prototype.concat.apply(this, t);
  }, e.prototype.prepend = function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    return t.length === 1 && Array.isArray(t[0]) ? new (e.bind.apply(e, vr([void 0], t[0].concat(this))))() : new (e.bind.apply(e, vr([void 0], t.concat(this))))();
  }, e;
})(Array);
(function(n) {
  Cs(e, n);
  function e() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    var a = n.apply(this, t) || this;
    return Object.setPrototypeOf(a, e.prototype), a;
  }
  return Object.defineProperty(e, Symbol.species, {
    get: function() {
      return e;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.concat = function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    return n.prototype.concat.apply(this, t);
  }, e.prototype.prepend = function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    return t.length === 1 && Array.isArray(t[0]) ? new (e.bind.apply(e, vr([void 0], t[0].concat(this))))() : new (e.bind.apply(e, vr([void 0], t.concat(this))))();
  }, e;
})(Array);
var Ph = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", jh = function(n) {
  n === void 0 && (n = 21);
  for (var e = "", t = n; t--; )
    e += Ph[Math.random() * 64 | 0];
  return e;
}, Eh = [
  "name",
  "message",
  "stack",
  "code"
], qr = (
  /** @class */
  function() {
    function n(e, t) {
      this.payload = e, this.meta = t;
    }
    return n;
  }()
), Li = (
  /** @class */
  function() {
    function n(e, t) {
      this.payload = e, this.meta = t;
    }
    return n;
  }()
), Sh = function(n) {
  if (typeof n == "object" && n !== null) {
    for (var e = {}, t = 0, r = Eh; t < r.length; t++) {
      var a = r[t];
      typeof n[a] == "string" && (e[a] = n[a]);
    }
    return e;
  }
  return { message: String(n) };
};
(function() {
  function n(e, t, r) {
    var a = Sn(e + "/fulfilled", function(f, p, d, c) {
      return {
        payload: f,
        meta: Ur(Vn({}, c || {}), {
          arg: d,
          requestId: p,
          requestStatus: "fulfilled"
        })
      };
    }), i = Sn(e + "/pending", function(f, p, d) {
      return {
        payload: void 0,
        meta: Ur(Vn({}, d || {}), {
          arg: p,
          requestId: f,
          requestStatus: "pending"
        })
      };
    }), s = Sn(e + "/rejected", function(f, p, d, c, l) {
      return {
        payload: c,
        error: (r && r.serializeError || Sh)(f || "Rejected"),
        meta: Ur(Vn({}, l || {}), {
          arg: d,
          requestId: p,
          rejectedWithValue: !!c,
          requestStatus: "rejected",
          aborted: (f == null ? void 0 : f.name) === "AbortError",
          condition: (f == null ? void 0 : f.name) === "ConditionError"
        })
      };
    }), u = typeof AbortController != "undefined" ? AbortController : (
      /** @class */
      function() {
        function f() {
          this.signal = {
            aborted: !1,
            addEventListener: function() {
            },
            dispatchEvent: function() {
              return !1;
            },
            onabort: function() {
            },
            removeEventListener: function() {
            },
            reason: void 0,
            throwIfAborted: function() {
            }
          };
        }
        return f.prototype.abort = function() {
        }, f;
      }()
    );
    function m(f) {
      return function(p, d, c) {
        var l = r != null && r.idGenerator ? r.idGenerator(f) : jh(), h = new u(), g;
        function b(y) {
          g = y, h.abort();
        }
        var w = function() {
          return Oh(this, null, function() {
            var y, v, x, T, j, A, N;
            return wh(this, function(S) {
              switch (S.label) {
                case 0:
                  return S.trys.push([0, 4, , 5]), T = (y = r == null ? void 0 : r.condition) == null ? void 0 : y.call(r, f, { getState: d, extra: c }), Nh(T) ? [4, T] : [3, 2];
                case 1:
                  T = S.sent(), S.label = 2;
                case 2:
                  if (T === !1 || h.signal.aborted)
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  return j = new Promise(function(E, k) {
                    return h.signal.addEventListener("abort", function() {
                      return k({
                        name: "AbortError",
                        message: g || "Aborted"
                      });
                    });
                  }), p(i(l, f, (v = r == null ? void 0 : r.getPendingMeta) == null ? void 0 : v.call(r, { requestId: l, arg: f }, { getState: d, extra: c }))), [4, Promise.race([
                    j,
                    Promise.resolve(t(f, {
                      dispatch: p,
                      getState: d,
                      extra: c,
                      requestId: l,
                      signal: h.signal,
                      abort: b,
                      rejectWithValue: function(E, k) {
                        return new qr(E, k);
                      },
                      fulfillWithValue: function(E, k) {
                        return new Li(E, k);
                      }
                    })).then(function(E) {
                      if (E instanceof qr)
                        throw E;
                      return E instanceof Li ? a(E.payload, l, f, E.meta) : a(E, l, f);
                    })
                  ])];
                case 3:
                  return x = S.sent(), [3, 5];
                case 4:
                  return A = S.sent(), x = A instanceof qr ? s(null, l, f, A.payload, A.meta) : s(A, l, f), [3, 5];
                case 5:
                  return N = r && !r.dispatchConditionRejection && s.match(x) && x.meta.condition, N || p(x), [2, x];
              }
            });
          });
        }();
        return Object.assign(w, {
          abort: b,
          requestId: l,
          arg: f,
          unwrap: function() {
            return w.then(Ah);
          }
        });
      };
    }
    return Object.assign(m, {
      pending: i,
      rejected: s,
      fulfilled: a,
      typePrefix: e
    });
  }
  return n.withTypes = function() {
    return n;
  }, n;
})();
function Ah(n) {
  if (n.meta && n.meta.rejectedWithValue)
    throw n.payload;
  if (n.error)
    throw n.error;
  return n.payload;
}
function Nh(n) {
  return n !== null && typeof n == "object" && typeof n.then == "function";
}
var Wa = "listenerMiddleware";
Sn(Wa + "/add");
Sn(Wa + "/removeAll");
Sn(Wa + "/remove");
typeof queueMicrotask == "function" && queueMicrotask.bind(typeof window != "undefined" ? window : typeof global != "undefined" ? global : globalThis);
hh();
var Ih = Object.prototype.toString, Ls = function(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  var t = typeof e;
  if (t === "boolean")
    return "boolean";
  if (t === "string")
    return "string";
  if (t === "number")
    return "number";
  if (t === "symbol")
    return "symbol";
  if (t === "function")
    return Lh(e) ? "generatorfunction" : "function";
  if (Mh(e))
    return "array";
  if (Bh(e))
    return "buffer";
  if ($h(e))
    return "arguments";
  if (Dh(e))
    return "date";
  if (_h(e))
    return "error";
  if (Ch(e))
    return "regexp";
  switch (Ws(e)) {
    case "Symbol":
      return "symbol";
    case "Promise":
      return "promise";
    case "WeakMap":
      return "weakmap";
    case "WeakSet":
      return "weakset";
    case "Map":
      return "map";
    case "Set":
      return "set";
    case "Int8Array":
      return "int8array";
    case "Uint8Array":
      return "uint8array";
    case "Uint8ClampedArray":
      return "uint8clampedarray";
    case "Int16Array":
      return "int16array";
    case "Uint16Array":
      return "uint16array";
    case "Int32Array":
      return "int32array";
    case "Uint32Array":
      return "uint32array";
    case "Float32Array":
      return "float32array";
    case "Float64Array":
      return "float64array";
  }
  if (Wh(e))
    return "generator";
  switch (t = Ih.call(e), t) {
    case "[object Object]":
      return "object";
    case "[object Map Iterator]":
      return "mapiterator";
    case "[object Set Iterator]":
      return "setiterator";
    case "[object String Iterator]":
      return "stringiterator";
    case "[object Array Iterator]":
      return "arrayiterator";
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
};
function Ws(n) {
  return typeof n.constructor == "function" ? n.constructor.name : null;
}
function Mh(n) {
  return Array.isArray ? Array.isArray(n) : n instanceof Array;
}
function _h(n) {
  return n instanceof Error || typeof n.message == "string" && n.constructor && typeof n.constructor.stackTraceLimit == "number";
}
function Dh(n) {
  return n instanceof Date ? !0 : typeof n.toDateString == "function" && typeof n.getDate == "function" && typeof n.setDate == "function";
}
function Ch(n) {
  return n instanceof RegExp ? !0 : typeof n.flags == "string" && typeof n.ignoreCase == "boolean" && typeof n.multiline == "boolean" && typeof n.global == "boolean";
}
function Lh(n, e) {
  return Ws(n) === "GeneratorFunction";
}
function Wh(n) {
  return typeof n.throw == "function" && typeof n.return == "function" && typeof n.next == "function";
}
function $h(n) {
  try {
    if (typeof n.length == "number" && typeof n.callee == "function")
      return !0;
  } catch (e) {
    if (e.message.indexOf("callee") !== -1)
      return !0;
  }
  return !1;
}
function Bh(n) {
  return n.constructor && typeof n.constructor.isBuffer == "function" ? n.constructor.isBuffer(n) : !1;
}
/*!
 * shallow-clone <https://github.com/jonschlinkert/shallow-clone>
 *
 * Copyright (c) 2015-present, Jon Schlinkert.
 * Released under the MIT License.
 */
const Wi = Symbol.prototype.valueOf, Fh = Ls;
function Rh(n, e) {
  switch (Fh(n)) {
    case "array":
      return n.slice();
    case "object":
      return Object.assign({}, n);
    case "date":
      return new n.constructor(Number(n));
    case "map":
      return new Map(n);
    case "set":
      return new Set(n);
    case "buffer":
      return qh(n);
    case "symbol":
      return Yh(n);
    case "arraybuffer":
      return zh(n);
    case "float32array":
    case "float64array":
    case "int16array":
    case "int32array":
    case "int8array":
    case "uint16array":
    case "uint32array":
    case "uint8clampedarray":
    case "uint8array":
      return Uh(n);
    case "regexp":
      return Hh(n);
    case "error":
      return Object.create(n);
    default:
      return n;
  }
}
function Hh(n) {
  const e = n.flags !== void 0 ? n.flags : /\w+$/.exec(n) || void 0, t = new n.constructor(n.source, e);
  return t.lastIndex = n.lastIndex, t;
}
function zh(n) {
  const e = new n.constructor(n.byteLength);
  return new Uint8Array(e).set(new Uint8Array(n)), e;
}
function Uh(n, e) {
  return new n.constructor(n.buffer, n.byteOffset, n.length);
}
function qh(n) {
  const e = n.length, t = Buffer.allocUnsafe ? Buffer.allocUnsafe(e) : Buffer.from(e);
  return n.copy(t), t;
}
function Yh(n) {
  return Wi ? Object(Wi.call(n)) : {};
}
var Vh = Rh;
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
var Gh = function(e) {
  return e != null && typeof e == "object" && Array.isArray(e) === !1;
};
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
var Qh = Gh;
function $i(n) {
  return Qh(n) === !0 && Object.prototype.toString.call(n) === "[object Object]";
}
var Xh = function(e) {
  var t, r;
  return !($i(e) === !1 || (t = e.constructor, typeof t != "function") || (r = t.prototype, $i(r) === !1) || r.hasOwnProperty("isPrototypeOf") === !1);
};
const Kh = Vh, Zh = Ls, Jh = Xh;
function $a(n, e) {
  switch (Zh(n)) {
    case "object":
      return ef(n, e);
    case "array":
      return tf(n, e);
    default:
      return Kh(n);
  }
}
function ef(n, e) {
  if (typeof e == "function")
    return e(n);
  if (e || Jh(n)) {
    const t = new n.constructor();
    for (let r in n)
      t[r] = $a(n[r], e);
    return t;
  }
  return n;
}
function tf(n, e) {
  const t = new n.constructor(n.length);
  for (let r = 0; r < n.length; r++)
    t[r] = $a(n[r], e);
  return t;
}
var nf = $a;
const Kt = /* @__PURE__ */ Vc(nf), Rt = {
  root: "/ponuka/telefony-a-zariadenia",
  listing: "/e-shop/produkty",
  detail: "/e-shop/produkt"
};
function Ba(n) {
  return n ? n == null ? void 0 : n.reduce((e, t) => t.type === "O2MOBIL" && t.amount > 0 ? e - t.amount : e + t.amount, 0) : 0;
}
function ze(n) {
  return n % 1 !== 0 ? n.toFixed(2).replace(".", ",") : n.toString().replace(".", ",");
}
function Qt(n, e) {
  return n === 1 ? e.one : n <= 5 ? e.maxFive : e.moreThanFive;
}
function Fa(n) {
  const e = Y({
    contextTariff: n.get("contextTariff"),
    transaction: n.get("transaction"),
    promoCode: n.get("promoCode"),
    compareHw: n.get("compareHw"),
    utm_source: n.get("utm_source")
  }, n.get("a") === "ORGANIZATION" ? { a: n.get("a") } : {});
  return Object.keys(e).reduce(function(t, r) {
    return e[r] !== null ? ie(Y({}, t), { [r]: e[r] }) : t;
  }, {});
}
function pn(n, e, t) {
  const r = rf(
    new URLSearchParams(Fa(n)),
    !!t
  );
  return r.toString() ? `${e}?${r.toString()}` : e;
}
function rf(n, e) {
  return e ? n.set(na, "true") : n.delete(na), n;
}
const af = (n) => {
  var e, t;
  return (t = (e = n.getAll("u")[0]) == null ? void 0 : e.split(",")) == null ? void 0 : t.map((r) => r);
}, of = (n) => n.getAll("t")[0] ? decodeURIComponent(n.getAll("t")[0]) : "", sf = (n) => {
  var e, t;
  return (t = (e = n.getAll("i")[0]) == null ? void 0 : e.split(",")) == null ? void 0 : t.map((r) => r);
}, cf = (n) => {
  const e = n.getAll("s")[0];
  if (e) {
    const t = Object.entries(ka).filter(
      (r) => r[1] === e
    )[0];
    if (t && t[0] === "cheapest")
      return {
        ascending: !0,
        attribute: "oneTimePrice"
      };
    if (t && t[0] === "mostExpensive")
      return {
        ascending: !1,
        attribute: "oneTimePrice"
      };
    if (t && t[0] === "newest")
      return;
  }
}, Bi = (n, e, t) => {
  var a;
  const r = [{ ascending: !0, attribute: "name" }];
  return e ? r.unshift(e) : (r.unshift({ attribute: "activeStartDate", ascending: !1 }), r.unshift({ attribute: "skuPopularity", ascending: !1 })), (!((a = n == null ? void 0 : n.availability) != null && a.find(() => "ORGANIZATION")) || !t) && r.unshift({ attribute: "stockAvailabilitySummary", ascending: !1 }), r;
}, uf = (n, e) => {
  var r, a, i, s, u, m, f;
  const t = Fa(n);
  for (const [p, d] of n.entries()) {
    let c = "";
    if (p === "p") {
      const l = Number((r = d.split("--")) == null ? void 0 : r[0]);
      l && ((a = e.aggregation) != null && a.oneTimePrice.minValue) && l > e.aggregation.oneTimePrice.minValue && (c = `${l}--`);
      const h = Number((i = d.split("--")) == null ? void 0 : i[1]);
      h && ((s = e.aggregation) != null && s.oneTimePrice.maxValue) && h < e.aggregation.oneTimePrice.maxValue && (c = `${c.replace("--", "")}--${h}`);
    }
    if (p === "a" && (delete t.a, c = d.split(",").filter((l) => {
      var h, g, b, w, y;
      return ((b = (g = (h = e.aggregation) == null ? void 0 : h.skuOnStock) == null ? void 0 : g[l.toLocaleLowerCase()]) == null ? void 0 : b.sum) && ((y = (w = e.aggregation) == null ? void 0 : w.skuOnStock) == null ? void 0 : y[l.toLocaleLowerCase()]).sum > 0;
    }).join(",")), p.startsWith("f_")) {
      const l = p.replace("f_", ""), h = (u = e.aggregation) == null ? void 0 : u.skuFeatures.filter(
        (g) => g.name === l
      );
      if (!(h != null && h[0]))
        continue;
      nr.includes(l) && lf(h[0].buckets) ? c = "1" : c = d.split(",").filter(
        (g) => h.some(
          (b) => b.buckets.some(
            (w) => w.name ? w.name === decodeURIComponent(g) : w.value === decodeURIComponent(g) && w.count > 0
          )
        )
      ).join(",");
    }
    p === "ONLY_DISCOUNTED" && ((m = e.aggregation) != null && m.skuOnStock.discounted) && ((f = e.aggregation) == null ? void 0 : f.skuOnStock.discounted.sum) > 0 && (c = "1"), p === "t" && (c = d), p === "s" && vl.includes(d) && (c = d), p === "i" && (e.total <= e.results.length ? c = d : c = d.split(",").filter((l) => e.results.some((h) => h.productId === l)).join(",")), p === "u" && (e.total <= e.results.length ? c = d : c = d.split(",").filter((l) => e.results.some((h) => h.id === l)).join(",")), p === "pt" && (c = d), c && (t[p] = c);
  }
  return new URLSearchParams(t);
}, lf = (n) => n ? !!n.find((e) => e.value.toLowerCase() === "true" || e.value.toLowerCase() === "áno") : !1, dr = (n, e, t, r, a, i) => {
  const s = Fa(e);
  n.availability && (n.availability.length > 1 ? s.a = n.availability.reduce(
    (c, l) => c + "," + encodeURIComponent(l)
  ) : n.availability[0] !== void 0 ? s.a = encodeURIComponent(n.availability[0]) : delete s.a), n.price && (s.p = n.price.from ? n.price.from.toString() : "", s.p += "--", s.p += n.price.to ? n.price.to : ""), n.onlyDiscounted && (s.ONLY_DISCOUNTED = "1"), n != null && n.skuFeatures && n.skuFeatures.forEach((c) => {
    nr.includes(c.name) ? s["f_" + c.name] = "1" : c.values.length > 1 ? s["f_" + c.name] = c.values.reduce(
      (l, h) => l + "," + encodeURIComponent(h)
    ) : s["f_" + c.name] = encodeURIComponent(c.values[0]);
  });
  const u = e.getAll("i"), m = e.getAll("u"), f = e.getAll("pt"), p = e.getAll("s"), d = e.getAll("t");
  return a && a.length > 0 ? s.i = a.join(",") : u.length > 0 && (s.i = u.join(",")), i && i.length > 0 ? s.u = i.join(",") : m.length > 0 && (s.u = m.join(",")), n != null && n.promoTags && n.promoTags.length > 0 ? s.pt = n.promoTags.join(",") : f.length > 0 && (s.pt = f.join(",")), r ? s.s = ka[r] : p.length > 0 && (s.s = p.join(",")), t ? s.t = encodeURIComponent(t) : t !== "" && d.length > 0 && (s.t = d.join(",")), new URLSearchParams(s);
}, df = (n, e) => {
  var t, r, a, i, s;
  return (s = (i = (a = (r = (t = e == null ? void 0 : e.skuFeatures) == null ? void 0 : t.filter((u) => u.name === gs)) == null ? void 0 : r[0]) == null ? void 0 : a.buckets.find((u) => u.name === n)) == null ? void 0 : i.value) != null ? s : n;
}, $s = (n) => {
  const e = {};
  for (const t of n.entries()) {
    if (t[0] === "p") {
      e.price = {};
      const r = t[1].split("--");
      r[0] && r[0] !== "undefined" && (e.price.from = Number(r[0])), r[1] && r[1] !== "undefined" && (e.price.to = Number(r[1]));
    }
    if (t[0] === "a" && (e.availability = t[1].split(",")), t[0].startsWith("f_")) {
      const r = t[0].replace("f_", "");
      if (e.skuFeatures || (e.skuFeatures = []), nr.includes(r)) {
        e.skuFeatures.push({ name: r, values: ["true"] });
        continue;
      }
      e.skuFeatures.push({
        name: r,
        values: t[1].split(",").map((a) => decodeURIComponent(a))
      });
    }
    t[0] === "ONLY_DISCOUNTED" && (e.onlyDiscounted = t[1] === "1"), t[0] === "pt" && (e.promoTags = t[1].split(","));
  }
  return e;
}, Fi = (n) => {
  var e, t, r;
  return !((e = n.availability) != null && e.length) && !n.price && !((t = n.skuFeatures) != null && t.length) && !n.onlyDiscounted && !((r = n.promoTags) != null && r.length);
}, Xn = (n, e, t, r) => {
  var a, i;
  return n ? !!(e && n.availability && n.availability.indexOf(e) > -1 || t && n.skuFeatures && ((i = (a = n.skuFeatures.filter((s) => s.name === t.name)) == null ? void 0 : a[0]) == null ? void 0 : i.values.indexOf(t == null ? void 0 : t.values[0])) > -1 || r && n.onlyDiscounted) : !1;
}, Ri = (n) => {
  var t, r;
  let e = 0;
  return n.skuFeatures && (e += (t = n == null ? void 0 : n.skuFeatures) == null ? void 0 : t.reduce((a, i, s, u) => a + u[s].values.reduce((m) => m + 1, 0), 0)), n.availability && (e += n.availability.length), n.price && e++, n.onlyDiscounted && e++, (r = n.promoTags) != null && r.length && (e += n.promoTags.length), e;
}, mf = (n, e) => {
  var t, r;
  return (t = n == null ? void 0 : n.availability) != null && t.find((a) => a === "ORGANIZATION") && e ? { stockAvailability: "ON_STOCK", organizations: [e] } : (r = n == null ? void 0 : n.availability) != null && r.find((a) => a === "AVAILABLE") ? {
    stockAvailability: "ON_STOCK",
    organizations: e ? [Xt, e] : [Xt]
  } : {
    organizations: e ? [Xt, e] : [Xt]
  };
}, hf = (n, e) => {
  const t = Kt(n);
  return t.hwPricingList = [
    ...e ? Kt(e.hwPricingList) : [],
    ...Kt(n == null ? void 0 : n.hwPricingList)
  ], t;
}, ff = (n) => {
  var t, r;
  const e = (t = n.tagsComputed) == null ? void 0 : t.filter((a) => (a == null ? void 0 : a.tagSource) === kl);
  return xl[(r = e == null ? void 0 : e[0]) == null ? void 0 : r.name];
}, ua = (n, e, t) => {
  if (n) {
    const a = Kt(n);
    e.price ? a.oneTimePrice = e.price : a.oneTimePrice = void 0, a.skuFeatures = e.skuFeatures ? Kt(e == null ? void 0 : e.skuFeatures) : [], a.onlyDiscounted = e.onlyDiscounted ? e.onlyDiscounted : !1, a.promoTags = e.promoTags ? e.promoTags : [];
    const i = mf(e, t), r = a, { stockAvailability: s } = r, u = Rn(r, ["stockAvailability"]);
    return Y(Y({}, u), i);
  }
}, Bs = (n, e, t) => {
  var r, a;
  if (n && n.aggregation) {
    const i = n.aggregation.skuFeatures.filter(
      (u) => u.name === e
    );
    if (i.length === 0)
      return 0;
    const s = i[0].buckets.filter((u) => u.value === t);
    return (a = (r = s == null ? void 0 : s[0]) == null ? void 0 : r.count) != null ? a : 0;
  }
  return 0;
}, Ra = (n, e) => pn(n, `${Rt.detail}/${e}`), kt = (n) => {
  const e = {}, t = {};
  return n.forEach((r) => {
    r.groupingFeatures && r.groupingFeatures.forEach((a) => {
      a.name === "DEVICE_COLOR" ? e[a.value] = a : a.name === "INTERNAL_STORAGE" && (t[a.value] = a);
    });
  }), { storage: Object.values(t), colors: Object.values(e) };
}, pf = (n) => ["Q125XINO", "Q125SAMS", "Q125MOTO", "Q125HONO", "Q125XI14"].includes(n), Fs = (n, e) => Tm(n || e).toLowerCase().replace(/\s/g, "_"), gf = (n) => n.features.reduce((e, t, r) => (r % 2 === 0 ? e.push([t]) : e[e.length - 1].push(t), e), []), Hi = (n) => parseFloat(n.replace(/[^0-9,.]/g, "").replace(",", "."));
function bf(n) {
  const e = /* @__PURE__ */ new Map();
  return n.forEach((t) => {
    let r = e.get(t.name);
    r ? r.values = [...r.values, t] : (r = {
      name: t.name,
      displayName: t.displayName,
      values: [t]
    }, e.set(t.name, r));
  }), e;
}
function wf(n) {
  n.forEach((e) => {
    e.values.sort((t, r) => {
      var s, u;
      const a = (s = t.displayValue) == null ? void 0 : s.toLowerCase(), i = (u = r.displayValue) == null ? void 0 : u.toLowerCase();
      return !a || !i ? 0 : a < i ? -1 : a > i ? 1 : 0;
    });
  });
}
function vf(n) {
  const e = /* @__PURE__ */ new Map();
  return n.forEach((t) => {
    e.set(t.name, t.value);
  }), e;
}
const yf = (n, e, t, r, a, i) => {
  let s = `${Ol}?${vn.HW_CONTEXT}=${e.seoId}`;
  return a && (s += `&${vn.PROMO_CODE}=${a}`), i && (s += `&${vn.TRANSACTION}=${i}`), r && (s += `&${vn.HW_INSURANCE}=${e.seoId}`), t.forEach((u) => {
    var f;
    const m = Fs(u.variantName, u.name);
    s += `&${vn.HW_CONTEXT}=${u.seoId}`, (f = n[m]) != null && f.insurance && (s += `&${vn.HW_INSURANCE}=${u.seoId}`);
  }), s;
}, Rs = (n) => n === "AVAILABLEINESHOP" ? "availableInEshop" : n === "AVAILABLEOUTSIDEESHOP" ? "availableOutsideEshop" : n === "UNAVAILABLE" ? "unavailable" : n, Hs = ({
  isHwDetail: n,
  buyHw: e,
  sku: t,
  hasNegativeStockOrders: r,
  hasUserAccountId: a,
  selectedOrganizationType: i
}) => !(!n || e || !a && ["Brand Store", "Franchise"].includes(i != null ? i : "") || Ta({
  stockAvailability: t == null ? void 0 : t.stockAvailability,
  stockAvailabilitySummary: t == null ? void 0 : t.stockAvailabilitySummary
}) === Ze.ESHOP_UNAVAILABLE && r), gn = {
  servletError: "Nastala chyba pri načítavaní údajov zo servera. Skúste neskôr prosím.",
  error: "Nepodarilo sa načítať produkty",
  compare: {
    heading: "Porovnanie produktov"
  },
  detail: {
    cancel: "Zrušiť",
    alreadyInCompare: "Pridané do porovnania",
    alreadyInCompareAria: "",
    addToCompare: "Pridať do porovnania",
    addToCompareAria: "",
    title: "HW Detail",
    notFound: "Produkt sa nenašiel. Skontrolujte zadanú URL adresu alebo skúste znova neskôr",
    error: "Pri načítavaní dát nastala chyba. Skúste znova neskôr.",
    showMore: "Zobraziť viac",
    specificationTitle: "Špecifikácia",
    notAvailable: "Dočasne nedostupný",
    availableIn: " a dostupný v ",
    notAvailableInOrganization: "Nedostupný na sklade predajne",
    notAvailableInEshop: "Nedostupný v e-shope",
    availableOnlyInEshop: "Na externom sklade",
    availableInOrganization: "Na sklade predajne $amount$ ks",
    availableInEshop: "Na sklade $amount$ ks",
    miniVersion: {
      availableInOrganization: "Na sklade predajne",
      availableInEshop: "Na sklade",
      amount: {
        one: " 1 ks",
        maxFive: " 2 - 5 ks",
        moreThanFive: " viac ako 5 ks"
      }
    },
    amount: {
      one: "1",
      maxFive: "2 - 5",
      moreThanFive: "viac ako 5"
    },
    externalAvailability: {
      inOne: "1 predajni",
      inMore: "$number$ predajniach"
    },
    loginPromptTitlte: "Ste už naším zákazníkom?",
    loginPrompt: "Prihláste sa pre ponuku na mieru.",
    insuranceHeading: "Poistenie zariadenia",
    insuranceTitle: "$hwInsuranceName$ za $hwInsurancePrice$ € mes.",
    login: "Prihlásiť sa",
    breadcrumb: {
      level1: "Telefóny a zariadenia"
    },
    responseCode: {
      title: {
        NOT_ELIGIBLE_WITH_FIX_PROGRAM: "Nepovolený produkt",
        unknown: "Niečo sa pokazilo"
      },
      description: {
        NOT_ELIGIBLE_WITH_FIX_PROGRAM: "Internet na doma nie je možné kúpiť s iným programom alebo tovarom. Pre nákup HW odstráňte program Internet na doma z košíka.",
        unknown: "Prepáčte, služba je momentálne nedostupná. Skúste to neskôr, prosím."
      }
    },
    buyWithTariffBtn: "Kúpiť na splátky k paušálu",
    buyWithoutTariffBtn: "Kúpiť za plnú sumu",
    accontation: "od $value$ €",
    monthlyPayment: {
      withHwInsurance: " + $value$ € mes. s poistením",
      noHwInsurance: " + $value$ € mes."
    },
    fromZero: "od 0",
    until: "do $date$",
    accontationWithMonthlyPayment: {
      withInsurance: "od $accontation$ € + $monthlyPayment$ € mes. s poistením",
      noInsurance: "od $accontation$ € + $monthlyPayment$ € mes."
    },
    withDiscountWithTariff: {
      hasTariffName: "so zľavou k $tariffName$",
      noTariffName: "so zľavou k vášmu paušálu"
    },
    orWithDiscountWithTariff: {
      hasTariffName: "alebo so zľavou k $tariffName$",
      noTariffName: "alebo so zľavou k vášmu paušálu"
    },
    hwPrice: "Cena $deviceType$ $oneTimePrice$ € ",
    priceWithCurrencySign: "$price$ €",
    priceUntil: " do $oldPriceEffectiveEndDate$",
    device: {
      O2_EXTRA: "zariadenia",
      SMARTWATCH: "smart hodiniek",
      MOBILE_PHONES: "telefónu",
      TABLETS: "tabletu",
      ACCESSORIES: "príslušenstva"
    },
    stockAvailabilityModal: {
      heading: "Dostupnosť tovaru",
      courierDelivery: "Doručenie kuriérom",
      courierDeliveryWithBalikovo: "Doručenie kuriérom a cez balíkovo",
      pickupInStore: "Osobný odber na predajni",
      searchStore: "Vyhľadať predajňu",
      available: "na sklade $amount$ ks",
      availableMoreThanFive: "ihneď k odberu (viac ako 5 ks)",
      deliverTomorrow: "už zajtra u vás",
      deliveryDate: "doručíme $date$",
      notAvailable: "nedostupný",
      availableEshop: "na objednávku do 3 dní",
      availableAt: "k odberu od $hour$:00 ($amount$ ks)",
      availableNow: "ihneď k odberu ($amount$ ks)",
      availableTomorrow: "k odberu zajtra o $hour$:00 ($amount$ ks)"
    },
    salesSticker: "Zľava - $value$ €"
  },
  login: {
    heading: "Ste už naším zákazníkom?",
    description: "Prihláste sa pre ponuku na mieru.",
    confirm: "Prihlásiť sa"
  },
  rootBreadcrumb: "Telefóny a zariadenia",
  nothingFound: "Nič sa nenašlo",
  nothingFoundDescription: "Vašim požiadavkám nevyhovuje žiadny tovar. Prosím, zmeňte svoj výber.",
  subscriberFromAnotherServiceProvider: "Nič sa nenašlo - prihlásený zákazník operátora Tescomobile / Radost",
  subscriberFromAnotherServiceProviderDescription: 'Pre načítanie "Telefóny a zariadenia" je potrebné zákazníka v O4 odhlásiť.',
  loadMore: "Zobraziť ďalšie",
  moreLink: "Zobraziť viac",
  sorting: {
    newest: "Najnovšie",
    cheapest: "Najlacnejšie",
    mostExpensive: "Najdrahšie"
  },
  stockAvailability: {
    availableInEshop: "na sklade",
    availableOutsideEshop: "nedostupný v e-shope",
    unavailable: "dočasne nedostupný"
  },
  stockAvailabilityOrganization: {
    default: "na sklade predajne",
    availableInEshop: "na externom sklade",
    availableOutsideEshop: "nedostupný na sklade predajne",
    unavailable: "dočasne nedostupný"
  },
  eyeCatchers: {
    discount: "Zľava"
  },
  clearFilter: "Vymazať filter",
  openFilterModal: "Otvoriť filter",
  findText: "Vyhľadať",
  closeFilterModal: "Zatvoriť",
  applyFilters: "Zobraziť",
  filter: {
    open: "Otvoriť filter",
    reset: "Vymazať filter",
    selectTariff: "Vybrať iný paušál",
    yourTariff: "Ceny platia pre váš paušál.",
    tariffPrice: "Ceny platia pre <strong>$tariffName$</strong>.",
    search: "Vyhľadať"
  },
  orWithTariff: "alebo k paušálu ",
  device: {
    O2_EXTRA: "zariadenia",
    SMARTWATCH: "smart hodiniek",
    MOBILE_PHONES: "telefónu",
    TABLETS: "tabletu",
    ACCESSORIES: "príslušenstva"
  },
  buyWithTariffBtn: "Kúpiť na splátky k paušálu",
  buyWithoutTariffBtn: "Kúpiť za plnú sumu",
  hwBudgetPromptTitle: "Máte nevyčerpanú zľavu",
  hwBudgetText: "Ceny zohľadňujú vašu zľavu $bonus$ € mes.",
  salesSticker: "Zľava - $value$ €",
  availability: {
    ALL: "Všetky zariadenia",
    AVAILABLE: "Iba dostupné",
    ORGANIZATION: "Dostupné v tejto predajni",
    DISCOUNTED: "Zľava"
  },
  numberOfDevices: {
    one: "$amount$ položka",
    few: "$amount$ položky",
    many: "$amount$ položiek"
  },
  skuCharacteristics: {
    FEATURES: "Technické parametre",
    MANUFACTURER: "Značka",
    OPERATING_SYSTEM: "Operačný systém",
    DEVICE_COLOR: "Farba",
    DISPLAY_RANGE: "Uhlopriečka displeja",
    VIRT_PRICE_RANGE: "Cena",
    VIRT_AVAILABILITY: "Dostupnosť",
    LTE: "LTE",
    GPS: "GPS",
    IRDA: "IrDA",
    NFC: "NFC",
    BLUETOOTH: "BlueTooth",
    WIFI: "Wi-Fi",
    WIFI_BOOL: "Wi-Fi",
    "5G": "5G",
    BLUETOOTH_BOOL: "BlueTooth",
    INTERNAL: "Vnútorná pamäť",
    DUAL_SIM: "Dual SIM",
    Volte: "VoLTE",
    WIRELESS_CHARGING: "Bezdrôtové nabíjanie",
    VoWiFi: "VoWi-Fi",
    FINGERPRINT: "Fingerprint",
    ACCESSORIES_SUBTYPE: "Typ príslušenstva",
    EXTRA_SUBCATEGORY: "Kategória",
    EXTRA_SUBTYPE: "Typ zariadenia",
    ESIM: "eSim",
    EXTERNAL: "Pamäťová karta"
  },
  promoDetail: {
    checkbox: {
      labelSingleHardBundle: "Získajte obal a sklo za 1€",
      labelMultipleHardBundle: "Získajte obal a sklo za 1€",
      labelSingle: "Chcem zariadenie navyše výhodne k nákupu",
      labelMultiple: "Chcem zariadenia navyše výhodne k nákupu",
      validTo: "Len do $date$"
    },
    unavailableEshop: {
      heading: "Dočasne nedostupné v e-shope",
      description: "Zistite dostupnosť zariadení na predajni"
    },
    showVariants: "Výber variantov",
    showPromo: "Zobraziť ponuku",
    variantModal: {
      submit: "Potvrdiť výber",
      cancel: "Zavrieť",
      color: "Farba",
      memory: "Veľkosť"
    },
    price: {
      validTo: "do $date$",
      intro: "Platí pri využití špeciálnej ponuky",
      description: 'Pri nákupe k paušálu získate <span class="text-body-1-strong">dodatočnú zľavu</span>.',
      total: 'Cena spolu za zariadenia <span class="text-brand">$price$ €</span>. Pri nákupe k paušálu získate <span class="text-body-1-strong">dodatočnú zľavu</span>.',
      buyWithTariff: "Kúpiť na splátky k paušálu",
      buyWithCash: "Kúpiť za plnú sumu"
    }
  },
  watchdog: {
    button: "Upozorniť na dostupnosť",
    modal: {
      heading: "Zapnúť upozornenie",
      description: "Zadajte kontakt, na ktorý chcete odoslať informáciu, akonáhle bude tovar dostupný na sklade e-shopu",
      contactEmail: {
        label: "Email",
        placeholder: "Váš email"
      },
      contactMsisdn: {
        label: "Telefónne číslo",
        placeholder: "0909 123 456",
        help: "Povinný je aspoň jeden kontakt",
        validationError: "Nepodporovaný formát telefónneho čísla. Povolené sú len slovenské telefónne čísla."
      },
      contactValidationError: "Treba zadať aspoň jeden kontaktný údaj",
      consent: {
        text: 'Súhlasím so spracúvaním osobných údajov na účel informovania o dostupnosti požadovaného zariadenia. <a href="$href$" target="_blank">Viac o ochrane osobných údajov</a>',
        accept: "Má záujem",
        deny: "Nemá záujem"
      },
      alert: {
        success: {
          heading: "Upozornenie úspešné nastavené",
          description: "Na váš kontakt <b>$contact$</b> vám zašleme informáciu akonáhle bude tovar dostupný na sklade e-shopu."
        },
        failure: {
          heading: "Upozornenie nebolo nastavené",
          description: "Bohužiaľ nastala systémová chyba. Nastavte si upozornenie na dostupnosť ešte raz."
        }
      },
      content: {
        heading: "Údaje z formulára",
        msisdn: "Telefónne číslo",
        email: "E-mail",
        date: "Dátum vytvorenia",
        additionalInfo: "Doplňujúce informácie",
        source: "Zdroj"
      },
      detail: "Detail",
      campaignName: "Záujem o zariadenie",
      offerName: "Watchdog - nedostupnosť",
      formType: "HW detail - watchdog",
      campaignActivity: {
        header: "Je skvelé, že máte záujem o naše produkty",
        subheader: "Budeme vás kontaktovať notifikáciou pri naskladnení tovaru",
        label: "Nechali ste nám svoj kontakt"
      },
      campaignParams: {
        CAMPAIN_NAME: {
          name: "Názov kampane",
          value: "HW ponuka"
        },
        OFFER_NAME: {
          name: "Názov ponuky",
          value: "Watchdog - nedostupnosť"
        },
        SKU_IMG: {
          name: "Zariadenie obrázok"
        },
        SKU_NAME: {
          name: "Zariadenie názov"
        },
        HANDLE_BY_ASSISTANT_REQUESTED: {
          name: "Priradiť mne na spracovanie"
        }
      },
      button: {
        submit: "Potvrdiť",
        confirm: "Rozumiem",
        close: "Zavrieť"
      }
    }
  }
}, xf = {
  AVAILABLE: gn.availability.AVAILABLE
}, kf = {
  AVAILABLE: gn.availability.AVAILABLE,
  ORGANIZATION: gn.availability.ORGANIZATION
}, zs = (r) => {
  var a = r, { path: n, label: e } = a, t = Rn(a, ["path", "label"]);
  return /* @__PURE__ */ o.jsx(
    fa.Item,
    ie(Y({}, t), {
      href: n,
      "data-testid": "router-breadcrumb",
      target: n.split("?")[0] === Rt.root ? "_top" : void 0,
      children: e
    })
  );
};
var Tf = Object.defineProperty, Of = Object.defineProperties, Pf = Object.getOwnPropertyDescriptors, zi = Object.getOwnPropertySymbols, jf = Object.prototype.hasOwnProperty, Ef = Object.prototype.propertyIsEnumerable, la = (n, e, t) => e in n ? Tf(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Sf = (n, e) => {
  for (var t in e || (e = {}))
    jf.call(e, t) && la(n, t, e[t]);
  if (zi)
    for (var t of zi(e))
      Ef.call(e, t) && la(n, t, e[t]);
  return n;
}, Af = (n, e) => Of(n, Pf(e)), W = (n, e, t) => (la(n, typeof e != "symbol" ? e + "" : e, t), t);
const yr = {
  required: "Toto pole je vyžadované.",
  birthNumber: "Nesprávny formát rodného čísla.",
  birthNumberLastDigits: "Nesprávny formát posledných 4 číslic z rodného čísla.",
  identificationNumber: "Nesprávny formát identifikačného čísla.",
  birthDate: "Zadajte menší dátum ako je dnešný dátum",
  dateFormat: (...n) => `Nesprávny formát dátumu. Zadajte dátum v tvare ${n[0]}.`,
  idCardNumber: "Nesprávny formát čísla dokladu.",
  idCardLastDigits: "Nesprávny formát posledných 4 číslic z občianského preukazu.",
  idCardValidity: "Zadajte dátum v budúcnosti",
  companyName: "Nesprávny formát názvu spoločnosti.",
  businessId: "Nesprávny formát IČO.",
  taxId: "Nesprávny formát DIČ.",
  vatId: "Nesprávny formát IČ DPH.",
  msisdnSk: "Zadaná hodnota musí byť slovenské telefónne číslo.",
  phoneNumber: "Nesprávny formát telefónneho čísla.",
  email: "Nesprávny formát emailu",
  simIcc: "Nesprávny formát posledného štvorčíslie novej SIM karty.",
  simCardNumber: "Nesprávny formát čísla SIM karty.",
  smartId: "Nesprávny formát bezpečnostného kódu.",
  smartIdRetype: "Bezpečnostné kódy sa nezhodujú",
  firstName: "Nesprávny formát mena.",
  lastName: "Nesprávny formát priezviska.",
  street: "Ulica môže obsahovať len písmená a/alebo číslice, prípadne bodku alebo čiarku. Maximálny počet znakov je 55.",
  streetInternational: "Ulica môže obsahovať len písmená a/alebo číslice, prípadne bodku alebo čiarku. Maximálny počet znakov je 55.",
  homeNumber: "Popisné číslo môže obsahovať len číslice a/alebo písmená, prípadne lomítko. Maximálny počet znakov je 20.",
  homeNumberInternational: "Popisné číslo môže obsahovať len číslice a/alebo písmená, prípadne lomítko. Maximálny počet znakov je 20.",
  city: "Nesprávny formát názvu mesta. Maximálny počet znakov je 40.",
  cityInternational: "Nesprávny formát názvu mesta. Maximálny počet znakov je 40.",
  zipCode: "Pole PSČ môže obsahovať len číslice. Maximálny počet znakov je 5.",
  zipCodeInternational: "Pole PSČ môže obsahovať písmena a číslice. Maximálny počet znakov je 11.",
  zipCodeForVerification: "Nesprávny formát PSČ. Zadajte ho v tvare 12345.",
  dateFrom: '"Dátum od" nemôže byť väčší ako "Dátum do".',
  dateTo: '"Dátum do" nemôže byť menší ako "Dátum od".',
  productNumber: "Nesprávny formát názvu produktu",
  decimal: "Nesprávny formát nezáporného desatinného čísla",
  promoExternalId: "Nesprávny formát Id ponuky",
  maxLength: (n) => `Maximálny počet znakov je ${n}.`,
  minLength: (n) => `Minimálny počet znakov je ${n}.`,
  promoUniversalCode: "Nesprávny formát univerzálneho kódu",
  numeric: "Nesprávny formát celého čísla",
  positiveNumeric: "Nesprávny formát celého nezáporného čísla",
  price: "Nesprávny formát ceny",
  positivePrice: "Nesprávny formát nezápornej ceny",
  residencePermit: "Nesprávny formát čísla povolenia na pobyt. Príklad: AB1234567",
  iccid: "Nesprávny formát ICCID",
  customerReferenceNumber: "Nesprávne číslo zákazníka.",
  requestOrderNumber: "Nesprávne číslo objednávky.",
  selectedCustomer: "Zákazník nebol vybratý.",
  selectedMsisdn: "Číslo nebolo vybraté.",
  idCardCheckbox: "Overenie identifikátorov musí byť zaškrtnuté.",
  alternative: {
    businessId: "Nesprávny formát IČO. Príklad: 35848863",
    idCardNumber: "Vyplňte číslo občianskeho preukazu. Príklad: SA123456",
    idCardLastDigits: "Vyplňte posledné 4 číslice z občianskeho preukazu. Príklad: 3456",
    phoneNumber: "Nesprávny formát telefónneho čísla. Príklad: 0949123456",
    birthNumber: "Nesprávny formát rodného čísla. Príklad: 999999/9999",
    birthNumberLastDigits: "Vyplňte posledné 4 číslice z rodného čísla. Príklad: 9999",
    required: "Povinný údaj."
  },
  passwordFormat: "Heslo nespĺňa podmienky",
  passwordRetype: "Zadané heslá sa nezhodujú",
  bscsCodeShort: "Nesprávny formát skráteného čísla predajne",
  bscsCode: "Nesprávny formát čísla predajne",
  sapCode: "Nesprávny formát SAP kódu",
  taxReceiptFolder: "Nesprávny formát zložky daňového dokladu",
  stockNumber: "Nesprávny formát čísla skladových zásob",
  adLogin: "Nesprávny formát prihlasovacieho mena",
  imei: "Nesprávny formát IMEI",
  contractNumber: "Nesprávny formát čísla kontraktu",
  hwContractNumber: "Nesprávny formát čísla fakturačného profilu",
  baInvoiceNumber: "Nesprávny formát čísla zmluvy na HW",
  existingSubcategory: "Podkategória sa už nachádza v zozname.",
  simSerial: "Nesprávny formát sériového čísla SIM karty",
  simPuk: "Nesprávny formát PUK kódu",
  latitude: "Nesprávny formát zemepisnej šírky",
  longitude: "Nesprávny formát zemepisnej dĺžky",
  minAge: (n) => `Osoba musí byť staršia než ${n} rokov`,
  iban: "Nesprávny formát IBAN.",
  tescoClubcard: "Zadaný formát čísla nie je správny. Prosím, uveďte platné číslo Clubcard.",
  url: "Zadaný formát URL adresy nie je správny. Prosím, zadajte platnú adresu (URL).",
  fsisdn: "Nesprávny formát. Zadajte telefónne číslo (príklad: 0949123456) alebo číslo služby (príklad: 11123456)."
}, Us = 6048e5, Nf = 6e4, If = 36e5, Mf = 1e3, Ui = Symbol.for("constructDateFrom");
function ct(n, e) {
  return typeof n == "function" ? n(e) : n && typeof n == "object" && Ui in n ? n[Ui](e) : n instanceof Date ? new n.constructor(e) : new Date(e);
}
function ut(n, e) {
  return ct(e || n, n);
}
function qs(n, e, t) {
  const r = ut(n, t == null ? void 0 : t.in);
  return isNaN(e) ? ct((t == null ? void 0 : t.in) || n, NaN) : (e && r.setDate(r.getDate() + e), r);
}
let _f = {};
function Ir() {
  return _f;
}
function Jt(n, e) {
  var t, r, a, i, s, u, m, f;
  const p = Ir(), d = (f = (m = (i = (a = e == null ? void 0 : e.weekStartsOn) != null ? a : (r = (t = e == null ? void 0 : e.locale) == null ? void 0 : t.options) == null ? void 0 : r.weekStartsOn) != null ? i : p.weekStartsOn) != null ? m : (u = (s = p.locale) == null ? void 0 : s.options) == null ? void 0 : u.weekStartsOn) != null ? f : 0, c = ut(n, e == null ? void 0 : e.in), l = c.getDay(), h = (l < d ? 7 : 0) + l - d;
  return c.setDate(c.getDate() - h), c.setHours(0, 0, 0, 0), c;
}
function Mn(n, e) {
  return Jt(n, Af(Sf({}, e), { weekStartsOn: 1 }));
}
function Df(n, e) {
  const t = ut(n, e == null ? void 0 : e.in), r = t.getFullYear(), a = ct(t, 0);
  a.setFullYear(r + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const i = Mn(a), s = ct(t, 0);
  s.setFullYear(r, 0, 4), s.setHours(0, 0, 0, 0);
  const u = Mn(s);
  return t.getTime() >= i.getTime() ? r + 1 : t.getTime() >= u.getTime() ? r : r - 1;
}
function Ys(n) {
  const e = ut(n), t = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return t.setUTCFullYear(e.getFullYear()), +n - +t;
}
function Cf(n, e) {
  const t = Df(n, e), r = ct((e == null ? void 0 : e.in) || n, 0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), Mn(r);
}
function Lf(n, e) {
  const t = ut(n, e == null ? void 0 : e.in), r = +Mn(t) - +Cf(t);
  return Math.round(r / Us) + 1;
}
function Vs(n, e) {
  var t, r, a, i, s, u, m, f;
  const p = ut(n, e == null ? void 0 : e.in), d = p.getFullYear(), c = Ir(), l = (f = (m = (i = (a = e == null ? void 0 : e.firstWeekContainsDate) != null ? a : (r = (t = e == null ? void 0 : e.locale) == null ? void 0 : t.options) == null ? void 0 : r.firstWeekContainsDate) != null ? i : c.firstWeekContainsDate) != null ? m : (u = (s = c.locale) == null ? void 0 : s.options) == null ? void 0 : u.firstWeekContainsDate) != null ? f : 1, h = ct((e == null ? void 0 : e.in) || n, 0);
  h.setFullYear(d + 1, 0, l), h.setHours(0, 0, 0, 0);
  const g = Jt(h, e), b = ct((e == null ? void 0 : e.in) || n, 0);
  b.setFullYear(d, 0, l), b.setHours(0, 0, 0, 0);
  const w = Jt(b, e);
  return +p >= +g ? d + 1 : +p >= +w ? d : d - 1;
}
function Wf(n, e) {
  var t, r, a, i, s, u, m, f;
  const p = Ir(), d = (f = (m = (i = (a = e == null ? void 0 : e.firstWeekContainsDate) != null ? a : (r = (t = e == null ? void 0 : e.locale) == null ? void 0 : t.options) == null ? void 0 : r.firstWeekContainsDate) != null ? i : p.firstWeekContainsDate) != null ? m : (u = (s = p.locale) == null ? void 0 : s.options) == null ? void 0 : u.firstWeekContainsDate) != null ? f : 1, c = Vs(n, e), l = ct((e == null ? void 0 : e.in) || n, 0);
  return l.setFullYear(c, 0, d), l.setHours(0, 0, 0, 0), Jt(l, e);
}
function $f(n, e) {
  const t = ut(n, e == null ? void 0 : e.in), r = +Jt(t, e) - +Wf(t, e);
  return Math.round(r / Us) + 1;
}
function Bf(n, e) {
  const t = ut(n, e == null ? void 0 : e.in).getDay();
  return t === 0 ? 7 : t;
}
class Ff {
  constructor() {
    W(this, "subPriority", 0);
  }
  validate(e, t) {
    return !0;
  }
}
class Rf extends Ff {
  constructor(e, t, r, a, i) {
    super(), this.value = e, this.validateValue = t, this.setValue = r, this.priority = a, i && (this.subPriority = i);
  }
  validate(e, t) {
    return this.validateValue(e, this.value, t);
  }
  set(e, t, r) {
    return this.setValue(e, t, this.value, r);
  }
}
class le {
  run(e, t, r, a) {
    const i = this.parse(e, t, r, a);
    return i ? {
      setter: new Rf(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(e, t, r) {
    return !0;
  }
}
class Hf extends le {
  constructor() {
    super(...arguments), W(this, "priority", 140), W(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(e, { width: "abbreviated" }) || r.era(e, { width: "narrow" });
      case "GGGGG":
        return r.era(e, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(e, { width: "wide" }) || r.era(e, { width: "abbreviated" }) || r.era(e, { width: "narrow" });
    }
  }
  set(e, t, r) {
    return t.era = r, e.setFullYear(r, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
const De = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Mt = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Ce(n, e) {
  return n && {
    value: e(n.value),
    rest: n.rest
  };
}
function Oe(n, e) {
  const t = e.match(n);
  return t ? {
    value: parseInt(t[0], 10),
    rest: e.slice(t[0].length)
  } : null;
}
function _t(n, e) {
  const t = e.match(n);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  const r = t[1] === "+" ? 1 : -1, a = t[2] ? parseInt(t[2], 10) : 0, i = t[3] ? parseInt(t[3], 10) : 0, s = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: r * (a * If + i * Nf + s * Mf),
    rest: e.slice(t[0].length)
  };
}
function Gs(n) {
  return Oe(De.anyDigitsSigned, n);
}
function Ae(n, e) {
  switch (n) {
    case 1:
      return Oe(De.singleDigit, e);
    case 2:
      return Oe(De.twoDigits, e);
    case 3:
      return Oe(De.threeDigits, e);
    case 4:
      return Oe(De.fourDigits, e);
    default:
      return Oe(new RegExp("^\\d{1," + n + "}"), e);
  }
}
function Qs(n, e) {
  switch (n) {
    case 1:
      return Oe(De.singleDigitSigned, e);
    case 2:
      return Oe(De.twoDigitsSigned, e);
    case 3:
      return Oe(De.threeDigitsSigned, e);
    case 4:
      return Oe(De.fourDigitsSigned, e);
    default:
      return Oe(new RegExp("^-?\\d{1," + n + "}"), e);
  }
}
function Ha(n) {
  switch (n) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Xs(n, e) {
  const t = e > 0, r = t ? e : 1 - e;
  let a;
  if (r <= 50)
    a = n || 100;
  else {
    const i = r + 50, s = Math.trunc(i / 100) * 100, u = n >= i % 100;
    a = n + s - (u ? 100 : 0);
  }
  return t ? a : 1 - a;
}
function Ks(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
class zf extends le {
  constructor() {
    super(...arguments), W(this, "priority", 130), W(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, t, r) {
    const a = (i) => ({
      year: i,
      isTwoDigitYear: t === "yy"
    });
    switch (t) {
      case "y":
        return Ce(Ae(4, e), a);
      case "yo":
        return Ce(
          r.ordinalNumber(e, {
            unit: "year"
          }),
          a
        );
      default:
        return Ce(Ae(t.length, e), a);
    }
  }
  validate(e, t) {
    return t.isTwoDigitYear || t.year > 0;
  }
  set(e, t, r) {
    const a = e.getFullYear();
    if (r.isTwoDigitYear) {
      const s = Xs(
        r.year,
        a
      );
      return e.setFullYear(s, 0, 1), e.setHours(0, 0, 0, 0), e;
    }
    const i = !("era" in t) || t.era === 1 ? r.year : 1 - r.year;
    return e.setFullYear(i, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Uf extends le {
  constructor() {
    super(...arguments), W(this, "priority", 130), W(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    const a = (i) => ({
      year: i,
      isTwoDigitYear: t === "YY"
    });
    switch (t) {
      case "Y":
        return Ce(Ae(4, e), a);
      case "Yo":
        return Ce(
          r.ordinalNumber(e, {
            unit: "year"
          }),
          a
        );
      default:
        return Ce(Ae(t.length, e), a);
    }
  }
  validate(e, t) {
    return t.isTwoDigitYear || t.year > 0;
  }
  set(e, t, r, a) {
    const i = Vs(e, a);
    if (r.isTwoDigitYear) {
      const u = Xs(
        r.year,
        i
      );
      return e.setFullYear(
        u,
        0,
        a.firstWeekContainsDate
      ), e.setHours(0, 0, 0, 0), Jt(e, a);
    }
    const s = !("era" in t) || t.era === 1 ? r.year : 1 - r.year;
    return e.setFullYear(s, 0, a.firstWeekContainsDate), e.setHours(0, 0, 0, 0), Jt(e, a);
  }
}
class qf extends le {
  constructor() {
    super(...arguments), W(this, "priority", 130), W(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t) {
    return Qs(t === "R" ? 4 : t.length, e);
  }
  set(e, t, r) {
    const a = ct(e, 0);
    return a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0), Mn(a);
  }
}
class Yf extends le {
  constructor() {
    super(...arguments), W(this, "priority", 130), W(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, t) {
    return Qs(t === "u" ? 4 : t.length, e);
  }
  set(e, t, r) {
    return e.setFullYear(r, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Vf extends le {
  constructor() {
    super(...arguments), W(this, "priority", 120), W(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    switch (t) {
      case "Q":
      case "QQ":
        return Ae(t.length, e);
      case "Qo":
        return r.ordinalNumber(e, { unit: "quarter" });
      case "QQQ":
        return r.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(e, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 4;
  }
  set(e, t, r) {
    return e.setMonth((r - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Gf extends le {
  constructor() {
    super(...arguments), W(this, "priority", 120), W(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    switch (t) {
      case "q":
      case "qq":
        return Ae(t.length, e);
      case "qo":
        return r.ordinalNumber(e, { unit: "quarter" });
      case "qqq":
        return r.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(e, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 4;
  }
  set(e, t, r) {
    return e.setMonth((r - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Qf extends le {
  constructor() {
    super(...arguments), W(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]), W(this, "priority", 110);
  }
  parse(e, t, r) {
    const a = (i) => i - 1;
    switch (t) {
      case "M":
        return Ce(
          Oe(De.month, e),
          a
        );
      case "MM":
        return Ce(Ae(2, e), a);
      case "Mo":
        return Ce(
          r.ordinalNumber(e, {
            unit: "month"
          }),
          a
        );
      case "MMM":
        return r.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(e, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return r.month(e, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(e, { width: "wide", context: "formatting" }) || r.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 11;
  }
  set(e, t, r) {
    return e.setMonth(r, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Xf extends le {
  constructor() {
    super(...arguments), W(this, "priority", 110), W(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    const a = (i) => i - 1;
    switch (t) {
      case "L":
        return Ce(
          Oe(De.month, e),
          a
        );
      case "LL":
        return Ce(Ae(2, e), a);
      case "Lo":
        return Ce(
          r.ordinalNumber(e, {
            unit: "month"
          }),
          a
        );
      case "LLL":
        return r.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(e, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return r.month(e, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(e, { width: "wide", context: "standalone" }) || r.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 11;
  }
  set(e, t, r) {
    return e.setMonth(r, 1), e.setHours(0, 0, 0, 0), e;
  }
}
function Kf(n, e, t) {
  const r = ut(n, t == null ? void 0 : t.in), a = $f(r, t) - e;
  return r.setDate(r.getDate() - a * 7), ut(r, t == null ? void 0 : t.in);
}
class Zf extends le {
  constructor() {
    super(...arguments), W(this, "priority", 100), W(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    switch (t) {
      case "w":
        return Oe(De.week, e);
      case "wo":
        return r.ordinalNumber(e, { unit: "week" });
      default:
        return Ae(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 53;
  }
  set(e, t, r, a) {
    return Jt(Kf(e, r, a), a);
  }
}
function Jf(n, e, t) {
  const r = ut(n, t == null ? void 0 : t.in), a = Lf(r, t) - e;
  return r.setDate(r.getDate() - a * 7), r;
}
class ep extends le {
  constructor() {
    super(...arguments), W(this, "priority", 100), W(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    switch (t) {
      case "I":
        return Oe(De.week, e);
      case "Io":
        return r.ordinalNumber(e, { unit: "week" });
      default:
        return Ae(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 53;
  }
  set(e, t, r) {
    return Mn(Jf(e, r));
  }
}
const tp = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], np = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class rp extends le {
  constructor() {
    super(...arguments), W(this, "priority", 90), W(this, "subPriority", 1), W(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    switch (t) {
      case "d":
        return Oe(De.date, e);
      case "do":
        return r.ordinalNumber(e, { unit: "date" });
      default:
        return Ae(t.length, e);
    }
  }
  validate(e, t) {
    const r = e.getFullYear(), a = Ks(r), i = e.getMonth();
    return a ? t >= 1 && t <= np[i] : t >= 1 && t <= tp[i];
  }
  set(e, t, r) {
    return e.setDate(r), e.setHours(0, 0, 0, 0), e;
  }
}
class ap extends le {
  constructor() {
    super(...arguments), W(this, "priority", 90), W(this, "subpriority", 1), W(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    switch (t) {
      case "D":
      case "DD":
        return Oe(De.dayOfYear, e);
      case "Do":
        return r.ordinalNumber(e, { unit: "date" });
      default:
        return Ae(t.length, e);
    }
  }
  validate(e, t) {
    const r = e.getFullYear();
    return Ks(r) ? t >= 1 && t <= 366 : t >= 1 && t <= 365;
  }
  set(e, t, r) {
    return e.setMonth(0, r), e.setHours(0, 0, 0, 0), e;
  }
}
function za(n, e, t) {
  var r, a, i, s, u, m, f, p;
  const d = Ir(), c = (p = (f = (s = (i = t == null ? void 0 : t.weekStartsOn) != null ? i : (a = (r = t == null ? void 0 : t.locale) == null ? void 0 : r.options) == null ? void 0 : a.weekStartsOn) != null ? s : d.weekStartsOn) != null ? f : (m = (u = d.locale) == null ? void 0 : u.options) == null ? void 0 : m.weekStartsOn) != null ? p : 0, l = ut(n, t == null ? void 0 : t.in), h = l.getDay(), g = (e % 7 + 7) % 7, b = 7 - c, w = e < 0 || e > 6 ? e - (h + b) % 7 : (g + b) % 7 - (h + b) % 7;
  return qs(l, w, t);
}
class ip extends le {
  constructor() {
    super(...arguments), W(this, "priority", 90), W(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return r.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return r.day(e, { width: "wide", context: "formatting" }) || r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 6;
  }
  set(e, t, r, a) {
    return e = za(e, r, a), e.setHours(0, 0, 0, 0), e;
  }
}
class op extends le {
  constructor() {
    super(...arguments), W(this, "priority", 90), W(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, r, a) {
    const i = (s) => {
      const u = Math.floor((s - 1) / 7) * 7;
      return (s + a.weekStartsOn + 6) % 7 + u;
    };
    switch (t) {
      case "e":
      case "ee":
        return Ce(Ae(t.length, e), i);
      case "eo":
        return Ce(
          r.ordinalNumber(e, {
            unit: "day"
          }),
          i
        );
      case "eee":
        return r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      case "eeeee":
        return r.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return r.day(e, { width: "wide", context: "formatting" }) || r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 6;
  }
  set(e, t, r, a) {
    return e = za(e, r, a), e.setHours(0, 0, 0, 0), e;
  }
}
class sp extends le {
  constructor() {
    super(...arguments), W(this, "priority", 90), W(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(e, t, r, a) {
    const i = (s) => {
      const u = Math.floor((s - 1) / 7) * 7;
      return (s + a.weekStartsOn + 6) % 7 + u;
    };
    switch (t) {
      case "c":
      case "cc":
        return Ce(Ae(t.length, e), i);
      case "co":
        return Ce(
          r.ordinalNumber(e, {
            unit: "day"
          }),
          i
        );
      case "ccc":
        return r.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(e, { width: "short", context: "standalone" }) || r.day(e, { width: "narrow", context: "standalone" });
      case "ccccc":
        return r.day(e, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(e, { width: "short", context: "standalone" }) || r.day(e, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return r.day(e, { width: "wide", context: "standalone" }) || r.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(e, { width: "short", context: "standalone" }) || r.day(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 6;
  }
  set(e, t, r, a) {
    return e = za(e, r, a), e.setHours(0, 0, 0, 0), e;
  }
}
function cp(n, e, t) {
  const r = ut(n, t == null ? void 0 : t.in), a = Bf(r, t), i = e - a;
  return qs(r, i, t);
}
class up extends le {
  constructor() {
    super(...arguments), W(this, "priority", 90), W(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, r) {
    const a = (i) => i === 0 ? 7 : i;
    switch (t) {
      case "i":
      case "ii":
        return Ae(t.length, e);
      case "io":
        return r.ordinalNumber(e, { unit: "day" });
      case "iii":
        return Ce(
          r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      case "iiiii":
        return Ce(
          r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      case "iiiiii":
        return Ce(
          r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      case "iiii":
      default:
        return Ce(
          r.day(e, {
            width: "wide",
            context: "formatting"
          }) || r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 7;
  }
  set(e, t, r) {
    return e = cp(e, r), e.setHours(0, 0, 0, 0), e;
  }
}
class lp extends le {
  constructor() {
    super(...arguments), W(this, "priority", 80), W(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, t, r) {
    return e.setHours(Ha(r), 0, 0, 0), e;
  }
}
class dp extends le {
  constructor() {
    super(...arguments), W(this, "priority", 80), W(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, t, r) {
    return e.setHours(Ha(r), 0, 0, 0), e;
  }
}
class mp extends le {
  constructor() {
    super(...arguments), W(this, "priority", 80), W(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, t, r) {
    return e.setHours(Ha(r), 0, 0, 0), e;
  }
}
class hp extends le {
  constructor() {
    super(...arguments), W(this, "priority", 70), W(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "h":
        return Oe(De.hour12h, e);
      case "ho":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return Ae(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 12;
  }
  set(e, t, r) {
    const a = e.getHours() >= 12;
    return a && r < 12 ? e.setHours(r + 12, 0, 0, 0) : !a && r === 12 ? e.setHours(0, 0, 0, 0) : e.setHours(r, 0, 0, 0), e;
  }
}
class fp extends le {
  constructor() {
    super(...arguments), W(this, "priority", 70), W(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "H":
        return Oe(De.hour23h, e);
      case "Ho":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return Ae(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 23;
  }
  set(e, t, r) {
    return e.setHours(r, 0, 0, 0), e;
  }
}
class pp extends le {
  constructor() {
    super(...arguments), W(this, "priority", 70), W(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "K":
        return Oe(De.hour11h, e);
      case "Ko":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return Ae(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 11;
  }
  set(e, t, r) {
    return e.getHours() >= 12 && r < 12 ? e.setHours(r + 12, 0, 0, 0) : e.setHours(r, 0, 0, 0), e;
  }
}
class gp extends le {
  constructor() {
    super(...arguments), W(this, "priority", 70), W(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "k":
        return Oe(De.hour24h, e);
      case "ko":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return Ae(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 24;
  }
  set(e, t, r) {
    const a = r <= 24 ? r % 24 : r;
    return e.setHours(a, 0, 0, 0), e;
  }
}
class bp extends le {
  constructor() {
    super(...arguments), W(this, "priority", 60), W(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "m":
        return Oe(De.minute, e);
      case "mo":
        return r.ordinalNumber(e, { unit: "minute" });
      default:
        return Ae(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 59;
  }
  set(e, t, r) {
    return e.setMinutes(r, 0, 0), e;
  }
}
class wp extends le {
  constructor() {
    super(...arguments), W(this, "priority", 50), W(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, t, r) {
    switch (t) {
      case "s":
        return Oe(De.second, e);
      case "so":
        return r.ordinalNumber(e, { unit: "second" });
      default:
        return Ae(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 59;
  }
  set(e, t, r) {
    return e.setSeconds(r, 0), e;
  }
}
class vp extends le {
  constructor() {
    super(...arguments), W(this, "priority", 30), W(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, t) {
    const r = (a) => Math.trunc(a * Math.pow(10, -t.length + 3));
    return Ce(Ae(t.length, e), r);
  }
  set(e, t, r) {
    return e.setMilliseconds(r), e;
  }
}
class yp extends le {
  constructor() {
    super(...arguments), W(this, "priority", 10), W(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(e, t) {
    switch (t) {
      case "X":
        return _t(
          Mt.basicOptionalMinutes,
          e
        );
      case "XX":
        return _t(Mt.basic, e);
      case "XXXX":
        return _t(
          Mt.basicOptionalSeconds,
          e
        );
      case "XXXXX":
        return _t(
          Mt.extendedOptionalSeconds,
          e
        );
      case "XXX":
      default:
        return _t(Mt.extended, e);
    }
  }
  set(e, t, r) {
    return t.timestampIsSet ? e : ct(
      e,
      e.getTime() - Ys(e) - r
    );
  }
}
class xp extends le {
  constructor() {
    super(...arguments), W(this, "priority", 10), W(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(e, t) {
    switch (t) {
      case "x":
        return _t(
          Mt.basicOptionalMinutes,
          e
        );
      case "xx":
        return _t(Mt.basic, e);
      case "xxxx":
        return _t(
          Mt.basicOptionalSeconds,
          e
        );
      case "xxxxx":
        return _t(
          Mt.extendedOptionalSeconds,
          e
        );
      case "xxx":
      default:
        return _t(Mt.extended, e);
    }
  }
  set(e, t, r) {
    return t.timestampIsSet ? e : ct(
      e,
      e.getTime() - Ys(e) - r
    );
  }
}
class kp extends le {
  constructor() {
    super(...arguments), W(this, "priority", 40), W(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return Gs(e);
  }
  set(e, t, r) {
    return [ct(e, r * 1e3), { timestampIsSet: !0 }];
  }
}
class Tp extends le {
  constructor() {
    super(...arguments), W(this, "priority", 20), W(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return Gs(e);
  }
  set(e, t, r) {
    return [ct(e, r), { timestampIsSet: !0 }];
  }
}
new Hf(), new zf(), new Uf(), new qf(), new Yf(), new Vf(), new Gf(), new Qf(), new Xf(), new Zf(), new ep(), new rp(), new ap(), new ip(), new op(), new sp(), new up(), new lp(), new dp(), new mp(), new hp(), new fp(), new pp(), new gp(), new bp(), new wp(), new vp(), new yp(), new xp(), new kp(), new Tp();
function Op(n, e) {
  if (!n)
    return e ? void 0 : yr.required;
  if (!n.match(/^((\+|00)?421\s?|0?)9\d{2}\s?(\d{3}\s?\d{3}|\d{2}\s?\d{2}\s?\d{2})$/g))
    return yr.msisdnSk;
}
function Pp(n, e) {
  if (!n)
    return e ? void 0 : yr.required;
  if (!n.match(/^[A-Za-z0-9]+(?:[_.-][A-Za-z0-9]+)*@[A-Za-z0-9]+(?:[.-][A-Za-z0-9]+)*\.[A-Za-z]{2,}$/g))
    return yr.email;
}
const Zs = 6048e5, jp = 864e5, Ua = 6e4, qa = 36e5, Ep = 1e3, qi = Symbol.for("constructDateFrom");
function Ne(n, e) {
  return typeof n == "function" ? n(e) : n && typeof n == "object" && qi in n ? n[qi](e) : n instanceof Date ? new n.constructor(e) : new Date(e);
}
function fe(n, e) {
  return Ne(e || n, n);
}
function Mr(n, e, t) {
  const r = fe(n, t == null ? void 0 : t.in);
  return isNaN(e) ? Ne((t == null ? void 0 : t.in) || n, NaN) : (e && r.setDate(r.getDate() + e), r);
}
function Sp(n, e, t) {
  const r = fe(n, t == null ? void 0 : t.in);
  if (isNaN(e))
    return Ne((t == null ? void 0 : t.in) || n, NaN);
  if (!e)
    return r;
  const a = r.getDate(), i = Ne((t == null ? void 0 : t.in) || n, r.getTime());
  i.setMonth(r.getMonth() + e + 1, 0);
  const s = i.getDate();
  return a >= s ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    a
  ), r);
}
function Yi(n, e, t) {
  const {
    years: r = 0,
    months: a = 0,
    weeks: i = 0,
    days: s = 0,
    hours: u = 0,
    minutes: m = 0,
    seconds: f = 0
  } = e, p = fe(n, t == null ? void 0 : t.in), d = a || r ? Sp(p, a + r * 12) : p, c = s || i ? Mr(d, s + i * 7) : d, l = m + u * 60, g = (f + l * 60) * 1e3;
  return Ne((t == null ? void 0 : t.in) || n, +c + g);
}
let Ap = {};
function Ln() {
  return Ap;
}
function Ht(n, e) {
  var u, m, f, p, d, c, l, h;
  const t = Ln(), r = (h = (l = (p = (f = e == null ? void 0 : e.weekStartsOn) != null ? f : (m = (u = e == null ? void 0 : e.locale) == null ? void 0 : u.options) == null ? void 0 : m.weekStartsOn) != null ? p : t.weekStartsOn) != null ? l : (c = (d = t.locale) == null ? void 0 : d.options) == null ? void 0 : c.weekStartsOn) != null ? h : 0, a = fe(n, e == null ? void 0 : e.in), i = a.getDay(), s = (i < r ? 7 : 0) + i - r;
  return a.setDate(a.getDate() - s), a.setHours(0, 0, 0, 0), a;
}
function _n(n, e) {
  return Ht(n, ie(Y({}, e), { weekStartsOn: 1 }));
}
function Js(n, e) {
  const t = fe(n, e == null ? void 0 : e.in), r = t.getFullYear(), a = Ne(t, 0);
  a.setFullYear(r + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const i = _n(a), s = Ne(t, 0);
  s.setFullYear(r, 0, 4), s.setHours(0, 0, 0, 0);
  const u = _n(s);
  return t.getTime() >= i.getTime() ? r + 1 : t.getTime() >= u.getTime() ? r : r - 1;
}
function xr(n) {
  const e = fe(n), t = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return t.setUTCFullYear(e.getFullYear()), +n - +t;
}
function Ya(n, ...e) {
  const t = Ne.bind(
    null,
    n || e.find((r) => typeof r == "object")
  );
  return e.map(t);
}
function kr(n, e) {
  const t = fe(n, e == null ? void 0 : e.in);
  return t.setHours(0, 0, 0, 0), t;
}
function Np(n, e, t) {
  const [r, a] = Ya(
    t == null ? void 0 : t.in,
    n,
    e
  ), i = kr(r), s = kr(a), u = +i - xr(i), m = +s - xr(s);
  return Math.round((u - m) / jp);
}
function Ip(n, e) {
  const t = Js(n, e), r = Ne((e == null ? void 0 : e.in) || n, 0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), _n(r);
}
function Vi(n, e, t) {
  const [r, a] = Ya(
    t == null ? void 0 : t.in,
    n,
    e
  );
  return +kr(r) == +kr(a);
}
function Mp(n) {
  return n instanceof Date || typeof n == "object" && Object.prototype.toString.call(n) === "[object Date]";
}
function _p(n) {
  return !(!Mp(n) && typeof n != "number" || isNaN(+fe(n)));
}
function Dp(n, e) {
  const t = fe(n, e == null ? void 0 : e.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
const Cp = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Lp = (n, e, t) => {
  let r;
  const a = Cp[n];
  return typeof a == "string" ? r = a : e === 1 ? r = a.one : r = a.other.replace("{{count}}", e.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + r : r + " ago" : r;
};
function An(n) {
  return (e = {}) => {
    const t = e.width ? String(e.width) : n.defaultWidth;
    return n.formats[t] || n.formats[n.defaultWidth];
  };
}
const Wp = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, $p = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Bp = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Fp = {
  date: An({
    formats: Wp,
    defaultWidth: "full"
  }),
  time: An({
    formats: $p,
    defaultWidth: "full"
  }),
  dateTime: An({
    formats: Bp,
    defaultWidth: "full"
  })
}, Rp = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Hp = (n, e, t, r) => Rp[n];
function Dt(n) {
  return (e, t) => {
    const r = t != null && t.context ? String(t.context) : "standalone";
    let a;
    if (r === "formatting" && n.formattingValues) {
      const s = n.defaultFormattingWidth || n.defaultWidth, u = t != null && t.width ? String(t.width) : s;
      a = n.formattingValues[u] || n.formattingValues[s];
    } else {
      const s = n.defaultWidth, u = t != null && t.width ? String(t.width) : n.defaultWidth;
      a = n.values[u] || n.values[s];
    }
    const i = n.argumentCallback ? n.argumentCallback(e) : e;
    return a[i];
  };
}
const zp = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Up = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, qp = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Yp = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Vp = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Gp = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Qp = (n, e) => {
  const t = Number(n), r = t % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, Xp = {
  ordinalNumber: Qp,
  era: Dt({
    values: zp,
    defaultWidth: "wide"
  }),
  quarter: Dt({
    values: Up,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: Dt({
    values: qp,
    defaultWidth: "wide"
  }),
  day: Dt({
    values: Yp,
    defaultWidth: "wide"
  }),
  dayPeriod: Dt({
    values: Vp,
    defaultWidth: "wide",
    formattingValues: Gp,
    defaultFormattingWidth: "wide"
  })
};
function Ct(n) {
  return (e, t = {}) => {
    const r = t.width, a = r && n.matchPatterns[r] || n.matchPatterns[n.defaultMatchWidth], i = e.match(a);
    if (!i)
      return null;
    const s = i[0], u = r && n.parsePatterns[r] || n.parsePatterns[n.defaultParseWidth], m = Array.isArray(u) ? Zp(u, (d) => d.test(s)) : (
      // [TODO] -- I challenge you to fix the type
      Kp(u, (d) => d.test(s))
    );
    let f;
    f = n.valueCallback ? n.valueCallback(m) : m, f = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(f)
    ) : f;
    const p = e.slice(s.length);
    return { value: f, rest: p };
  };
}
function Kp(n, e) {
  for (const t in n)
    if (Object.prototype.hasOwnProperty.call(n, t) && e(n[t]))
      return t;
}
function Zp(n, e) {
  for (let t = 0; t < n.length; t++)
    if (e(n[t]))
      return t;
}
function ec(n) {
  return (e, t = {}) => {
    const r = e.match(n.matchPattern);
    if (!r)
      return null;
    const a = r[0], i = e.match(n.parsePattern);
    if (!i)
      return null;
    let s = n.valueCallback ? n.valueCallback(i[0]) : i[0];
    s = t.valueCallback ? t.valueCallback(s) : s;
    const u = e.slice(a.length);
    return { value: s, rest: u };
  };
}
const Jp = /^(\d+)(th|st|nd|rd)?/i, eg = /\d+/i, tg = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, ng = {
  any: [/^b/i, /^(a|c)/i]
}, rg = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, ag = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ig = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, og = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, sg = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, cg = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, ug = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, lg = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, dg = {
  ordinalNumber: ec({
    matchPattern: Jp,
    parsePattern: eg,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: Ct({
    matchPatterns: tg,
    defaultMatchWidth: "wide",
    parsePatterns: ng,
    defaultParseWidth: "any"
  }),
  quarter: Ct({
    matchPatterns: rg,
    defaultMatchWidth: "wide",
    parsePatterns: ag,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: Ct({
    matchPatterns: ig,
    defaultMatchWidth: "wide",
    parsePatterns: og,
    defaultParseWidth: "any"
  }),
  day: Ct({
    matchPatterns: sg,
    defaultMatchWidth: "wide",
    parsePatterns: cg,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ct({
    matchPatterns: ug,
    defaultMatchWidth: "any",
    parsePatterns: lg,
    defaultParseWidth: "any"
  })
}, tc = {
  code: "en-US",
  formatDistance: Lp,
  formatLong: Fp,
  formatRelative: Hp,
  localize: Xp,
  match: dg,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function mg(n, e) {
  const t = fe(n, e == null ? void 0 : e.in);
  return Np(t, Dp(t)) + 1;
}
function nc(n, e) {
  const t = fe(n, e == null ? void 0 : e.in), r = +_n(t) - +Ip(t);
  return Math.round(r / Zs) + 1;
}
function Va(n, e) {
  var p, d, c, l, h, g, b, w;
  const t = fe(n, e == null ? void 0 : e.in), r = t.getFullYear(), a = Ln(), i = (w = (b = (l = (c = e == null ? void 0 : e.firstWeekContainsDate) != null ? c : (d = (p = e == null ? void 0 : e.locale) == null ? void 0 : p.options) == null ? void 0 : d.firstWeekContainsDate) != null ? l : a.firstWeekContainsDate) != null ? b : (g = (h = a.locale) == null ? void 0 : h.options) == null ? void 0 : g.firstWeekContainsDate) != null ? w : 1, s = Ne((e == null ? void 0 : e.in) || n, 0);
  s.setFullYear(r + 1, 0, i), s.setHours(0, 0, 0, 0);
  const u = Ht(s, e), m = Ne((e == null ? void 0 : e.in) || n, 0);
  m.setFullYear(r, 0, i), m.setHours(0, 0, 0, 0);
  const f = Ht(m, e);
  return +t >= +u ? r + 1 : +t >= +f ? r : r - 1;
}
function hg(n, e) {
  var u, m, f, p, d, c, l, h;
  const t = Ln(), r = (h = (l = (p = (f = e == null ? void 0 : e.firstWeekContainsDate) != null ? f : (m = (u = e == null ? void 0 : e.locale) == null ? void 0 : u.options) == null ? void 0 : m.firstWeekContainsDate) != null ? p : t.firstWeekContainsDate) != null ? l : (c = (d = t.locale) == null ? void 0 : d.options) == null ? void 0 : c.firstWeekContainsDate) != null ? h : 1, a = Va(n, e), i = Ne((e == null ? void 0 : e.in) || n, 0);
  return i.setFullYear(a, 0, r), i.setHours(0, 0, 0, 0), Ht(i, e);
}
function rc(n, e) {
  const t = fe(n, e == null ? void 0 : e.in), r = +Ht(t, e) - +hg(t, e);
  return Math.round(r / Zs) + 1;
}
function he(n, e) {
  const t = n < 0 ? "-" : "", r = Math.abs(n).toString().padStart(e, "0");
  return t + r;
}
const Vt = {
  // Year
  y(n, e) {
    const t = n.getFullYear(), r = t > 0 ? t : 1 - t;
    return he(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(n, e) {
    const t = n.getMonth();
    return e === "M" ? String(t + 1) : he(t + 1, 2);
  },
  // Day of the month
  d(n, e) {
    return he(n.getDate(), e.length);
  },
  // AM or PM
  a(n, e) {
    const t = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(n, e) {
    return he(n.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(n, e) {
    return he(n.getHours(), e.length);
  },
  // Minute
  m(n, e) {
    return he(n.getMinutes(), e.length);
  },
  // Second
  s(n, e) {
    return he(n.getSeconds(), e.length);
  },
  // Fraction of second
  S(n, e) {
    const t = e.length, r = n.getMilliseconds(), a = Math.trunc(
      r * Math.pow(10, t - 3)
    );
    return he(a, e.length);
  }
}, xn = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Gi = {
  // Era
  G: function(n, e, t) {
    const r = n.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(r, { width: "abbreviated" });
      case "GGGGG":
        return t.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(n, e, t) {
    if (e === "yo") {
      const r = n.getFullYear(), a = r > 0 ? r : 1 - r;
      return t.ordinalNumber(a, { unit: "year" });
    }
    return Vt.y(n, e);
  },
  // Local week-numbering year
  Y: function(n, e, t, r) {
    const a = Va(n, r), i = a > 0 ? a : 1 - a;
    if (e === "YY") {
      const s = i % 100;
      return he(s, 2);
    }
    return e === "Yo" ? t.ordinalNumber(i, { unit: "year" }) : he(i, e.length);
  },
  // ISO week-numbering year
  R: function(n, e) {
    const t = Js(n);
    return he(t, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, e) {
    const t = n.getFullYear();
    return he(t, e.length);
  },
  // Quarter
  Q: function(n, e, t) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(r);
      case "QQ":
        return he(r, 2);
      case "Qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return t.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, e, t) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(r);
      case "qq":
        return he(r, 2);
      case "qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return t.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, e, t) {
    const r = n.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Vt.M(n, e);
      case "Mo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return t.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(n, e, t) {
    const r = n.getMonth();
    switch (e) {
      case "L":
        return String(r + 1);
      case "LL":
        return he(r + 1, 2);
      case "Lo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return t.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(n, e, t, r) {
    const a = rc(n, r);
    return e === "wo" ? t.ordinalNumber(a, { unit: "week" }) : he(a, e.length);
  },
  // ISO week of year
  I: function(n, e, t) {
    const r = nc(n);
    return e === "Io" ? t.ordinalNumber(r, { unit: "week" }) : he(r, e.length);
  },
  // Day of the month
  d: function(n, e, t) {
    return e === "do" ? t.ordinalNumber(n.getDate(), { unit: "date" }) : Vt.d(n, e);
  },
  // Day of year
  D: function(n, e, t) {
    const r = mg(n);
    return e === "Do" ? t.ordinalNumber(r, { unit: "dayOfYear" }) : he(r, e.length);
  },
  // Day of week
  E: function(n, e, t) {
    const r = n.getDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, e, t, r) {
    const a = n.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(i);
      case "ee":
        return he(i, 2);
      case "eo":
        return t.ordinalNumber(i, { unit: "day" });
      case "eee":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, e, t, r) {
    const a = n.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(i);
      case "cc":
        return he(i, e.length);
      case "co":
        return t.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return t.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, e, t) {
    const r = n.getDay(), a = r === 0 ? 7 : r;
    switch (e) {
      case "i":
        return String(a);
      case "ii":
        return he(a, e.length);
      case "io":
        return t.ordinalNumber(a, { unit: "day" });
      case "iii":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, e, t) {
    const a = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, e, t) {
    const r = n.getHours();
    let a;
    switch (r === 12 ? a = xn.noon : r === 0 ? a = xn.midnight : a = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, e, t) {
    const r = n.getHours();
    let a;
    switch (r >= 17 ? a = xn.evening : r >= 12 ? a = xn.afternoon : r >= 4 ? a = xn.morning : a = xn.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, e, t) {
    if (e === "ho") {
      let r = n.getHours() % 12;
      return r === 0 && (r = 12), t.ordinalNumber(r, { unit: "hour" });
    }
    return Vt.h(n, e);
  },
  // Hour [0-23]
  H: function(n, e, t) {
    return e === "Ho" ? t.ordinalNumber(n.getHours(), { unit: "hour" }) : Vt.H(n, e);
  },
  // Hour [0-11]
  K: function(n, e, t) {
    const r = n.getHours() % 12;
    return e === "Ko" ? t.ordinalNumber(r, { unit: "hour" }) : he(r, e.length);
  },
  // Hour [1-24]
  k: function(n, e, t) {
    let r = n.getHours();
    return r === 0 && (r = 24), e === "ko" ? t.ordinalNumber(r, { unit: "hour" }) : he(r, e.length);
  },
  // Minute
  m: function(n, e, t) {
    return e === "mo" ? t.ordinalNumber(n.getMinutes(), { unit: "minute" }) : Vt.m(n, e);
  },
  // Second
  s: function(n, e, t) {
    return e === "so" ? t.ordinalNumber(n.getSeconds(), { unit: "second" }) : Vt.s(n, e);
  },
  // Fraction of second
  S: function(n, e) {
    return Vt.S(n, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, e, t) {
    const r = n.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      case "X":
        return Xi(r);
      case "XXXX":
      case "XX":
        return ln(r);
      case "XXXXX":
      case "XXX":
      default:
        return ln(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      case "x":
        return Xi(r);
      case "xxxx":
      case "xx":
        return ln(r);
      case "xxxxx":
      case "xxx":
      default:
        return ln(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Qi(r, ":");
      case "OOOO":
      default:
        return "GMT" + ln(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Qi(r, ":");
      case "zzzz":
      default:
        return "GMT" + ln(r, ":");
    }
  },
  // Seconds timestamp
  t: function(n, e, t) {
    const r = Math.trunc(+n / 1e3);
    return he(r, e.length);
  },
  // Milliseconds timestamp
  T: function(n, e, t) {
    return he(+n, e.length);
  }
};
function Qi(n, e = "") {
  const t = n > 0 ? "-" : "+", r = Math.abs(n), a = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? t + String(a) : t + String(a) + e + he(i, 2);
}
function Xi(n, e) {
  return n % 60 === 0 ? (n > 0 ? "-" : "+") + he(Math.abs(n) / 60, 2) : ln(n, e);
}
function ln(n, e = "") {
  const t = n > 0 ? "-" : "+", r = Math.abs(n), a = he(Math.trunc(r / 60), 2), i = he(r % 60, 2);
  return t + a + e + i;
}
const Ki = (n, e) => {
  switch (n) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, ac = (n, e) => {
  switch (n) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, fg = (n, e) => {
  const t = n.match(/(P+)(p+)?/) || [], r = t[1], a = t[2];
  if (!a)
    return Ki(n, e);
  let i;
  switch (r) {
    case "P":
      i = e.dateTime({ width: "short" });
      break;
    case "PP":
      i = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = e.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Ki(r, e)).replace("{{time}}", ac(a, e));
}, da = {
  p: ac,
  P: fg
}, pg = /^D+$/, gg = /^Y+$/, bg = ["D", "DD", "YY", "YYYY"];
function ic(n) {
  return pg.test(n);
}
function oc(n) {
  return gg.test(n);
}
function ma(n, e, t) {
  const r = wg(n, e, t);
  if (console.warn(r), bg.includes(n))
    throw new RangeError(r);
}
function wg(n, e, t) {
  const r = n[0] === "Y" ? "years" : "days of the month";
  return `Use \`${n.toLowerCase()}\` instead of \`${n}\` (in \`${e}\`) for formatting ${r} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const vg = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, yg = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, xg = /^'([^]*?)'?$/, kg = /''/g, Tg = /[a-zA-Z]/;
function Kn(n, e, t) {
  var p, d, c, l, h, g, b, w, y, v, x, T, j, A, N, S, E, k;
  const r = Ln(), a = (d = (p = t == null ? void 0 : t.locale) != null ? p : r.locale) != null ? d : tc, i = (v = (y = (g = (h = t == null ? void 0 : t.firstWeekContainsDate) != null ? h : (l = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : l.firstWeekContainsDate) != null ? g : r.firstWeekContainsDate) != null ? y : (w = (b = r.locale) == null ? void 0 : b.options) == null ? void 0 : w.firstWeekContainsDate) != null ? v : 1, s = (k = (E = (A = (j = t == null ? void 0 : t.weekStartsOn) != null ? j : (T = (x = t == null ? void 0 : t.locale) == null ? void 0 : x.options) == null ? void 0 : T.weekStartsOn) != null ? A : r.weekStartsOn) != null ? E : (S = (N = r.locale) == null ? void 0 : N.options) == null ? void 0 : S.weekStartsOn) != null ? k : 0, u = fe(n, t == null ? void 0 : t.in);
  if (!_p(u))
    throw new RangeError("Invalid time value");
  let m = e.match(yg).map((M) => {
    const O = M[0];
    if (O === "p" || O === "P") {
      const I = da[O];
      return I(M, a.formatLong);
    }
    return M;
  }).join("").match(vg).map((M) => {
    if (M === "''")
      return { isToken: !1, value: "'" };
    const O = M[0];
    if (O === "'")
      return { isToken: !1, value: Og(M) };
    if (Gi[O])
      return { isToken: !0, value: M };
    if (O.match(Tg))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + O + "`"
      );
    return { isToken: !1, value: M };
  });
  a.localize.preprocessor && (m = a.localize.preprocessor(u, m));
  const f = {
    firstWeekContainsDate: i,
    weekStartsOn: s,
    locale: a
  };
  return m.map((M) => {
    if (!M.isToken)
      return M.value;
    const O = M.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && oc(O) || !(t != null && t.useAdditionalDayOfYearTokens) && ic(O)) && ma(O, e, String(n));
    const I = Gi[O[0]];
    return I(u, O, a.localize, f);
  }).join("");
}
function Og(n) {
  const e = n.match(xg);
  return e ? e[1].replace(kg, "'") : n;
}
function Pg() {
  return Object.assign({}, Ln());
}
function Zi(n, e) {
  return fe(n, e == null ? void 0 : e.in).getHours();
}
function jg(n, e) {
  const t = fe(n, e == null ? void 0 : e.in).getDay();
  return t === 0 ? 7 : t;
}
function Tr(n, e) {
  return +fe(n) > +fe(e);
}
function Eg(n, e) {
  return +fe(n) < +fe(e);
}
function Sg(n, e) {
  const t = Ag(e) ? new e(0) : Ne(e, 0);
  return t.setFullYear(n.getFullYear(), n.getMonth(), n.getDate()), t.setHours(
    n.getHours(),
    n.getMinutes(),
    n.getSeconds(),
    n.getMilliseconds()
  ), t;
}
function Ag(n) {
  var e;
  return typeof n == "function" && ((e = n.prototype) == null ? void 0 : e.constructor) === n;
}
const Ng = 10;
class sc {
  constructor() {
    _(this, "subPriority", 0);
  }
  validate(e, t) {
    return !0;
  }
}
class Ig extends sc {
  constructor(e, t, r, a, i) {
    super(), this.value = e, this.validateValue = t, this.setValue = r, this.priority = a, i && (this.subPriority = i);
  }
  validate(e, t) {
    return this.validateValue(e, this.value, t);
  }
  set(e, t, r) {
    return this.setValue(e, t, this.value, r);
  }
}
class Mg extends sc {
  constructor(t, r) {
    super();
    _(this, "priority", Ng);
    _(this, "subPriority", -1);
    this.context = t || ((a) => Ne(r, a));
  }
  set(t, r) {
    return r.timestampIsSet ? t : Ne(t, Sg(t, this.context));
  }
}
class de {
  run(e, t, r, a) {
    const i = this.parse(e, t, r, a);
    return i ? {
      setter: new Ig(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(e, t, r) {
    return !0;
  }
}
class _g extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 140);
    _(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, r, a) {
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return a.era(t, { width: "abbreviated" }) || a.era(t, { width: "narrow" });
      case "GGGGG":
        return a.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return a.era(t, { width: "wide" }) || a.era(t, { width: "abbreviated" }) || a.era(t, { width: "narrow" });
    }
  }
  set(t, r, a) {
    return r.era = a, t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const Le = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Lt = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function We(n, e) {
  return n && {
    value: e(n.value),
    rest: n.rest
  };
}
function Pe(n, e) {
  const t = e.match(n);
  return t ? {
    value: parseInt(t[0], 10),
    rest: e.slice(t[0].length)
  } : null;
}
function Wt(n, e) {
  const t = e.match(n);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  const r = t[1] === "+" ? 1 : -1, a = t[2] ? parseInt(t[2], 10) : 0, i = t[3] ? parseInt(t[3], 10) : 0, s = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: r * (a * qa + i * Ua + s * Ep),
    rest: e.slice(t[0].length)
  };
}
function cc(n) {
  return Pe(Le.anyDigitsSigned, n);
}
function Ie(n, e) {
  switch (n) {
    case 1:
      return Pe(Le.singleDigit, e);
    case 2:
      return Pe(Le.twoDigits, e);
    case 3:
      return Pe(Le.threeDigits, e);
    case 4:
      return Pe(Le.fourDigits, e);
    default:
      return Pe(new RegExp("^\\d{1," + n + "}"), e);
  }
}
function Or(n, e) {
  switch (n) {
    case 1:
      return Pe(Le.singleDigitSigned, e);
    case 2:
      return Pe(Le.twoDigitsSigned, e);
    case 3:
      return Pe(Le.threeDigitsSigned, e);
    case 4:
      return Pe(Le.fourDigitsSigned, e);
    default:
      return Pe(new RegExp("^-?\\d{1," + n + "}"), e);
  }
}
function Ga(n) {
  switch (n) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function uc(n, e) {
  const t = e > 0, r = t ? e : 1 - e;
  let a;
  if (r <= 50)
    a = n || 100;
  else {
    const i = r + 50, s = Math.trunc(i / 100) * 100, u = n >= i % 100;
    a = n + s - (u ? 100 : 0);
  }
  return t ? a : 1 - a;
}
function lc(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
class Dg extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 130);
    _(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, a) {
    const i = (s) => ({
      year: s,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return We(Ie(4, t), i);
      case "yo":
        return We(
          a.ordinalNumber(t, {
            unit: "year"
          }),
          i
        );
      default:
        return We(Ie(r.length, t), i);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, a) {
    const i = t.getFullYear();
    if (a.isTwoDigitYear) {
      const u = uc(
        a.year,
        i
      );
      return t.setFullYear(u, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const s = !("era" in r) || r.era === 1 ? a.year : 1 - a.year;
    return t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Cg extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 130);
    _(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, r, a) {
    const i = (s) => ({
      year: s,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return We(Ie(4, t), i);
      case "Yo":
        return We(
          a.ordinalNumber(t, {
            unit: "year"
          }),
          i
        );
      default:
        return We(Ie(r.length, t), i);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, a, i) {
    const s = Va(t, i);
    if (a.isTwoDigitYear) {
      const m = uc(
        a.year,
        s
      );
      return t.setFullYear(
        m,
        0,
        i.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), Ht(t, i);
    }
    const u = !("era" in r) || r.era === 1 ? a.year : 1 - a.year;
    return t.setFullYear(u, 0, i.firstWeekContainsDate), t.setHours(0, 0, 0, 0), Ht(t, i);
  }
}
class Lg extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 130);
    _(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r) {
    return Or(r === "R" ? 4 : r.length, t);
  }
  set(t, r, a) {
    const i = Ne(t, 0);
    return i.setFullYear(a, 0, 4), i.setHours(0, 0, 0, 0), _n(i);
  }
}
class Wg extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 130);
    _(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r) {
    return Or(r === "u" ? 4 : r.length, t);
  }
  set(t, r, a) {
    return t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class $g extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 120);
    _(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, a) {
    switch (r) {
      case "Q":
      case "QQ":
        return Ie(r.length, t);
      case "Qo":
        return a.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return a.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return a.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return a.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || a.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, a) {
    return t.setMonth((a - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Bg extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 120);
    _(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, a) {
    switch (r) {
      case "q":
      case "qq":
        return Ie(r.length, t);
      case "qo":
        return a.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return a.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return a.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return a.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || a.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, a) {
    return t.setMonth((a - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Fg extends de {
  constructor() {
    super(...arguments);
    _(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    _(this, "priority", 110);
  }
  parse(t, r, a) {
    const i = (s) => s - 1;
    switch (r) {
      case "M":
        return We(
          Pe(Le.month, t),
          i
        );
      case "MM":
        return We(Ie(2, t), i);
      case "Mo":
        return We(
          a.ordinalNumber(t, {
            unit: "month"
          }),
          i
        );
      case "MMM":
        return a.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return a.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return a.month(t, { width: "wide", context: "formatting" }) || a.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, a) {
    return t.setMonth(a, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Rg extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 110);
    _(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, a) {
    const i = (s) => s - 1;
    switch (r) {
      case "L":
        return We(
          Pe(Le.month, t),
          i
        );
      case "LL":
        return We(Ie(2, t), i);
      case "Lo":
        return We(
          a.ordinalNumber(t, {
            unit: "month"
          }),
          i
        );
      case "LLL":
        return a.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return a.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return a.month(t, { width: "wide", context: "standalone" }) || a.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, a) {
    return t.setMonth(a, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function Hg(n, e, t) {
  const r = fe(n, t == null ? void 0 : t.in), a = rc(r, t) - e;
  return r.setDate(r.getDate() - a * 7), fe(r, t == null ? void 0 : t.in);
}
class zg extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 100);
    _(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, r, a) {
    switch (r) {
      case "w":
        return Pe(Le.week, t);
      case "wo":
        return a.ordinalNumber(t, { unit: "week" });
      default:
        return Ie(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, a, i) {
    return Ht(Hg(t, a, i), i);
  }
}
function Ug(n, e, t) {
  const r = fe(n, t == null ? void 0 : t.in), a = nc(r, t) - e;
  return r.setDate(r.getDate() - a * 7), r;
}
class qg extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 100);
    _(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, a) {
    switch (r) {
      case "I":
        return Pe(Le.week, t);
      case "Io":
        return a.ordinalNumber(t, { unit: "week" });
      default:
        return Ie(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, a) {
    return _n(Ug(t, a));
  }
}
const Yg = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Vg = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Gg extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 90);
    _(this, "subPriority", 1);
    _(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, a) {
    switch (r) {
      case "d":
        return Pe(Le.date, t);
      case "do":
        return a.ordinalNumber(t, { unit: "date" });
      default:
        return Ie(r.length, t);
    }
  }
  validate(t, r) {
    const a = t.getFullYear(), i = lc(a), s = t.getMonth();
    return i ? r >= 1 && r <= Vg[s] : r >= 1 && r <= Yg[s];
  }
  set(t, r, a) {
    return t.setDate(a), t.setHours(0, 0, 0, 0), t;
  }
}
class Qg extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 90);
    _(this, "subpriority", 1);
    _(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, a) {
    switch (r) {
      case "D":
      case "DD":
        return Pe(Le.dayOfYear, t);
      case "Do":
        return a.ordinalNumber(t, { unit: "date" });
      default:
        return Ie(r.length, t);
    }
  }
  validate(t, r) {
    const a = t.getFullYear();
    return lc(a) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(t, r, a) {
    return t.setMonth(0, a), t.setHours(0, 0, 0, 0), t;
  }
}
function Qa(n, e, t) {
  var d, c, l, h, g, b, w, y;
  const r = Ln(), a = (y = (w = (h = (l = t == null ? void 0 : t.weekStartsOn) != null ? l : (c = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : c.weekStartsOn) != null ? h : r.weekStartsOn) != null ? w : (b = (g = r.locale) == null ? void 0 : g.options) == null ? void 0 : b.weekStartsOn) != null ? y : 0, i = fe(n, t == null ? void 0 : t.in), s = i.getDay(), m = (e % 7 + 7) % 7, f = 7 - a, p = e < 0 || e > 6 ? e - (s + f) % 7 : (m + f) % 7 - (s + f) % 7;
  return Mr(i, p, t);
}
class Xg extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 90);
    _(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, a) {
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return a.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return a.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return a.day(t, { width: "wide", context: "formatting" }) || a.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, a, i) {
    return t = Qa(t, a, i), t.setHours(0, 0, 0, 0), t;
  }
}
class Kg extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 90);
    _(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, a, i) {
    const s = (u) => {
      const m = Math.floor((u - 1) / 7) * 7;
      return (u + i.weekStartsOn + 6) % 7 + m;
    };
    switch (r) {
      case "e":
      case "ee":
        return We(Ie(r.length, t), s);
      case "eo":
        return We(
          a.ordinalNumber(t, {
            unit: "day"
          }),
          s
        );
      case "eee":
        return a.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return a.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return a.day(t, { width: "wide", context: "formatting" }) || a.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, a, i) {
    return t = Qa(t, a, i), t.setHours(0, 0, 0, 0), t;
  }
}
class Zg extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 90);
    _(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, r, a, i) {
    const s = (u) => {
      const m = Math.floor((u - 1) / 7) * 7;
      return (u + i.weekStartsOn + 6) % 7 + m;
    };
    switch (r) {
      case "c":
      case "cc":
        return We(Ie(r.length, t), s);
      case "co":
        return We(
          a.ordinalNumber(t, {
            unit: "day"
          }),
          s
        );
      case "ccc":
        return a.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.day(t, { width: "short", context: "standalone" }) || a.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return a.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return a.day(t, { width: "short", context: "standalone" }) || a.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return a.day(t, { width: "wide", context: "standalone" }) || a.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.day(t, { width: "short", context: "standalone" }) || a.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, a, i) {
    return t = Qa(t, a, i), t.setHours(0, 0, 0, 0), t;
  }
}
function Jg(n, e, t) {
  const r = fe(n, t == null ? void 0 : t.in), a = jg(r, t), i = e - a;
  return Mr(r, i, t);
}
class eb extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 90);
    _(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, a) {
    const i = (s) => s === 0 ? 7 : s;
    switch (r) {
      case "i":
      case "ii":
        return Ie(r.length, t);
      case "io":
        return a.ordinalNumber(t, { unit: "day" });
      case "iii":
        return We(
          a.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiii":
        return We(
          a.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiiii":
        return We(
          a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiii":
      default:
        return We(
          a.day(t, {
            width: "wide",
            context: "formatting"
          }) || a.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 7;
  }
  set(t, r, a) {
    return t = Jg(t, a), t.setHours(0, 0, 0, 0), t;
  }
}
class tb extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 80);
    _(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, a) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, a) {
    return t.setHours(Ga(a), 0, 0, 0), t;
  }
}
class nb extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 80);
    _(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, a) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, a) {
    return t.setHours(Ga(a), 0, 0, 0), t;
  }
}
class rb extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 80);
    _(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, r, a) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, a) {
    return t.setHours(Ga(a), 0, 0, 0), t;
  }
}
class ab extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 70);
    _(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, r, a) {
    switch (r) {
      case "h":
        return Pe(Le.hour12h, t);
      case "ho":
        return a.ordinalNumber(t, { unit: "hour" });
      default:
        return Ie(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 12;
  }
  set(t, r, a) {
    const i = t.getHours() >= 12;
    return i && a < 12 ? t.setHours(a + 12, 0, 0, 0) : !i && a === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(a, 0, 0, 0), t;
  }
}
class ib extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 70);
    _(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, r, a) {
    switch (r) {
      case "H":
        return Pe(Le.hour23h, t);
      case "Ho":
        return a.ordinalNumber(t, { unit: "hour" });
      default:
        return Ie(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 23;
  }
  set(t, r, a) {
    return t.setHours(a, 0, 0, 0), t;
  }
}
class ob extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 70);
    _(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, r, a) {
    switch (r) {
      case "K":
        return Pe(Le.hour11h, t);
      case "Ko":
        return a.ordinalNumber(t, { unit: "hour" });
      default:
        return Ie(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, a) {
    return t.getHours() >= 12 && a < 12 ? t.setHours(a + 12, 0, 0, 0) : t.setHours(a, 0, 0, 0), t;
  }
}
class sb extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 70);
    _(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, r, a) {
    switch (r) {
      case "k":
        return Pe(Le.hour24h, t);
      case "ko":
        return a.ordinalNumber(t, { unit: "hour" });
      default:
        return Ie(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 24;
  }
  set(t, r, a) {
    const i = a <= 24 ? a % 24 : a;
    return t.setHours(i, 0, 0, 0), t;
  }
}
class cb extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 60);
    _(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, a) {
    switch (r) {
      case "m":
        return Pe(Le.minute, t);
      case "mo":
        return a.ordinalNumber(t, { unit: "minute" });
      default:
        return Ie(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, a) {
    return t.setMinutes(a, 0, 0), t;
  }
}
class ub extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 50);
    _(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, a) {
    switch (r) {
      case "s":
        return Pe(Le.second, t);
      case "so":
        return a.ordinalNumber(t, { unit: "second" });
      default:
        return Ie(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, a) {
    return t.setSeconds(a, 0), t;
  }
}
class lb extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 30);
    _(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r) {
    const a = (i) => Math.trunc(i * Math.pow(10, -r.length + 3));
    return We(Ie(r.length, t), a);
  }
  set(t, r, a) {
    return t.setMilliseconds(a), t;
  }
}
class db extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 10);
    _(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, r) {
    switch (r) {
      case "X":
        return Wt(
          Lt.basicOptionalMinutes,
          t
        );
      case "XX":
        return Wt(Lt.basic, t);
      case "XXXX":
        return Wt(
          Lt.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return Wt(
          Lt.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return Wt(Lt.extended, t);
    }
  }
  set(t, r, a) {
    return r.timestampIsSet ? t : Ne(
      t,
      t.getTime() - xr(t) - a
    );
  }
}
class mb extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 10);
    _(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, r) {
    switch (r) {
      case "x":
        return Wt(
          Lt.basicOptionalMinutes,
          t
        );
      case "xx":
        return Wt(Lt.basic, t);
      case "xxxx":
        return Wt(
          Lt.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return Wt(
          Lt.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return Wt(Lt.extended, t);
    }
  }
  set(t, r, a) {
    return r.timestampIsSet ? t : Ne(
      t,
      t.getTime() - xr(t) - a
    );
  }
}
class hb extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 40);
    _(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return cc(t);
  }
  set(t, r, a) {
    return [Ne(t, a * 1e3), { timestampIsSet: !0 }];
  }
}
class fb extends de {
  constructor() {
    super(...arguments);
    _(this, "priority", 20);
    _(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return cc(t);
  }
  set(t, r, a) {
    return [Ne(t, a), { timestampIsSet: !0 }];
  }
}
const pb = {
  G: new _g(),
  y: new Dg(),
  Y: new Cg(),
  R: new Lg(),
  u: new Wg(),
  Q: new $g(),
  q: new Bg(),
  M: new Fg(),
  L: new Rg(),
  w: new zg(),
  I: new qg(),
  d: new Gg(),
  D: new Qg(),
  E: new Xg(),
  e: new Kg(),
  c: new Zg(),
  i: new eb(),
  a: new tb(),
  b: new nb(),
  B: new rb(),
  h: new ab(),
  H: new ib(),
  K: new ob(),
  k: new sb(),
  m: new cb(),
  s: new ub(),
  S: new lb(),
  X: new db(),
  x: new mb(),
  t: new hb(),
  T: new fb()
}, gb = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, bb = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, wb = /^'([^]*?)'?$/, vb = /''/g, yb = /\S/, xb = /[a-zA-Z]/;
function cr(n, e, t, r) {
  var b, w, y, v, x, T, j, A, N, S, E, k, M, O, I, re, V, R;
  const a = () => Ne((r == null ? void 0 : r.in) || t, NaN), i = Pg(), s = (w = (b = r == null ? void 0 : r.locale) != null ? b : i.locale) != null ? w : tc, u = (S = (N = (T = (x = r == null ? void 0 : r.firstWeekContainsDate) != null ? x : (v = (y = r == null ? void 0 : r.locale) == null ? void 0 : y.options) == null ? void 0 : v.firstWeekContainsDate) != null ? T : i.firstWeekContainsDate) != null ? N : (A = (j = i.locale) == null ? void 0 : j.options) == null ? void 0 : A.firstWeekContainsDate) != null ? S : 1, m = (R = (V = (O = (M = r == null ? void 0 : r.weekStartsOn) != null ? M : (k = (E = r == null ? void 0 : r.locale) == null ? void 0 : E.options) == null ? void 0 : k.weekStartsOn) != null ? O : i.weekStartsOn) != null ? V : (re = (I = i.locale) == null ? void 0 : I.options) == null ? void 0 : re.weekStartsOn) != null ? R : 0;
  if (!e)
    return n ? a() : fe(t, r == null ? void 0 : r.in);
  const f = {
    firstWeekContainsDate: u,
    weekStartsOn: m,
    locale: s
  }, p = [new Mg(r == null ? void 0 : r.in, t)], d = e.match(bb).map((P) => {
    const Q = P[0];
    if (Q in da) {
      const H = da[Q];
      return H(P, s.formatLong);
    }
    return P;
  }).join("").match(gb), c = [];
  for (let P of d) {
    !(r != null && r.useAdditionalWeekYearTokens) && oc(P) && ma(P, e, n), !(r != null && r.useAdditionalDayOfYearTokens) && ic(P) && ma(P, e, n);
    const Q = P[0], H = pb[Q];
    if (H) {
      const { incompatibleTokens: xe } = H;
      if (Array.isArray(xe)) {
        const $e = c.find(
          (F) => xe.includes(F.token) || F.token === Q
        );
        if ($e)
          throw new RangeError(
            `The format string mustn't contain \`${$e.fullToken}\` and \`${P}\` at the same time`
          );
      } else if (H.incompatibleTokens === "*" && c.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${P}\` and any other token at the same time`
        );
      c.push({ token: Q, fullToken: P });
      const Fe = H.run(
        n,
        P,
        s.match,
        f
      );
      if (!Fe)
        return a();
      p.push(Fe.setter), n = Fe.rest;
    } else {
      if (Q.match(xb))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + Q + "`"
        );
      if (P === "''" ? P = "'" : Q === "'" && (P = kb(P)), n.indexOf(P) === 0)
        n = n.slice(P.length);
      else
        return a();
    }
  }
  if (n.length > 0 && yb.test(n))
    return a();
  const l = p.map((P) => P.priority).sort((P, Q) => Q - P).filter((P, Q, H) => H.indexOf(P) === Q).map(
    (P) => p.filter((Q) => Q.priority === P).sort((Q, H) => H.subPriority - Q.subPriority)
  ).map((P) => P[0]);
  let h = fe(t, r == null ? void 0 : r.in);
  if (isNaN(+h))
    return a();
  const g = {};
  for (const P of l) {
    if (!P.validate(h, f))
      return a();
    const Q = P.set(h, g, f);
    Array.isArray(Q) ? (h = Q[0], Object.assign(g, Q[1])) : h = Q;
  }
  return h;
}
function kb(n) {
  return n.match(wb)[1].replace(vb, "'");
}
function Ji(n, e, t) {
  const [r, a] = Ya(
    t == null ? void 0 : t.in,
    n,
    e
  );
  return +Ht(r, t) == +Ht(a, t);
}
function Yr(n, e) {
  var f;
  const t = () => Ne(e == null ? void 0 : e.in, NaN), r = (f = e == null ? void 0 : e.additionalDigits) != null ? f : 2, a = jb(n);
  let i;
  if (a.date) {
    const p = Eb(a.date, r);
    i = Sb(p.restDateString, p.year);
  }
  if (!i || isNaN(+i))
    return t();
  const s = +i;
  let u = 0, m;
  if (a.time && (u = Ab(a.time), isNaN(u)))
    return t();
  if (a.timezone) {
    if (m = Nb(a.timezone), isNaN(m))
      return t();
  } else {
    const p = new Date(s + u), d = fe(0, e == null ? void 0 : e.in);
    return d.setFullYear(
      p.getUTCFullYear(),
      p.getUTCMonth(),
      p.getUTCDate()
    ), d.setHours(
      p.getUTCHours(),
      p.getUTCMinutes(),
      p.getUTCSeconds(),
      p.getUTCMilliseconds()
    ), d;
  }
  return fe(s + u + m, e == null ? void 0 : e.in);
}
const ur = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Tb = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Ob = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, Pb = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function jb(n) {
  const e = {}, t = n.split(ur.dateTimeDelimiter);
  let r;
  if (t.length > 2)
    return e;
  if (/:/.test(t[0]) ? r = t[0] : (e.date = t[0], r = t[1], ur.timeZoneDelimiter.test(e.date) && (e.date = n.split(ur.timeZoneDelimiter)[0], r = n.substr(
    e.date.length,
    n.length
  ))), r) {
    const a = ur.timezone.exec(r);
    a ? (e.time = r.replace(a[1], ""), e.timezone = a[1]) : e.time = r;
  }
  return e;
}
function Eb(n, e) {
  const t = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"
  ), r = n.match(t);
  if (!r)
    return { year: NaN, restDateString: "" };
  const a = r[1] ? parseInt(r[1]) : null, i = r[2] ? parseInt(r[2]) : null;
  return {
    year: i === null ? a : i * 100,
    restDateString: n.slice((r[1] || r[2]).length)
  };
}
function Sb(n, e) {
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  const t = n.match(Tb);
  if (!t)
    return /* @__PURE__ */ new Date(NaN);
  const r = !!t[4], a = Hn(t[1]), i = Hn(t[2]) - 1, s = Hn(t[3]), u = Hn(t[4]), m = Hn(t[5]) - 1;
  if (r)
    return Cb(e, u, m) ? Ib(e, u, m) : /* @__PURE__ */ new Date(NaN);
  {
    const f = /* @__PURE__ */ new Date(0);
    return !_b(e, i, s) || !Db(e, a) ? /* @__PURE__ */ new Date(NaN) : (f.setUTCFullYear(e, i, Math.max(a, s)), f);
  }
}
function Hn(n) {
  return n ? parseInt(n) : 1;
}
function Ab(n) {
  const e = n.match(Ob);
  if (!e)
    return NaN;
  const t = Vr(e[1]), r = Vr(e[2]), a = Vr(e[3]);
  return Lb(t, r, a) ? t * qa + r * Ua + a * 1e3 : NaN;
}
function Vr(n) {
  return n && parseFloat(n.replace(",", ".")) || 0;
}
function Nb(n) {
  if (n === "Z")
    return 0;
  const e = n.match(Pb);
  if (!e)
    return 0;
  const t = e[1] === "+" ? -1 : 1, r = parseInt(e[2]), a = e[3] && parseInt(e[3]) || 0;
  return Wb(r, a) ? t * (r * qa + a * Ua) : NaN;
}
function Ib(n, e, t) {
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n, 0, 4);
  const a = r.getUTCDay() || 7, i = (e - 1) * 7 + t + 1 - a;
  return r.setUTCDate(r.getUTCDate() + i), r;
}
const Mb = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function dc(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
function _b(n, e, t) {
  return e >= 0 && e <= 11 && t >= 1 && t <= (Mb[e] || (dc(n) ? 29 : 28));
}
function Db(n, e) {
  return e >= 1 && e <= (dc(n) ? 366 : 365);
}
function Cb(n, e, t) {
  return e >= 1 && e <= 53 && t >= 0 && t <= 6;
}
function Lb(n, e, t) {
  return n === 24 ? e === 0 && t === 0 : t >= 0 && t < 60 && e >= 0 && e < 60 && n >= 0 && n < 25;
}
function Wb(n, e) {
  return e >= 0 && e <= 59;
}
const $b = ({ closeModal: n }) => {
  const { unionText: e } = J(), t = pa(), r = ["base", "sm", "md"].includes(t);
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsxs(ce, { direction: "column", gap: 3, alignItems: "center", children: [
      /* @__PURE__ */ o.jsx(Ge, { name: "close-circle", size: 44, color: "red" }),
      /* @__PURE__ */ o.jsxs(ce, { direction: "column", bg: "red-light", gap: 1, p: 4, className: "rounded", children: [
        /* @__PURE__ */ o.jsx(ne, { fs: "body1-strong", c: "red", children: e.watchdog.modal.alert.failure.heading }),
        /* @__PURE__ */ o.jsx(ne, { as: "p", fs: "body1", className: "text-dark", children: e.watchdog.modal.alert.failure.description })
      ] })
    ] }),
    /* @__PURE__ */ o.jsx(ce, { d: { lg: "flex" }, direction: !r && "row", justify: !r && "end", mt: 5, children: /* @__PURE__ */ o.jsx(
      ve,
      {
        "data-o2-id": "watchdog-submit",
        "data-testid": "watchdog-submit",
        id: "watchdog-submit",
        name: "watchdogSubmit",
        usage: "outlined",
        onClick: n,
        fullwidth: r,
        children: e.watchdog.modal.button.close
      }
    ) })
  ] });
}, Bb = ({ email: n, phone: e, closeModal: t }) => {
  const { unionText: r, withParams: a } = J(), i = pa(), s = ["base", "sm", "md"].includes(i), u = n && e ? `${n}, ${e}` : n || e;
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsxs(ce, { direction: "column", gap: 3, alignItems: "center", children: [
      /* @__PURE__ */ o.jsx(Ge, { name: "check-circle", size: 44, color: "green" }),
      /* @__PURE__ */ o.jsxs(ce, { direction: "column", bg: "green-light", gap: 1, p: 4, className: "rounded", children: [
        /* @__PURE__ */ o.jsx(ne, { fs: "body1-strong", c: "green", children: r.watchdog.modal.alert.success.heading }),
        /* @__PURE__ */ o.jsx(
          ne,
          {
            as: "p",
            fs: "body1",
            className: "text-dark",
            dangerouslySetInnerHTML: {
              __html: a(r.watchdog.modal.alert.success.description, {
                contact: u
              })
            }
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ o.jsx(ce, { d: { lg: "flex" }, direction: !s && "row", justify: !s && "end", mt: 5, children: /* @__PURE__ */ o.jsx(
      ve,
      {
        "data-o2-id": "watchdog-submit",
        "data-testid": "watchdog-submit",
        id: "watchdog-submit",
        name: "watchdogSubmit",
        usage: "outlined",
        onClick: t,
        fullwidth: s,
        children: r.watchdog.modal.button.confirm
      }
    ) })
  ] });
}, Fb = ({ modalRef: n, sku: e }) => {
  const { namespace: t, config: r } = je(ye), { unionText: a, withParams: i } = J(), s = pt(), u = pa(), m = ["base", "sm", "md"].includes(u), [f, p] = C(), [d, c] = C(), { data: l, loading: h } = qe(
    r.customerContactsUrl,
    {
      method: "POST",
      payload: {}
    }
  ), g = f === "pending" || h, b = B(
    () => {
      var x, T;
      return {
        contactEmail: (x = l == null ? void 0 : l.contactEmail) != null ? x : "",
        contactMsisdn: (T = l == null ? void 0 : l.contactMsisdn) != null ? T : ""
      };
    },
    [l]
  ), w = B(() => {
    if (l != null && l.contactMsisdn)
      return "NULL";
    const x = `${window.location.origin}/ako-nakupovat/klientske-suhlasy/suhlas-so-spracovanim-osobnych-udajov-dostupnost`;
    return i(a.watchdog.modal.consent.text, { href: x });
  }, [l == null ? void 0 : l.contactMsisdn, a.watchdog.modal.consent.text, i]), y = (j, A) => ai(void 0, [j, A], function* (x, { setFieldError: T }) {
    var N, S, E, k, M;
    if (!x.contactEmail && !x.contactMsisdn) {
      T("contactEmail", a.watchdog.modal.contactValidationError), T("contactMsisdn", a.watchdog.modal.contactValidationError);
      return;
    }
    try {
      const O = new FormData(), I = Ic("watchdogForm"), re = l != null && l.contactMsisdn ? "WD_CUSTOMER" : "WD_ANONYM", V = "dd.MM.yyyy", R = Kn(new Date(Date.now()), V), P = Kn(Mr(new Date(Date.now()), 60), V), Q = l != null && l.contactMsisdn ? "CONTRACT" : "LEAD_APPROVAL", H = window.location.href, xe = `<div class="row"><div class="col-md-6"><h4>${a.watchdog.modal.content.heading}</h4><hr><div id="read-more-wrapper" class="read-more-wrapper" data-max-height="150"><div class="label-small">${a.watchdog.modal.content.msisdn}</div><p>${x.contactMsisdn}</p><div class="label-small">${a.watchdog.modal.content.email}</div><p>${x.contactEmail}</p><div class="label-small">${a.watchdog.modal.content.date}</div><p>${R}</p></div></div><div class="col-md-6"><h4>${a.watchdog.modal.content.additionalInfo}</h4><hr><div class="label-small">${a.watchdog.modal.content.source}</div><p> <a href="${H}" target="_blank">${H}</a></p></div></div>`, Fe = [
        {
          code: "CAMPAIN_NAME",
          name: a.watchdog.modal.campaignParams.CAMPAIN_NAME.name,
          value: a.watchdog.modal.campaignParams.CAMPAIN_NAME.value
        },
        {
          code: "OFFER_NAME",
          name: a.watchdog.modal.campaignParams.OFFER_NAME.name,
          value: a.watchdog.modal.campaignParams.OFFER_NAME.value
        },
        {
          code: "SKU_IMG",
          name: a.watchdog.modal.campaignParams.SKU_IMG.name,
          value: (E = (S = (N = e.media) == null ? void 0 : N[0]) == null ? void 0 : S.originalImage) != null ? E : ""
        },
        {
          code: "SKU_NAME",
          name: a.watchdog.modal.campaignParams.SKU_NAME.name,
          value: e.name
        },
        {
          code: "HANDLE_BY_ASSISTANT_REQUESTED",
          name: a.watchdog.modal.campaignParams.HANDLE_BY_ASSISTANT_REQUESTED.name,
          value: "FALSE"
        }
      ];
      O.append("captcha", (k = I == null ? void 0 : I.captchaCode) != null ? k : ""), O.append("captchaId", (M = I == null ? void 0 : I.captchaId) != null ? M : ""), O.append("contactPhone", x.contactMsisdn), O.append("approvalType", re), O.append("consentText", w), O.append("campaignActivity_target", x.contactMsisdn), O.append("campaignActivity_actionAcceptLabel", a.watchdog.modal.consent.accept), O.append("campaignActivity_actionAcceptUrl", H), O.append("campaignActivity_actionDenyLabel", a.watchdog.modal.consent.deny), O.append("campaignActivity_content", xe), O.append("campaignActivity_validFrom", R), O.append("campaignActivity_validTo", P), O.append("campaignActivity_internalOnly", "TRUE"), O.append("campaignActivity_displayOnMvp", "FALSE"), O.append("campaignActivity_displayOnMobile", "FALSE"), O.append("campaignActivity_callActivity", "FALSE"), O.append("campaignActivity_offerName", a.watchdog.modal.offerName), O.append("campaignActivity_ignoreUnpaidInvoices", "TRUE"), O.append("campaignActivity_offerId", "1500000099"), O.append("campaignActivity_priority", "99"), O.append("campaignActivity_header", a.watchdog.modal.campaignActivity.header), O.append("campaignActivity_subheader", a.watchdog.modal.campaignActivity.subheader), O.append("campaignActivity_label", a.watchdog.modal.campaignActivity.label), O.append("campaignActivity_actionDetailLabel", a.watchdog.modal.detail), O.append("campaignActivity_email", x.contactEmail), O.append("campaignActivity_unavailable", "TRUE"), O.append("campaignOpty_contactDate", R), O.append("campaignOpty_approvalType", re), O.append("campaignOpty_sourceLink", H), O.append("campaignOpty_formType", a.watchdog.modal.formType), O.append("campaignOpty", "TRUE"), O.append("campaignOptyParams", JSON.stringify(Fe)), O.append("campaignName", a.watchdog.modal.campaignName), O.append("offerName", a.watchdog.modal.offerName), O.append("legalBasis", Q), O.append("campaignActivity_partNumber", e.externalId), O.append("campaignActivity_stockId", "P007:SK02"), O.append("campaignActivity_type", "WD_AVAILABILITY");
      const $e = yield fetch("/delegate/create-lead-servlet?action=force", {
        method: "POST",
        body: O
      });
      if ($e.ok)
        c(x), p("success");
      else
        throw Na(
          "Request failed",
          JSON.stringify({
            url: $e.url,
            headers: $e.headers,
            status: $e.status,
            statusText: $e.statusText,
            type: "text",
            body: O
          })
        ), new Error($e.status.toString());
    } catch (O) {
      console.error(O), p("failure");
    }
  }), v = () => {
    var x, T;
    return (T = (x = n == null ? void 0 : n.current) == null ? void 0 : x.hide) == null ? void 0 : T.call(x);
  };
  return /* @__PURE__ */ o.jsxs(bn, { "data-testid": "watchdog-modal", o2Ref: n, heading: a.watchdog.modal.heading, children: [
    (!f || f === "pending") && /* @__PURE__ */ o.jsxs(ce, { direction: "column", gap: 3, children: [
      /* @__PURE__ */ o.jsx(Bt, { children: /* @__PURE__ */ o.jsxs(ce, { alignItems: "center", gap: 2, children: [
        /* @__PURE__ */ o.jsx(
          wn,
          {
            src: e.media[0].originalImage,
            height: "64",
            width: "64",
            alt: e.name,
            d: "flex",
            className: "justify-content-center",
            p: 2
          }
        ),
        /* @__PURE__ */ o.jsx(ne, { fs: "body1-strong", children: e.name })
      ] }) }),
      /* @__PURE__ */ o.jsx(ne, { as: "p", fs: "body1", mb: 0, children: a.watchdog.modal.description }),
      /* @__PURE__ */ o.jsx(Uc, { initialValues: b, onSubmit: y, enableReinitialize: !0, children: /* @__PURE__ */ o.jsx(Ac, { "data-o2-id": "watchdog-form", "data-testid": "watchdog-form", id: "watchdog-form", name: "watchdogForm", w: 100, children: /* @__PURE__ */ o.jsx("div", { className: "row justify-content-center", children: /* @__PURE__ */ o.jsxs("div", { className: "col-12", children: [
        /* @__PURE__ */ o.jsx(
          ci,
          {
            as: oi,
            "data-testid": "watchdog-email",
            "data-o2-id": "watchdog-email",
            id: "watchdog-email",
            name: "contactEmail",
            label: a.watchdog.modal.contactEmail.label,
            placeholder: a.watchdog.modal.contactEmail.placeholder,
            required: !0,
            mb: 0,
            disabled: g,
            validate: (x) => Pp(x, !0)
          }
        ),
        /* @__PURE__ */ o.jsx(
          ci,
          {
            as: oi,
            "data-testid": "watchdog-phone",
            "data-o2-id": "watchdog-phone",
            id: "watchdog-phone",
            name: "contactMsisdn",
            label: a.watchdog.modal.contactMsisdn.label,
            placeholder: a.watchdog.modal.contactMsisdn.placeholder,
            required: !0,
            help: a.watchdog.modal.contactMsisdn.help,
            mb: 0,
            disabled: g,
            validate: (x) => Op(x, !0) && a.watchdog.modal.contactMsisdn.validationError
          }
        ),
        !(l != null && l.contactMsisdn) && /* @__PURE__ */ o.jsx(ne, { dangerouslySetInnerHTML: { __html: w }, fs: "body2", c: "gray-medium", mb: 5 }),
        /* @__PURE__ */ o.jsx(Nc, { portlet: t, formName: "watchdogForm", imperativeRef: s }),
        /* @__PURE__ */ o.jsx(ce, { d: { lg: "flex" }, direction: !m && "row", justify: !m && "end", mt: 5, children: /* @__PURE__ */ o.jsx(
          ve,
          {
            "data-o2-id": "watchdog-submit",
            "data-testid": "watchdog-submit",
            id: "watchdog-submit",
            name: "watchdogSubmit",
            disabled: g,
            type: "submit",
            "data-o2-role": "action-submit",
            fullwidth: m,
            children: a.watchdog.modal.button.submit
          }
        ) })
      ] }) }) }) })
    ] }),
    f === "success" && /* @__PURE__ */ o.jsx(
      Bb,
      {
        phone: d == null ? void 0 : d.contactMsisdn,
        email: d == null ? void 0 : d.contactEmail,
        closeModal: v
      }
    ),
    f === "failure" && /* @__PURE__ */ o.jsx($b, { closeModal: v })
  ] });
}, mc = ({ sku: n }) => {
  const { unionText: e } = J(), t = pt();
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsxs(
      ve,
      {
        "data-o2-id": "watchdog-button",
        "data-testid": "watchdog-button",
        name: "watchdog-button",
        className: "mt-4",
        fullwidth: !0,
        onClick: () => {
          var r;
          return (r = t == null ? void 0 : t.current) == null ? void 0 : r.show();
        },
        children: [
          /* @__PURE__ */ o.jsx(Ge, { name: "notification" }),
          e.watchdog.button
        ]
      }
    ),
    /* @__PURE__ */ o.jsx(Fb, { modalRef: t, sku: n })
  ] });
}, nn = ({ children: n, isHwDetail: e, backgroundColor: t = "blue-light" }) => e && t === "transparent" ? /* @__PURE__ */ o.jsx(ce, { direction: "column", "data-testid": "hw-detail-price-section", children: n }) : e ? /* @__PURE__ */ o.jsx(
  Bt,
  {
    background: t,
    heading: "",
    "data-o2-id": "hw-detail-price-box",
    "data-testid": "hw-detail-price-box",
    my: 0,
    children: n
  }
) : /* @__PURE__ */ o.jsx(o.Fragment, { children: n }), ar = ({
  sku: n,
  oldPrice: e,
  oldPriceEffectiveEndDate: t,
  isHwDetail: r,
  hideOldPriceEffectiveEndDate: a
}) => {
  const { unionText: i, withParams: s } = J();
  return /* @__PURE__ */ o.jsx(o.Fragment, { children: n && /* @__PURE__ */ o.jsxs("div", { className: "d-flex flex-row gap-3 align-items-baseline", children: [
    /* @__PURE__ */ o.jsxs("div", { className: "d-flex flex-row flex-grow-1 align-items-baseline", children: [
      /* @__PURE__ */ o.jsx(
        "div",
        {
          className: r ? "text-brand h3 fw-bold m-0 text-secondary" : "text-brand h4 fw-bold m-0 text-secondary",
          "data-o2-id": r ? "hw-detail-one-time-price" : "",
          "data-testid": r ? "hw-detail-one-time-price" : "",
          children: s(i.detail.priceWithCurrencySign, {
            price: ze(n.priceInfo.oneTimePrice)
          })
        }
      ),
      t && e && e !== n.priceInfo.oneTimePrice && /* @__PURE__ */ o.jsx(
        "div",
        {
          className: "ms-2 text-secondary text-decoration-line-through",
          "data-o2-id": r ? "hw-detail-old-price" : "",
          "data-testid": r ? "hw-detail-old-price" : "",
          children: s(i.detail.priceWithCurrencySign, {
            price: ze(e)
          })
        }
      )
    ] }),
    !a && t && e && /* @__PURE__ */ o.jsx("div", { className: "text-secondary", children: s(i.detail.until, { date: t }) })
  ] }) });
}, Rb = ({
  pricingInfo: n,
  sku: e,
  monthlyPayment: t,
  oldPrice: r,
  oldPriceEffectiveEndDate: a,
  buyHw: i,
  chosenAdvancedPaymentAbs: s,
  disableBuyWithTariff: u,
  isHwDetail: m,
  isHwInsuranceSelected: f,
  backgroundColor: p,
  hideOldPriceEffectiveEndDate: d,
  forceHideBuySku: c
}) => {
  var x;
  const { config: l } = je(ye), { unionText: h, withParams: g } = J(), b = Hs({
    isHwDetail: m,
    buyHw: i,
    sku: e,
    hasNegativeStockOrders: l.hasNegativeStockOrders,
    hasUserAccountId: l.hasUserAccountId,
    selectedOrganizationType: l.selectedOrganizationType
  });
  if (!n || !e)
    return /* @__PURE__ */ o.jsx(o.Fragment, {});
  const w = (T) => {
    const j = h.detail.orWithDiscountWithTariff;
    return m ? T ? g(j.hasTariffName, {
      tariffName: T
    }) : j.noTariffName : h.orWithTariff;
  }, y = (T) => T < 0 ? 0 : T, v = (T, j) => f ? g(h.detail.accontationWithMonthlyPayment.withInsurance, {
    accontation: ze(y(T)),
    monthlyPayment: ze(j).toString()
  }) : g(h.detail.accontationWithMonthlyPayment.noInsurance, {
    accontation: ze(y(T)),
    monthlyPayment: ze(j).toString()
  });
  return /* @__PURE__ */ o.jsxs(nn, { isHwDetail: m, backgroundColor: p, children: [
    /* @__PURE__ */ o.jsx(
      ar,
      {
        isHwDetail: m,
        sku: e,
        oldPrice: r,
        oldPriceEffectiveEndDate: a,
        hideOldPriceEffectiveEndDate: d
      }
    ),
    /* @__PURE__ */ o.jsx("hr", { className: "my-2" }),
    /* @__PURE__ */ o.jsxs("p", { className: i && m ? "mb-4" : "mb-0", children: [
      w((x = n.tariffSku) == null ? void 0 : x.displayNameInDative),
      " ",
      n.tariffSku && t !== void 0 && s !== void 0 && (m ? /* @__PURE__ */ o.jsx(
        "span",
        {
          className: "text-brand",
          "data-o2-id": "hw-detail-advance-monthly-price",
          "data-testid": "hw-detail-advance-monthly-price",
          children: v(s, t)
        }
      ) : /* @__PURE__ */ o.jsx("strong", { className: "text-brand", children: v(s, t) }))
    ] }),
    !c && i && m && /* @__PURE__ */ o.jsx(Nr, { buyHw: i, disableBuyWithTariff: u }),
    b && /* @__PURE__ */ o.jsx(mc, { sku: e })
  ] });
}, Hb = ({ sku: n, oldPrice: e, oldPriceEffectiveEndDate: t, buyHw: r, isHwDetail: a }) => {
  const { namespace: i } = je(ye), { unionText: s } = J();
  return n ? /* @__PURE__ */ o.jsxs(nn, { isHwDetail: a, children: [
    /* @__PURE__ */ o.jsx(ft, { portlet: i, children: /* @__PURE__ */ o.jsx(
      ar,
      {
        sku: n,
        isHwDetail: a,
        oldPrice: e,
        oldPriceEffectiveEndDate: t
      }
    ) }),
    r && a && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsx("hr", { className: "my-2" }),
      /* @__PURE__ */ o.jsx(
        ve,
        {
          "data-o2-id": "hw-detail-pricing-buy-without-tariff",
          "data-testid": "hw-detail-pricing-buy-without-tariff",
          name: "hw-detail-pricing-buy-without-tariff",
          onClick: () => r(!1),
          fullwidth: !0,
          children: s.detail.buyWithoutTariffBtn
        }
      )
    ] })
  ] }) : /* @__PURE__ */ o.jsx(o.Fragment, {});
}, zb = ({
  sku: n,
  oldPrice: e,
  oldPriceEffectiveEndDate: t,
  buyHw: r,
  disableBuyWithTariff: a,
  isHwDetail: i
}) => {
  const { namespace: s } = je(ye), { unionText: u } = J();
  return n ? /* @__PURE__ */ o.jsxs(nn, { isHwDetail: i, children: [
    /* @__PURE__ */ o.jsx(ft, { portlet: s, children: /* @__PURE__ */ o.jsx(
      ar,
      {
        isHwDetail: i,
        sku: n,
        oldPrice: e,
        oldPriceEffectiveEndDate: t
      }
    ) }),
    /* @__PURE__ */ o.jsx("hr", { className: "my-2" }),
    /* @__PURE__ */ o.jsx("p", { className: r && i ? "mb-4" : "mb-0", children: u.detail.orWithDiscountWithTariff.noTariffName }),
    r && i && /* @__PURE__ */ o.jsx(Nr, { buyHw: r, disableBuyWithTariff: a })
  ] }) : /* @__PURE__ */ o.jsx(o.Fragment, {});
}, Xa = ({
  deviceType: n,
  oneTimePrice: e,
  oldPrice: t,
  oldPriceEffectiveEndDate: r,
  isHwDetail: a
}) => {
  const { unionText: i, withParams: s } = J();
  return /* @__PURE__ */ o.jsxs(
    "p",
    {
      className: a ? "text-secondary mb-4" : "text-secondary mb-2",
      "data-o2-id": a ? "hw-detail-onetime-old-price" : "",
      "data-testid": a ? "hw-detail-onetime-old-price" : "",
      children: [
        s(i.detail.hwPrice, { deviceType: n, oneTimePrice: ze(e) }),
        t && r && t !== e ? /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
          /* @__PURE__ */ o.jsxs("span", { className: "text-decoration-line-through", children: [
            " ",
            s(i.detail.priceWithCurrencySign, {
              price: ze(t)
            })
          ] }),
          s(i.detail.priceUntil, { oldPriceEffectiveEndDate: r })
        ] }) : ""
      ]
    }
  );
}, Ub = ({
  pricingInfo: n,
  businessId: e,
  sku: t,
  oldPrice: r,
  oldPriceEffectiveEndDate: a,
  buyHw: i,
  disableBuyWithTariff: s,
  isHwDetail: u
}) => {
  var d;
  const { unionText: m, withParams: f } = J();
  if (!n || !t)
    return /* @__PURE__ */ o.jsx(o.Fragment, {});
  const p = (d = n.tariffSku) == null ? void 0 : d.displayNameInDative;
  return /* @__PURE__ */ o.jsxs(nn, { isHwDetail: u, children: [
    /* @__PURE__ */ o.jsx("div", { className: "box-cta", children: /* @__PURE__ */ o.jsx(
      "div",
      {
        className: "hw-price",
        "data-o2-id": u ? "hw-detail-advance-monthly-payment" : "",
        "data-testid": u ? "hw-detail-advance-monthly-payment" : "",
        children: f(m.detail.accontation, { value: "0" })
      }
    ) }),
    u && /* @__PURE__ */ o.jsx("p", { children: p ? f(m.detail.withDiscountWithTariff.hasTariffName, {
      tariffName: p
    }) : m.detail.withDiscountWithTariff.noTariffName }),
    /* @__PURE__ */ o.jsx("hr", { className: "my-2" }),
    /* @__PURE__ */ o.jsx(
      Xa,
      {
        deviceType: gn.detail.device[e],
        oneTimePrice: t.priceInfo.oneTimePrice,
        oldPrice: r,
        oldPriceEffectiveEndDate: a,
        isHwDetail: u
      }
    ),
    i && !s && /* @__PURE__ */ o.jsx(
      ve,
      {
        "data-o2-id": "hw-detail-pricing-buy-with-tariff",
        "data-testid": "hw-detail-pricing-buy-with-tariff",
        name: "hw-detail-pricing-buy-with-tariff",
        fullwidth: !0,
        onClick: () => i(!0),
        children: gn.detail.buyWithTariffBtn
      }
    )
  ] });
}, qb = ({
  pricingInfo: n,
  sku: e,
  oldPrice: t,
  oldPriceEffectiveEndDate: r,
  buyHw: a,
  disableBuyWithTariff: i,
  isHwDetail: s
}) => {
  var d;
  const { namespace: u } = je(ye), { unionText: m, withParams: f } = J();
  if (!n || !e)
    return /* @__PURE__ */ o.jsx(o.Fragment, {});
  const p = (d = n.tariffSku) == null ? void 0 : d.displayNameInDative;
  return /* @__PURE__ */ o.jsxs(nn, { isHwDetail: s, children: [
    /* @__PURE__ */ o.jsx(ft, { portlet: u, children: /* @__PURE__ */ o.jsx(
      ar,
      {
        isHwDetail: s,
        sku: e,
        oldPrice: t,
        oldPriceEffectiveEndDate: r
      }
    ) }),
    /* @__PURE__ */ o.jsx("hr", { className: "my-2" }),
    /* @__PURE__ */ o.jsx("p", { className: a && s ? "mb-4" : "mb-0", children: p ? f(m.detail.orWithDiscountWithTariff.hasTariffName, {
      tariffName: p
    }) : m.detail.orWithDiscountWithTariff.noTariffName }),
    a && s && /* @__PURE__ */ o.jsx(Nr, { buyHw: a, disableBuyWithTariff: i })
  ] });
}, eo = ({
  sku: n,
  oldPrice: e,
  monthlyPayment: t,
  businessId: r,
  oldPriceEffectiveEndDate: a,
  buyHw: i,
  chosenAdvancedPaymentAbs: s,
  disableBuyWithTariff: u,
  isHwDetail: m,
  isHwInsuranceSelected: f,
  forceHideBuySku: p
}) => {
  const { config: d } = je(ye), { unionText: c, withParams: l } = J(), h = Hs({
    isHwDetail: m,
    buyHw: i,
    sku: n,
    hasNegativeStockOrders: d.hasNegativeStockOrders,
    hasUserAccountId: d.hasUserAccountId,
    selectedOrganizationType: d.selectedOrganizationType
  }), g = (b) => b < 0 ? 0 : b;
  return n ? /* @__PURE__ */ o.jsxs(nn, { isHwDetail: m, children: [
    /* @__PURE__ */ o.jsx("div", { className: "box-cta", children: /* @__PURE__ */ o.jsxs(
      "div",
      {
        className: "hw-price",
        "data-o2-id": m ? "hw-detail-advance-monthly-payment" : "",
        "data-testid": m ? "hw-detail-advance-monthly-payment" : "",
        children: [
          s !== void 0 && l(c.detail.accontation, {
            value: ze(g(s))
          }),
          /* @__PURE__ */ o.jsx(
            "span",
            {
              className: "text-brand hw-monthly-price",
              "data-o2-id": m ? "hw-detail-advance-monthly-price" : "",
              "data-testid": m ? "hw-detail-advance-monthly-price" : "",
              children: t !== void 0 && (f ? l(c.detail.monthlyPayment.withHwInsurance, {
                value: ze(t)
              }) : l(c.detail.monthlyPayment.noHwInsurance, {
                value: ze(t)
              }))
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ o.jsx("p", { children: c.detail.withDiscountWithTariff.noTariffName }),
    /* @__PURE__ */ o.jsx("hr", { className: "my-2" }),
    /* @__PURE__ */ o.jsx(
      Xa,
      {
        deviceType: gn.detail.device[r],
        oneTimePrice: n.priceInfo.oneTimePrice,
        oldPrice: e,
        oldPriceEffectiveEndDate: a,
        isHwDetail: m
      }
    ),
    !p && i && m && /* @__PURE__ */ o.jsx(Nr, { buyHw: i, disableBuyWithTariff: u }),
    h && /* @__PURE__ */ o.jsx(mc, { sku: n })
  ] }) : /* @__PURE__ */ o.jsx(o.Fragment, {});
}, Yb = ({
  pricingInfo: n,
  businessId: e,
  sku: t,
  monthlyPayment: r,
  oldPrice: a,
  oldPriceEffectiveEndDate: i,
  buyHw: s,
  chosenAdvancedPaymentAbs: u,
  disableBuyWithTariff: m,
  isHwDetail: f,
  isHwInsuranceSelected: p
}) => {
  var g;
  const { unionText: d, withParams: c } = J(), l = (b) => b < 0 ? 0 : b;
  if (!n || !t)
    return /* @__PURE__ */ o.jsx(o.Fragment, {});
  const h = (g = n.tariffSku) == null ? void 0 : g.displayNameInDative;
  return /* @__PURE__ */ o.jsxs(nn, { isHwDetail: f, children: [
    /* @__PURE__ */ o.jsx("div", { className: "box-cta", children: /* @__PURE__ */ o.jsxs(
      "div",
      {
        className: "hw-price",
        "data-o2-id": f ? "hw-detail-advance-monthly-payment" : "",
        "data-testid": f ? "hw-detail-advance-monthly-payment" : "",
        children: [
          u !== void 0 && c(d.detail.accontation, {
            value: ze(l(u))
          }),
          /* @__PURE__ */ o.jsx(
            "span",
            {
              className: "text-brand hw-monthly-price",
              "data-o2-id": f ? "hw-detail-advance-monthly-price" : "",
              "data-testid": f ? "hw-detail-advance-monthly-price" : "",
              children: r !== void 0 && (p ? c(d.detail.monthlyPayment.withHwInsurance, {
                value: ze(r)
              }) : c(d.detail.monthlyPayment.noHwInsurance, {
                value: ze(r)
              }))
            }
          )
        ]
      }
    ) }),
    f && /* @__PURE__ */ o.jsx("p", { children: h ? c(d.detail.withDiscountWithTariff.hasTariffName, {
      tariffName: h
    }) : d.detail.withDiscountWithTariff.noTariffName }),
    /* @__PURE__ */ o.jsx("hr", { className: "my-2" }),
    /* @__PURE__ */ o.jsx(
      Xa,
      {
        deviceType: d.detail.device[e],
        oneTimePrice: t.priceInfo.oneTimePrice,
        oldPrice: a,
        oldPriceEffectiveEndDate: i,
        isHwDetail: f
      }
    ),
    s && !m && f && /* @__PURE__ */ o.jsx(
      ve,
      {
        "data-o2-id": "hw-detail-pricing-buy-with-tariff",
        "data-testid": "hw-detail-pricing-buy-with-tariff",
        name: "hw-detail-pricing-buy-with-tariff",
        fullwidth: !0,
        onClick: () => s(!0),
        children: d.detail.buyWithTariffBtn
      }
    )
  ] });
}, hc = ({
  sku: n,
  pricingInfo: e,
  oldPrice: t,
  oldPriceEffectiveEndDate: r,
  buyHw: a,
  businessId: i,
  monthlyPayment: s,
  chosenAdvancedPaymentAbs: u,
  disableBuyWithTariff: m,
  isHwDetail: f,
  missingHwListingPricingInfo: p,
  isHwInsuranceSelected: d,
  backgroundColor: c,
  hideOldPriceEffectiveEndDate: l,
  forceHideBuySku: h
}) => {
  const [g] = Ue(), { namespace: b } = je(ye), w = B(() => {
    var v;
    return (v = g.get("contextTariff")) != null ? v : void 0;
  }, [g]), y = B(() => g.get("forceHirePurchase") === "true", [g]);
  return n ? !e || p ? /* @__PURE__ */ o.jsx(nn, { isHwDetail: f, children: /* @__PURE__ */ o.jsx(ft, { portlet: b, children: /* @__PURE__ */ o.jsx(
    ar,
    {
      isHwDetail: f,
      sku: n,
      oldPrice: t,
      oldPriceEffectiveEndDate: r
    }
  ) }) }) : n.disableHirePurchase || n.disabledHirePurchase ? /* @__PURE__ */ o.jsx(
    Hb,
    {
      sku: n,
      oldPrice: t,
      oldPriceEffectiveEndDate: r,
      buyHw: a,
      disableBuyWithTariff: m,
      isHwDetail: f
    }
  ) : n.priceInfo.oneTimePrice < ps ? w ? /* @__PURE__ */ o.jsx(ft, { portlet: b, children: /* @__PURE__ */ o.jsx(
    Ub,
    {
      pricingInfo: e,
      businessId: i,
      sku: n,
      oldPrice: t,
      oldPriceEffectiveEndDate: r,
      buyHw: a,
      disableBuyWithTariff: m,
      isHwDetail: f
    }
  ) }) : e.tariffSku ? /* @__PURE__ */ o.jsx(ft, { portlet: b, children: /* @__PURE__ */ o.jsx(
    qb,
    {
      pricingInfo: e,
      sku: n,
      oldPrice: t,
      oldPriceEffectiveEndDate: r,
      buyHw: a,
      disableBuyWithTariff: m,
      isHwDetail: f
    }
  ) }) : /* @__PURE__ */ o.jsx(ft, { portlet: b, children: /* @__PURE__ */ o.jsx(
    zb,
    {
      sku: n,
      oldPrice: t,
      disableBuyWithTariff: m,
      oldPriceEffectiveEndDate: r,
      buyHw: a,
      isHwDetail: f
    }
  ) }) : w || y ? /* @__PURE__ */ o.jsx(ft, { portlet: b, children: /* @__PURE__ */ o.jsx(
    Yb,
    {
      pricingInfo: e,
      businessId: i,
      sku: n,
      monthlyPayment: s,
      oldPrice: t,
      oldPriceEffectiveEndDate: r,
      buyHw: a,
      chosenAdvancedPaymentAbs: u,
      disableBuyWithTariff: m,
      isHwDetail: f,
      isHwInsuranceSelected: d
    }
  ) }) : e.postpaidUser && !e.tariffSku ? /* @__PURE__ */ o.jsx(ft, { portlet: b, children: /* @__PURE__ */ o.jsx(
    eo,
    {
      sku: n,
      oldPrice: t,
      monthlyPayment: s,
      businessId: i,
      oldPriceEffectiveEndDate: r,
      buyHw: a,
      chosenAdvancedPaymentAbs: u,
      disableBuyWithTariff: m,
      isHwDetail: f,
      isHwInsuranceSelected: d,
      forceHideBuySku: h
    }
  ) }) : !e.operation && !e.tariffSku ? /* @__PURE__ */ o.jsx(ft, { portlet: b, children: /* @__PURE__ */ o.jsx(
    eo,
    {
      sku: n,
      oldPrice: t,
      monthlyPayment: s,
      businessId: i,
      oldPriceEffectiveEndDate: r,
      buyHw: a,
      forceHideBuySku: h,
      chosenAdvancedPaymentAbs: u,
      disableBuyWithTariff: m,
      isHwDetail: f
    }
  ) }) : /* @__PURE__ */ o.jsx(ft, { portlet: b, children: /* @__PURE__ */ o.jsx(
    Rb,
    {
      pricingInfo: e,
      sku: n,
      monthlyPayment: s,
      oldPrice: t,
      oldPriceEffectiveEndDate: r,
      buyHw: a,
      forceHideBuySku: h,
      disableBuyWithTariff: m,
      chosenAdvancedPaymentAbs: u,
      isHwDetail: f,
      isHwInsuranceSelected: d,
      backgroundColor: c,
      hideOldPriceEffectiveEndDate: l
    }
  ) }) : /* @__PURE__ */ o.jsx(o.Fragment, {});
};
var fc, to = qc;
fc = to.createRoot, to.hydrateRoot;
const pc = ({ children: n }) => {
  const e = pt(document.createElement("div")), t = B(() => fc(e.current), [e]), r = pt(""), a = oe((c) => Array.from(c || []).filter((l) => !l.id), []), i = oe(() => document.head.querySelectorAll("title"), []), s = oe(() => document.head.querySelectorAll('link[rel="canonical"]'), []), u = oe(({ id: c }) => c && document.head.querySelector(`#${c}`), []), m = oe(
    (c) => {
      const l = ["property", "name", "itemprop"], h = document.head;
      return l.reduce((g, b) => {
        const w = c.getAttribute(b);
        return w ? g.concat(
          a(h.querySelectorAll(`[${b} = "${w}"]`))
        ) : g;
      }, []);
    },
    [a]
  ), f = oe((c, l) => {
    l.length === void 0 && (l = [l]);
    const h = document.createDocumentFragment();
    for (let g = 0, b = l.length; g < b; g++)
      h.appendChild(l[g]);
    c.appendChild(h);
  }, []), p = oe((c, l) => {
    l.length === void 0 && (l = [l]);
    for (let h = 0, g = l.length; h < g; h++)
      c.removeChild(l[h]);
  }, []), d = oe(() => {
    const c = e.current.innerHTML;
    if (r.current === c)
      return;
    r.current = c;
    const l = e.current.querySelector(".react-head-temp");
    if (l === null)
      return;
    let h = Array.prototype.slice.call(l.children);
    const g = document.head, b = g.innerHTML;
    h = h.filter((w) => b.indexOf(w.outerHTML) === -1), h = h.map((w) => w.cloneNode(!0)), h.forEach((w) => {
      const y = w.tagName.toLowerCase();
      if (y === "title") {
        const v = i();
        v && p(g, v);
      } else if (w.id) {
        const v = u(w);
        v && p(g, v);
      } else if (y === "meta") {
        const v = m(w);
        v && p(g, v);
      } else if (y === "link" && w.rel === "canonical") {
        const v = s();
        v && p(g, v);
      }
    }), f(document.head, h);
  }, [f, s, u, m, i, p]);
  return U(() => {
    t.render(
      /* @__PURE__ */ o.jsx("div", { ref: d, className: "react-head-temp", children: n })
    );
  }, [t, n, d]), U(() => () => {
    setTimeout(() => t.unmount());
  }, [t]), null;
}, gc = () => {
  const { seoIds: n, addSeoIds: e, removeSeoId: t } = Mc({
    maxPerComparison: hi
  }), [r, a] = C(!1);
  U(() => {
    a(n.length >= hi);
  }, [n]);
  const i = oe(
    (u) => {
      e([u]);
    },
    [e]
  ), s = oe(
    (u) => n == null ? void 0 : n.some((m) => m === u),
    [n]
  );
  return {
    addSeoId: i,
    removeSeoId: t,
    isSeoIdActive: s,
    isMaxCapacityReached: r
  };
}, Vb = ({ seoId: n }) => {
  const { unionText: e } = J(), { removeSeoId: t, isMaxCapacityReached: r, isSeoIdActive: a, addSeoId: i } = gc();
  return a(n) ? /* @__PURE__ */ o.jsxs(
    ii,
    {
      "aria-label": e.detail.alreadyInCompareAria,
      usage: "text",
      variant: "primary",
      "data-testid": "comparison-button",
      onPress: () => {
        t(n);
      },
      children: [
        /* @__PURE__ */ o.jsx(Ge, { color: "green", name: "check-circle", solid: !0, className: "me-2" }),
        e.detail.alreadyInCompare
      ]
    }
  ) : /* @__PURE__ */ o.jsxs(
    ii,
    {
      "aria-label": e.detail.addToCompareAria,
      usage: "text",
      variant: "primary",
      disabled: r,
      "data-testid": "comparison-button",
      onPress: () => {
        !r && i(n);
      },
      children: [
        /* @__PURE__ */ o.jsx(Ge, { color: "gray-medium", name: "transfer", className: "me-2" }),
        e.detail.addToCompare
      ]
    }
  );
}, Gb = ({ sku: n }) => {
  const { config: e } = je(ye), { unionText: t } = J(), { data: r, fetcher: a } = qe(e.cpcPagesUrl, {
    manual: !0,
    method: "POST"
  }), [i] = Ue(), s = B(
    () => {
      var p, d;
      return ((d = (p = n.categories) == null ? void 0 : p.find((c) => xa.includes(c.businessId))) == null ? void 0 : d.businessId) || "MOBILE_PHONES";
    },
    [n]
  ), u = oe(
    (p) => {
      var d, c;
      return (c = (d = n.features) == null ? void 0 : d.find((l) => l.name === p)) == null ? void 0 : c.value.toLowerCase().replaceAll("_", "-");
    },
    [n.features]
  );
  U(() => {
    if (n.tags) {
      const p = {
        tags: n.tags,
        tagsOperator: "SUBSET",
        organizations: e.selectedOrganization ? [Xt, e.selectedOrganization] : [Xt]
      };
      a(p);
    }
  }, [e.selectedOrganization, a, n]);
  function m(p) {
    return {
      url: "/e-shop/produkty/" + p.seoId,
      displayName: p.title
    };
  }
  const f = B(() => {
    const d = [{
      url: Tl,
      displayName: t.detail.breadcrumb.level1
    }];
    if (r) {
      const c = (y) => r == null ? void 0 : r.find(
        (v) => v.tagsComputed.every((x) => y.includes(x.name)) && y.every((x) => v.tagsComputed.map((T) => T.name).includes(x))
      ), l = [s.toLowerCase().replaceAll("_", "-")], h = c(l);
      if (!h)
        return d;
      d.push(m(h));
      const g = u(s === "O2_EXTRA" ? "EXTRA_SUBCATEGORY" : "MANUFACTURER");
      if (!g)
        return d;
      l.push(g);
      const b = c(l);
      if (!b)
        return d;
      if (d.push(m(b)), ["MOBILE_PHONES", "SMARTWATCH", "TABLETS"].includes(s)) {
        if (!n.modelSeries)
          return d;
        l.push(n.modelSeries.toLowerCase().replaceAll(" ", "-").replaceAll("_", "-"));
      } else if (s === "O2_EXTRA") {
        const y = u("EXTRA_SUBTYPE");
        if (!y)
          return d;
        l.push(y);
      } else if (s === "ACCESSORIES") {
        const y = u("ACCESSORIES_SUBTYPE");
        if (!y)
          return d;
        l.push(y);
      }
      const w = c(l);
      if (!w)
        return d;
      d.push(m(w));
    }
    return d;
  }, [t.detail.breadcrumb.level1, r, s, u, n.modelSeries]);
  return /* @__PURE__ */ o.jsx(fa, { children: f.map(({ url: p, displayName: d }) => /* @__PURE__ */ o.jsx(zs, { path: pn(i, p), label: d }, p)) });
}, Qb = ({ heading: n, media: e }) => /* @__PURE__ */ o.jsx(
  _c,
  {
    "data-o2-id": "hw-gallery-carousel",
    "data-testid": "hw-gallery-carousel",
    heading: n,
    id: "hw-gallery-carousel-id",
    thumbSlidesPerView: 6,
    images: e != null && e.length ? e == null ? void 0 : e.map((t) => ({
      detail: t.fullImage,
      thumbnail: t.thumbnailImage,
      key: t.key,
      alternateText: n
    })) : []
  }
), Xb = ({ groupSelect: n, onGroupSelectChange: e, selectedParams: t, models: r }) => {
  const [a, i] = C(), s = oe((l) => {
    const h = /* @__PURE__ */ new Map();
    return l.forEach((g) => {
      h.set(g.value, g);
    }), Array.from(h.values());
  }, []), u = oe(
    (l, h) => l.displayOrder > h.displayOrder ? -1 : 1,
    []
  ), m = oe(
    (l, h) => r == null ? void 0 : r.reduce((g, b) => {
      var x, T, j;
      const w = !!((x = b.stockAvailability) != null && x.find((A) => A.availableAmount > 0)), y = (j = (T = b.features) == null ? void 0 : T.find((A) => A.name === l)) == null ? void 0 : j.value, v = h ? [...h].filter(
        (A) => {
          var N;
          return A[0] !== l && ((N = b.features.find((S) => S.name === A[0])) == null ? void 0 : N.value) === A[1];
        }
      ).length > 0 : !1;
      return y && ((h == null ? void 0 : h.size) === 1 || v) ? ie(Y({}, g), { [y]: w }) : Y({}, g);
    }, {}),
    [r]
  ), f = oe(
    (l, h) => {
      var w;
      const g = !((w = m(or, h)) != null && w[l.value]), b = l.displayValue || l.value;
      return l.parameter === "#ffffff" ? `
        <div style="display: flex;">
          <div style="margin-right: 12px; border: .1rem solid #C7D4E1; border-radius: 100%; width: 1.6rem; height: 1.6rem; flex-shrink: 0;"></div>
          ${g ? '<span style="width: 1.6rem; height: 0.1rem; background: #C7D4E1; position: absolute; left: 12px; top: 0; bottom: 0; margin: auto; transform: rotate(-45deg);"></span>' : ""}
          <span style="display: block;">${b}</span>
        </div>
      ` : `
      <div style="display: flex;">
        <o2-status style="--background: ${l.parameter}; margin-right: 12px; flex-shrink: 0;"></o2-status>
        ${g ? '<span style="width: 1.6rem; height: 0.1rem; background: white; position: absolute; left: 12px; top: 0; bottom: 0; margin: auto; transform: rotate(-45deg);"></span>' : ""}
        <span style="display: block;">${b}</span>
      </div>
      `;
    },
    [m]
  ), p = oe(
    (l, h) => {
      var w;
      const g = !((w = m(sr, h)) != null && w[l.value]), b = l.displayValue || l.value;
      return g ? `
        <div style="display: flex;">
          <o2-icon color="gray" name="close-circle" size="16" type="solid" style="margin-right: 12px; display: block;"></o2-icon>
          <span style="display: block;">${b}</span>
        </div>` : `
      <div style="display: flex;">
          <o2-icon color="gray" name="check-circle" size="19" type="solid" style="margin-right: 12px; display: block;"></o2-icon>
          <span style="display: block;">${b}</span>
      </div>`;
    },
    [m]
  ), d = oe(
    (l) => {
      if (n.name !== or)
        return !0;
      const h = t == null ? void 0 : t.get(sr), g = t == null ? void 0 : t.get(pi);
      return !!(r != null && r.find((b) => {
        var x, T, j;
        const w = !!((x = b == null ? void 0 : b.features) != null && x.find(
          (A) => A.name === sr && A.value === h
        )), y = !!((T = b == null ? void 0 : b.features) != null && T.find(
          (A) => A.name === or && A.value === l.value
        )), v = !!((j = b == null ? void 0 : b.features) != null && j.find(
          (A) => A.name === pi && A.value === g
        ));
        return h ? w && y : g ? v && y : y;
      }));
    },
    [n.name, r, t]
  ), c = B(
    () => s(n.values).filter(d).sort(u).map((l) => {
      const h = {
        text: l.displayValue || l.value,
        value: l.value,
        innerHTML: void 0
      };
      return n.name === or ? ie(Y({}, h), { innerHTML: f(l, t) }) : n.name === sr ? ie(Y({}, h), { innerHTML: p(l, t) }) : h;
    }),
    [
      d,
      f,
      p,
      n.name,
      n.values,
      s,
      t,
      u
    ]
  );
  return U(() => {
    i(t == null ? void 0 : t.get(n.name));
  }, [n.name, t]), /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx(
      Kr,
      {
        label: n.displayName,
        name: `hw-detail-group-${n.name}`,
        multiple: !1,
        "data-o2-id": `hw-detail-group-${n.name}`,
        "data-testid": `hw-detail-group-${n.name}`,
        dataOptions: c,
        onChange: (l) => e({
          selectedValue: l.target.value,
          featureName: n.name
        }),
        value: a,
        disabled: (c == null ? void 0 : c.length) === 1
      },
      `hw-detail-group-key-${n.name}-${a}`
    ),
    !1,
    !1
  ] });
}, bc = ({
  sku: n,
  salesValue: e,
  disableBuySku: t,
  disableBuyWithTariff: r,
  hwInsurancePrice: a,
  isHwInsuranceSelected: i,
  backgroundColor: s,
  hideOldPriceEffectiveEndDate: u,
  forceHideBuySku: m
}) => {
  var I, re;
  const { config: f } = je(ye), [p, d] = C(), [c, l] = C(0), [h, g] = C(), [b, w] = C(), [y] = Ue(), v = B(() => {
    var V;
    return (V = y.get("contextTariff")) != null ? V : void 0;
  }, [y]), x = B(() => {
    var V;
    return (V = y.get("transaction")) != null ? V : void 0;
  }, [y]), T = B(() => {
    var V;
    return (V = y.get("promoCode")) != null ? V : void 0;
  }, [y]), j = B(() => {
    var V;
    return (V = y.get("utm_source")) != null ? V : void 0;
  }, [y]), A = B(
    () => {
      var V, R;
      return ((R = (V = n.categories) == null ? void 0 : V.find((P) => xa.includes(P.businessId))) == null ? void 0 : R.businessId) || "O2_EXTRA";
    },
    [n]
  ), {
    fetcher: N,
    data: S,
    error: E
  } = qe(f.pricingInfoUrl, {
    method: "POST",
    manual: !0
  }), [k, M] = C(!1);
  U(() => {
    M(!0);
  }, [S, i]), U(() => {
    var V, R, P, Q, H;
    if (S && k) {
      const xe = Ba((R = (V = S.hwPricingList) == null ? void 0 : V[0]) == null ? void 0 : R.hwBudgetItems), Fe = ((Q = (P = S.hwPricingList) == null ? void 0 : P[0]) == null ? void 0 : Q.hirePurchaseSetup.installmentAmount) - (!xe || xe < 0 ? 0 : xe), $e = i && a ? a : 0;
      l((Fe < 0 ? 0 : Fe) + $e);
      const F = ((H = n.oldPriceInfo) == null ? void 0 : H.effectiveEndDate) && new Date(n.oldPriceInfo.effectiveEndDate);
      F && Tr(F, new Date(Date.now())) ? (w(Kn(F, "d.M.yyyy")), g(n.oldPriceInfo.oneTimePrice), e(n.oldPriceInfo.oneTimePrice - n.priceInfo.oneTimePrice)) : (w(""), g(0), e(0)), d(S), M(!1);
    }
  }, [
    S,
    k,
    e,
    n.oldPriceInfo,
    n.priceInfo.oneTimePrice,
    i,
    a
  ]), U(() => {
    E && Na(
      "Request failed",
      JSON.stringify({
        url: f.pricingInfoUrl,
        type: "json",
        body: { code: E.toString() }
      })
    );
  }, [f.pricingInfoUrl, E]), U(() => {
    N({
      skuSeoId: n.seoId,
      preferredTariff: v,
      transaction: x
    });
  }, [n, v, x, N]);
  const O = (V) => {
    let R = "/e-shop/nakup/#/?contextHw=" + n.seoId;
    V ? R += "&paymentMethod=o2mobil" + (v ? "&contextTariff=" + v : "") : R += "&paymentMethod=cash", x && (R += "&transaction=" + x), i && (R += "&hwInsurance=" + n.seoId), T && (R += "&promoCode=" + T), j && (R += "&utm_source=" + j), window.liferayRedirect(R);
  };
  return p ? /* @__PURE__ */ o.jsx(
    hc,
    {
      sku: n,
      oldPrice: h,
      oldPriceEffectiveEndDate: b,
      businessId: A,
      monthlyPayment: c,
      pricingInfo: p,
      buyHw: t && !f.hasNegativeStockOrders ? void 0 : O,
      forceHideBuySku: m,
      disableBuyWithTariff: r,
      chosenAdvancedPaymentAbs: (re = (I = p == null ? void 0 : p.hwPricingList) == null ? void 0 : I[0]) == null ? void 0 : re.hirePurchaseSetup.chosenAdvancePaymentAbs,
      isHwDetail: !0,
      isHwInsuranceSelected: i,
      backgroundColor: s,
      hideOldPriceEffectiveEndDate: u
    }
  ) : /* @__PURE__ */ o.jsx(o.Fragment, {});
}, wc = ({ hwInsurance: n, isHwInsuranceSelected: e, setIsHwInsuranceSelected: t }) => {
  const { unionText: r, withParams: a } = J(), i = () => {
    s(e);
  }, s = oe(
    (u) => {
      t(!u);
    },
    [t]
  );
  return /* @__PURE__ */ o.jsxs("div", { className: "d-flex flex-column gap-1", children: [
    /* @__PURE__ */ o.jsx("span", { className: "o2-label text-body-2", children: r.detail.insuranceHeading }),
    /* @__PURE__ */ o.jsx(Bt, { className: "mb-0", border: !0, children: /* @__PURE__ */ o.jsxs("div", { className: "d-flex flex-row gap-3", children: [
      /* @__PURE__ */ o.jsx(
        so,
        {
          value: "true",
          name: "addHwInsurance",
          className: "mb-0",
          "data-o2-id": "addHwInsurance",
          "data-testid": "addHwInsurance",
          onChange: i,
          checked: e
        }
      ),
      /* @__PURE__ */ o.jsxs("div", { className: "d-flex flex-wrap align-items-center justify-content-between flex-grow-1 gap-2 row-gap-1", children: [
        /* @__PURE__ */ o.jsx("div", { className: "d-flex flex-row gap-2", children: /* @__PURE__ */ o.jsxs("div", { className: "text-body-1-strong", children: [
          a(r.detail.insuranceTitle, {
            hwInsuranceName: n.name,
            hwInsurancePrice: ze(n.price)
          }),
          n.tooltip && /* @__PURE__ */ o.jsxs(Bc, { className: "o2-tooltip--default", children: [
            /* @__PURE__ */ o.jsx(
              Ge,
              {
                className: "o2-icon--tooltip ms-2",
                name: "question-circle",
                solid: !0,
                size: 20,
                "aria-expanded": "false",
                style: { width: "20px", height: "20px" }
              }
            ),
            /* @__PURE__ */ o.jsx("div", { slot: "content", dangerouslySetInnerHTML: { __html: n.tooltip } })
          ] })
        ] }) }),
        n.eyeCatcher && /* @__PURE__ */ o.jsx(dn, { color: "brand", children: n.eyeCatcher.value })
      ] })
    ] }) })
  ] });
}, vc = ({ featureGroups: n }) => {
  const { unionText: e } = J();
  return /* @__PURE__ */ o.jsx(ne, { as: "section", py: { base: 4, md: 5 }, bg: "blue-action-light", children: /* @__PURE__ */ o.jsx(Dc, { children: /* @__PURE__ */ o.jsx(ot, { justify: { md: "center" }, children: /* @__PURE__ */ o.jsxs(Je, { span: { md: 8, lg: 6 }, children: [
    /* @__PURE__ */ o.jsx(ne, { fs: "h2", mb: 3, children: e.detail.specificationTitle }),
    n.map((t, r) => /* @__PURE__ */ o.jsx(
      Fc,
      {
        heading: t.name,
        "data-o2-id": `accordion.${t.businessId}`,
        "data-testid": `accordion.${t.businessId}`,
        open: r === 0,
        type: "box",
        children: gf(t).map((a, i) => /* @__PURE__ */ o.jsxs(ha, { children: [
          !!i && /* @__PURE__ */ o.jsx(ne, { as: "hr", my: 3 }),
          /* @__PURE__ */ o.jsxs(ce, { direction: { base: "column", md: "row" }, children: [
            a.map((s, u) => /* @__PURE__ */ o.jsx(ce, { isFlexed: !0, className: "feature-pair-accordion-column", children: /* @__PURE__ */ o.jsxs(ce, { direction: "column", children: [
              /* @__PURE__ */ o.jsx(ne, { fs: "body1", c: "gray-dark", children: s.displayName ? s.displayName : s.name }),
              /* @__PURE__ */ o.jsx(ne, { fs: "body1", c: "black", children: s.displayValue ? s.displayValue : s.value })
            ] }) }, `feature-${u}`)),
            t.features.length % 2 === 1 && /* @__PURE__ */ o.jsx("div", { className: "hw__parameter" })
          ] })
        ] }, `feature-pair-${i}`))
      },
      t.businessId
    ))
  ] }) }) }) });
}, Pr = ({ contentTag: n }) => /* @__PURE__ */ o.jsx(jr, { url: `${window.location.origin}/delegate/web-content?sid=2355222&tag=${n}` }), Kb = ({ masterSku: n, slaveSkus: e, masterInsuranceSelected: t, promoCode: r, masterId: a }) => {
  const { unionText: i, withParams: s } = J(), [u] = Ue(), m = B(() => {
    var g;
    return (g = u.get("transaction")) != null ? g : void 0;
  }, [u]), f = B(
    () => {
      var g;
      return r || ((g = u.get("promoCode")) != null ? g : void 0);
    },
    [r, u]
  ), p = B(() => {
    var g;
    return (g = u.get("contextTariff")) != null ? g : void 0;
  }, [u]), d = B(() => {
    const g = Hi(n.price.originalPrice.toString()), b = e.reduce(
      (w, y) => {
        var v, x;
        return w + Hi((x = (v = y.price.discountedPrice) == null ? void 0 : v.toString()) != null ? x : "0");
      },
      0
    );
    return Pn(g + b);
  }, [n.price.originalPrice, e]), c = B(() => {
    var w, y;
    const b = (y = JSON.parse((w = localStorage.getItem("promo")) != null ? w : "{}")[a]) != null ? y : {};
    return yf(
      b,
      n,
      e,
      t,
      f,
      m
    );
  }, [a, t, n, f, e, m]), l = () => {
    let g = `${c}&${gi}=${bi.MOBILE}`;
    p && (g += `&${Pl}=${p}`), window.liferayRedirect(g);
  }, h = () => {
    window.liferayRedirect(`${c}&${gi}=${bi.CASH}`);
  };
  return /* @__PURE__ */ o.jsx(Bt, { background: "blue-light", mb: 0, children: /* @__PURE__ */ o.jsxs(ce, { direction: "column", gap: 4, children: [
    /* @__PURE__ */ o.jsx(
      ne,
      {
        as: "p",
        fs: "body1",
        mb: 0,
        dangerouslySetInnerHTML: {
          __html: s(i.promoDetail.price.total, { price: `${d}` })
        }
      }
    ),
    /* @__PURE__ */ o.jsxs(ce, { direction: "column", gap: 3, children: [
      /* @__PURE__ */ o.jsx(
        ve,
        {
          "data-o2-id": "hw-detail-pricing-buy-with-tariff",
          "data-testid": "hw-detail-pricing-buy-with-tariff",
          name: "hw-detail-pricing-buy-with-tariff",
          variant: "primary",
          fullwidth: !0,
          onClick: l,
          children: i.promoDetail.price.buyWithTariff
        }
      ),
      /* @__PURE__ */ o.jsx(
        ve,
        {
          "data-o2-id": "hw-detail-pricing-buy-without-tariff",
          "data-testid": "hw-detail-pricing-buy-without-tariff",
          name: "hw-detail-pricing-buy-without-tariff",
          usage: "outlined",
          fullwidth: !0,
          onClick: h,
          children: i.promoDetail.price.buyWithCash
        }
      )
    ] })
  ] }) });
}, Zb = ({ sku: n, submit: e, closeModal: t }) => {
  const { config: r } = je(ye), { unionText: a } = J(), i = B(() => {
    const s = Ta({
      selectedOrganization: r.selectedOrganization,
      selectedOrganizationStockId: r.selectedOrganizationStockId,
      stockAvailability: n.stockAvailability.map((m) => ie(Y({}, m), {
        availableAmount: Number(m.availableAmount)
      })),
      stockAvailabilitySummary: Rs(n.stockAvailabilitySummary)
    });
    return [
      Ze.ESHOP_AVAILABLEINESHOP,
      Ze.SHOP_AVAILABLE,
      Ze.SHOP_AVAILABLEINESHOP
    ].includes(s);
  }, [n.stockAvailability, n.stockAvailabilitySummary, r]);
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    i && /* @__PURE__ */ o.jsx(
      ve,
      {
        "data-o2-id": "submit-button",
        "data-testid": "submit-button",
        name: "submit-button",
        slot: "primary",
        usage: "filled",
        variant: "primary",
        mb: 0,
        fullwidth: !0,
        onClick: e,
        children: a.promoDetail.variantModal.submit
      }
    ),
    !i && /* @__PURE__ */ o.jsx(
      ve,
      {
        "data-o2-id": "submit-button",
        "data-testid": "submit-button",
        name: "submit-button",
        slot: "primary",
        usage: "outlined",
        variant: "primary",
        mb: 0,
        onClick: t,
        fullwidth: !0,
        children: a.promoDetail.variantModal.cancel
      }
    )
  ] });
}, Jb = ({ content: n }) => {
  const { unionText: e } = J();
  return /* @__PURE__ */ o.jsx("section", { children: /* @__PURE__ */ o.jsx(ot, { justify: { md: "center" }, children: /* @__PURE__ */ o.jsx(Je, { span: { md: 8, lg: 6 }, children: /* @__PURE__ */ o.jsx(mr, { mb: 5, lineClamp: 2, moreLink: e.detail.showMore, sourceType: "text", children: n }) }) }) });
}, ew = ({ variants: n, selectedSku: e, setSelectedSku: t }) => {
  const { unionText: r } = J(), a = () => {
    var w;
    const { colors: b } = kt([e]);
    return (w = b[0]) == null ? void 0 : w.value;
  }, i = () => {
    var w;
    const { storage: b } = kt([e]);
    return (w = b[0]) == null ? void 0 : w.value;
  }, [s, u] = C(a), [m, f] = C(i), p = oe((b) => b.parameter === "#ffffff" ? `
        <div style="display: flex;">
          <div style="margin-right: 12px; border: .1rem solid #C7D4E1; border-radius: 100%; width: 1.6rem; height: 1.6rem; flex-shrink: 0;"></div>
          <span style="display: block;">${b.displayValue}</span>
        </div>
      ` : `
      <div style="display: flex;">
        <o2-status style="--background: ${b.parameter}; margin-right: 12px; flex-shrink: 0;"></o2-status>
        <span style="display: block;">${b.displayValue}</span>
      </div>
      `, []), d = oe((b) => `
      <div style="display: flex;">
          <o2-icon color="gray" name="check-circle" size="19" type="solid" style="margin-right: 12px; display: block;"></o2-icon>
          <span style="display: block;">${b.displayValue}</span>
      </div>`, []), { colors: c, storage: l } = B(() => {
    const b = kt(n);
    return {
      colors: b.colors.map((w) => ({
        selected: w.value === s,
        value: w.value,
        text: w.displayValue,
        innerHTML: p(w)
      })),
      storage: b.storage.map((w) => ({
        selected: w.value === m,
        value: w.value,
        text: w.displayValue,
        innerHTML: d(w)
      }))
    };
  }, [p, d, s, m, n]), h = (b) => {
    var x, T;
    const w = b.target.value, y = n.filter((j) => {
      var N;
      return ((N = kt([j]).storage[0]) == null ? void 0 : N.value) === w;
    }), v = (x = y.find((j) => {
      var N;
      return ((N = kt([j]).colors[0]) == null ? void 0 : N.value) === s;
    })) != null ? x : y[0];
    f(w), u((T = kt([v]).colors[0]) == null ? void 0 : T.value), t(v);
  }, g = (b) => {
    var x, T;
    const w = b.target.value, y = n.filter((j) => {
      var N;
      return ((N = kt([j]).colors[0]) == null ? void 0 : N.value) === w;
    }), v = (x = y.find((j) => {
      var N;
      return ((N = kt([j]).storage[0]) == null ? void 0 : N.value) === m;
    })) != null ? x : y[0];
    u(w), f((T = kt([v]).storage[0]) == null ? void 0 : T.value), t(v);
  };
  return /* @__PURE__ */ o.jsxs(ot, { children: [
    /* @__PURE__ */ o.jsx(Je, { span: 6, children: m && /* @__PURE__ */ o.jsx(
      Kr,
      {
        "data-o2-id": "select-phone-memory",
        "data-testid": "select-phone-memory",
        name: "select-phone-memory",
        dataOptions: l,
        id: "select-phone-memory",
        label: r.promoDetail.variantModal.memory,
        value: m,
        onChange: h
      }
    ) }, `selected-sku-${h}-${g}`),
    /* @__PURE__ */ o.jsx(Je, { span: 6, children: s && /* @__PURE__ */ o.jsx(
      Kr,
      {
        "data-o2-id": "select-phone-color",
        "data-testid": "select-phone-color",
        name: "select-phone-color",
        dataOptions: c,
        id: "select-phone-color",
        label: r.promoDetail.variantModal.color,
        value: s,
        onChange: g
      }
    ) })
  ] });
}, tw = ({ sku: n }) => /* @__PURE__ */ o.jsxs(Je, { span: { md: 7 }, d: "flex", className: "flex-column justify-content-start promo-modal-media-swiper", children: [
  n.eyeCatcher && /* @__PURE__ */ o.jsx(dn, { mb: 1, color: n.eyeCatcher.color, children: n.eyeCatcher.value }),
  /* @__PURE__ */ o.jsx(wn, { d: "flex", className: "justify-content-center", src: n.media[0].fullImage, alt: n.name })
] }), nw = ({ sku: n, validTo: e }) => {
  var a;
  const { unionText: t, withParams: r } = J();
  return /* @__PURE__ */ o.jsx(Bt, { background: "blue-light", mb: 0, children: /* @__PURE__ */ o.jsxs(ce, { direction: "column", gap: 2, children: [
    /* @__PURE__ */ o.jsx(ne, { fs: "body1", c: "gray-dark", children: t.promoDetail.price.intro }),
    /* @__PURE__ */ o.jsxs(ce, { direction: "row", alignItems: "baseline", justify: "between", children: [
      /* @__PURE__ */ o.jsxs(ce, { direction: "row", gap: 1, alignItems: "baseline", children: [
        /* @__PURE__ */ o.jsx(ne, { fs: "h3", mb: 0, c: "blue-brand", children: r(t.detail.priceWithCurrencySign, {
          price: (a = n.price.discountedPrice) == null ? void 0 : a.toString()
        }) }),
        n.price.originalPrice.toString() !== n.price.discountedPrice.toString() && /* @__PURE__ */ o.jsx(ne, { fs: "body1", c: "gray-dark", td: "line-through", children: r(t.detail.priceWithCurrencySign, {
          price: n.price.originalPrice.toString()
        }) })
      ] }),
      e && /* @__PURE__ */ o.jsx(ne, { fs: "body1", c: "gray-dark", children: r(t.promoDetail.price.validTo, {
        date: aa(e, "d.M.yyyy")
      }) })
    ] }),
    /* @__PURE__ */ o.jsx(ne, { as: "hr", my: 0 }),
    /* @__PURE__ */ o.jsx(
      ne,
      {
        as: "p",
        fs: "body1",
        mb: 0,
        dangerouslySetInnerHTML: { __html: t.promoDetail.price.description }
      }
    )
  ] }) });
};
function rw(n, e) {
  return e === 1 && n.one ? n.one : e >= 2 && e <= 4 && n.twoFour ? n.twoFour : n.other;
}
function Gr(n, e, t) {
  return rw(n, e)[t].replace("{{count}}", String(e));
}
function aw(n) {
  return ["lessThan", "about", "over", "almost"].filter(
    function(t) {
      return !!n.match(new RegExp("^" + t));
    }
  )[0];
}
function Qr(n) {
  let e = "";
  return n === "almost" && (e = "takmer"), n === "about" && (e = "približne"), e.length > 0 ? e + " " : "";
}
function Xr(n) {
  let e = "";
  return n === "lessThan" && (e = "menej než"), n === "over" && (e = "viac než"), e.length > 0 ? e + " " : "";
}
function iw(n) {
  return n.charAt(0).toLowerCase() + n.slice(1);
}
const ow = {
  xSeconds: {
    one: {
      present: "sekunda",
      past: "sekundou",
      future: "sekundu"
    },
    twoFour: {
      present: "{{count}} sekundy",
      past: "{{count}} sekundami",
      future: "{{count}} sekundy"
    },
    other: {
      present: "{{count}} sekúnd",
      past: "{{count}} sekundami",
      future: "{{count}} sekúnd"
    }
  },
  halfAMinute: {
    other: {
      present: "pol minúty",
      past: "pol minútou",
      future: "pol minúty"
    }
  },
  xMinutes: {
    one: {
      present: "minúta",
      past: "minútou",
      future: "minútu"
    },
    twoFour: {
      present: "{{count}} minúty",
      past: "{{count}} minútami",
      future: "{{count}} minúty"
    },
    other: {
      present: "{{count}} minút",
      past: "{{count}} minútami",
      future: "{{count}} minút"
    }
  },
  xHours: {
    one: {
      present: "hodina",
      past: "hodinou",
      future: "hodinu"
    },
    twoFour: {
      present: "{{count}} hodiny",
      past: "{{count}} hodinami",
      future: "{{count}} hodiny"
    },
    other: {
      present: "{{count}} hodín",
      past: "{{count}} hodinami",
      future: "{{count}} hodín"
    }
  },
  xDays: {
    one: {
      present: "deň",
      past: "dňom",
      future: "deň"
    },
    twoFour: {
      present: "{{count}} dni",
      past: "{{count}} dňami",
      future: "{{count}} dni"
    },
    other: {
      present: "{{count}} dní",
      past: "{{count}} dňami",
      future: "{{count}} dní"
    }
  },
  xWeeks: {
    one: {
      present: "týždeň",
      past: "týždňom",
      future: "týždeň"
    },
    twoFour: {
      present: "{{count}} týždne",
      past: "{{count}} týždňami",
      future: "{{count}} týždne"
    },
    other: {
      present: "{{count}} týždňov",
      past: "{{count}} týždňami",
      future: "{{count}} týždňov"
    }
  },
  xMonths: {
    one: {
      present: "mesiac",
      past: "mesiacom",
      future: "mesiac"
    },
    twoFour: {
      present: "{{count}} mesiace",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiace"
    },
    other: {
      present: "{{count}} mesiacov",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiacov"
    }
  },
  xYears: {
    one: {
      present: "rok",
      past: "rokom",
      future: "rok"
    },
    twoFour: {
      present: "{{count}} roky",
      past: "{{count}} rokmi",
      future: "{{count}} roky"
    },
    other: {
      present: "{{count}} rokov",
      past: "{{count}} rokmi",
      future: "{{count}} rokov"
    }
  }
}, sw = (n, e, t) => {
  const r = aw(n) || "", a = iw(n.substring(r.length)), i = ow[a];
  return t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? Qr(r) + "o " + Xr(r) + Gr(i, e, "future") : Qr(r) + "pred " + Xr(r) + Gr(i, e, "past") : Qr(r) + Xr(r) + Gr(i, e, "present");
}, cw = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. M. y",
  short: "d. M. y"
}, uw = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, lw = {
  full: "{{date}}, {{time}}",
  long: "{{date}}, {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}} {{time}}"
}, dw = {
  date: An({
    formats: cw,
    defaultWidth: "full"
  }),
  time: An({
    formats: uw,
    defaultWidth: "full"
  }),
  dateTime: An({
    formats: lw,
    defaultWidth: "full"
  })
}, Ka = [
  "nedeľu",
  "pondelok",
  "utorok",
  "stredu",
  "štvrtok",
  "piatok",
  "sobotu"
];
function mw(n) {
  const e = Ka[n];
  switch (n) {
    case 0:
    case 3:
    case 6:
      return "'minulú " + e + " o' p";
    default:
      return "'minulý' eeee 'o' p";
  }
}
function no(n) {
  const e = Ka[n];
  return n === 4 ? "'vo' eeee 'o' p" : "'v " + e + " o' p";
}
function hw(n) {
  const e = Ka[n];
  switch (n) {
    case 0:
    case 4:
    case 6:
      return "'budúcu " + e + " o' p";
    default:
      return "'budúci' eeee 'o' p";
  }
}
const fw = {
  lastWeek: (n, e, t) => {
    const r = n.getDay();
    return Ji(n, e, t) ? no(r) : mw(r);
  },
  yesterday: "'včera o' p",
  today: "'dnes o' p",
  tomorrow: "'zajtra o' p",
  nextWeek: (n, e, t) => {
    const r = n.getDay();
    return Ji(n, e, t) ? no(r) : hw(r);
  },
  other: "P"
}, pw = (n, e, t, r) => {
  const a = fw[n];
  return typeof a == "function" ? a(e, t, r) : a;
}, gw = {
  narrow: ["pred Kr.", "po Kr."],
  abbreviated: ["pred Kr.", "po Kr."],
  wide: ["pred Kristom", "po Kristovi"]
}, bw = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. štvrťrok", "2. štvrťrok", "3. štvrťrok", "4. štvrťrok"]
}, ww = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "január",
    "február",
    "marec",
    "apríl",
    "máj",
    "jún",
    "júl",
    "august",
    "september",
    "október",
    "november",
    "december"
  ]
}, vw = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januára",
    "februára",
    "marca",
    "apríla",
    "mája",
    "júna",
    "júla",
    "augusta",
    "septembra",
    "októbra",
    "novembra",
    "decembra"
  ]
}, yw = {
  narrow: ["n", "p", "u", "s", "š", "p", "s"],
  short: ["ne", "po", "ut", "st", "št", "pi", "so"],
  abbreviated: ["ne", "po", "ut", "st", "št", "pi", "so"],
  wide: [
    "nedeľa",
    "pondelok",
    "utorok",
    "streda",
    "štvrtok",
    "piatok",
    "sobota"
  ]
}, xw = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "noc"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "polnoc",
    noon: "poludnie",
    morning: "ráno",
    afternoon: "popoludnie",
    evening: "večer",
    night: "noc"
  }
}, kw = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "nap.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "v n."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "napol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "v noci"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o polnoci",
    noon: "napoludnie",
    morning: "ráno",
    afternoon: "popoludní",
    evening: "večer",
    night: "v noci"
  }
}, Tw = (n, e) => Number(n) + ".", Ow = {
  ordinalNumber: Tw,
  era: Dt({
    values: gw,
    defaultWidth: "wide"
  }),
  quarter: Dt({
    values: bw,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: Dt({
    values: ww,
    defaultWidth: "wide",
    formattingValues: vw,
    defaultFormattingWidth: "wide"
  }),
  day: Dt({
    values: yw,
    defaultWidth: "wide"
  }),
  dayPeriod: Dt({
    values: xw,
    defaultWidth: "wide",
    formattingValues: kw,
    defaultFormattingWidth: "wide"
  })
}, Pw = /^(\d+)\.?/i, jw = /\d+/i, Ew = {
  narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
}, Sw = {
  any: [/^pr/i, /^(po|n)/i]
}, Aw = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\. [šs]tvr[ťt]rok/i
}, Nw = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Iw = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
  wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
}, Mw = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^m[áa]j/i,
    /^j[úu]n/i,
    /^j[úu]l/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, _w = {
  narrow: /^[npusšp]/i,
  short: /^(ne|po|ut|st|št|pi|so)/i,
  abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
  wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
}, Dw = {
  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
}, Cw = {
  narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
  abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
  any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
}, Lw = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /poln/i,
    noon: /^(nap|(na)?pol(\.|u))/i,
    morning: /^r[áa]no/i,
    afternoon: /^pop/i,
    evening: /^ve[čc]/i,
    night: /^(noc|v n\.)/i
  }
}, Ww = {
  ordinalNumber: ec({
    matchPattern: Pw,
    parsePattern: jw,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: Ct({
    matchPatterns: Ew,
    defaultMatchWidth: "wide",
    parsePatterns: Sw,
    defaultParseWidth: "any"
  }),
  quarter: Ct({
    matchPatterns: Aw,
    defaultMatchWidth: "wide",
    parsePatterns: Nw,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: Ct({
    matchPatterns: Iw,
    defaultMatchWidth: "wide",
    parsePatterns: Mw,
    defaultParseWidth: "any"
  }),
  day: Ct({
    matchPatterns: _w,
    defaultMatchWidth: "wide",
    parsePatterns: Dw,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ct({
    matchPatterns: Cw,
    defaultMatchWidth: "any",
    parsePatterns: Lw,
    defaultParseWidth: "any"
  })
}, $w = {
  code: "sk",
  formatDistance: sw,
  formatLong: dw,
  formatRelative: pw,
  localize: Ow,
  match: Ww,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Bw = ({ sku: n, setModalRef: e, onShow: t, onHide: r, showBalikovoText: a }) => {
  var y, v, x, T;
  const { config: i } = je(ye), { unionText: s, withParams: u } = J(), [m, f] = C(), [p, d] = C(), {
    fetcher: c,
    data: l,
    error: h
  } = qe(i.stockAvailabilityDetailUrl, {
    method: "POST",
    manual: !0
  });
  U(() => {
    var j;
    l && (f(l), d((j = l.storeOrganizationPickUpInfos) == null ? void 0 : j.sort(g)));
  }, [l]), U(() => {
    h && Na(
      "Request failed",
      JSON.stringify({
        url: i.stockAvailabilityDetailUrl,
        type: "json",
        body: { code: h.toString() }
      })
    );
  }, [i.stockAvailabilityDetailUrl, h]), U(() => {
    const j = {
      stockAvailability: n.stockAvailability
    };
    c(j);
  }, [c, n]);
  const g = (j, A) => {
    var N, S, E, k, M, O;
    return (N = j.stockLevels) != null && N.availableAmount && !((S = A.stockLevels) != null && S.availableAmount) ? -1 : !((E = j.stockLevels) != null && E.availableAmount) && ((k = A.stockLevels) != null && k.availableAmount) ? 1 : (M = j.organization) != null && M.webName ? j.organization.webName.localeCompare((O = A.organization) == null ? void 0 : O.webName, "sk") : 0;
  }, b = (j) => {
    if (j && j.length >= 2) {
      const A = p == null ? void 0 : p.filter((N) => N.organization.webName.toLowerCase().indexOf(j.toLowerCase()) > -1 || N.organization.address.street.toLowerCase().indexOf(j.toLowerCase()) > -1 || N.organization.address.city.toLowerCase().indexOf(j.toLowerCase()) > -1);
      d(A);
    } else
      d(m == null ? void 0 : m.storeOrganizationPickUpInfos);
  }, w = (j) => {
    var k, M, O, I, re;
    const A = (M = (k = m == null ? void 0 : m.eshopOrganizationPickUpInfo) == null ? void 0 : k.stockLevels) == null ? void 0 : M.availableAmount;
    if (!((O = j.stockLevels) != null && O.availableAmount))
      return A ? {
        label: s.detail.stockAvailabilityModal.availableEshop,
        color: "text-warning"
      } : {
        label: s.detail.stockAvailabilityModal.notAvailable,
        color: "text-danger"
      };
    const N = cr(j.closestOpeningHours.opening, "d.M.yyyy H:mm", new Date(Date.now())), S = cr(j.closestOpeningHours.closing, "d.M.yyyy H:mm", new Date(Date.now())), E = new Date(Date.now());
    if (Vi(N, E)) {
      if (Tr(N, E))
        return {
          label: u(s.detail.stockAvailabilityModal.availableAt, {
            hour: Zi(N).toString(),
            amount: Qt(j.stockLevels.availableAmount, s.detail.amount)
          }),
          color: "text-success"
        };
      if (Eg(E, S))
        return {
          label: u(s.detail.stockAvailabilityModal.availableNow, {
            amount: Qt(j.stockLevels.availableAmount, s.detail.amount).toString()
          }),
          color: "text-success"
        };
    }
    return Vi(N, Yi(new Date(Date.now()), { days: 1 })) ? {
      label: u(s.detail.stockAvailabilityModal.availableTomorrow, {
        hour: Zi(N).toString(),
        amount: Qt(j.stockLevels.availableAmount, s.detail.amount)
      }),
      color: "text-success"
    } : {
      label: ((I = j.stockLevels) == null ? void 0 : I.availableAmount) > 5 ? s.detail.stockAvailabilityModal.availableMoreThanFive : u(s.detail.stockAvailabilityModal.available, {
        amount: Qt((re = j.stockLevels) == null ? void 0 : re.availableAmount, s.detail.amount)
      }),
      color: "text-success"
    };
  };
  return m ? /* @__PURE__ */ o.jsxs(
    bn,
    {
      size: "medium",
      "data-testid": "o2-modal",
      heading: s.detail.stockAvailabilityModal.heading,
      onShow: t,
      onHide: r,
      onRef: (j) => e(j),
      children: [
        (v = (y = m == null ? void 0 : m.eshopOrganizationPickUpInfo) == null ? void 0 : y.stockLevels) != null && v.availableAmount && ((T = (x = m == null ? void 0 : m.eshopOrganizationPickUpInfo) == null ? void 0 : x.stockLevels) == null ? void 0 : T.availableAmount) > 0 ? /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
          /* @__PURE__ */ o.jsxs("div", { className: "text-subtitle mb-3", children: [
            /* @__PURE__ */ o.jsx(Ge, { name: "delivery", size: 20, color: "blue-brand", className: "me-1" }),
            /* @__PURE__ */ o.jsx("span", { children: a ? s.detail.stockAvailabilityModal.courierDeliveryWithBalikovo : s.detail.stockAvailabilityModal.courierDelivery })
          ] }),
          /* @__PURE__ */ o.jsx(
            Bt,
            {
              background: "blue-light",
              heading: "",
              "data-o2-id": "stock-availability-box",
              "data-testid": "stock-availability-box",
              children: /* @__PURE__ */ o.jsxs("div", { className: "stock-info__status-wrapper", children: [
                /* @__PURE__ */ o.jsxs("div", { className: "stock-info__status", children: [
                  /* @__PURE__ */ o.jsx(Er, { size: "small", color: "success" }),
                  /* @__PURE__ */ o.jsx("span", { className: "text-success", children: u(s.detail.stockAvailabilityModal.available, {
                    amount: Qt(
                      m.eshopOrganizationPickUpInfo.stockLevels.availableAmount,
                      s.detail.amount
                    )
                  }) })
                ] }),
                /* @__PURE__ */ o.jsx("div", { children: Tr(
                  cr(
                    m.eshopOrganizationPickUpInfo.closestOpeningHours.closing,
                    "d.M.yyyy H:mm",
                    new Date(Date.now())
                  ),
                  Yi(new Date(Date.now()), { days: 1 })
                ) ? s.detail.stockAvailabilityModal.deliverTomorrow : u(s.detail.stockAvailabilityModal.deliveryDate, {
                  date: Kn(
                    cr(
                      m.eshopOrganizationPickUpInfo.closestOpeningHours.closing,
                      "d.M.yyyy H:mm",
                      new Date(Date.now())
                    ),
                    "d.M.yyyy",
                    {
                      locale: $w
                    }
                  )
                }) })
              ] })
            }
          )
        ] }) : /* @__PURE__ */ o.jsx(o.Fragment, {}),
        p && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
          /* @__PURE__ */ o.jsxs("div", { className: "text-subtitle mb-3", children: [
            /* @__PURE__ */ o.jsx(Ge, { name: "store", color: "blue-brand", size: 20, className: "me-1" }),
            /* @__PURE__ */ o.jsx("span", { children: s.detail.stockAvailabilityModal.pickupInStore })
          ] }),
          /* @__PURE__ */ o.jsx(
            Bt,
            {
              heading: "",
              background: "blue-light",
              className: "mb-3",
              "data-testid": "store-list-box",
              "data-o2-id": "store-list-box",
              children: /* @__PURE__ */ o.jsx(
                co,
                {
                  placeholder: s.detail.stockAvailabilityModal.searchStore,
                  name: "hw-detail-store-search",
                  onSearch: (j) => {
                    b(j.target.value);
                  },
                  "data-o2-id": "hw-detail-store-search",
                  "data-testid": "hw-detail-store-search"
                },
                "fullText"
              )
            }
          ),
          /* @__PURE__ */ o.jsx("div", { className: "stock-info__stores", children: p.map((j) => {
            const A = w(j);
            return /* @__PURE__ */ o.jsxs("div", { className: "stock-info__store", children: [
              /* @__PURE__ */ o.jsxs("div", { className: "stock-info__store-info", children: [
                /* @__PURE__ */ o.jsx("div", { className: "stock-info__store-name", children: j.organization.webName }),
                /* @__PURE__ */ o.jsx("div", { className: "stock-info__store-addres", children: `${j.organization.address.street} ${j.organization.address.number}, ${j.organization.address.city}` })
              ] }),
              /* @__PURE__ */ o.jsx("div", { className: `stock-info__store-status ${A.color}`, children: A.label }),
              /* @__PURE__ */ o.jsx("hr", { className: "my-5" })
            ] }, `store-${j.organization.bscsCode}`);
          }) })
        ] })
      ]
    }
  ) : /* @__PURE__ */ o.jsx(o.Fragment, {});
}, Za = ({
  availability: n,
  sku: e,
  disableBuySku: t,
  onStockAvailabilityShow: r,
  onStockAvailabilityHide: a,
  showBalikovoText: i
}) => {
  const { unionText: s, withParams: u } = J(), [m, f] = C(), [p, d] = C(), [c, l] = C(), [h, g] = C(), [b, w] = C(), { config: y } = je(ye), [v, x] = C(!1), [T, j] = C(), [A, N] = C();
  U(() => {
    x(!0);
  }, [n]), U(() => {
    v && (l(void 0), g(void 0), x(!1), !(n != null && n.organization) && !(n != null && n.externalAvailability) && !(n != null && n.eshop) ? (l(s.detail.notAvailable), d("close"), f("bg-danger"), t(!0)) : !(n != null && n.organization) && !(n != null && n.eshop) ? (l(
      n.selectedOrganization ? s.detail.notAvailableInOrganization : s.detail.notAvailableInEshop
    ), f("bg-danger"), d("close"), t(!0)) : y.selectedOrganizationStockId ? !(n != null && n.organization) && (n != null && n.eshop) && (n == null ? void 0 : n.eshop) > 0 ? (l(s.detail.availableOnlyInEshop), f("bg-warning"), d("clock"), t(!1)) : n != null && n.organization && n.organization > 0 && (l(
      u(s.detail.availableInOrganization, { amount: n.organization.toString() })
    ), j(s.detail.miniVersion.availableInOrganization), N(Qt(n.organization, s.detail.miniVersion.amount)), f("bg-success"), d("check"), t(!1)) : n != null && n.eshop && n.eshop > 0 && (l(
      u(s.detail.availableInEshop, {
        amount: Qt(n.eshop, s.detail.amount)
      })
    ), j(s.detail.miniVersion.availableInEshop), N(Qt(n.eshop, s.detail.miniVersion.amount)), f("bg-success"), d("check"), t(!1)), n != null && n.externalAvailability && g(
      (n == null ? void 0 : n.externalAvailability) === 1 ? s.detail.externalAvailability.inOne : u(s.detail.externalAvailability.inMore, {
        number: n == null ? void 0 : n.externalAvailability.toString()
      })
    ));
  }, [
    n.eshop,
    n == null ? void 0 : n.externalAvailability,
    n.organization,
    n.selectedOrganization,
    y.selectedOrganizationStockId,
    t,
    v,
    s.detail.amount,
    s.detail.availableInEshop,
    s.detail.availableInOrganization,
    s.detail.availableOnlyInEshop,
    s.detail.externalAvailability.inMore,
    s.detail.externalAvailability.inOne,
    s.detail.miniVersion.amount,
    s.detail.miniVersion.availableInEshop,
    s.detail.miniVersion.availableInOrganization,
    s.detail.notAvailable,
    s.detail.notAvailableInEshop,
    s.detail.notAvailableInOrganization,
    u
  ]);
  const S = (M) => {
    var O;
    M.preventDefault(), (O = b == null ? void 0 : b.current) == null || O.show();
  }, E = {
    check: {
      name: "check-circle",
      solid: !0
    },
    close: {
      name: "close-circle",
      solid: !0
    },
    clock: {
      name: "clock"
    }
  }, k = {
    "bg-success": "green",
    "bg-danger": "red",
    "bg-warning": "orange"
  };
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    p && m && /* @__PURE__ */ o.jsx(Ge, ie(Y({ color: k[m] }, E[p]), { size: 20 })),
    /* @__PURE__ */ o.jsxs(ne, { fs: "body1", children: [
      A && T ? /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
        /* @__PURE__ */ o.jsx(ne, { as: "span", fs: "body1-strong", c: !!m && k[m], children: T }),
        A
      ] }) : /* @__PURE__ */ o.jsx(ne, { as: "span", fs: "body1-strong", c: !!m && k[m], children: c }),
      h && /* @__PURE__ */ o.jsxs(ne, { "data-testid": "stock-availability-external-message", children: [
        s.detail.availableIn,
        /* @__PURE__ */ o.jsx("a", { href: "#open-stock-modal", className: "link--standalone", onClick: S, children: h })
      ] }),
      /* @__PURE__ */ o.jsx(
        Bw,
        {
          sku: e,
          showBalikovoText: i,
          setModalRef: w,
          onHide: a,
          onShow: r
        }
      )
    ] })
  ] });
}, Fw = io(function({ sku: e, validTo: t, variants: r, masterId: a, onVariantUpdate: i }, s) {
  var I, re, V;
  const { config: u, namespace: m } = je(ye), { unionText: f } = J(), [p, d] = C(!1), [c, l] = C(!1), [h, g] = C(e), b = B(() => {
    var Q, H;
    const P = (H = JSON.parse((Q = localStorage.getItem("promo")) != null ? Q : "{}")[a]) != null ? H : {};
    if (P[e.modelId])
      return P[e.modelId];
  }, [a, e.modelId]), [w, y] = C(!!(b != null && b.insurance)), {
    data: v,
    error: x,
    fetcher: T
  } = qe(u.skuSearchUrl, {
    method: "POST",
    manual: !0
  }), j = () => d(!1), A = () => d(!0), N = () => {
    var R, P;
    l(!1), (R = s == null ? void 0 : s.current) == null || R.hide(), (P = s == null ? void 0 : s.current) == null || P.show();
  }, S = () => {
    l(!0);
  }, E = () => {
  }, k = B(
    () => {
      var R, P;
      return !!(v != null && v.hwInsurance && ((P = (R = v == null ? void 0 : v.sku) == null ? void 0 : R.categories) != null && P.find((Q) => Q.businessId === "INSURABLE_HW")));
    },
    [v == null ? void 0 : v.hwInsurance, (I = v == null ? void 0 : v.sku) == null ? void 0 : I.categories]
  ), M = oe(() => {
    var Q, H, xe;
    const R = JSON.parse((Q = localStorage.getItem("promo")) != null ? Q : "{}"), P = ie(Y({}, R), {
      [a]: ie(Y({}, (H = R[a]) != null ? H : {}), {
        [h.modelId]: {
          seoId: h.seoId,
          insurance: w
        }
      })
    });
    localStorage.setItem("promo", JSON.stringify(P)), (xe = s == null ? void 0 : s.current) == null || xe.hide(), i();
  }, [w, a, i, s, h.modelId, h.seoId]);
  U(() => {
    p && !v && T({ seoId: h.seoId });
  }, [T, v, p, h.seoId]);
  const O = B(() => v != null && v.balikovoAvailable ? !(u.selectedOrganization && w) : !1, [v == null ? void 0 : v.balikovoAvailable, w, u.selectedOrganization]);
  return /* @__PURE__ */ o.jsx(o.Fragment, { children: /* @__PURE__ */ o.jsxs(
    bn,
    {
      o2Ref: s,
      id: "promo-bundle-modal",
      "data-testid": "promo-bundle-modal",
      size: "large",
      heading: c ? "" : h.name,
      onHide: j,
      onShow: A,
      isBlocking: (
        /* hide close button when StockAvailabilityModal is opened */
        c
      ),
      children: [
        p && /* @__PURE__ */ o.jsxs(ne, { "data-testid": "promo-bundle-modal-opened", children: [
          x && /* @__PURE__ */ o.jsx(
            Zt,
            {
              color: "danger",
              "data-o2-portlet": m,
              "data-o2-role": "alert-system",
              mt: 5,
              children: f.servletError
            }
          ),
          v && /* @__PURE__ */ o.jsxs(
            "div",
            {
              style: (
                /* hide most of the main content without hiding StockAvailabilityModal when StockAvailabilityModal is opened */
                c ? { height: 0 } : {}
              ),
              children: [
                /* @__PURE__ */ o.jsx(ne, { as: "section", mb: { base: 4, md: 5 }, children: /* @__PURE__ */ o.jsxs(ot, {
                  /* hide eye catcher in gallery when StockAvailabilityModal is opened */
                  children: [
                    !c && /* @__PURE__ */ o.jsx(tw, { sku: h }),
                    /* @__PURE__ */ o.jsx(Je, { span: { md: 5 }, children: /* @__PURE__ */ o.jsxs(ce, { direction: "column", gap: 4, children: [
                      /* @__PURE__ */ o.jsxs(ce, { direction: "column", gap: 3, children: [
                        /* @__PURE__ */ o.jsx(
                          ew,
                          {
                            variants: r,
                            selectedSku: h,
                            setSelectedSku: g
                          }
                        ),
                        k && /* @__PURE__ */ o.jsx(
                          wc,
                          {
                            hwInsurance: v.hwInsurance,
                            isHwInsuranceSelected: w,
                            setIsHwInsuranceSelected: y
                          }
                        )
                      ] }),
                      /* @__PURE__ */ o.jsx(ce, { alignItems: "start", gap: 1, "data-testid": "promo-bundle-modale-stock-availability-panel", children: /* @__PURE__ */ o.jsx(
                        Za,
                        {
                          availability: v.availability,
                          sku: v.sku,
                          showBalikovoText: O,
                          disableBuySku: E,
                          onStockAvailabilityShow: S,
                          onStockAvailabilityHide: N
                        }
                      ) }),
                      /* @__PURE__ */ o.jsx(nw, { sku: h, validTo: t })
                    ] }) })
                  ]
                }) }),
                /* @__PURE__ */ o.jsx(Jb, { content: v.sku.longDescription || v.sku.description }),
                !!((V = (re = v.sku) == null ? void 0 : re.featureGroups) != null && V.length) && /* @__PURE__ */ o.jsx(vc, { featureGroups: v.sku.featureGroups })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ o.jsx("div", {
          slot: "primary",
          /* hide modal buttons when StockAvailabilityModal is opened */
          children: !c && v && /* @__PURE__ */ o.jsx(
            Zb,
            {
              sku: h,
              submit: M,
              closeModal: () => {
                var R;
                return (R = s == null ? void 0 : s.current) == null ? void 0 : R.hide();
              }
            }
          )
        })
      ]
    }
  ) });
}), Rw = ({ sku: n, variants: e, validTo: t, masterId: r, onVariantUpdate: a }) => {
  var l, h;
  const { config: i } = je(ye), { unionText: s, withParams: u } = J(), m = pt(), f = oe(() => {
  }, []), { data: p } = qe(i.skuSearchUrl, {
    method: "POST",
    payload: {
      seoId: n.seoId
    }
  }), d = Pn(n.price.originalPrice), c = n.price.discountedPrice !== void 0 && Pn(n.price.discountedPrice);
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx(ne, { as: "hr", my: 0 }),
    /* @__PURE__ */ o.jsxs(ce, { direction: "column", gap: 3, children: [
      /* @__PURE__ */ o.jsx(ot, { children: /* @__PURE__ */ o.jsxs(ce, { gap: 2, children: [
        /* @__PURE__ */ o.jsx(ne, { flexGrow: 0, children: ((h = (l = n.media) == null ? void 0 : l[0]) == null ? void 0 : h.thumbnailImage) && /* @__PURE__ */ o.jsx(
          wn,
          {
            d: "flex",
            className: "justify-content-center",
            src: n.media[0].thumbnailImage,
            width: "54",
            height: "54",
            alt: n.name
          }
        ) }),
        /* @__PURE__ */ o.jsx(ne, { flexGrow: 1, children: /* @__PURE__ */ o.jsxs(ot, { className: "row-gap-2", children: [
          /* @__PURE__ */ o.jsxs(Je, { d: "flex", span: { base: 12, md: 9 }, className: "gap-1 flex-column", children: [
            n.eyeCatcher && /* @__PURE__ */ o.jsx(dn, { color: n.eyeCatcher.color, children: n.eyeCatcher.value }),
            /* @__PURE__ */ o.jsx(ne, { as: "p", fs: "body1-strong", my: 0, children: n.name })
          ] }),
          /* @__PURE__ */ o.jsx(Je, { d: "flex", span: { base: 12, md: 3 }, className: "flex-md-column flex-row align-items-center gap-1", children: /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
            /* @__PURE__ */ o.jsx(
              "div",
              {
                className: `text-body-1-strong text-brand
                    `,
                children: u(s.detail.priceWithCurrencySign, { price: c })
              }
            ),
            c !== d && /* @__PURE__ */ o.jsx("div", { className: "text-body-2 text-gray-dark text-decoration-line-through", children: u(s.detail.priceWithCurrencySign, { price: d }) })
          ] }) })
        ] }) })
      ] }) }),
      /* @__PURE__ */ o.jsxs(ot, { className: "row-gap-3", children: [
        /* @__PURE__ */ o.jsx(Je, { d: "flex", span: { base: 12, xl: e.length > 1 && 7 }, className: "gap-1 align-items-start", children: p && /* @__PURE__ */ o.jsx(
          Za,
          {
            availability: p.availability,
            sku: p.sku,
            showBalikovoText: !!p.balikovoAvailable,
            disableBuySku: f
          }
        ) }),
        e.length > 1 && /* @__PURE__ */ o.jsxs(Je, { d: "flex", span: { base: 12, xl: 5 }, className: "align-items-end justify-content-xl-end", children: [
          /* @__PURE__ */ o.jsxs(
            ve,
            {
              "data-testid": "show-variants",
              "data-o2-id": "show-variants",
              name: "show-variants",
              usage: "text",
              id: "show-variants",
              onClick: () => {
                var g;
                return (g = m == null ? void 0 : m.current) == null ? void 0 : g.show();
              },
              children: [
                s.promoDetail.showVariants,
                " ",
                /* @__PURE__ */ o.jsx(Ge, { name: "chevron-right", size: 16 })
              ]
            }
          ),
          /* @__PURE__ */ o.jsx(
            Fw,
            {
              ref: m,
              sku: n,
              validTo: t,
              variants: e,
              masterId: r,
              onVariantUpdate: a
            }
          )
        ] })
      ] })
    ] })
  ] });
}, Hw = ({ contentTag: n }) => /* @__PURE__ */ o.jsx(Pr, { contentTag: n }), zw = ({ promoDetail: n, hwDetailPricing: e, promoActive: t, setPromoActive: r }) => {
  const { unionText: a, withParams: i } = J(), { config: s } = je(ye), [u, m] = C(0), f = B(
    () => n.masterSkus.find((l) => l.default),
    [n.masterSkus]
  ), p = B(() => {
    if (!f)
      return "";
    const { variantName: l, name: h } = f;
    return Fs(l, h);
  }, [f]), d = B(() => n.skuIsMaster ? n.slaveGroups.filter(
    (h) => !!h.slaveSkus.find((g) => {
      const b = Ta({
        selectedOrganization: s.selectedOrganization,
        selectedOrganizationStockId: s.selectedOrganizationStockId,
        stockAvailability: g.stockAvailability.map((y) => ie(Y({}, y), {
          availableAmount: Number(y.availableAmount)
        })),
        stockAvailabilitySummary: Rs(g.stockAvailabilitySummary)
        //toCamelCase because of AD-18632
      });
      return [
        Ze.ESHOP_AVAILABLEINESHOP,
        Ze.SHOP_AVAILABLE,
        Ze.SHOP_AVAILABLEINESHOP
      ].includes(b);
    })
  ).length === n.slaveGroups.length : !1, [n.slaveGroups, n.skuIsMaster, s]), c = (l) => {
    var b, w;
    const h = JSON.parse((b = localStorage.getItem("promo")) != null ? b : "{}"), g = (w = h == null ? void 0 : h[p]) != null ? w : {};
    return g[l.modelId] ? g[l.modelId].seoId === l.seoId : l.default;
  };
  return U(() => {
    d && r(!0);
  }, [d, r]), n.skuIsMaster ? /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    t && /* @__PURE__ */ o.jsx(
      bc,
      {
        sku: e.sku,
        disableBuyWithTariff: e.disableBuyWithTariff,
        salesValue: e.salesValue,
        hwInsurancePrice: e.hwInsurancePrice,
        isHwInsuranceSelected: e.isHwInsuranceSelected,
        disableBuySku: e.disableBuySku,
        forceHideBuySku: !0,
        backgroundColor: "transparent",
        hideOldPriceEffectiveEndDate: !0
      }
    ),
    /* @__PURE__ */ o.jsx(Bt, { background: "transparent", border: !0, my: 0, children: /* @__PURE__ */ o.jsxs(ce, { direction: "column", gap: 4, children: [
      d ? (
        // TODO - tech debt with no-nested-ternary and istanbul ignore file
        pf(n.code) ? /* @__PURE__ */ o.jsxs("div", { children: [
          /* @__PURE__ */ o.jsx(ne, { fs: "body2-strong", children: n.slaveGroups.length > 1 ? a.promoDetail.checkbox.labelMultipleHardBundle : a.promoDetail.checkbox.labelSingleHardBundle }),
          /* @__PURE__ */ o.jsx(ne, { c: "gray-medium", className: "text-small", children: i(a.promoDetail.checkbox.validTo, {
            date: aa(n.validTo, "d.M.yyyy")
          }) })
        ] }) : /* @__PURE__ */ o.jsxs(
          so,
          {
            value: "promo-active",
            checked: t,
            onChange: (l) => r(l.target.value),
            "data-o2-id": "promo-active-checkbox",
            "data-testid": "promo-active-checkbox",
            name: "promo-active-checkbox",
            my: 0,
            children: [
              n.bundleDescription && /* @__PURE__ */ o.jsx(ne, { fs: "body2-strong", children: n.bundleDescription }),
              !n.bundleDescription && /* @__PURE__ */ o.jsx(ne, { fs: "body2-strong", children: n.slaveGroups.length > 1 ? a.promoDetail.checkbox.labelMultiple : a.promoDetail.checkbox.labelSingle }),
              /* @__PURE__ */ o.jsx(ne, { c: "gray-medium", className: "text-small", children: i(a.promoDetail.checkbox.validTo, {
                date: aa(n.validTo, "d.M.yyyy")
              }) })
            ]
          }
        )
      ) : /* @__PURE__ */ o.jsxs(ce, { direction: "row", gap: 2, children: [
        /* @__PURE__ */ o.jsx(Ge, { color: "red", name: "close-circle", solid: !0, size: 20 }),
        /* @__PURE__ */ o.jsxs(ce, { direction: "column", children: [
          /* @__PURE__ */ o.jsx(ne, { fs: "body1-strong", c: "red", children: a.promoDetail.unavailableEshop.heading }),
          /* @__PURE__ */ o.jsx(ne, { fs: "body1", c: "gray-dark", children: a.promoDetail.unavailableEshop.description })
        ] })
      ] }),
      /* @__PURE__ */ o.jsx(ha, { children: n.slaveGroups.map(
        (l) => l.slaveSkus.filter(c).map((h) => /* @__PURE__ */ o.jsx(
          Rw,
          {
            sku: h,
            variants: l.slaveSkus,
            validTo: n.validTo,
            masterId: p,
            onVariantUpdate: () => m((g) => g + 1)
          },
          h.seoId
        ))
      ) }, `promo-bundle-products-${u}`)
    ] }) }),
    t && /* @__PURE__ */ o.jsx(
      Kb,
      {
        masterSku: f,
        slaveSkus: n.slaveGroups.flatMap((l) => l.slaveSkus.filter(c)),
        masterInsuranceSelected: e.isHwInsuranceSelected,
        promoCode: n != null && n.skipBundlePromoForWizard ? void 0 : n.code,
        masterId: p
      },
      `promo-bundle-price-${u}`
    )
  ] }) : /* @__PURE__ */ o.jsx(Hw, { contentTag: n.slaveDetailContentTag });
}, zn = ({ keyVar: n, id: e, text: t, onClose: r }) => /* @__PURE__ */ o.jsx("a", { "data-testid": "filter-option-selected-" + t, onClick: r, children: /* @__PURE__ */ o.jsx(
  uo,
  {
    id: e,
    "data-o2-id": `chip.${e}`,
    "data-testid": `chip.${e}`,
    switchable: !0,
    selected: !0,
    className: "me-2",
    children: t
  },
  n
) }), Uw = ({ pages: n, currentSeoId: e }) => {
  const [t] = Ue(), { unionText: r } = J(), a = B(() => {
    var u;
    if (!e || !(n != null && n.length))
      return;
    const i = [];
    let s = (u = n.find((m) => m.seoId === e)) == null ? void 0 : u.parentPageId;
    for (; s; ) {
      const m = n == null ? void 0 : n.find((f) => f.id === s);
      if (!m)
        break;
      i.push({
        path: pn(t, `${Rt.listing}/${m.seoId}`),
        label: m.title
      }), s = m.parentPageId;
    }
    return i.push({
      path: pn(t, Rt.root),
      label: r.rootBreadcrumb
    }), i.reverse();
  }, [e, n, t, r.rootBreadcrumb]);
  return a && a.length > 0 ? /* @__PURE__ */ o.jsx(fa, { children: a.map(({ path: i, label: s }) => /* @__PURE__ */ o.jsx(zs, { path: i, label: s }, i)) }) : null;
}, qw = ({ setFetchNewModel: n }) => {
  const {
    config: { tariffDetailUrl: e },
    namespace: t
  } = je(ye), { unionText: r } = J(), [a, i] = C(!1), s = pt(), [u, m] = C(), [f, p] = C(), [d, c] = C(), [l, h] = Ue(new URLSearchParams());
  U(() => {
    d != null && d.current && d.current.querySelectorAll("[data-tariff-name]").forEach(
      (y) => y.addEventListener("tariff-selected", (v) => {
        var j;
        const x = v.target.getAttribute("data-tariff-name"), T = localStorage.getItem("quote");
        if (T) {
          const A = JSON.parse(T);
          A.contextTariff = { seoId: x }, localStorage.setItem("quote", JSON.stringify(A));
        } else {
          const A = { contextTariff: { seoId: x } };
          localStorage.setItem("quote", JSON.stringify(A));
        }
        l.set("contextTariff", x), h(l), n && n(!0), (j = s == null ? void 0 : s.current) == null || j.hide();
      })
    );
  }, [d, l, n, h]);
  const g = oe(
    (w) => {
      var y;
      w.preventDefault(), (y = s == null ? void 0 : s.current) == null || y.show();
    },
    [s]
  ), b = B(() => ({ headers: { "Accept-Language": "sk-SK;q=0.9" } }), []);
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx("a", { href: "#", onClick: g, children: r.filter.selectTariff }),
    /* @__PURE__ */ o.jsxs(
      bn,
      {
        size: "large",
        "data-testid": "o2-modal",
        heading: r.filter.selectTariff,
        o2Ref: s,
        onHide: () => i(!1),
        onShow: () => i(!0),
        children: [
          f && /* @__PURE__ */ o.jsx(Zt, { color: "danger", "data-o2-portlet": t, "data-o2-role": "alert-system", heading: f.message }),
          u && /* @__PURE__ */ o.jsx(Ge, { name: "loading", size: 40 }),
          a && /* @__PURE__ */ o.jsx(
            jr,
            {
              url: e,
              options: b,
              onLoading: m,
              onError: p,
              onFetched: c
            }
          )
        ]
      }
    )
  ] });
}, Yw = ({ tariffName: n, setFetchNewModel: e }) => {
  const { unionText: t, withParams: r } = J();
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    n && /* @__PURE__ */ o.jsx(
      "div",
      {
        className: "text-small",
        dangerouslySetInnerHTML: { __html: r(t.filter.tariffPrice, { tariffName: n }) }
      }
    ),
    !n && /* @__PURE__ */ o.jsx("div", { className: "text-small", children: t.filter.yourTariff }),
    /* @__PURE__ */ o.jsx(qw, { setFetchNewModel: e }),
    /* @__PURE__ */ o.jsx("hr", { className: "d-md-none" })
  ] });
};
function yc(n) {
  var e, t, r = "";
  if (typeof n == "string" || typeof n == "number")
    r += n;
  else if (typeof n == "object")
    if (Array.isArray(n)) {
      var a = n.length;
      for (e = 0; e < a; e++)
        n[e] && (t = yc(n[e])) && (r && (r += " "), r += t);
    } else
      for (t in n)
        n[t] && (r && (r += " "), r += t);
  return r;
}
function Vw() {
  for (var n, e, t = 0, r = "", a = arguments.length; t < a; t++)
    (n = arguments[t]) && (e = yc(n)) && (r && (r += " "), r += e);
  return r;
}
const Zn = ({ id: n, text: e, onClick: t, numberOfOptions: r, color: a, hideZeroOptions: i, isActive: s }) => i && r === 0 ? /* @__PURE__ */ o.jsx(o.Fragment, {}) : /* @__PURE__ */ o.jsx("a", { "data-testid": "filter-option-" + e, onClick: r > 0 ? t : void 0, children: /* @__PURE__ */ o.jsxs(
  uo,
  {
    id: n,
    "data-o2-id": `chip.${n}`,
    "data-testid": `chip.${n}`,
    switchable: !0,
    className: "me-2 mb-2",
    disabled: r === 0,
    selected: s,
    children: [
      a && /* @__PURE__ */ o.jsx(
        Er,
        {
          className: "me-1",
          style: { "--background": a },
          id: "",
          shape: "circle",
          size: "medium"
        }
      ),
      e + " ",
      /* @__PURE__ */ o.jsx("span", { className: Vw(!s && "text-secondary", "fw-normal"), children: "(" + r + ")" })
    ]
  }
) }), Gw = ({ filter: n, availability: e, text: t, setFilter: r, searchResultForFilter: a }) => {
  var u, m, f, p;
  const i = B(() => Xn(n, e), [n, e]), s = () => {
    const d = n.availability ? Kt(n.availability) : [];
    if (i) {
      const c = d.find((l) => l === e);
      c && d.splice(d.indexOf(c), 1);
    } else
      d.push(e);
    r(
      (c) => c ? ie(Y({}, c), { availability: d }) : { availability: d }
    );
  };
  return /* @__PURE__ */ o.jsx(
    Zn,
    {
      id: "tag-sku-feature-" + e,
      numberOfOptions: (m = (u = a == null ? void 0 : a.aggregation) == null ? void 0 : u.skuOnStock) != null && m[e.toLocaleLowerCase()] ? (p = (f = a == null ? void 0 : a.aggregation) == null ? void 0 : f.skuOnStock) == null ? void 0 : p[e.toLocaleLowerCase()].sum : 0,
      text: t,
      isActive: i,
      onClick: s
    }
  );
}, Qw = ({
  filter: n,
  filterType: e,
  skuCharacteristicBucket: t,
  setFilter: r,
  searchResultForFilter: a
}) => {
  const i = B(
    () => Xn(n, void 0, {
      name: e.featureBusinessIds[0],
      values: [t.name ? t.name : t.value]
    }),
    [n, e, t]
  ), s = (u) => () => {
    const m = n.skuFeatures ? Kt(n.skuFeatures) : [], f = u.name ? u.name : u.value;
    if (i) {
      const p = m.find(
        (d) => d.name === e.featureBusinessIds[0]
      );
      (p == null ? void 0 : p.values.length) === 1 ? m.splice(m.indexOf(p), 1) : p == null || p.values.splice(p == null ? void 0 : p.values.indexOf(f), 1);
    } else {
      let p = !1;
      m.map((d) => (d.name === e.featureBusinessIds[0] && (p = !0, d.values.push(
        // Added name for DEVICE_COLOR so we can filter by its name
        f
      ), d.values = d.values.filter((c, l, h) => h.indexOf(c) === l)), d)), p || m.push({
        name: e.featureBusinessIds[0],
        values: [
          // Added name for DEVICE_COLOR so we can filter by its name
          f
        ]
      });
    }
    r(
      (p) => p ? ie(Y({}, p), { skuFeatures: m }) : { skuFeatures: m }
    );
  };
  return /* @__PURE__ */ o.jsx(
    Zn,
    {
      id: "tag-sku-feature-" + t.value,
      numberOfOptions: Bs(
        a,
        e.featureBusinessIds[0],
        t == null ? void 0 : t.value
      ),
      color: t == null ? void 0 : t.color,
      text: t == null ? void 0 : t.value,
      isActive: i,
      onClick: s(t)
    }
  );
}, Xw = ({ min: n, max: e, filterPrice: t, setFilterPrice: r, keyCnt: a }) => /* @__PURE__ */ o.jsx(
  Rc,
  {
    type: "range",
    min: n,
    max: e,
    from: t != null && t.from ? t.from.toString() : n,
    to: t != null && t.to ? t.to.toString() : e,
    suffix: "€",
    onChange: (i) => {
      let s = {};
      i.target.value[0].replaceAll(" ", "") !== n && (s = ie(Y({}, s), {
        from: Number(i.target.value[0].replaceAll(" ", ""))
      })), i.target.value[1].replaceAll(" ", "") !== e && (s = ie(Y({}, s), {
        to: Number(i.target.value[1].replaceAll(" ", ""))
      })), r(s.from || s.to ? s : void 0);
    },
    step: 1,
    name: "price-slider",
    id: "hw-listing-price-slider",
    "data-o2-id": "hw-listing-price-slider",
    "data-testid": "hw-listing-price-slider"
  },
  "priceSlider" + a + "_min_" + n + "_max_" + e
), Kw = ({
  filter: n,
  skuCharacteristic: e,
  setFilter: t,
  searchResultForFilter: r
}) => {
  var u, m;
  const { unionText: a } = J(), i = B(
    () => Xn(n, void 0, {
      name: e.name,
      values: ["true"]
    }),
    [n, e]
  ), s = () => {
    const f = n != null && n.skuFeatures ? Kt(n.skuFeatures) : [];
    if (i) {
      const p = f.find(
        (d) => d.name === e.name
      );
      p && f.splice(f.indexOf(p), 1);
    } else
      f.push({
        name: e.name,
        values: ["true"]
      });
    t(
      (p) => p ? ie(Y({}, p), { skuFeatures: f }) : { skuFeatures: f }
    );
  };
  return /* @__PURE__ */ o.jsx(
    Zn,
    {
      id: "tag-sku-feature-" + e.name,
      numberOfOptions: Bs(
        r,
        e == null ? void 0 : e.name,
        (m = (u = e == null ? void 0 : e.buckets.filter(
          (f) => f.value.toLowerCase() === "true" || f.value.toLowerCase() === "áno"
        )) == null ? void 0 : u[0]) == null ? void 0 : m.value
        // Because it's single value SkufilterFeature we can afford this little hack
      ),
      isActive: i,
      text: a.skuCharacteristics[e.name],
      onClick: s
    }
  );
}, Zw = ({
  filter: n,
  filterType: e,
  setFilter: t,
  searchResultForFilter: r,
  priceFilterKey: a,
  aggregationValues: i
}) => {
  var c, l, h, g, b, w, y, v, x, T, j, A, N, S;
  const { unionText: s } = J(), [u] = Ue(), [m, f] = C(0), p = () => f((E) => E + 1);
  U(() => {
    p();
  }, [n, u]);
  const { config: d } = je(ye);
  return e ? e.featureBusinessIds.length > 1 ? /* @__PURE__ */ o.jsxs("div", { className: "filter__tag-group", children: [
    /* @__PURE__ */ o.jsx("div", { className: "tag-group__heading", children: s.skuCharacteristics.FEATURES }),
    (l = (c = i == null ? void 0 : i.aggregation) == null ? void 0 : c.skuFeatures) == null ? void 0 : l.filter((E) => nr.includes(E.name)).map((E) => /* @__PURE__ */ o.jsx(
      Kw,
      {
        filter: n,
        skuCharacteristic: E,
        setFilter: t,
        searchResultForFilter: r
      },
      "tag-sku-feature-" + E.name + "-" + m
    ))
  ] }, "single-value-features") : e.featureBusinessIds[0] === "VIRT_PRICE_RANGE" && ((h = r == null ? void 0 : r.aggregation) != null && h.oneTimePrice) ? /* @__PURE__ */ o.jsxs("div", { className: "filter__tag-group", children: [
    /* @__PURE__ */ o.jsx("div", { className: "tag-group__heading", children: s.skuCharacteristics[e.featureBusinessIds[0]] }),
    /* @__PURE__ */ o.jsx(
      Xw,
      {
        keyCnt: a,
        min: r == null ? void 0 : r.aggregation.oneTimePrice.minValue.toString(),
        max: r == null ? void 0 : r.aggregation.oneTimePrice.maxValue.toString(),
        filterPrice: n == null ? void 0 : n.price,
        setFilterPrice: (E) => {
          t(
            (k) => k ? ie(Y({}, k), { price: E }) : { price: E }
          );
        }
      }
    )
  ] }, "value-feature-" + e.featureBusinessIds[0]) : e.featureBusinessIds[0] === "VIRT_AVAILABILITY" && ((g = i == null ? void 0 : i.aggregation) != null && g.skuOnStock) ? /* @__PURE__ */ o.jsxs("div", { className: "filter__tag-group", children: [
    /* @__PURE__ */ o.jsx("div", { className: "tag-group__heading", children: s.skuCharacteristics.VIRT_AVAILABILITY }),
    Object.entries(
      d != null && d.selectedOrganization && d.selectedOrganizationType !== "EFIS" ? kf : xf
    ).map(([E, k]) => /* @__PURE__ */ o.jsx(
      Gw,
      {
        filter: n,
        availability: E,
        text: k,
        setFilter: t,
        searchResultForFilter: r
      },
      "tag-sku-feature-" + E + "-" + m
    )),
    /* @__PURE__ */ o.jsx(
      Zn,
      {
        id: "tag-sku-feature-discounted",
        hideZeroOptions: !0,
        numberOfOptions: (y = (w = (b = r == null ? void 0 : r.aggregation) == null ? void 0 : b.skuOnStock) == null ? void 0 : w.discounted) != null && y.sum ? (v = r == null ? void 0 : r.aggregation) == null ? void 0 : v.skuOnStock.discounted.sum : 0,
        isActive: Xn(n, void 0, void 0, !0),
        text: s.availability.DISCOUNTED,
        onClick: () => {
          const E = !Xn(n, void 0, void 0, !0);
          t(
            (k) => k ? ie(Y({}, k), { onlyDiscounted: E }) : { onlyDiscounted: E }
          );
        }
      },
      "tag-sku-feature-discounted-" + m
    ),
    (j = (T = (x = i == null ? void 0 : i.aggregation) == null ? void 0 : x.promoTags) == null ? void 0 : T.buckets) == null ? void 0 : j.map((E) => {
      var k, M, O;
      return /* @__PURE__ */ o.jsx(
        Zn,
        {
          id: `tag-promo-${E.value}`,
          numberOfOptions: (k = E.count) != null ? k : 0,
          isActive: (O = (M = n.promoTags) == null ? void 0 : M.includes(E.value)) != null ? O : !1,
          text: E.value,
          onClick: () => t((I) => {
            var R;
            const re = (R = I == null ? void 0 : I.promoTags) != null ? R : [], V = re.includes(E.value) ? re.filter((P) => P !== E.value) : [...re, E.value];
            return I ? ie(Y({}, I), { promoTags: V }) : { promoTags: V };
          })
        },
        `tag-promo-${E.value}-${m}`
      );
    })
  ] }, "value-feature-" + e.featureBusinessIds[0]) : /* @__PURE__ */ o.jsxs("div", { className: "filter__tag-group", children: [
    /* @__PURE__ */ o.jsx("div", { className: "tag-group__heading", children: s.skuCharacteristics[e.featureBusinessIds[0]] }),
    i && ((S = (N = (A = i == null ? void 0 : i.aggregation) == null ? void 0 : A.skuFeatures) == null ? void 0 : N.filter((E) => E.name === e.featureBusinessIds[0])[0]) == null ? void 0 : S.buckets.map((E) => /* @__PURE__ */ o.jsx(
      Qw,
      {
        filter: n,
        filterType: e,
        skuCharacteristicBucket: E,
        setFilter: t,
        searchResultForFilter: r
      },
      "tag-sku-feature-" + E.value + "-" + m
    )))
  ] }, "value-feature-" + e.featureBusinessIds[0]) : /* @__PURE__ */ o.jsx(o.Fragment, {});
}, Jw = ({ filter: n, setFilter: e, resetFilterToEmptyValues: t, aggregation: r }) => {
  var f, p, d;
  const { unionText: a } = J(), [i] = Ue(), [s, u] = C(0), m = () => u((c) => c + 1);
  return U(() => {
    m();
  }, [n, i]), /* @__PURE__ */ o.jsxs("div", { className: "filter__selected", "data-testid": "filter__selected", children: [
    /* @__PURE__ */ o.jsxs("div", { className: "mb-3", children: [
      n.availability && ((f = n.availability) == null ? void 0 : f.map((c) => /* @__PURE__ */ o.jsx(
        zn,
        {
          id: "tag-active-availability-" + c,
          text: a.availability[c],
          onClose: () => {
            var h;
            const l = (h = n == null ? void 0 : n.availability) == null ? void 0 : h.filter(
              (g) => g !== c
            );
            e((g) => g ? ie(Y({}, g), { availability: l }) : { availability: l });
          }
        },
        "tag-active-availability-" + c + "-" + s
      ))),
      n.onlyDiscounted && /* @__PURE__ */ o.jsx(
        zn,
        {
          id: "tag-active-only-discounted",
          text: a.availability.DISCOUNTED,
          onClose: () => {
            e(
              (c) => c ? ie(Y({}, c), { onlyDiscounted: void 0 }) : {}
            );
          }
        },
        "tag-active-only-discounted-" + s
      ),
      (p = n.skuFeatures) == null ? void 0 : p.map(
        (c) => nr.includes(c.name) ? /* @__PURE__ */ o.jsx(
          zn,
          {
            id: "tag-active-sku-feature-" + c.name,
            text: a.skuCharacteristics[c.name],
            onClose: () => {
              var h;
              const l = (h = n == null ? void 0 : n.skuFeatures) == null ? void 0 : h.filter(
                (g) => g.name !== c.name
              );
              e(
                (g) => g ? ie(Y({}, g), { skuFeatures: l }) : { skuFeatures: l }
              );
            }
          },
          "tag-active-sku-feature-" + c.name + "-" + s
        ) : c.values.map((l) => /* @__PURE__ */ o.jsx(
          zn,
          {
            id: "tag-active-sku-feature-" + l,
            text: (c == null ? void 0 : c.name) === gs ? df(l, r) : l,
            onClose: () => {
              var b;
              const h = c.values.filter(
                (w) => w !== l
              ), g = (b = n == null ? void 0 : n.skuFeatures) == null ? void 0 : b.filter(
                (w) => w.name !== c.name
              );
              h.length > 0 && (g == null || g.push({
                name: c.name,
                values: h
              })), e(
                (w) => w ? ie(Y({}, w), { skuFeatures: g }) : { skuFeatures: g }
              );
            }
          },
          "tag-active-sku-feature-" + l + "-" + s
        ))
      ),
      (d = n.promoTags) == null ? void 0 : d.map((c) => /* @__PURE__ */ o.jsx(
        zn,
        {
          id: `tag-promo-${c}`,
          text: c,
          onClose: () => e((l) => {
            var b;
            const g = ((b = l == null ? void 0 : l.promoTags) != null ? b : []).filter((w) => w !== c);
            return l ? ie(Y({}, l), { promoTags: g }) : { promoTags: g };
          })
        },
        `tag-promo-${c}-${s}`
      ))
    ] }),
    /* @__PURE__ */ o.jsx("a", { onClick: t, "data-testid": "reset-filter-inside-modal", href: "#", children: a.clearFilter })
  ] });
}, ev = ({
  filter: n,
  previousFilter: e,
  foundDevices: t,
  filters: r,
  setFilter: a,
  searchResultForFilter: i,
  aggregationValues: s,
  skuFilters: u,
  getFilteredSkus: m,
  setDisplayedSkus: f,
  modalFilterState: p,
  setModalFilterState: d,
  searchValue: c
}) => {
  const [l, h] = C(0), { config: g } = je(ye), { unionText: b, withParams: w } = J(), y = pt(), [v, x] = C(), [T, j] = Ue(), A = ga(), N = ho(), S = () => {
    var F;
    (F = v == null ? void 0 : v.current) == null || F.show(), d(
      (ee) => ee ? ie(Y({}, ee), { isOpen: !0 }) : { isOpen: !0 }
    );
  }, E = () => h((F) => F + 1), k = () => {
    d(
      (F) => F ? ie(Y({}, F), { isClosing: !0 }) : { isClosing: !0 }
    );
  }, M = (F) => {
    F.preventDefault(), a({});
  }, O = () => {
    E(), j(
      new URLSearchParams(Y(Y(Y({}, T.getAll("s")[0] && { s: T.getAll("s")[0] }), T.getAll("u")[0] && { u: T.getAll("u")[0] }), T.getAll("i")[0] && { i: T.getAll("i")[0] }))
    );
  }, I = (F, ee) => F.initParamSequenceNumber > ee.initParamSequenceNumber ? 1 : -1;
  U(() => {
    r == null || r.sort(I);
  }, [r]);
  const re = (F, ee, Xe) => {
    var Ot, Ee;
    const dt = Xe.length < fi;
    if (dt && ((Ot = ee.getAll("t")) != null && Ot[0]) && ((Ee = ee.getAll("t")) == null ? void 0 : Ee[0].length) >= fi)
      return j(dr(F, ee, ""));
    if (!dt)
      return j(dr(F, ee, Xe));
  }, V = oe(() => {
    d({
      isClosing: !1,
      closedByApply: !1,
      isOpen: !1
    });
  }, [d]), R = oe(() => {
    const F = dr(n, T);
    j(F), A(N.pathname + "?" + F.toString().replaceAll("%2C", ","), { replace: !0 });
  }, [n, N.pathname, A, T, j]), P = oe(() => {
    f(i == null ? void 0 : i.results), R();
  }, [R, i == null ? void 0 : i.results, f]), Q = oe(() => {
    a($s(T));
  }, [T, a]);
  U(() => {
    if (p != null && p.isClosing && (p != null && p.isOpen)) {
      if (p != null && p.closedByApply) {
        P(), V();
        return;
      }
      Q(), E(), V();
    }
  }, [P, V, p, Q]);
  const H = () => {
    var F;
    d(
      (ee) => ee ? ie(Y({}, ee), { closedByApply: !0 }) : { closedByApply: !0 }
    ), (F = v == null ? void 0 : v.current) == null || F.hide();
  }, xe = ua(u, n, g.selectedOrganization);
  U(() => {
    p != null && p.isOpen && !Un(n, e) && m(xe);
  }, [n, m, xe, p == null ? void 0 : p.isOpen, e]);
  const $e = ((F) => F === 1 ? w(b.numberOfDevices.one, { amount: `${F}` }) : F >= 2 && F <= 4 ? w(b.numberOfDevices.few, { amount: `${F}` }) : w(b.numberOfDevices.many, { amount: `${F}` }))(t || 0);
  return /* @__PURE__ */ o.jsxs("div", { className: "d-md-flex gap-2 justify-content-end", style: { marginRight: "-1.2rem" }, children: [
    /* @__PURE__ */ o.jsxs("div", { className: "flex-shrink-0 text-small mb-2 mb-md-0 align-self-center", children: [
      $e,
      (!Fi(n) || c) && /* @__PURE__ */ o.jsxs("span", { className: "remove-filter-link", children: [
        " | ",
        /* @__PURE__ */ o.jsx("br", { className: "d-none d-md-block d-lg-none" }),
        /* @__PURE__ */ o.jsx("a", { onClick: O, "data-testid": "reset-filter", children: b.clearFilter })
      ] })
    ] }),
    /* @__PURE__ */ o.jsx(
      co,
      {
        placeholder: b.findText,
        name: "hw-listing-search",
        "data-o2-id": "hw-listing-search",
        "data-testid": "hw-listing-search",
        onSearch: (F) => {
          re(n, T, F.target.value);
        },
        onClear: (F) => {
          re(n, T, F.target.value);
        },
        o2Ref: y,
        value: c,
        className: "mb-2 mb-md-0",
        formFieldClassName: "mb-0"
      }
    ),
    r && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsxs(
        ve,
        {
          "data-o2-id": "hw-listing-open-filters-modal",
          "data-testid": "hw-listing-open-filters-modal",
          name: "hw-listing-open-filters-modal",
          fullwidth: !0,
          usage: "outlined",
          slot: "primary",
          onClick: S,
          children: [
            b.openFilterModal,
            Ri(n) > 0 && /* @__PURE__ */ o.jsx(
              "span",
              {
                dangerouslySetInnerHTML: {
                  __html: '<o2-badge class="ms-2" color="primary">' + Ri(n) + "</o2-badge>"
                }
              }
            )
          ]
        },
        "btn-tess"
      ),
      /* @__PURE__ */ o.jsxs(
        bn,
        {
          size: "medium",
          heading: "Filter",
          onRef: (F) => x(F),
          onHide: k,
          "data-testid": "filter-modal",
          children: [
            !Fi(n) && /* @__PURE__ */ o.jsx(
              Jw,
              {
                filter: n,
                setFilter: a,
                resetFilterToEmptyValues: M,
                aggregation: s == null ? void 0 : s.aggregation
              }
            ),
            r && r.map((F) => /* @__PURE__ */ o.jsx(
              Zw,
              {
                filter: n,
                setFilter: a,
                searchResultForFilter: i,
                priceFilterKey: l,
                aggregationValues: s,
                filterType: F
              },
              "filterType" + F.featureBusinessIds.reduce((ee, Xe) => ee + "_" + Xe)
            )),
            /* @__PURE__ */ o.jsx(
              ve,
              {
                "data-o2-id": "hw-listing-open-filters-modal-cancel",
                "data-testid": "hw-listing-open-filters-modal-cancel",
                name: "hw-listing-open-filters-modal-cancel",
                fullwidth: !0,
                usage: "outlined",
                slot: "secondary",
                children: b.closeFilterModal
              }
            ),
            /* @__PURE__ */ o.jsxs(
              ve,
              {
                "data-o2-id": "hw-listing-open-filters-modal-confirm",
                "data-testid": "hw-listing-open-filters-modal-confirm",
                name: "hw-listing-open-filters-modal-confirm",
                fullwidth: !0,
                slot: "primary",
                onClick: H,
                children: [
                  b.applyFilters,
                  " ",
                  "(" + (i == null ? void 0 : i.total) + ")"
                ]
              }
            )
          ]
        },
        l
      )
    ] })
  ] });
}, tv = ({ pricingInfoResponse: n }) => {
  const { unionText: e, withParams: t } = J(), r = B(
    () => {
      var a, i;
      return Ba((i = (a = n == null ? void 0 : n.hwPricingList) == null ? void 0 : a[0]) == null ? void 0 : i.hwBudgetItems);
    },
    [n]
  );
  return /* @__PURE__ */ o.jsx(o.Fragment, { children: (n == null ? void 0 : n.hasContextCustomerId) && r > 0 && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx("hr", { className: "my-5" }),
    /* @__PURE__ */ o.jsxs(Zt, { color: "purple", inline: !0, children: [
      /* @__PURE__ */ o.jsx("div", { slot: "heading", children: e.hwBudgetPromptTitle }),
      /* @__PURE__ */ o.jsx("p", { children: t(e.hwBudgetText, { bonus: ze(r) }) })
    ] })
  ] }) });
}, nv = ({ page: n }) => {
  const [e] = Ue(), [t, r] = C(`${Rt.listing}/${n.seoId}`);
  return U(() => {
    r(pn(e, `${Rt.listing}/${n.seoId}`));
  }, [e, n]), /* @__PURE__ */ o.jsx("div", { className: "col-6 col-md-4 col-lg-3", children: /* @__PURE__ */ o.jsx(Jn, { className: "text-decoration-none", "data-testid": "tag-link", to: t, children: /* @__PURE__ */ o.jsxs("div", { className: `mb-3 w-100 hw-tag ${n.icon ? "hw-tag-has-image" : ""}`, children: [
    n.icon && /* @__PURE__ */ o.jsx("div", { className: "hw-image-wrapper", children: /* @__PURE__ */ o.jsx(wn, { src: n.icon, height: "40" }) }),
    /* @__PURE__ */ o.jsx("div", { className: "hw-content link-dark", children: n.name })
  ] }) }) });
}, rv = ({ currentSeoId: n, visiblePages: e, currentPage: t }) => {
  const r = B(() => {
    if (!n)
      return e != null && e.length ? e.filter((a) => !a.parentPageId) : void 0;
    if (t)
      return [
        ...e ? e.filter((a) => a.parentPageId === (t == null ? void 0 : t.id) && a.skuCount > 0) : []
      ].sort((a, i) => a.displayOrder - i.displayOrder);
  }, [n, e, t]);
  return r && r.length > 0 ? /* @__PURE__ */ o.jsx("div", { className: "hw-listing__tags", children: /* @__PURE__ */ o.jsx("div", { className: "row", children: r.map((a) => /* @__PURE__ */ o.jsx(nv, { page: a }, a.seoId)) }) }) : null;
}, av = ({ loadMore: n, loading: e }) => {
  const { unionText: t } = J();
  return /* @__PURE__ */ o.jsx("div", { className: "products-loader", children: /* @__PURE__ */ o.jsx("div", { className: "container", children: /* @__PURE__ */ o.jsx("div", { className: "row justify-content-md-center", children: /* @__PURE__ */ o.jsx("div", { className: "col-md-6 col-lg-4", children: /* @__PURE__ */ o.jsxs(
    ve,
    {
      "data-o2-id": "show-more",
      "data-testid": "show-more",
      name: "showMore",
      fullwidth: !0,
      onClick: n,
      disabled: e,
      children: [
        t.loadMore,
        e && /* @__PURE__ */ o.jsx(Ge, { name: "loading", className: "ms-1" })
      ]
    }
  ) }) }) }) });
}, iv = () => {
  const { unionText: n } = J(), e = oe(() => {
    Authentication.authenticate({
      redirect_url: window.location.href
    });
  }, []);
  return /* @__PURE__ */ o.jsx("article", { className: "col-md-6 col-xl-4 hw-listing__product-wrapper", children: /* @__PURE__ */ o.jsx(Bt, { heading: "", background: "white", className: "box--login", "data-o2-id": "login-box", "data-testid": "login-box", children: /* @__PURE__ */ o.jsxs("div", { className: "login--wrapper", children: [
    /* @__PURE__ */ o.jsxs("div", { className: "login__heading", children: [
      /* @__PURE__ */ o.jsx("h4", { className: "text-success mb-1", children: n.login.heading }),
      /* @__PURE__ */ o.jsx("div", { children: n.login.description })
    ] }),
    /* @__PURE__ */ o.jsx("div", { className: "login__image", children: /* @__PURE__ */ o.jsx(wn, { src: "https://www.o2.sk/documents/2355222/180577834/login-luddo.png" }) }),
    /* @__PURE__ */ o.jsx(
      ve,
      {
        id: "authenticate-btn",
        variant: "secondary",
        "data-o2-id": "login.authenticate",
        "data-testid": "login.authenticate",
        name: "login.authenticate",
        onClick: e,
        usage: "filled",
        fullwidth: !0,
        children: n.login.confirm
      }
    )
  ] }) }) });
}, ro = ({ contentTag: n }) => /* @__PURE__ */ o.jsx(jr, { url: `${window.location.origin}/delegate/web-content?sid=2355222&tag=${n}` }), ov = ({ onClick: n, linkText: e, icon: t, id: r }) => {
  const a = document.getElementById(r);
  return a && ba(
    /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsx("hr", { className: "my-2", style: { borderStyle: "dashed" } }),
      /* @__PURE__ */ o.jsx("div", { className: "bq-root", children: /* @__PURE__ */ o.jsxs("a", { className: "link--standalone", onClick: n, "data-testid": r, children: [
        t && /* @__PURE__ */ o.jsx(Ge, { name: t, className: "me-1" }),
        /* @__PURE__ */ o.jsx("span", { dangerouslySetInnerHTML: { __html: e } })
      ] }) })
    ] }),
    a
  );
}, sv = io(function({ seoId: e }, t) {
  var w;
  const [r] = Ue(), { config: a, namespace: i } = je(ye), { unionText: s } = J(), [u, m] = C(!1), {
    data: f,
    error: p,
    fetcher: d
  } = qe(a.hwDeviceDetailUrl, {
    method: "POST",
    manual: !0
  }), c = B(() => {
    if (!f)
      return;
    const y = f.masterSkus.find((v) => v.default);
    return ie(Y({}, y), {
      colors: kt([y, ...f.masterSkus]).colors.map((v) => v.parameter),
      // eyeCatcher should not be displayed for master sku
      eyeCatcher: void 0,
      price: ie(Y({}, y.price), {
        // discountedPrice should not be displayed for master sku
        discountedPrice: void 0
      })
    });
  }, [f]), l = B(
    () => (c == null ? void 0 : c.seoId) && Ra(r, c.seoId),
    [r, c]
  ), h = B(() => {
    if (!c || !f)
      return [];
    const y = f.slaveGroups.map((v) => ie(Y({}, v), {
      colors: [...kt(v.slaveSkus).colors.map((x) => x.parameter)]
    })).flatMap((v) => v.slaveSkus.map((x) => ie(Y({}, x), { colors: v.colors }))).filter((v) => v.default);
    return [c, ...y];
  }, [c, f]), g = () => m(!1), b = () => m(!0);
  return U(() => {
    u && !f && d({ seoId: e });
  }, [d, u, f, e]), /* @__PURE__ */ o.jsxs(
    bn,
    {
      o2Ref: t,
      "data-testid": "promo-modal",
      heading: (w = c == null ? void 0 : c.title) != null ? w : "",
      onHide: g,
      onShow: b,
      children: [
        u && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
          (c == null ? void 0 : c.contentTag) && /* @__PURE__ */ o.jsx(
            jr,
            {
              mb: 5,
              url: `${window.location.origin}/delegate/web-content?sid=2355222&tag=${c.contentTag}`
            }
          ),
          p && /* @__PURE__ */ o.jsx(Zt, { color: "danger", "data-o2-portlet": i, "data-o2-role": "alert-system", mt: 5, children: s.servletError }),
          /* @__PURE__ */ o.jsx(ot, { alignItems: "stretch", children: h.map((y, v) => {
            var x, T, j, A;
            return /* @__PURE__ */ o.jsx(Je, { span: { base: 12, md: 4 }, mb: { base: 5, md: 0 }, mt: { md: v > 2 && 5 }, children: /* @__PURE__ */ o.jsxs(ce, { gap: 2, children: [
              /* @__PURE__ */ o.jsx(ce, { flexGrow: 0, children: /* @__PURE__ */ o.jsx(ot, { children: /* @__PURE__ */ o.jsx(Je, { children: ((T = (x = y.media) == null ? void 0 : x[0]) == null ? void 0 : T.thumbnailImage) && /* @__PURE__ */ o.jsx(
                wn,
                {
                  d: "flex",
                  className: "justify-content-center",
                  src: (A = (j = y.media) == null ? void 0 : j[1]) != null && A.thumbnailImage ? y.media[1].thumbnailImage : y.media[0].thumbnailImage,
                  width: "54",
                  height: "54",
                  alt: y.name
                }
              ) }) }) }),
              /* @__PURE__ */ o.jsxs(ce, { direction: "column", gap: 1, style: { flex: 1, width: 0 }, children: [
                y.eyeCatcher && /* @__PURE__ */ o.jsx(ot, { children: /* @__PURE__ */ o.jsx(dn, { color: y.eyeCatcher.color, children: y.eyeCatcher.value }) }),
                /* @__PURE__ */ o.jsx(ot, { children: /* @__PURE__ */ o.jsx(Je, { children: /* @__PURE__ */ o.jsx(ne, { as: "p", mb: 0, fs: "body2", children: y.name }) }) }),
                /* @__PURE__ */ o.jsx(ot, { children: /* @__PURE__ */ o.jsx(Je, { children: /* @__PURE__ */ o.jsxs(ce, { direction: "row", flexGrow: 1, alignItems: "baseline", my: 1, children: [
                  y.price.discountedPrice && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
                    /* @__PURE__ */ o.jsx(ne, { m: 0, fs: "body1-strong", c: "blue-brand", children: `${Pn(y.price.discountedPrice)} €` }),
                    /* @__PURE__ */ o.jsx(ne, { ms: 1, fs: "body2", c: "gray-dark", td: "line-through", children: `${Pn(y.price.originalPrice)} €` })
                  ] }),
                  !y.price.discountedPrice && /* @__PURE__ */ o.jsx(ne, { m: 0, fs: "body1-strong", c: "blue-brand", children: `${Pn(y.price.originalPrice)} €` })
                ] }) }) }),
                /* @__PURE__ */ o.jsx(ot, { mt: "auto", children: /* @__PURE__ */ o.jsx(Je, { children: y.colors.map((N, S) => /* @__PURE__ */ o.jsx(
                  Er,
                  {
                    ms: S !== 0 && 1,
                    style: { "--background": N }
                  },
                  N
                )) }) })
              ] })
            ] }) }, y.seoId);
          }) })
        ] }),
        /* @__PURE__ */ o.jsx("div", { slot: "primary", children: l && /* @__PURE__ */ o.jsx(Jn, { to: l, reloadDocument: !0, children: /* @__PURE__ */ o.jsx(
          ve,
          {
            "data-testid": "show-promo",
            "data-o2-id": "show-promo",
            name: "show-promo",
            usage: "filled",
            variant: "primary",
            fullwidth: !0,
            mb: 0,
            children: s.promoDetail.showPromo
          }
        ) }) })
      ]
    }
  );
}), cv = ({ imageVariant: n, setImage: e }) => {
  const [t] = Ue(), r = pt(), a = B(
    () => Ra(t, n.seoId),
    [t, n.seoId]
  );
  return U(() => {
    const i = r == null ? void 0 : r.current, s = () => {
      e(n.image);
    };
    return i && i.addEventListener("mouseenter", s), () => {
      i && i.removeEventListener("mouseenter", s);
    };
  }, [r, e, a, n.image]), /* @__PURE__ */ o.jsx(Jn, { to: a, children: /* @__PURE__ */ o.jsx(
    ve,
    {
      "data-o2-id": `color-${n.seoId}`,
      "data-testid": `color-${n.seoId}`,
      name: `color-${n.seoId}`,
      usage: "outlined",
      className: "icon-button",
      o2Ref: r,
      children: /* @__PURE__ */ o.jsx(Er, { style: { "--background": n.rgbValue } })
    }
  ) });
}, uv = ({ seoId: n }) => {
  const { removeSeoId: e, isMaxCapacityReached: t, isSeoIdActive: r, addSeoId: a } = gc(), i = oe(
    (m) => {
      m.preventDefault(), m.stopPropagation(), a(n);
    },
    [a, n]
  ), s = oe(
    (m) => {
      m.preventDefault(), m.stopPropagation(), e(n);
    },
    [e, n]
  ), u = B(() => r(n), [r, n]);
  return /* @__PURE__ */ o.jsx(
    ve,
    {
      "data-o2-id": u ? "check-circle" : "transfer",
      "data-testid": u ? "check-circle" : "transfer",
      name: u ? "check-circle" : "transfer",
      disabled: t && !u,
      usage: "outlined",
      className: "icon-button mb-2",
      onClick: u ? s : i,
      children: u ? /* @__PURE__ */ o.jsx(Ge, { name: "check-circle", color: "green", solid: !0 }) : /* @__PURE__ */ o.jsx(Ge, { name: "transfer", color: "gray-medium" })
    },
    `compare-${t}-${u}`
  );
}, lv = ({ children: n, id: e }) => document.getElementById(e) ? ba(n, document.getElementById(e)) : /* @__PURE__ */ o.jsx(o.Fragment, {}), dv = ({ seoId: n, imageVariants: e, setImage: t, skuId: r }) => {
  const a = `product__colors-${r}`;
  return /* @__PURE__ */ o.jsxs("div", { className: "product__actions", children: [
    /* @__PURE__ */ o.jsx(uv, { seoId: n }),
    e && e.length > 1 && /* @__PURE__ */ o.jsx("div", { className: "product__colors", id: a, children: /* @__PURE__ */ o.jsx(lv, { id: a, children: /* @__PURE__ */ o.jsx(lo, { "data-testid": "o2-swiper", spaceBetween: 0, direction: "vertical", children: e.map((i) => /* @__PURE__ */ o.jsx(mo, { children: /* @__PURE__ */ o.jsx(cv, { imageVariant: i, setImage: t }) }, `image-variant-wrapper-${r}-${i.seoId}`)) }) }) })
  ] });
}, mv = ({ features: n }) => n ? /* @__PURE__ */ o.jsx(o.Fragment, { children: n.map(({ name: e, displayName: t, value: r }) => /* @__PURE__ */ o.jsxs("div", { className: "d-flex text-small gap-2 mb-1", children: [
  /* @__PURE__ */ o.jsx("div", { className: "flex-grow-1 text-secondary", children: t }),
  /* @__PURE__ */ o.jsx("div", { children: r })
] }, e)) }) : null, hv = ({ labels: n }) => {
  const { unionText: e } = J(), t = n && n.filter(({ startDate: r, endDate: a, locations: i }) => {
    const s = i.includes("LISTING"), u = new Date(Date.now()), m = a ? r && Yr(r) <= u && Yr(a) >= u : r && Yr(r) <= u;
    return s && m;
  }).sort((r, a) => new RegExp(`^${e.eyeCatchers.discount}`).test(r.value) ? -1 : r.sortingWeight > a.sortingWeight ? 1 : -1).slice(0, 3);
  return t ? /* @__PURE__ */ o.jsx("div", { className: "product__labels", children: t.map(({ color: r, name: a, value: i }) => /* @__PURE__ */ o.jsx(dn, { color: r, className: "mb-1", children: i }, a)) }) : null;
}, fv = ({ sku: n, salesValue: e, bussinessId: t, pricingInfo: r }) => {
  const [a, i] = C(), [s, u] = C(), m = B(() => {
    var c, l;
    return (l = (c = r == null ? void 0 : r.hwPricingList) == null ? void 0 : c.filter(
      (h) => h.hirePurchaseSetup.seoId === n.seoId
    )) == null ? void 0 : l[0];
  }, [r, n]), f = B(() => Ba(m == null ? void 0 : m.hwBudgetItems), [m]), p = B(() => {
    if (n && n.oldPriceInfo && n.oldPriceInfo.effectiveEndDate)
      return new Date(n.oldPriceInfo.effectiveEndDate);
  }, [n]), d = B(() => n != null && n.oldPriceInfo && p && Tr(p, new Date(Date.now())) ? n.oldPriceInfo.oneTimePrice : void 0, [n, p]);
  return U(() => {
    if (!m)
      return;
    if (n.priceInfo.oneTimePrice < ps) {
      i(m == null ? void 0 : m.hirePurchaseSetup.chosenAdvancePaymentAbs), u(0);
      return;
    }
    i(m == null ? void 0 : m.hirePurchaseSetup.chosenAdvancePaymentAbs);
    const c = m.hirePurchaseSetup.installmentAmount;
    u(c - (f < 0 ? 0 : f));
  }, [f, m, n]), U(() => e(d), [d, e]), /* @__PURE__ */ o.jsx(
    hc,
    {
      sku: n,
      oldPrice: d,
      oldPriceEffectiveEndDate: p ? Kn(p, "d.M.yyyy") : void 0,
      businessId: t,
      monthlyPayment: !s || s < 0 ? 0 : s,
      pricingInfo: r,
      chosenAdvancedPaymentAbs: a,
      isHwDetail: !1,
      missingHwListingPricingInfo: !m
    }
  );
}, pv = ({ sku: n, pricingInfo: e }) => {
  var A, N;
  const { config: t } = je(ye), { unionText: r, withParams: a } = J(), [i, s] = C((N = (A = n.media) == null ? void 0 : A[0]) == null ? void 0 : N.originalImage), u = pt(), [m] = Ue(), f = ga(), [p, d] = C(0), c = oe(() => {
    var S, E;
    s((E = (S = n.media) == null ? void 0 : S[0]) == null ? void 0 : E.originalImage);
  }, [n.media]), l = oe(() => {
    var S;
    (S = u.current) == null || S.removeEventListener("mouseleave", c);
  }, [c]);
  U(() => {
    var S;
    return (S = u.current) == null || S.addEventListener("mouseleave", c), () => {
      l();
    };
  }, [u, s, n, c, l]);
  const h = () => {
    if (!n.skuEyeCatchers)
      return;
    if (!p)
      return n.skuEyeCatchers;
    const S = ze(p - n.priceInfo.oneTimePrice), E = a(r.salesSticker, { value: S });
    return [
      ...n.skuEyeCatchers,
      {
        id: "xxxxx",
        name: E,
        value: E,
        color: "blue",
        locations: ["DETAIL", "LISTING"],
        startDate: wl,
        archived: !1,
        sortingWeight: 0
      }
    ];
  }, g = B(() => {
    var S, E;
    return ((E = (S = n.categories) == null ? void 0 : S.find((k) => xa.includes(k.businessId))) == null ? void 0 : E.businessId) || "MOBILE_PHONES";
  }, [n]), b = B(() => {
    var k, M;
    const S = (M = (k = t.skuConfigs[g]) == null ? void 0 : k.highlightFeatures) == null ? void 0 : M.sort(
      (O, I) => O.initParamSequenceNumber - I.initParamSequenceNumber
    ), E = [];
    return S == null || S.forEach((O) => {
      const I = n.features.find((re) => re.name === O.featureBusinessId);
      I && (I.displayName = O.displayName, E.push(I));
    }), E;
  }, [t, n, g]), w = h(), y = B(() => Ra(m, n.seoId), [m, n.seoId]), v = pt(), x = `${n.seoId}-promo-link`, T = document.getElementById(x), j = oe(
    (S) => {
      var E, k;
      S.preventDefault(), (E = n.promoInfo) != null && E.skuIsTarget ? f(y) : (k = v.current) == null || k.show();
    },
    [v, n.promoInfo, f, y]
  );
  return /* @__PURE__ */ o.jsx("article", { className: "col-md-6 col-xl-4 hw-listing__product-wrapper", children: /* @__PURE__ */ o.jsxs("div", { className: "hw-listing__anchor-wrapper", children: [
    /* @__PURE__ */ o.jsx(Jn, { className: "sku-card-link", to: y, "data-testid": "sku-card", children: /* @__PURE__ */ o.jsxs(
      Bt,
      {
        heading: "",
        background: "white",
        className: "hw-listing__product",
        "data-o2-id": "sku-card-box-" + n.id,
        "data-testid": "sku-card-box-" + n.id,
        children: [
          /* @__PURE__ */ o.jsxs("div", { className: "product__image", ref: u, "data-testid": "product-image", children: [
            i && /* @__PURE__ */ o.jsx(wn, { src: i, height: "154", alt: n.name }),
            /* @__PURE__ */ o.jsx(dv, { imageVariants: n.imageVariants, setImage: s, skuId: n.id, seoId: n.seoId })
          ] }),
          /* @__PURE__ */ o.jsx(hv, { labels: w }),
          /* @__PURE__ */ o.jsx(
            Cc,
            {
              stockAvailability: n.stockAvailability,
              stockAvailabilitySummary: n.stockAvailabilitySummary,
              config: t
            }
          ),
          /* @__PURE__ */ o.jsx("div", { className: "product__title", children: n.name }),
          /* @__PURE__ */ o.jsx(
            fv,
            {
              pricingInfo: e,
              sku: n,
              salesValue: d,
              bussinessId: g
            }
          ),
          !Tn && b.length > 0 && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
            /* @__PURE__ */ o.jsx("hr", { className: "divider my-2" }),
            /* @__PURE__ */ o.jsx(mv, { features: b })
          ] }),
          (n.promoInfo || n.hwBannerModal) && /* @__PURE__ */ o.jsx("div", { id: x })
        ]
      }
    ) }),
    (n == null ? void 0 : n.hwBannerText) && T && ba(/* @__PURE__ */ o.jsx(Pr, { contentTag: n.hwBannerText }), T),
    (n == null ? void 0 : n.hwBannerModal) && /* @__PURE__ */ o.jsx(Pr, { contentTag: n.hwBannerModal }),
    n.promoInfo && !(n != null && n.hwBannerModal) && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsx(
        ov,
        {
          onClick: j,
          linkText: n.promoInfo.linkText,
          icon: n.promoInfo.icon,
          id: x
        }
      ),
      /* @__PURE__ */ o.jsx(sv, { ref: v, seoId: n.seoId })
    ] })
  ] }) });
}, gv = () => /* @__PURE__ */ o.jsx("article", { className: "col-md-6 col-xl-4 hw-listing__product-wrapper", children: /* @__PURE__ */ o.jsx("div", { className: "hw-listing__anchor-wrapper__empty-card" }) }), bv = ({ orderType: n, activeSorting: e }) => {
  const [t] = Ue(), r = ho(), { unionText: a } = J(), i = B(() => {
    const s = new URLSearchParams(t);
    return s.set("s", ka[n]), `${r.pathname}?${s.toString()}`;
  }, [r.pathname, n, t]);
  return /* @__PURE__ */ o.jsx(mo, { className: e === n && "text-brand", children: /* @__PURE__ */ o.jsx(Jn, { className: "order-link", to: i, children: a.sorting[n] }) });
}, wv = ({ displayedSkus: n, orderBy: e, loginPrompt: t, pricingInfoResponse: r }) => {
  const a = ["newest", "cheapest", "mostExpensive"], { unionText: i } = J(), { namespace: s } = je(ye), [u] = Ue(), [m, f] = C(0), p = B(() => {
    if (e != null && e.ascending && (e == null ? void 0 : e.attribute) === "oneTimePrice")
      return "cheapest";
    if (!(e != null && e.ascending) && (e == null ? void 0 : e.attribute) === "oneTimePrice")
      return "mostExpensive";
    if (!e)
      return "newest";
  }, [e]), d = () => f((c) => c + 1);
  return U(() => {
    d();
  }, [u]), /* @__PURE__ */ o.jsx("section", { className: "hw-listing__products", children: /* @__PURE__ */ o.jsxs("div", { className: "container", children: [
    n.length > 0 && /* @__PURE__ */ o.jsx(
      lo,
      {
        id: "hw-listing__swiper-order-links",
        pagination: !1,
        freeMode: !0,
        spaceBetween: 0,
        children: a.map((c) => /* @__PURE__ */ o.jsx(bv, { orderType: c, activeSorting: p }, c + "_" + m))
      },
      p + "_" + m
    ),
    /* @__PURE__ */ o.jsxs("div", { className: "global-overlay--element-parent", style: { minHeight: "120px" }, children: [
      n.length === 0 && /* @__PURE__ */ o.jsxs("div", { className: "row bg-blue-light pt-5 ps-3 pe-3 text-center", children: [
        /* @__PURE__ */ o.jsx("h3", { children: i.nothingFound }),
        /* @__PURE__ */ o.jsx("p", { children: i.nothingFoundDescription })
      ] }),
      n.length > 0 && /* @__PURE__ */ o.jsx("div", { className: "row", children: n.map((c, l) => /* @__PURE__ */ o.jsxs(ha, { children: [
        /* @__PURE__ */ o.jsx(ft, { portlet: s, fallback: /* @__PURE__ */ o.jsx(gv, {}), children: /* @__PURE__ */ o.jsx(pv, { sku: c, pricingInfo: r }) }),
        t && (n.length === 1 || l === 1) && /* @__PURE__ */ o.jsx(iv, {})
      ] }, c.seoId)) })
    ] })
  ] }) });
}, vv = () => {
  var dt, Ot, Ee, rn, an, bt, Pt, rt, Ke, Ut, wt, zt, qt, vt;
  const n = ga(), { seoId: e } = fo(), t = sn(e), [r] = Ue(), { config: a, namespace: i } = je(ye), { unionText: s, withParams: u } = J(), [m, f] = C(null), [p, d] = C(), [c, l] = C(!1), [h, g] = C(), b = pt(), [w, y] = C(!1), [v, x] = C(0), [T, j] = C(null), [A, N] = C(!1), {
    fetcher: S,
    loading: E,
    data: k,
    error: M
  } = qe(a.skuSearchUrl, {
    method: "POST",
    manual: !0
  }), O = B(() => {
    if (k != null && k.models) {
      const te = k.models.map((ke) => ke.features).flat().filter((ke) => ke.groupBusinessId === Lr), ae = bf(te);
      return wf(ae), [...ae.values()];
    } else
      return;
  }, [k == null ? void 0 : k.models]), {
    data: I,
    error: re,
    loading: V,
    fetcher: R
  } = qe(a.hwDeviceDetailUrl, {
    method: "POST",
    manual: !0
  });
  U(() => {
    var q, te;
    (q = k == null ? void 0 : k.sku) != null && q.seoId && ((te = k == null ? void 0 : k.sku) != null && te.promoInfo) && R({ seoId: k.sku.seoId });
  }, [R, (dt = k == null ? void 0 : k.sku) == null ? void 0 : dt.promoInfo, (Ot = k == null ? void 0 : k.sku) == null ? void 0 : Ot.seoId]), U(() => {
    re && f(s.detail.error);
  }, [re, s.detail.error]), U(() => {
    j(I);
  }, [I]), U(() => {
    var ae, ke;
    const q = (ae = r.get("responseCode")) != null ? ae : "", te = (ke = r.get(na)) != null ? ke : "";
    q && q !== "OK" && d({
      title: s.detail.responseCode.title[q] || s.detail.responseCode.title.unknown,
      description: s.detail.responseCode.description[q] || s.detail.responseCode.description.unknown
    }), l(!!te);
  }, [r, s.detail.responseCode.description, s.detail.responseCode.title]), U(() => {
    var q;
    p && ((q = b == null ? void 0 : b.current) == null || q.show());
  }, [p]), U(() => {
    if (e && e !== t) {
      const q = {
        seoId: e
      };
      j(null), f(null), S(q);
    }
  }, [e, t, O, S]), U(() => {
    var te;
    const q = (te = k == null ? void 0 : k.models) == null ? void 0 : te.find((ae) => {
      var ke;
      return ae.seoId === ((ke = k == null ? void 0 : k.sku) == null ? void 0 : ke.seoId);
    });
    if (q) {
      const ae = q == null ? void 0 : q.features, ke = ae == null ? void 0 : ae.filter(
        (z) => z.groupBusinessId === Lr
      ), G = vf(ke);
      g(G);
    } else
      g(void 0);
  }, [k == null ? void 0 : k.models, (Ee = k == null ? void 0 : k.sku) == null ? void 0 : Ee.seoId]);
  const P = B(
    () => {
      var q, te;
      return !!(k != null && k.hwInsurance && ((te = (q = k == null ? void 0 : k.sku) == null ? void 0 : q.categories) != null && te.find((ae) => ae.businessId === "INSURABLE_HW")));
    },
    [k == null ? void 0 : k.hwInsurance, (rn = k == null ? void 0 : k.sku) == null ? void 0 : rn.categories]
  ), Q = B(() => k != null && k.balikovoAvailable ? !(a.selectedOrganization && c) : !1, [k == null ? void 0 : k.balikovoAvailable, c, a.selectedOrganization]), H = (q, te, ae) => ae.filter(
    (ke) => {
      var G;
      return (G = ke.features) == null ? void 0 : G.find((z) => z.name === q && z.value === te);
    }
  ), xe = (q) => {
    var ke, G;
    const te = h || /* @__PURE__ */ new Map();
    te.set(q.featureName, q.selectedValue);
    let ae = k.models;
    if (te.forEach((z, X) => {
      ae = H(X, z, ae);
    }), (!ae || ae.length === 0) && (ae = H(
      q.featureName,
      q.selectedValue,
      k.models
    ), (G = (ke = ae == null ? void 0 : ae[0]) == null ? void 0 : ke.features) == null || G.filter((z) => z.groupBusinessId === Lr).forEach((z) => {
      te.set(z.name, z.value);
    })), g(new Map(te)), ae && ae.length > 0) {
      const z = ie(Y({}, k), { sku: ae[0] });
      n(pn(r, `${Rt.detail}/${z.sku.seoId}`, c));
    }
  }, Fe = oe(() => {
    Authentication.authenticate({
      redirect_url: window.location.href
    });
  }, []), F = k && !k.sku ? s.detail.notFound : void 0, ee = M || m ? s.detail.error : void 0, Xe = E || V;
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    (ee || F) && /* @__PURE__ */ o.jsx("div", { className: "container", children: /* @__PURE__ */ o.jsx(Zt, { color: "danger", "data-o2-role": "alert-system", "data-o2-portlet": i, children: ee || F }) }),
    /* @__PURE__ */ o.jsxs(bn, { "data-testid": "o2-modal", size: "small", heading: (p == null ? void 0 : p.title) || "", o2Ref: b, children: [
      /* @__PURE__ */ o.jsx("span", { children: p == null ? void 0 : p.description }),
      /* @__PURE__ */ o.jsx(
        ve,
        {
          "data-o2-id": "hw-detail-error-modal-cancel",
          "data-testid": "hw-detail-error-modal-cancel",
          name: "error-modal-cancel",
          fullwidth: !0,
          usage: "outlined",
          slot: "secondary",
          onClick: () => {
            var q;
            (q = b.current) == null || q.hide();
          },
          children: s.detail.cancel
        }
      )
    ] }),
    /* @__PURE__ */ o.jsx("div", { className: "hw-detail", style: Xe ? { pointerEvents: "none", opacity: 0.5 } : {}, children: k && k.sku && k.availability && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsxs(pc, { children: [
        /* @__PURE__ */ o.jsx("title", { children: k.sku.name + " | O2" }),
        k.sku.seoDescription && /* @__PURE__ */ o.jsx("meta", { name: "description", lang: "sk-SK", content: k.sku.seoDescription }),
        /* @__PURE__ */ o.jsx(
          "link",
          {
            rel: "canonical",
            href: window.location.protocol + "//" + window.location.hostname + window.location.pathname
          }
        ),
        /* @__PURE__ */ o.jsx("meta", { property: "lb:id", content: k.sku.id }),
        ((bt = (an = k.sku.media) == null ? void 0 : an[0]) == null ? void 0 : bt.fullImage) && /* @__PURE__ */ o.jsx("meta", { property: "og:image", content: k.sku.media[0].fullImage })
      ] }),
      /* @__PURE__ */ o.jsxs("div", { className: "container", children: [
        /* @__PURE__ */ o.jsx(Gb, { sku: k.sku }),
        /* @__PURE__ */ o.jsxs("section", { className: "hw-configuration", children: [
          /* @__PURE__ */ o.jsxs("div", { className: "hw-configuration__stickers", children: [
            (Pt = k.sku.skuEyeCatchers) == null ? void 0 : Pt.filter((q) => q.locations.includes("DETAIL")).sort(
              (q, te) => q.sortingWeight > te.sortingWeight ? 1 : -1
            ).map((q, te) => /* @__PURE__ */ o.jsx(dn, { color: q.color, className: "d-block mb-1", children: q.value }, `detail_sticker_${te}`)),
            v && v > 0 ? /* @__PURE__ */ o.jsx(dn, { color: "blue", children: u(s.detail.salesSticker, { value: `${v}` }) }, "detail_sticker_sale") : void 0
          ] }),
          /* @__PURE__ */ o.jsxs("div", { className: "row mt-5", children: [
            /* @__PURE__ */ o.jsx("div", { className: "col-md-7 d-flex flex-column justify-content-start mt-5", children: /* @__PURE__ */ o.jsx(
              Qb,
              {
                heading: k.sku.name,
                media: k.sku.media
              },
              (Ut = (Ke = (rt = k.sku.media) == null ? void 0 : rt[0]) == null ? void 0 : Ke.originalImage) != null ? Ut : "hw-gallery"
            ) }),
            /* @__PURE__ */ o.jsx("div", { className: "col-md-5", children: /* @__PURE__ */ o.jsxs("div", { className: "d-flex flex-column gap-4", children: [
              /* @__PURE__ */ o.jsx("h1", { className: "my-0", children: k.sku.name }),
              /* @__PURE__ */ o.jsxs("div", { className: "d-flex flex-column gap-3", children: [
                /* @__PURE__ */ o.jsx("div", { className: "row", children: O == null ? void 0 : O.map((q, te) => /* @__PURE__ */ o.jsx("div", { className: "col-6", children: /* @__PURE__ */ o.jsx(
                  Xb,
                  {
                    groupSelect: q,
                    onGroupSelectChange: xe,
                    selectedParams: h,
                    models: k.models
                  }
                ) }, `detail-model-select-${te}-${q.name}`)) }),
                P && /* @__PURE__ */ o.jsx(
                  wc,
                  {
                    hwInsurance: k == null ? void 0 : k.hwInsurance,
                    isHwInsuranceSelected: c,
                    setIsHwInsuranceSelected: l
                  }
                )
              ] }),
              /* @__PURE__ */ o.jsx(ce, { alignItems: "start", gap: 1, "data-testid": "hw-detail-stock-availability-panel", children: /* @__PURE__ */ o.jsx(
                Za,
                {
                  availability: k.availability,
                  sku: k.sku,
                  disableBuySku: y,
                  showBalikovoText: Q
                }
              ) }),
              ((wt = k.sku) == null ? void 0 : wt.hwBannerTag) && /* @__PURE__ */ o.jsx(Pr, { contentTag: k.sku.hwBannerTag }),
              T && /* @__PURE__ */ o.jsx(
                zw,
                {
                  promoDetail: T,
                  hwDetailPricing: {
                    sku: k.sku,
                    disableBuyWithTariff: k.disableBuyWithTariff,
                    disableBuySku: w,
                    salesValue: x,
                    hwInsurancePrice: (zt = k == null ? void 0 : k.hwInsurance) == null ? void 0 : zt.price,
                    isHwInsuranceSelected: c
                  },
                  promoActive: A,
                  setPromoActive: N
                }
              ),
              (!A || !(T != null && T.skuIsMaster)) && /* @__PURE__ */ o.jsx(
                bc,
                {
                  sku: k.sku,
                  disableBuyWithTariff: k.disableBuyWithTariff,
                  disableBuySku: w,
                  salesValue: x,
                  hwInsurancePrice: (qt = k == null ? void 0 : k.hwInsurance) == null ? void 0 : qt.price,
                  isHwInsuranceSelected: c
                }
              ),
              /* @__PURE__ */ o.jsx("div", { children: /* @__PURE__ */ o.jsx(Vb, { seoId: k.sku.seoId }) })
            ] }) })
          ] })
        ] }),
        !a.hasUserAccountId && /* @__PURE__ */ o.jsxs(Zt, { color: "success", inline: !0, children: [
          /* @__PURE__ */ o.jsx("div", { slot: "heading", children: s.detail.loginPromptTitlte }),
          /* @__PURE__ */ o.jsx("p", { children: s.detail.loginPrompt }),
          /* @__PURE__ */ o.jsx(
            ve,
            {
              slot: "inline",
              "data-o2-id": "login.authenticate",
              "data-testid": "login.authenticate",
              name: "login.authenticate",
              variant: "secondary",
              onClick: Fe,
              children: s.detail.login
            }
          )
        ] }),
        /* @__PURE__ */ o.jsx("div", { className: "divider" }),
        k.sku.content && /* @__PURE__ */ o.jsx(
          mr,
          {
            className: "mb-5",
            lineClamp: Tn ? 2 : void 0,
            moreLink: Tn ? s.detail.showMore : void 0,
            sourceType: "text",
            children: k.sku.content
          }
        ),
        !k.sku.content && (k.sku.longDescription || k.sku.description) && /* @__PURE__ */ o.jsx("div", { className: "row justify-content-md-center", children: /* @__PURE__ */ o.jsx("div", { className: "col-md-8 col-lg-6", children: /* @__PURE__ */ o.jsx(mr, { className: "mb-5", lineClamp: 2, moreLink: s.detail.showMore, sourceType: "text", children: k.sku.longDescription || k.sku.description }) }) })
      ] }),
      !!((vt = k.sku.featureGroups) != null && vt.length) && /* @__PURE__ */ o.jsx(vc, { featureGroups: k.sku.featureGroups }),
      /* @__PURE__ */ o.jsx("div", { className: "container", children: /* @__PURE__ */ o.jsx("section", { className: "hw-featured", children: /* @__PURE__ */ o.jsx("div", { className: "row" }) }) })
    ] }) }),
    /* @__PURE__ */ o.jsx(oo, { searchHwUrl: a.searchHwUrl, maxPerComparison: 5 })
  ] });
}, yv = () => {
  var ti;
  const { unionText: n } = J(), [e, t] = C({
    closedByApply: !1,
    isClosing: !1,
    isOpen: !1
  }), [r, a] = C(), i = pt(!1), [s, u] = C(), m = 23, f = 24, { namespace: p, config: d } = je(ye), [c, l] = C({}), h = sn(c), [g, b] = C([]), [w, y] = C([]), [v, x] = C([]), [T, j] = C([]), [A, N] = C(), { seoId: S } = fo(), [E, k] = C(void 0), [M, O] = C(), {
    data: I,
    error: re,
    loading: V,
    fetcher: R
  } = qe(d.cpcPagesUrl, { manual: !0, method: "POST" }), P = B(() => {
    if (I != null && I.length)
      return I.find((Z) => Z.seoId === S);
  }, [I, S]), Q = sn(P);
  U(() => {
    var Z;
    O((Z = P == null ? void 0 : P.headlineSkus) != null ? Z : []);
  }, [P]);
  const [H, xe] = C(), [Fe, $e] = C(), F = sn(H), [ee, Xe] = Ue(), dt = sn(ee), Ot = (Z) => {
    l(Z);
  }, [Ee, rn] = C(), [an, bt] = C(!1), [Pt, rt] = C(!1), {
    data: Ke,
    error: Ut,
    fetcher: wt
  } = qe(d.pricingInfoUrl, { manual: !0, method: "POST" }), zt = sn(Ke);
  U(() => {
    var Z, be, Be;
    if (an) {
      const et = (Z = ee.get("contextTariff")) != null ? Z : void 0, it = (be = ee.get("transaction")) != null ? be : void 0, xt = Pt ? Ee == null ? void 0 : Ee.hwPricingList.map((on) => on.hirePurchaseSetup.seoId) : [], Re = (Be = E == null ? void 0 : E.filter((on) => !(xt != null && xt.includes(on.seoId))).map((on) => on.seoId)) != null ? Be : [];
      Re.length !== 0 && wt({
        skuSeoIds: Re,
        preferredTariff: et,
        transaction: it
      }), bt(!1);
    }
  }, [ee, wt, an, E, Pt, Ee == null ? void 0 : Ee.hwPricingList]), U(() => {
    Ke && zt !== Ke && (rn(Pt ? hf(Ke, Ee) : Ke), Ke.tariffSku ? (localStorage.setItem("selectedTariff", JSON.stringify(Ke.tariffSku)), rt(!1)) : (Ke.customerTariffSku ? localStorage.setItem("selectedTariff", JSON.stringify(Ke.customerTariffSku)) : localStorage.removeItem("selectedTariff"), rt(!1)));
  }, [Pt, Ke, zt, Ee]);
  const qt = localStorage.getItem("askedForLogin"), vt = B(
    () => (!qt || qt === "false") && localStorage.getItem("signed") === "false",
    [qt]
  ), q = B(
    () => ({ offset: 0, size: vt ? m : f }),
    [vt]
  ), te = B(() => {
    var Z;
    return ((Z = H == null ? void 0 : H.paging) == null ? void 0 : Z.offset) === 0;
  }, [H]), { data: ae, fetcher: ke } = qe(
    d.skusSearchUrl,
    {
      method: "POST",
      manual: !0
    }
  ), G = B(
    () => d.selectedOrganization ? [d.selectedOrganization] : [Xt],
    [d.selectedOrganization]
  ), {
    data: z,
    error: X,
    fetcher: pe
  } = qe(d.articleSearchUrl, {
    manual: !0,
    method: "POST"
  }), {
    data: at,
    error: mt,
    fetcher: se
  } = qe(d.cpcPagesUrl, { manual: !0, method: "POST" }), {
    data: $,
    loading: ht,
    error: Wn,
    fetcher: $n
  } = qe(d.skusSearchUrl, {
    method: "POST",
    manual: !0
  }), Ja = sn($), {
    data: _r,
    error: xc,
    fetcher: ei
  } = qe(d.skusSearchUrl, {
    method: "POST",
    manual: !0
  }), kc = B(
    () => S && $ && E && $.total > E.length,
    [S, E, $]
  );
  U(() => {
    var Z;
    if (!(e != null && e.isOpen)) {
      const be = $s(ee);
      l(be), j((Z = be.promoTags) != null ? Z : []);
      const Be = sf(ee);
      x(Be || []);
      const et = af(ee);
      b(et || []);
      const it = of(ee);
      u(it);
      const xt = cf(ee);
      a(xt), dt !== ee && xe((Re) => {
        const Fn = Re || {}, { stockAvailability: on } = Fn, Dr = Rn(Fn, ["stockAvailability"]);
        return ie(Y(Y({}, Dr), ua(H, be, d.selectedOrganization)), {
          skuIds: et || [],
          productIds: Be || [],
          paging: q,
          orderByList: Bi(be, xt, d.selectedOrganization),
          name: it,
          promoTags: be.promoTags || []
        });
      });
    }
  }, [
    ee,
    d.selectedOrganization,
    e == null ? void 0 : e.isOpen,
    q,
    H,
    dt
  ]), U(() => {
    if (ee.toString() === "" && d.selectedOrganization && d.selectedOrganizationType !== "EFIS" && !i.current) {
      const Z = { availability: ["ORGANIZATION"] };
      l(Z), Xe(dr(Z, ee)), i.current = !0;
    }
  }, [d.selectedOrganization, d.selectedOrganizationType, ee, Xe]);
  const yt = B(
    () => I == null ? void 0 : I.filter((Z) => Z.redirectPageId).map((Z) => Z.redirectPageId),
    [I]
  ), Tc = B(() => {
    const Z = (be) => be.skuCount > 0 && be.seoId !== S && !be.redirectPageId;
    if (I) {
      if (I.length === 0) {
        window.location.replace(pn(ee, Rt.root));
        return;
      }
      return yt != null && yt.length ? w != null && w.length ? [...w, ...I].filter(Z) : void 0 : I == null ? void 0 : I.filter(Z);
    }
  }, [I, yt == null ? void 0 : yt.length, w, ee, S]), Oc = oe(() => {
    xe((Z) => {
      var Be, et, it;
      const be = Z.paging;
      return P != null && P.headlineSkus && (P == null ? void 0 : P.headlineSkus.length) > 0 && be.offset === 0 ? ie(Y({}, Z), {
        paging: {
          offset: P.headlineSkus.length,
          size: f
        },
        headlineSkusExternalIds: M
      }) : ie(Y({}, Z), {
        paging: {
          offset: vt && be.offset === 0 ? be.offset + m : ((Be = E == null ? void 0 : E.length) != null ? Be : 0) - ((it = (et = P == null ? void 0 : P.headlineSkus) == null ? void 0 : et.length) != null ? it : 0) + f,
          size: f
        },
        headlineSkusExternalIds: M
      });
    });
  }, [P == null ? void 0 : P.headlineSkus, vt, M, f, m, E]), Bn = B(() => {
    var Be, et, it, xt;
    if (!P)
      return;
    const Z = ff(P), be = Y(ie(Y({
      paging: { offset: 0, size: 1 },
      onlyVisible: !0,
      onlyOrderable: !0
    }, P != null && P.tagsComputed ? { tags: P.tagsComputed.map((Re) => Re.name) } : {}), {
      productIds: [],
      skuIds: [],
      includeSkuOnStock: !0,
      aggregation: {
        skuFeatures: Z ? (et = (Be = d == null ? void 0 : d.skuConfigs[Z]) == null ? void 0 : Be.filterFacets) == null ? void 0 : et.map((Re) => Re.featureBusinessIds).flat() : (xt = (it = d == null ? void 0 : d.skuConfigs.MOBILE_PHONES) == null ? void 0 : it.filterFacets) == null ? void 0 : xt.map((Re) => Re.featureBusinessIds).flat()
      },
      promoTags: []
    }), d.selectedOrganization ? {} : {
      organizations: [Xt],
      stockExternalIds: [yl]
    });
    return d.selectedOrganization && ((d == null ? void 0 : d.subscriberServiceProvider) === "TM" || (d == null ? void 0 : d.subscriberServiceProvider) === "RA") || ei(be), Z;
  }, [
    d.selectedOrganization,
    d == null ? void 0 : d.skuConfigs,
    d == null ? void 0 : d.subscriberServiceProvider,
    P,
    ei
  ]);
  return U(() => {
    R({
      seoId: S,
      onlyVisible: !0,
      includeChildren: !0,
      includeParents: !0,
      sortByDisplayOrder: "ASC",
      organizations: G
    });
  }, [R, G, S]), U(() => {
    var Z, be, Be, et, it;
    if (!V && !Un(P, Q)) {
      const xt = ie(Y({
        paging: q,
        onlyVisible: !0,
        onlyOrderable: !0
      }, P != null && P.tagsComputed ? { tags: P.tagsComputed.map((Re) => Re.name) } : {}), {
        productIds: v,
        skuIds: g,
        orderByList: Bi(c, r, d.selectedOrganization),
        includeSkuOnStock: !0,
        aggregation: {
          skuFeatures: Bn ? (be = (Z = d == null ? void 0 : d.skuConfigs[Bn]) == null ? void 0 : Z.filterFacets) == null ? void 0 : be.map((Re) => Re.featureBusinessIds).flat() : (et = (Be = d == null ? void 0 : d.skuConfigs.MOBILE_PHONES) == null ? void 0 : Be.filterFacets) == null ? void 0 : et.map((Re) => Re.featureBusinessIds).flat()
        },
        promoTags: T,
        headlineSkusExternalIds: (it = P == null ? void 0 : P.headlineSkus) != null ? it : []
        // This is useful for campaing pages when we want to show on "firstPage" only selected few skus
      });
      xe((Re) => {
        const Fn = Re, { stockAvailability: on } = Fn, Dr = Rn(Fn, ["stockAvailability"]);
        return Y(Y({}, Dr), ua(xt, c, d.selectedOrganization));
      });
    }
  }, [
    d.selectedOrganization,
    d == null ? void 0 : d.skuConfigs,
    Bn,
    P,
    q,
    c,
    v,
    T,
    g,
    r,
    V,
    Q
  ]), U(() => {
    if (H != null && H.tags && !Un(H, F)) {
      if (te && k(void 0), Un(H.paging, F == null ? void 0 : F.paging) ? rt(!1) : rt(!0), d.selectedOrganization && ((d == null ? void 0 : d.subscriberServiceProvider) === "TM" || (d == null ? void 0 : d.subscriberServiceProvider) === "RA"))
        return;
      $n(H);
    }
  }, [
    H,
    $n,
    te,
    F,
    V,
    d.selectedOrganization,
    d == null ? void 0 : d.subscriberServiceProvider
  ]), U(() => {
    $ && N($);
  }, [$]), U(() => {
    _r && $e(_r);
  }, [_r]), U(() => {
    ae && N(ae);
  }, [ae]), U(() => {
    var Z;
    if ($ && !Un($, Ja)) {
      k((Be) => [...Be != null ? Be : [], ...$.results]), O((Z = $.filteredOutSkusExternalIds) != null ? Z : []);
      const be = uf(ee, $);
      be.toString() === ee.toString() ? bt(!0) : Xe(be);
    }
  }, [Ja, ee, Xe, $]), U(() => {
    yt != null && yt.length ? se({ pageId: yt, onlyVisible: !0, organizations: G }) : y([]);
  }, [se, G, yt]), U(() => {
    at && P && at.forEach((Z) => Z.parentPageId = P.id), y(at);
  }, [at, P]), /* @__PURE__ */ o.jsxs("div", { className: "hw-listing", children: [
    /* @__PURE__ */ o.jsxs("div", { className: "container", children: [
      (re || mt || Wn || Ut || X || xc) && /* @__PURE__ */ o.jsx(Zt, { color: "danger", "data-o2-portlet": p, "data-o2-role": "alert-system", children: n.error }),
      /* @__PURE__ */ o.jsx(Uw, { pages: I, currentSeoId: S }),
      P && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
        /* @__PURE__ */ o.jsxs(pc, { children: [
          /* @__PURE__ */ o.jsx("title", { children: P.title + " | O2" }),
          P.seoDescription && /* @__PURE__ */ o.jsx("meta", { name: "description", lang: "sk-SK", content: P.seoDescription }),
          /* @__PURE__ */ o.jsx(
            "link",
            {
              rel: "canonical",
              href: window.location.protocol + "//" + window.location.hostname + window.location.pathname
            }
          )
        ] }),
        !P.contentTag && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
          /* @__PURE__ */ o.jsx("h1", { className: "text-md-center", children: P.title }),
          (z || P.descriptionMarkdown) && /* @__PURE__ */ o.jsx("div", { className: "row justify-content-center", children: /* @__PURE__ */ o.jsx("div", { className: "col-12 col-md-6", children: /* @__PURE__ */ o.jsx(
            mr,
            {
              className: ["text-md-center mb-5", !(z != null && z.value) && "text-secondary"],
              lineClamp: Tn ? 3 : void 0,
              moreLink: Tn ? n.moreLink : void 0,
              sourceType: "text",
              children: (z == null ? void 0 : z.value) || P.descriptionMarkdown
            },
            `content_is_mobile_${Tn}_${P.seoId}`
          ) }) })
        ] }),
        !P.contentTag && P.liferayArticleTag && !z && /* @__PURE__ */ o.jsx("p", { className: "text-md-center", children: /* @__PURE__ */ o.jsx(
          "a",
          {
            className: "more-link",
            onClick: () => {
              var Z;
              pe({
                tag: (Z = P.liferayArticleTag) != null ? Z : ""
              });
            },
            children: n.moreLink
          }
        ) })
      ] }),
      !(P != null && P.contentTag) && /* @__PURE__ */ o.jsx(rv, { currentSeoId: S, visiblePages: Tc, currentPage: P }),
      (P == null ? void 0 : P.contentTag) && /* @__PURE__ */ o.jsx(ro, { contentTag: P.contentTag }),
      /* @__PURE__ */ o.jsx(tv, { pricingInfoResponse: Ee }),
      /* @__PURE__ */ o.jsx("hr", { className: "my-5" }),
      /* @__PURE__ */ o.jsx("div", { className: "hw-listing__filter", children: /* @__PURE__ */ o.jsxs("div", { className: "row", children: [
        /* @__PURE__ */ o.jsx("div", { className: "col-md-3 col-lg-4", children: /* @__PURE__ */ o.jsx(Yw, { tariffName: (ti = Ee == null ? void 0 : Ee.tariffSku) == null ? void 0 : ti.name, setFetchNewModel: bt }) }),
        /* @__PURE__ */ o.jsx("div", { className: "col-md-9 col-lg-8", children: /* @__PURE__ */ o.jsx(
          ev,
          {
            filter: c,
            foundDevices: $ == null ? void 0 : $.total,
            aggregationValues: Fe,
            searchResultForFilter: A,
            filters: Bn ? d.skuConfigs[Bn].filterFacets : d.skuConfigs.MOBILE_PHONES.filterFacets,
            setFilter: Ot,
            skuFilters: H,
            getFilteredSkus: ke,
            setDisplayedSkus: k,
            modalFilterState: e,
            setModalFilterState: t,
            searchValue: s,
            previousFilter: h
          }
        ) })
      ] }) }),
      /* @__PURE__ */ o.jsx("div", { className: "divider" })
    ] }),
    !E && d.selectedOrganization && ((d == null ? void 0 : d.subscriberServiceProvider) === "TM" || (d == null ? void 0 : d.subscriberServiceProvider) === "RA") && /* @__PURE__ */ o.jsx("section", { className: "hw-listing__products", children: /* @__PURE__ */ o.jsx("div", { className: "container", children: /* @__PURE__ */ o.jsxs("div", { className: "row bg-blue-light pt-5 ps-3 pe-3 text-center", children: [
      /* @__PURE__ */ o.jsx("h3", { children: n.subscriberFromAnotherServiceProvider }),
      /* @__PURE__ */ o.jsx("p", { children: n.subscriberFromAnotherServiceProviderDescription })
    ] }) }) }),
    E && /* @__PURE__ */ o.jsx(
      wv,
      {
        displayedSkus: (
          //ignored because when we don't have seoId and therefore we don't send skuSearch request
          S ? E : []
        ),
        orderBy: r,
        loginPrompt: vt,
        pricingInfoResponse: Ee
      }
    ),
    (H == null ? void 0 : H.paging) && kc && /* @__PURE__ */ o.jsx(av, { loadMore: Oc, loading: ht }),
    (P == null ? void 0 : P.bottomContentTag) && /* @__PURE__ */ o.jsx(ro, { contentTag: P.bottomContentTag }),
    /* @__PURE__ */ o.jsx(oo, { searchHwUrl: d.searchHwUrl, maxPerComparison: 5 })
  ] });
}, xv = () => /* @__PURE__ */ o.jsxs(Hc, { children: [
  /* @__PURE__ */ o.jsx(si, { path: `${Rt.listing}/:seoId`, element: /* @__PURE__ */ o.jsx(yv, {}) }),
  /* @__PURE__ */ o.jsx(si, { path: `${Rt.detail}/:seoId`, element: /* @__PURE__ */ o.jsx(vv, {}) }),
  /* initial route for portlet files */
  !1
] });
const Iv = ({ namespace: n, data: e }) => {
  const { synced: t, error: r } = Lc();
  return /* @__PURE__ */ o.jsx(Wc, { portlet: n, initialTexts: gn, children: ({ unionText: a }) => /* @__PURE__ */ o.jsx(ye.Provider, { value: { namespace: n, config: e }, children: /* @__PURE__ */ o.jsx(zc, { children: /* @__PURE__ */ o.jsxs($c, { portlet: n, children: [
    r && /* @__PURE__ */ o.jsx(Zt, { color: "danger", "data-o2-portlet": n, "data-o2-role": "alert-system", children: a.servletError }),
    t && /* @__PURE__ */ o.jsx(xv, {})
  ] }) }) }) });
};
export {
  Iv as EshopHardwarePortlet
};
//# sourceMappingURL=index.js.map
